// Admin Panel i18n Dictionaries (RU, EN, KY)
// IMPORTANT: All UI text must be in 3 languages: Russian, English, Kyrgyz

export const dictionaries = {
  ru: {
    // Common
    common: {
      save: 'Сохранить',
      cancel: 'Отмена',
      delete: 'Удалить',
      edit: 'Редактировать',
      add: 'Добавить',
      search: 'Поиск',
      filter: 'Фильтр',
      export: 'Экспорт',
      import: 'Импорт',
      loading: 'Загрузка...',
      noData: 'Нет данных',
      error: 'Ошибка',
      success: 'Успешно',
      confirm: 'Подтвердить',
      confirmTitle: 'Подтверждение',
      confirmMessage: 'Вы уверены?',
      yes: 'Да',
      no: 'Нет',
      refresh: 'Обновить',
      active: 'Активен',
      inactive: 'Неактивен',
      saving: 'Сохранение...',
      update: 'Обновить',
      create: 'Создать',
      actions: 'Действия',
      close: 'Закрыть',
      back: 'Назад',
      next: 'Далее',
      all: 'Все',
      status: 'Статус',
      name: 'Название',
      total: 'Итого',
      details: 'Детали',
      unknownError: 'Неизвестная ошибка',
      retry: 'Повторить',
      view: 'Просмотр',
      rowsPerPage: 'Строк на странице:',
      of: 'из',
      closeGallery: 'Закрыть галерею',
      previousImage: 'Предыдущее изображение',
      nextImage: 'Следующее изображение',
      deleteImage: 'Удалить изображение',
      deleteVideo: 'Удалить видео',
      refreshWidget: 'Обновить виджет',
      openMenu: 'Открыть меню',
      closeMenu: 'Закрыть меню',
      notifications: 'Уведомления',
      changeLanguage: 'Сменить язык',
      expand: 'Развернуть',
      collapse: 'Свернуть',
      selectVideoQuality: 'Выбрать качество видео',
      previousMedia: 'Предыдущий медиафайл',
      nextMedia: 'Следующий медиафайл',
      hideMenu: 'Скрыть меню',
      collapseMenu: 'Свернуть меню',
      markAsRead: 'Отметить прочитанным',
      manageColumns: 'Управление колонками',
      dragColumnsHint: 'Перетащите колонки для изменения порядка',
      resetOrder: 'Сбросить порядок',
      showAll: 'Показать все',
      done: 'Готово',
      noDataToDisplay: 'Нет данных для отображения',
      tableUnavailable: 'Таблица временно недоступна',
      tryAgain: 'Попробовать снова',
      enableDataGrid: 'Включить таблицу (DataGrid)',
      dataGridDisabled: 'DataGrid отключён из-за ошибки рендера. Показан упрощённый режим.',
      auto: 'Авто',
      autoAdaptive: 'Авто (Адаптивное)',
      videoQuality: 'Качество видео',
      currencyKGS: 'сом',
      ms: 'мс',
      seconds: 'с',
      displayedRows: '{{from}}–{{to}} из {{count}}',
      product: 'Продукт',
      email: 'Email',
      video: 'Видео',
      image: 'Изображение',
      upload: 'Загрузить',
      statusSuccess: 'Успешно',
      statusError: 'Ошибка',
      statusPending: 'Ожидание',
      statusProcessing: 'Обработка',
      currencyCode: 'KGS',
      none: 'Не выбрано',
    },
    profile: {
      open: 'Открыть профиль',
    },

    // Navigation
    nav: {
      dashboard: 'Панель управления',
      products: 'Товары',
      inventory: 'Инвентаризация',
      orders: 'Заказы',
      users: 'Пользователи',
      analytics: 'Аналитика',
      settings: 'Настройки',
      logout: 'Выход',
      openMenu: 'Открыть меню',
      more: 'Ещё',
      notifications: 'Уведомления',
      language: 'Язык',
      categories: 'Категории',
      batches: 'Партии товаров',
      roles: 'Роли и права',
      badges: 'Бейджи товаров',
      counting: 'Пересчет товаров',
      serials: 'Серийные номера',
      purchases: 'Закупки',
      bom: 'Спецификации (BOM)',
      manufacturing: 'Производство',
      production: 'Трекер производства',
      materials: 'Материалы',
      qualityControl: 'Контроль качества',
      finance: 'Финансы',
      messenger: 'Мессенджер',
      customerSupport: 'Поддержка клиентов',
      integrations: 'Интеграции',
      suppliers: 'Поставщики',
      advancedAnalytics: 'Расширенная аналитика',
      organizations: 'Организации',
      onecDatabases: '1C Базы данных',
      onecMetrics: '1C Метрики',
      onecHealth: '1C Здоровье',
      onecSyncLogs: '1C Логи',
      onecInstaller: 'Скачать 1C',
      connectorSettings: 'Настройки коннектора',
      newBatch: 'Новая партия',
      newCounting: 'Новый пересчёт',
      pin: 'Закрепить',
      unpin: 'Открепить',
      pinAction: 'Закрепить действие: {{label}}',
      unpinAction: 'Открепить действие: {{label}}',
      pinHint: 'Чтобы закрепить действие: нажми на 📌 или зажми иконку (long-press).',
      myProfile: 'Мой профиль',
      home: 'Главная',
      superAdmin: 'СУПЕР АДМИН',
      featureFlags: 'Feature Flags',
      adminPanel: 'Панель администратора',
      mobileHome: 'Главная',
      mobileOrders: 'Заказы',
      mobileInventory: 'Склад',
      mobileAnalytics: 'Аналитика',
      mobileMenu: 'Меню',
    },

    // Theme
    theme: {
      lightTheme: 'Светлая тема',
      darkTheme: 'Тёмная тема',
      toggle: 'Переключить тему',
    },

    // Export (Excel price lists)
    export: {
      priceList: 'Прайс-лист',
      sku: 'Артикул',
      photo: 'Фото',
      productName: 'Наименование',
      description: 'Описание',
      category: 'Категория',
      priceWithCurrency: 'Цена ({{currency}})',
      priceB2B: 'Цена B2B ({{currency}})',
      priceQty10: 'Цена за 10 шт ({{currency}})',
      priceQty50: 'Цена за 50 шт ({{currency}})',
      stock: 'Наличие',
      inStock: 'В наличии',
      toOrder: 'Под заказ',
      phone: 'Тел',
      address: 'Адрес',
      website: 'Сайт',
      report: 'Отчёт',
      generated: 'Сгенерировано',
      page: 'Страница',
      orderNumber: 'Заказ',
      status: 'Статус',
      customerInformation: 'Информация о клиенте',
      customerName: 'Имя',
      email: 'Email',
      orderItems: 'Позиции заказа',
      productCol: 'Товар',
      skuCol: 'Артикул',
      qtyCol: 'Кол-во',
      priceCol: 'Цена',
      totalCol: 'Сумма',
      orderSummary: 'Итог заказа',
      subtotal: 'Подитог',
      shipping: 'Доставка',
      discount: 'Скидка',
      totalLabel: 'Итого',
      notes: 'Заметки',
      platformName: 'WASSER E-commerce Platform',
      emailAttachedReport: 'Прилагается отчёт',
      emailRegards: 'С уважением,',
    },

    // Products
    products: {
      title: 'Управление товарами',
      addProduct: 'Добавить товар',
      editProduct: 'Редактировать товар',
      columnName: 'Название',
      columnCategory: 'Категория',
      columnPrice: 'Цена',
      columnStock: 'Остаток',
      columnStatus: 'Статус',
      columnActions: 'Действия',
      editVariant: 'Редактировать вариант',
      deleteVariant: 'Удалить вариант',
      variantName: 'Название варианта',
      variantUpdated: 'Вариант обновлён',
      variantCreated: 'Вариант создан',
      variantDeleted: 'Вариант удалён',
      confirmDeleteVariant: 'Удалить этот вариант?',
      productVariants: 'Варианты товара',
      addVariant: 'Добавить вариант',
      editVariantTitle: 'Редактировать вариант',
      addVariantTitle: 'Добавить вариант',
      failedToLoadData: 'Не удалось загрузить данные',
      failedToSave: 'Не удалось сохранить товар',
      deleteProduct: 'Удалить товар',
      noMedia: 'Нет медиафайлов для этого товара',
      openMedia: 'Открыть медиа',
      productName: 'Название товара',
      sku: 'Артикул',
      price: 'Цена',
      stock: 'Остаток',
      stockAvailable: 'Доступно',
      stockOnHand: 'На складе',
      stockReserved: 'Резерв',
      status: 'Статус',
      active: 'Активен',
      inactive: 'Неактивен',
      lowStock: 'Мало на складе',
      outOfStock: 'Нет в наличии',
      category: 'Категория',
      description: 'Описание',
      images: 'Изображения',
      specifications: 'Характеристики',
      pricing: 'Цены',
      b2bPrice: 'B2B цена',
      volumePrice: 'Оптовая цена',
      qty10Price: 'Цена от 10 шт',
      qty50Price: 'Цена от 50 шт',
      stockQuantity: 'Количество на складе',
      confirmDelete: 'Вы уверены, что хотите удалить этот товар?',
      deleteSuccess: 'Товар успешно удалён',
      saveSuccess: 'Товар успешно сохранён',
      totalCountLabel: 'Всего активных товаров',
      featured: 'Хит продаж',
      featuredBadge: 'Товар, выделенный на витрине',
      noLowStock: 'Нет товаров с низким остатком',
      createProduct: 'Создать товар',
      deleteAll: 'Удалить все',
      basicInfo: 'Основная информация',
      noCategory: 'Без категории',
      nameRu: 'Название (Русский)',
      nameEn: 'Name (English)',
      nameKy: 'Аталышы (Кыргызча)',
      descriptionRu: 'Описание (Русский)',
      descriptionEn: 'Description (English)',
      descriptionKy: 'Сүрөттөмө (Кыргызча)',
      retailPrice: 'Розничная цена',
      quantity: 'Количество на складе',
      lowThreshold: 'Минимальный остаток',
      isActive: 'Активен (виден покупателям)',
      isFeatured: 'Хит (показывать на главной)',
      errors: {
        skuRequired: 'Артикул обязателен',
      },
      // Product management page
      columnName: 'Название',
      columnActions: 'Действия',
      viewMode: 'Режим отображения',
      viewGridLarge: 'Крупная плитка',
      viewGridSmall: 'Мелкая плитка',
      viewListPhoto: 'Список с фото',
      viewTable: 'Таблица',
      sorting: 'Сортировка',
      sortByName: 'По названию',
      sortByPrice: 'По цене',
      sortByDate: 'По дате',
      sortByStock: 'По остатку',
      sortByStatus: 'По статусу',
      sortAsc: 'По возрастанию',
      sortDesc: 'По убыванию',
      sortAscLabel: 'Сортировка по возрастанию',
      sortDescLabel: 'Сортировка по убыванию',
      filters: 'Фильтры',
      resetAll: 'Сбросить все',
      allStatuses: 'Все статусы',
      activeFilter: 'Активные',
      inactiveFilter: 'Неактивные',
      allCategories: 'Все категории',
      openFilters: 'Открыть фильтры',
      searchPlaceholder: 'Поиск по названию, SKU или категории...',
      clearSearch: 'Очистить поиск',
      productBundles: 'Комплекты товаров',
      exportExcel: 'Экспорт Excel',
      manageColumns: 'Управление колонками',
      variants: 'Варианты',
      manageVariants: 'Управление вариантами товара',
      openVariants: 'Открыть варианты товара',
      exportWithPhotos: 'Полный экспорт с фото',
      exportWithoutPhotos: 'Полный экспорт без фото',
      exportPriceListCustom: 'Прайс-лист (настраиваемый)',
      shown: 'Показано',
      productUpdated: 'Товар "{{name}}" успешно обновлён',
      productCreated: 'Товар "{{name}}" успешно создан',
      missingSlug: 'Ошибка: отсутствует slug/id товара',
      confirmDeleteProduct: 'Удалить товар "{{name}}"? Это действие нельзя отменить.',
      productDeleted: 'Товар "{{name}}" удалён.',
      cannotDeleteLinked: 'Невозможно удалить товар "{{name}}".\n\nТовар используется в заказах или других связанных записях. Сначала удалите связанные данные.',
      deleteError: 'Ошибка удаления',
      confirmDeleteAllProducts: 'Удалить ВСЕ товары? Это действие нельзя отменить.',
      deletedCount: 'Удалено товаров: {{count}}',
      bulkDeleteError: 'Ошибка массового удаления',
      noProductsToExport: 'Нет товаров для экспорта',
      exportError: 'Ошибка экспорта',
      priceListExportError: 'Ошибка экспорта прайс-листа',
      noMatchingProducts: 'Нет товаров, соответствующих фильтрам. Попробуйте изменить параметры поиска.',
      authRequired: 'Требуется авторизация',
      closeDialog: 'Закрыть диалог',
      exportPhoto: 'Фото',
      exportNameRu: 'Название (RU)',
      exportNameEn: 'Название (EN)',
      exportNameKy: 'Название (KY)',
      exportPriceKgs: 'Цена (KGS)',
      exportPriceB2b: 'Цена B2B (KGS)',
      exportStockCol: 'Остаток',
      exportAvailable: 'Доступно',
      exportOnHand: 'На складе',
      exportReserved: 'Зарезервировано',
      exportCategory: 'Категория',
      exportStatus: 'Статус',
      exportFeatured: 'Рекомендуемый',
      exportCreated: 'Создан',
      exportUpdated: 'Обновлен',
      exportDescRu: 'Описание (RU)',
      exportDescEn: 'Описание (EN)',
      exportDescKy: 'Описание (KY)',
      exportQty10: 'Цена за 10шт (KGS)',
      exportQty50: 'Цена за 50шт (KGS)',
      // ProductForm
      form: {
        changesSaved: 'Изменения сохранены',
        tabBasicInfo: 'Основная информация',
        tabPricing: 'Цены',
        tabStock: 'Остатки',
        tabMedia: 'Медиа',
        tabBom: 'Спецификация',
        tabCost: 'Себестоимость',
        skuNoChange: 'SKU нельзя изменить после создания',
        skuHint: 'Уникальный код товара',
        skuPlaceholder: 'Например: PROD-001',
        nameRuPlaceholder: 'Введите название на русском',
        nameEnPlaceholder: 'Введите название на английском',
        nameKyPlaceholder: 'Кыргызча аталышын киргизиңиз',
        descRuPlaceholder: 'Подробное описание товара на русском языке...',
        descEnPlaceholder: 'Подробное описание товара на английском языке...',
        descKyPlaceholder: 'Товардын толук сүрөттөмөсү кыргызча...',
        chars: 'символов',
        currencySom: 'сом',
        retailPriceHint: 'Основная цена для покупателей',
        b2bPriceHint: 'Цена для оптовых покупателей',
        qty10Hint: 'При покупке от 10 единиц',
        qty50Hint: 'При покупке от 50 единиц',
        pcs: 'шт',
        stockQtyHint: 'Текущее количество товара на складе',
        lowThresholdHint: 'Предупреждение при достижении этого уровня',
        lowStockWarning: 'Товар заканчивается на складе! Текущий остаток: {{qty}} шт',
        bomUnavailable: 'Спецификация доступна только для сохраненных товаров. Пожалуйста, сначала создайте товар.',
        costUnavailable: 'Расчет себестоимости доступен только для сохраненных товаров. Пожалуйста, сначала создайте товар.',
        editingProduct: 'Редактирование товара',
        creatingProduct: 'Создание нового товара',
        productFallback: 'Товар',
      },
    },

    // Badges
    badges: {
      title: 'Управление бейджами товаров',
      subtitle: 'Назначайте акционные бейджи товарам: Хит, Новинка, Чёрная пятница, Новогодняя скидка и др.',
      loadError: 'Не удалось загрузить товары',
      addError: 'Не удалось добавить бейдж',
      deleteConfirm: 'Удалить этот бейдж?',
      deleteError: 'Не удалось удалить бейдж',
      bulkDeleteConfirm: 'Удалить бейдж "{{badge}}" у {{count}} товаров?',
      bulkDeleteError: 'Не удалось удалить бейджи',
      columnProduct: 'Товар',
      noName: 'Без названия',
      columnStatus: 'Статус',
      statusActive: 'Активен',
      statusHidden: 'Скрыт',
      columnBadges: 'Бейджи',
      noBadges: 'Нет бейджей',
      columnActions: 'Действия',
      addBadge: 'Добавить бейдж',
      selected: 'Выбрано: {{count}} товаров',
      removeBadge: 'Удалить бейдж',
      filterAll: 'Все',
      dialogTitleBulk: 'Добавить бейдж к {{count}} товарам',
      dialogTitleSingle: 'Добавить бейдж: {{name}}',
      badgeType: 'Тип бейджа',
      discountPercent: 'Процент скидки',
      discountHint: 'Опционально: будет показан на бейдже',
      startDate: 'Дата начала (опционально)',
      endDate: 'Дата окончания (опционально)',
      customImageUrl: 'URL изображения бейджа (PNG)',
      customImageHint: 'Загрузите PNG и вставьте ссылку',
      customText: 'Текст бейджа',
      customPlaceholder: 'Свой текст',
      preview: 'Предпросмотр:',
      types: {
        hot: { label: 'Хит 🔥', description: 'Популярный товар' },
        new: { label: 'Новинка ✨', description: 'Новый товар в каталоге' },
        sale: { label: 'Скидка 💰', description: 'Товар со скидкой' },
        black_friday: { label: 'Чёрная пятница 🖤', description: 'Акция Чёрная пятница' },
        new_year: { label: 'Новогодняя скидка 🎄', description: 'Новогодняя акция' },
        limited: { label: 'Ограничено ⏰', description: 'Ограниченное предложение' },
        bestseller: { label: 'Бестселлер ⭐', description: 'Лидер продаж' },
        custom: { label: 'Пользовательский 🏷️', description: 'Свой бейдж с PNG' },
      },
    },

    // Bundles
    bundles: {
      title: 'Комплекты товаров',
      subtitle: 'Создавайте и управляйте комплектами товаров со специальными ценами',
      loadError: 'Ошибка загрузки комплектов',
      updated: 'Комплект обновлён',
      created: 'Комплект создан',
      saveError: 'Ошибка сохранения',
      deleteConfirm: 'Удалить этот комплект?',
      deleted: 'Комплект удалён',
      deleteError: 'Ошибка удаления',
      backToProducts: 'Назад к товарам',
      createBundle: 'Создать комплект',
      empty: 'Комплектов пока нет. Создайте комплект, чтобы предложить покупателям набор товаров по специальной цене.',
      statusActive: 'Активен',
      statusInactive: 'Неактивен',
      itemsCount: 'Товаров в комплекте: {{count}}',
      composition: 'Состав:',
      dialogEdit: 'Редактировать комплект',
      dialogCreate: 'Создать комплект',
      nameLabel: 'Название комплекта',
      nameHint: 'Например: Комплект Ванная Премиум',
      skuHint: 'Артикул комплекта',
      priceLabel: 'Цена комплекта',
      currencySom: 'сом',
      descriptionLabel: 'Описание',
      itemsTitle: 'Товары в комплекте',
      selectProduct: 'Выберите товар',
      quantity: 'Кол-во',
      addItem: 'Добавить',
      removeItemAria: 'Удалить товар из комплекта',
      noItemsWarning: 'Добавьте хотя бы один товар в комплект',
      totalSeparate: 'Сумма товаров по отдельности:',
      bundlePrice: 'Цена комплекта:',
      savings: 'Экономия:',
      isActive: 'Комплект активен',
      nameRequired: 'Введите название комплекта',
      itemsRequired: 'Добавьте хотя бы один товар в комплект',
      deleteMessage: 'Это действие нельзя отменить',
    },
    dashboard: {
      title: 'Панель управления',
      welcome: 'Добро пожаловать в панель администратора мебельного магазина',
      totalUsers: 'Всего пользователей',
      products: 'Товары',
      ordersToday: 'Заказов сегодня',
      revenue: 'Выручка',
  revenue30d: 'Выручка за 30 дней',
      recentActivity: 'Последняя активность',
      activityChart: 'График активности и последние заказы будут отображаться здесь',
      quickActions: 'Быстрые действия',
      addNewProduct: 'Добавить новый товар',
      viewPendingOrders: 'Просмотр ожидающих заказов',
      userManagement: 'Управление пользователями',
  activeUsersLabel: 'Активные',
  lowStockLabel: 'Низкий остаток',
  pendingOrdersLabel: 'В обработке',
  revenueTodayLabel: 'Сегодня',
  lowStockTitle: 'Товары с низким остатком',
  unknownDate: 'Дата неизвестна',
      subtitle: 'Панель управления бизнесом (ERP-light)',
      refresh: 'Обновить',
      dataPartialWarning: 'Часть данных недоступна. Dashboard покажет fallback значения.',
      revenueMtd: 'Выручка (MTD)',
      vsPrevMonth: 'к прошлому месяцу',
      ordersToday: 'Заказов сегодня',
      vsYesterday: 'к вчера',
      conversionPct: 'Конверсия (%)',
      marginPct: 'Маржа (%)',
      salesRevenue: 'Продажи / Выручка',
      additionalMetrics: 'Дополнительные показатели',
      ordersVolume: 'Операции — Объём заказов',
      inventoryAlerts: 'Оповещения о запасах',
      inventoryHealth: 'Состояние запасов',
      orderFlow: 'Поток заказов',
      activityFeed: 'Активность / Лента сигналов',
      createPurchase: 'Создать закупку',
      justNow: 'только что',
      minutesAgo: '{{m}} мин назад',
      hoursAgo: '{{h}} ч назад',
      daysAgo: '{{d}} дн назад',
      noEvents: 'Нет событий.',
      event: 'Событие',
      // Dashboard components
      inventoryRiskTitle: 'Склад как финансовый риск',
      inventoryHealthAria: 'Сегментированный индикатор здоровья склада',
      okStock: 'Норма',
      lowStock: 'Мало',
      outOfStock: 'Нет в наличии',
      severityCritical: 'КРИТИЧЕСКИ',
      severityWarning: 'ПРЕДУПРЕЖДЕНИЕ',
      severityInfo: 'ИНФО',
      noInventoryAlerts: 'Нет алертов по складу.',
      productFallback: 'Товар',
      createPurchaseAria: 'Создать закупку по SKU',
      purchaseBtn: 'Закупить',
      stockRemaining: 'Остаток',
      pctVsPrevDay: '{{pct}}% к предыдущему дню',
      revenueRangeAria: 'Выбор периода выручки',
      avgOrderValue: 'Средний чек',
      ordersMtd: 'Заказов (MTD)',
      avgFulfillmentTime: 'Ср. время исполнения',
      days: 'дн.',
      thisMonth: 'в этом месяце',
      today: 'сегодня',
      topProducts: 'Топ-5 товаров',
      noTopProducts: 'Нет данных о товарах',
      orders: 'заказов',
    },

    // Orders
    orders: {
      title: 'Управление заказами',
      subtitle: 'Управление заказами B2B и B2C клиентов',
      confirmBulkDelete: 'Удалить {{count}} заказов?',
      orderId: 'ID заказа',
      orderNumber: 'Номер заказа',
      customer: 'Клиент',
      date: 'Дата',
      total: 'Итого',
      type: 'Тип',
      status: 'Статус',
      actions: 'Действия',
      pending: 'В ожидании',
      confirmed: 'Подтверждён',
      processing: 'В обработке',
      shipped: 'Отправлен',
      delivered: 'Доставлен',
      cancelled: 'Отменён',
      view: 'Просмотр',
      viewDetails: 'Посмотреть детали',
      quickConfirm: 'Подтвердить',
      quickProcess: 'В работу',
      updateStatus: 'Обновить статус',
      noRecentOrders: 'Недавних заказов нет',
      // API-related
      errorLoadOrders: 'Ошибка загрузки заказов',
      filterByStatus: 'Фильтр по статусу',
      filterByType: 'Тип клиента',
      filterByDate: 'Период',
      searchPlaceholder: 'Поиск по номеру, имени, телефону...',
      allOrders: 'Всего',
      todayOrders: 'Сегодня',
      period_all: 'Все время',
      period_today: 'Сегодня',
      period_week: 'Неделя',
      period_month: 'Месяц',
      period_quarter: 'Квартал',
      guest: 'Гость',
      // Status translations (with status_ prefix for dynamic lookup)
      status_pending: 'В ожидании',
      status_processing: 'В обработке',
      status_shipped: 'Отправлен',
      status_delivered: 'Доставлен',
      status_cancelled: 'Отменён',
      // PDF Export
      pdf: {
        orderTitle: 'ЗАКАЗ',
        date: 'Дата',
        orderInfo: 'Информация о заказе',
        status: 'Статус',
        type: 'Тип',
        payment: 'Оплата',
        paymentMethod: 'Способ оплаты',
        customer: 'Клиент',
        customerName: 'Имя',
        phone: 'Телефон',
        shippingAddress: 'Адрес доставки',
        orderItems: 'Товары в заказе',
        product: 'Товар',
        qty: 'Кол-во',
        price: 'Цена',
        total: 'Итого',
        subtotal: 'Подытог',
        tax: 'Налог',
        shipping: 'Доставка',
        grandTotal: 'ИТОГО',
        orderHistory: 'История заказа',
        note: 'Примечание',
        footer: 'Создано автоматически системой управления | Страница {{current}} из {{total}}',
        currencyShort: 'с',
      },
      // Kanban view
      kanbanTitle: 'Канбан-доска заказов',
      kanbanView: 'Канбан',
      tableView: 'Таблица',
      noOrders: 'Нет заказов',
      unknownCustomer: 'Неизвестный клиент',
      loadError: 'Ошибка загрузки заказов',
      statusUpdateError: 'Ошибка обновления статуса',
      changeStatusTitle: 'Изменить статус заказа',
      changeStatusConfirm: 'Переместить заказ #{{orderId}} в статус "{{newStatus}}"?',
      cancelReason: 'Причина отмены',
      status_confirmed: 'Подтверждён',
      moveTo_confirmed: 'Подтвердить',
      moveTo_processing: 'В обработку',
      moveTo_shipped: 'Отгрузить',
      moveTo_delivered: 'Доставлено',
      moveTo_cancelled: 'Отменить',
      statusUpdatedToast: 'Заказ #{{orderId}} обновлён: {{status}}',
      overdue: 'Просрочено',
      saveView: 'Сохранить вид',
      viewNamePlaceholder: 'Название вида...',
      viewSaved: 'Вид сохранён',
      savedViews: 'Сохранённые виды',
    },

    // Users
    users: {
      title: 'Управление пользователями',
      addUser: 'Добавить пользователя',
      name: 'Имя',
      email: 'Email',
      role: 'Роль',
      status: 'Статус',
      actions: 'Действия',
      admin: 'Администратор',
      b2b: 'B2B клиент',
      b2bVerified: 'B2B Подтверждён',
      b2bCandidate: 'B2B Кандидат',
      b2c: 'B2C клиент',
      b2cCustomer: 'B2C Клиент',
      createdAt: 'Дата регистрации',
      lastLogin: 'Последний вход',
      active: 'Активен',
      pending: 'Ожидает',
      blocked: 'Заблокирован',
      subtitle: 'Управление пользователями B2C и B2B клиентами',
    },

    // Roles Management
    roles: {
      title: 'Управление ролями',
      subtitle: 'Настройка ролей и прав доступа пользователей',
      newRole: 'Новая роль',
      editRole: 'Редактировать роль',
      searchPlaceholder: 'Поиск по названию, коду или описанию...',
      manageColumns: 'Управление колонками',
      colRole: 'Роль',
      colCode: 'Код',
      colDescription: 'Описание',
      colPermissions: 'Права',
      colUsers: 'Пользователей',
      colActions: 'Действия',
      module_products: 'Товары',
      module_orders: 'Заказы',
      module_customers: 'Клиенты',
      module_inventory: 'Склад',
      module_manufacturing: 'Производство',
      module_bom: 'Спецификации (BOM)',
      module_materials: 'Материалы',
      module_qc: 'Контроль качества',
      module_purchases: 'Закупки',
      module_analytics: 'Аналитика',
      module_reports: 'Отчёты',
      module_settings: 'Настройки',
      module_integrations: 'Интеграции',
      module_users: 'Пользователи',
      module_roles: 'Роли',
      perm_view: 'Просмотр',
      perm_create: 'Создание',
      perm_edit: 'Редактирование',
      perm_delete: 'Удаление',
      perm_export: 'Экспорт',
      perm_import: 'Импорт',
      perm_cancel: 'Отмена',
      perm_approve: 'Одобрение',
      perm_adjust: 'Корректировка',
      perm_count: 'Инвентаризация',
      perm_start: 'Запуск',
      perm_complete: 'Завершение',
      perm_price_update: 'Обновление цен',
      perm_schedule: 'Планирование',
      perm_roles: 'Управление ролями',
      perm_assign: 'Назначение',
      perm_hold: 'Удержание',
      perm_release: 'Выпуск',
      perm_receive: 'Приёмка',
      perm_sync: 'Синхронизация',
      perm_advanced: 'Расширенная',
      basicInfo: 'Основная информация',
      nameLabel: 'Название *',
      codeLabel: 'Код *',
      descriptionLabel: 'Описание',
      permissionsSection: 'Права доступа',
      validationRequired: 'Обязательное поле',
      validationCodeFormat: 'Только латинские буквы и _',
      codeHelperText: 'Уникальный идентификатор (латиница)',
      generateCode: 'Сгенерировать код',
      create: 'Создать',
      system: 'Системная',
      notFound: 'Ничего не найдено',
      noRoles: 'Нет ролей',
      viewUsers: 'Просмотреть пользователей',
      editTooltip: 'Редактировать',
      copyTooltip: 'Копировать',
      deleteTooltip: 'Удалить',
      editRoleLabel: 'Редактировать роль',
      copyRoleLabel: 'Копировать роль',
      deleteRoleLabel: 'Удалить роль',
      deleteTitle: 'Удалить роль?',
      deleteConfirmText: 'Вы уверены, что хотите удалить роль',
      deleteWarningText: 'У этой роли есть пользователи. Они потеряют права доступа.',
      usersWithRole: 'Пользователи с ролью',
      noUsersWithRole: 'Нет пользователей с этой ролью',
      roleUpdated: 'Роль успешно обновлена',
      roleCreated: 'Роль успешно создана',
      roleDeleted: 'Роль удалена',
      roleCloned: 'Роль скопирована',
      loadError: 'Не удалось загрузить роли',
      saveError: 'Ошибка сохранения',
      deleteError: 'Ошибка удаления',
      cloneError: 'Ошибка копирования',
      serverError: 'Ошибка сервера',
      // Role names (fallback)
      roleName_super_admin: 'Супер Админ',
      roleName_admin: 'Администратор',
      roleName_manager: 'Менеджер',
      roleName_operator: 'Оператор',
      roleName_warehouse: 'Кладовщик',
      roleName_qc_inspector: 'Инспектор ОТК',
      roleName_purchaser: 'Закупщик',
      roleName_analyst: 'Аналитик',
      roleName_viewer: 'Просмотр',
      // Role descriptions (fallback)
      roleDesc_super_admin: 'Полный доступ ко всем функциям',
      roleDesc_admin: 'Управление системой без системных настроек',
      roleDesc_manager: 'Работа с заказами и клиентами',
      roleDesc_operator: 'Обработка заказов',
      roleDesc_warehouse: 'Управление складом',
      roleDesc_qc_inspector: 'Контроль качества продукции',
      roleDesc_purchaser: 'Управление закупками',
      roleDesc_analyst: 'Доступ к отчётам и аналитике',
      roleDesc_viewer: 'Только просмотр данных',
    },

    // Analytics
    analytics: {
      title: 'Аналитика и отчёты',
      totalRevenue: 'Общая выручка',
      b2bRevenue: 'Выручка B2B',
      b2cRevenue: 'Выручка B2C',
      newCustomers: 'Новые клиенты',
      revenue: 'Выручка',
      orders: 'Заказы',
      customers: 'Клиенты',
      products: 'Товары',
      thisMonth: 'За этот месяц',
      lastMonth: 'За прошлый месяц',
      growthRate: 'Рост',
      topProducts: 'Топ товаров',
      recentOrders: 'Последние заказы',
      b2bVsB2c: 'B2B vs B2C производительность',
      b2bPerformance: 'B2B составляет 71% от общей выручки с более высоким средним чеком. B2C показывает стабильный рост привлечения клиентов.',
      topProductsDesc: 'Мебель для руководителей и офисные решения лидируют в продажах. Стоячие столы показывают рост на 25% в сегменте B2B.',
      overview: 'Обзор',
      qualityControl: 'Контроль качества',
      manufacturing: 'Производство',
      purchasesTab: 'Закупки',
      qcDataUnavailable: 'Данные QC недоступны',
      totalInspections: 'Всего проверок',
      passed: 'Пройдено',
      successful: 'успешно',
      failed: 'Не пройдено',
      activeHolds: 'Активные удержания',
      qualityScore: 'Показатель качества',
      targetScore: 'Целевой показатель',
      manufacturingDataUnavailable: 'Данные производства недоступны',
      totalOrders: 'Всего заказов',
      inProgress: 'В работе',
      today: 'сегодня',
      planned: 'Запланировано',
      forWeek: 'на неделю',
      completed: 'Завершено',
      demoProduct1: 'Тумба Модерн 60см',
      demoProduct2: 'Зеркало LED 80x60',
      demoProduct3: 'Унитаз WASSER Pro',
      demoProduct4: 'Смеситель Cascade',
      sales: 'продаж',
      purchasesComingSoon: 'Аналитика закупок будет доступна в следующем обновлении',
    },

    // Settings
    settings: {
      title: 'Настройки',
      customization: 'Кастомизация',
      customizationDesc: 'Модули, кастомные поля, права доступа и интеграции',
      general: 'Общие настройки',
      generalSettings: 'Общие настройки',
      systemSettings: 'Системные настройки',
      apiConfiguration: 'Конфигурация API',
      siteName: 'Название сайта',
      adminEmail: 'Email администратора',
      supportEmail: 'Email поддержки',
      saveChanges: 'Сохранить изменения',
      updateApiSettings: 'Обновить настройки API',
      enableB2b: 'Включить регистрацию B2B',
      emailNotifications: 'Email уведомления',
      maintenanceMode: 'Режим обслуживания',
      autoApproveB2b: 'Автоматическое одобрение заявок B2B',
      realtimeInventory: 'Обновления инвентаря в реальном времени',
      apiBaseUrl: 'Базовый URL API',
      stripeApiKey: 'Ключ API Stripe',
      profile: 'Профиль',
      security: 'Безопасность',
      notifications: 'Уведомления',
      language: 'Язык',
      theme: 'Тема',
      light: 'Светлая',
      dark: 'Тёмная',
      comingSoon: 'Скоро будет доступно',
    },
    inventory: {
      tabs: { warehouses: 'Склады', stock: 'Остатки', movements: 'Движения', history: 'История' },
      warehouses: {
        list: 'Список складов',
        empty: 'Складов пока нет',
        seed: 'Создать склад по умолчанию',
        create: 'Создать склад',
        all: 'Все склады',
      },
      stock: { title: 'Остатки', columns: { onHandReserved: 'На складе / Резерв', available: 'Доступно' } },
      movements: { title: 'Движение товара', submit: 'Провести', result: 'Результат' },
      history: {
        title: 'История движений',
        empty: 'История движений пуста',
        allTypes: 'Все типы',
        columns: {
          date: 'Дата',
          type: 'Тип',
          warehouse: 'Склад',
          qty: 'Кол.',
          product: 'Товар',
        },
      },
      movementType: {
        RECEIVE: 'Приход',
        ISSUE: 'Отпуск',
        TRANSFER: 'Перемещение',
        RESERVE: 'Резерв',
        RELEASE: 'Освобождение',
        ADJUST: 'Коррекция',
      },
      fields: {
        name: 'Название',
        code: 'Код',
        warehouse: 'Склад',
        warehouseTo: 'Склад назначения',
        productId: 'ID товара',
        qty: 'Количество',
        type: 'Тип операции',
        reason: 'Причина',
      },
      subtitle: 'Управление складами, остатками и движениями товаров',
      status: {
        draft: 'Черновик',
        inProgress: 'В процессе',
        completed: 'Завершено',
        cancelled: 'Отменено',
        active: 'Активна',
        completedFem: 'Завершена',
        cancelledFem: 'Отменена',
      },
      list: {
        title: 'Инвентаризация',
        subtitle: 'Управление складскими инвентаризациями',
        refresh: 'Обновить',
        create: 'Создать инвентаризацию',
        searchPlaceholder: 'Поиск по номеру...',
        authRequired: 'Требуется авторизация для доступа к инвентаризации',
        deleteError: 'Ошибка удаления: {{message}}',
        deleteDraftOnly: 'Можно удалять только черновики',
        confirmDelete: 'Удалить инвентаризацию {{number}}?',
        reportCompletedOnly: 'Отчет доступен только для завершенных инвентаризаций',
        colDocumentNumber: 'Номер документа',
        colStatus: 'Статус',
        colWarehouse: 'Склад',
        colResponsible: 'Ответственный',
        colStartDate: 'Дата начала',
        colEndDate: 'Дата завершения',
        colPositions: 'Позиций',
        colCounted: 'Подсчитано',
        colDiscrepancies: 'Расхождений',
        colActions: 'Действия',
        tooltipView: 'Просмотр',
        tooltipEdit: 'Редактировать',
        tooltipDownload: 'Скачать отчет',
        tooltipDelete: 'Удалить',
        filterStatus: 'Статус',
        filterWarehouse: 'Склад',
        allStatuses: 'Все статусы',
        allWarehouses: 'Все склады',
      },
      create: {
        title: 'Создание инвентаризации',
        subtitle: 'Создайте новую складскую инвентаризацию',
        back: 'Назад',
        errorCreate: 'Ошибка создания инвентаризации',
        selectWarehouse: 'Выберите склад',
        selectResponsible: 'Выберите ответственного',
        specifyStartDate: 'Укажите дату начала',
        warehouseLabel: 'Склад',
        responsibleLabel: 'Ответственный',
        startDateLabel: 'Дата начала',
        commentLabel: 'Комментарий',
        commentPlaceholder: 'Дополнительная информация об инвентаризации...',
        loading: 'Загрузка...',
        fillOptions: 'Опции заполнения',
        autoFill: 'Автозаполнить позициями по складу',
        includeZeroStock: 'Включить товары с нулевыми остатками',
        cancel: 'Отмена',
        filling: 'Заполнение позиций...',
        creating: 'Создание...',
        createDraft: 'Создать черновик',
      },
      detail: {
        back: 'Назад',
        title: 'Инвентаризация',
        notFound: 'Инвентаризация не найдена',
        confirmCancel: 'Вы уверены, что хотите отменить инвентаризацию?',
        start: 'Запустить',
        complete: 'Завершить',
        cancel: 'Отменить',
        report: 'Отчет',
        infoTitle: 'Информация об инвентаризации',
        warehouse: 'Склад',
        responsible: 'Ответственный',
        createdDate: 'Дата создания',
        startDate: 'Дата начала',
        endDate: 'Дата завершения',
        comment: 'Комментарий',
        statsTitle: 'Статистика',
        totalPositions: 'Общее количество позиций',
        checkedPositions: 'Проверено позиций',
        withDiscrepancies: 'С расхождениями',
        checkProgress: 'Прогресс проверки',
        itemsTitle: 'Позиции инвентаризации',
        addItem: 'Добавить позицию',
        product: 'Товар',
        sku: 'SKU',
        expected: 'Ожидается',
        actual: 'Фактически',
        discrepancy: 'Расхождение',
        commentCol: 'Комментарий',
        actionsCol: 'Действия',
        noItems: 'Позиции не найдены',
        commentPlaceholder: 'Комментарий',
        errorSaveEdit: 'Не удалось сохранить изменения',
        errorStart: 'Не удалось запустить инвентаризацию',
        errorComplete: 'Не удалось завершить инвентаризацию',
        errorCancel: 'Не удалось отменить инвентаризацию',
      },
      report: {
        title: 'Отчеты по инвентаризации',
        refresh: 'Обновить',
        noExportData: 'Нет данных для экспорта',
        downloadError: 'Ошибка при скачивании отчета',
        totalInventories: 'Всего инвентаризаций',
        withDiscrepancies: 'С расхождениями',
        totalPositions: 'Общее кол-во позиций',
        valueDifference: 'Разность по стоимости',
        filters: 'Фильтры',
        clear: 'Очистить',
        reportType: 'Тип отчета',
        typeSummary: 'Сводный',
        typeDetailed: 'Подробный',
        typeDiscrepancies: 'Только расхождения',
        warehouseLabel: 'Склад',
        statusLabel: 'Статус',
        responsibleLabel: 'Ответственный',
        dateFrom: 'Дата с',
        dateTo: 'Дата по',
        allWarehouses: 'Все склады',
        allStatuses: 'Все статусы',
        allUsers: 'Все пользователи',
        onlyDiscrepancies: 'Только с расхождениями',
        noData: 'Нет данных для отображения. Попробуйте изменить фильтры.',
        colId: 'ID',
        colWarehouse: 'Склад',
        colStatus: 'Статус',
        colResponsible: 'Ответственный',
        colCreatedDate: 'Дата создания',
        colEndDate: 'Дата завершения',
        colPositions: 'Позиций',
        colDiscrepancies: 'Расхождения',
        colValueDiff: 'Разность (KGS)',
        hasDiscrepancies: 'Есть',
        noDiscrepancies: 'Нет',
      },
      errorCreateWarehouse: 'Ошибка при создании склада',
      errorSeedDefault: 'Ошибка при создании склада по умолчанию',
      errorPostMovement: 'Ошибка при создании движения товара',
    },

    // Auth
    auth: {
      login: 'Вход',
      logout: 'Выход',
      email: 'Email адрес',
      emailAddress: 'Email адрес',
      password: 'Пароль',
      signIn: 'Войти',
      signingIn: 'Вход...',
      adminLogin: 'Вход в админ панель',
      adminPanel: 'Панель администратора мебельного магазина',
      demoCredentials: 'Демо данные:',
      loginFailed: 'Ошибка входа',
      invalidCredentials: 'Неверные данные',
      loginRequired: 'Для изменений требуется войти как администратор.',
    },

    // Order Detail
    orderDetail: {
      backToList: 'Назад к списку',
      order: 'Заказ',
      createdAt: 'Создан: ',
      orderActions: 'Действия заказа',
      print: 'Печать',
      downloading: 'Загрузка...',
      savePdf: 'Сохранить в PDF',
      orderInfo: 'Информация о заказе',
      status: 'Статус',
      orderStatus: 'Статус заказа',
      type: 'Тип',
      payment: 'Оплата',
      paymentMethod: 'Способ оплаты',
      orderHistory: 'История заказа',
      customer: 'Клиент',
      deliveryAddress: 'Адрес доставки',
      deliveryMap: 'Карта доставки',
      orderItems: 'Товары в заказе',
      subtotal: 'Подытог',
      tax: 'Налог',
      shipping: 'Доставка',
      total: 'Итого',
      product: 'Товар',
      qty: 'Кол-во',
      price: 'Цена',
      clickToCopy: 'Нажми — скопировать',
      copied: 'Скопировано',
      copyFailed: 'Не удалось скопировать. Зажми SKU — выделишь вручную.',
      orderNotFound: 'Заказ с ID {id} не найден в системе.',
      pdfError: 'Ошибка при создании PDF. Попробуйте позже.',
      creditCard: 'Кредитная карта',
      bankTransfer: 'Банковский перевод',
      cash: 'Наличные',
      paid: 'Оплачен',
      paidOnDelivery: 'Оплачен при получении',
      created: 'Создан',
      orderCreated: 'Заказ создан',
      orderProcessing: 'Заказ в обработке',
      orderShipped: 'Заказ отправлен',
      orderDelivered: 'Заказ доставлен',
      // Status actions (new)
      statusUpdated: 'Статус заказа обновлён',
      statusUpdateError: 'Ошибка обновления статуса',
      startProcessing: 'Начать обработку',
      markShipped: 'Отметить как отправлен',
      markDelivered: 'Отметить как доставлен',
      cancelOrder: 'Отменить заказ',
      cancelConfirmation: 'Вы уверены, что хотите отменить этот заказ?',
      cancelReason: 'Причина отмены',
      confirmCancel: 'Подтвердить отмену',
      noHistory: 'История заказа недоступна',
      // Internal notes
      internalNotes: 'Внутренние заметки',
      internalNotesHint: 'Заметки только для сотрудников, не видны клиенту',
      notesPlaceholder: 'Добавьте внутренние заметки к этому заказу...',
      notesSaved: 'Заметки сохранены',
      notesSaveError: 'Ошибка сохранения заметок',
    },

    // Categories
    categories: {
      title: 'Категории товаров',
      addCategory: 'Добавить категорию',
      editCategory: 'Редактировать категорию',
      newCategory: 'Новая категория',
      noCategories: 'Категории пока не созданы',
      createFirst: 'Создать первую категорию',
      nameRu: 'Название (RU)',
      nameEn: 'Название (EN)',
      slug: 'Slug (URL)',
      slugHelp: 'Латинские буквы, цифры и дефисы',
      parentCategory: 'Родительская категория',
      noParent: 'Нет (корневая)',
      sortOrder: 'Порядок сортировки',
      activeInCatalog: 'Активна (видна в каталоге)',
      hidden: 'Скрыта',
      deleteCategory: 'Удалить категорию?',
      confirmDelete: 'Вы уверены, что хотите удалить категорию "{name}"?',
      hasSubcategories: 'Эта категория содержит подкатегории. Они тоже будут удалены!',
      categoryUpdated: 'Категория обновлена',
      categoryCreated: 'Категория создана',
      categoryDeleted: 'Категория удалена',
      loadError: 'Ошибка загрузки категорий',
      saveError: 'Ошибка сохранения категории',
      deleteError: 'Ошибка удаления категории',
      statusError: 'Ошибка изменения статуса',
      nameRequired: 'Введите название категории',
      categoryHidden: 'Категория "{name}" скрыта',
      categoryActivated: 'Категория "{name}" активирована',
    },

    // Profile
    profile: {
      open: 'Открыть профиль',
      title: 'Профиль администратора',
      subtitle: 'Управление личной информацией и настройками аккаунта',
      uploadPhoto: 'Загрузить фото',
      chooseAvatar: 'Выбрать готовый аватар',
      administrator: 'Администратор',
      phone: 'Телефон',
      activity: 'Активность',
      lastLogin: 'Последний вход',
      ordersProcessed: 'Обработано заказов',
      productsAdded: 'Добавлено товаров',
      personalInfo: 'Личная информация',
      firstName: 'Имя',
      lastName: 'Фамилия',
      position: 'Должность',
      positionPlaceholder: 'Например: Главный администратор',
      security: 'Безопасность',
      changePassword: 'Изменить пароль',
      twoFactor: 'Двухфакторная аутентификация',
      extraProtection: 'Дополнительная защита аккаунта',
      notConfigured: 'Не настроено',
      activeSessions: 'Активные сессии',
      oneDevice: '1 устройство',
      view: 'Просмотр',
      notifications: 'Уведомления',
      emailNotifications: 'Email уведомления',
      receiveByEmail: 'Получать уведомления на почту',
      orderNotifications: 'Уведомления о заказах',
      orderNotificationsDesc: 'Новые заказы и изменения статусов',
      productNotifications: 'Уведомления о товарах',
      productNotificationsDesc: 'Низкие остатки и критические ситуации',
      systemUpdates: 'Системные обновления',
      systemUpdatesDesc: 'Новые функции и изменения системы',
      profileUpdated: 'Профиль успешно обновлен!',
      updateSuccess: 'Профиль успешно обновлен!',
      updateError: 'Ошибка при обновлении профиля',
      fileTooLarge: 'Размер файла не должен превышать 5MB',
      fileSizeError: 'Размер файла не должен превышать 5MB',
      roleAdmin: 'Администратор',
      todayTime: 'Сегодня, 10:30',
      twoFactorDesc: 'Дополнительная защита аккаунта',
      emailNotificationsDesc: 'Получать уведомления на почту',
      email: 'Email',
    },

    // Organizations
    orgs: {
      title: 'Организации',
      subtitle: 'Управление компаниями-арендаторами платформы',
      createOrg: 'Создать организацию',
      searchPlaceholder: 'Поиск по названию, домену...',
      plan: 'Тариф',
      planFree: 'Бесплатный',
      planStarter: 'Стартовый',
      planBusiness: 'Бизнес',
      planEnterprise: 'Корпоративный',
      all: 'Все',
      active: 'Активный',
      trial: 'Триал',
      cancelled: 'Отменён',
      disabled: 'Отключен',
      refreshList: 'Обновить список',
      organization: 'Организация',
      domain: 'Домен',
      users: 'Польз.',
      products: 'Товары',
      orders: 'Заказы',
      notFound: 'Организации не найдены',
      viewOrg: 'Просмотр организации',
      editOrg: 'Редактировать организацию',
      deactivate: 'Деактивировать',
      deactivateOrg: 'Деактивировать организацию',
      activate: 'Активировать',
      activateOrg: 'Активировать организацию',
      perPage: 'На странице:',
      accessDenied: 'Доступ запрещён. Только для Super Admin.',
      confirmDeactivate: 'Деактивировать организацию "{name}"? Пользователи потеряют доступ.',
      confirmActivate: 'Активировать организацию "{name}"?',
      loadError: 'Ошибка загрузки: ',
      unknownError: 'Неизвестная ошибка',
      retry: 'Повторить',
      // Detail
      orgNotFound: 'Организация не найдена',
      backToList: 'К списку',
      back: 'Назад',
      disabledBadge: 'ОТКЛЮЧЕНО',
      deactivateQuestion: 'Деактивировать организацию?',
      deactivateWarning: 'Все пользователи организации "{name}" потеряют доступ.',
      deactivating: 'Деактивация...',
      activating: 'Активация...',
      openAdminPanel: 'Открыть админку организации',
      orgCreated: 'Организация успешно создана!',
      tabGeneral: 'Основное',
      tabLimits: 'Лимиты',
      tabBranding: 'Брендинг',
      tabStats: 'Статистика',
      info: 'Информация',
      name: 'Название',
      description: 'Описание',
      subdomain: 'Субдомен',
      customDomain: 'Кастомный домен',
      verified: 'Подтверждён',
      owner: 'Владелец',
      createdDate: 'Создано',
      updatedDate: 'Обновлено',
      planTitle: 'Тарифный план',
      currentPlan: 'Текущий план',
      subscriptionStatus: 'Статус подписки',
      maxUsers: 'Макс. пользователей',
      maxProducts: 'Макс. товаров',
      maxOrders: 'Макс. заказов',
      userLimit: 'Лимит пользователей',
      productLimit: 'Лимит товаров',
      orderLimit: 'Лимит заказов',
      branding: 'Брендинг',
      logoUrl: 'URL логотипа',
      primaryColor: 'Основной цвет',
      secondaryColor: 'Дополнительный цвет',
      logo: 'Логотип',
      notSet: 'Не установлен',
      usersCount: 'Пользователей',
      productsCount: 'Товаров',
      ordersCount: 'Заказов',
      activeStatus: 'Активна',
      disabledStatus: 'Отключена',
      // Create
      createTitle: 'Создание организации',
      orgData: 'Данные организации',
      companyName: 'Название компании',
      subdomainHelp: 'Только латиница, цифры и дефис',
      ownerAdmin: 'Владелец (Admin)',
      ownerEmail: 'Email владельца',
      password: 'Пароль',
      minChars: 'Минимум 8 символов',
      required: 'Обязательное поле',
      requiredField: 'Обязательное поле',
      creating: 'Создание...',
      limits: 'Лимиты',
      deactivateConfirm: 'Деактивировать организацию',
      reactivateConfirm: 'Активировать организацию',
      statusActive: 'Активный',
      statusTrial: 'Триал',
      statusCancelled: 'Отменён',
      usersShort: 'Польз.',
      tariffPlan: 'Тарифный план',
      subdomainValidation: 'Только латиница, цифры и дефис',
      toList: 'К списку',
      openAdmin: 'Открыть админку организации',
      createSuccess: 'Организация успешно создана!',
      tabBasic: 'Основное',
      information: 'Информация',
      created: 'Создано',
      updated: 'Обновлено',
      deactivated: 'Отключена',
      deactivateTitle: 'Деактивировать организацию?',
    },

    // Notifications
    notif: {
      title: 'Уведомления',
      subtitle: 'Управление уведомлениями системы',
      readAll: 'Прочитать все',
      type: 'Тип',
      all: 'Все',
      info: 'Информация',
      ordersType: 'Заказы',
      warehouse: 'Склад',
      payments: 'Платежи',
      delivery: 'Доставка',
      production: 'Производство',
      warnings: 'Предупреждения',
      errors: 'Ошибки',
      successType: 'Успех',
      statusFilter: 'Статус',
      unread: 'Непрочитанные',
      read: 'Прочитанные',
      loadError: 'Ошибка загрузки уведомлений: ',
      heading: 'Заголовок',
      message: 'Сообщение',
      date: 'Дата',
      noNotifications: 'Нет уведомлений',
      readStatus: 'Прочитано',
      newStatus: 'Новое',
      markRead: 'Отметить как прочитанное',
      deleteNotif: 'Удалить уведомление',
      rowsPerPage: 'Строк на странице:',
      markAllRead: 'Прочитать все',
      typeInfo: 'Информация',
      typeOrders: 'Заказы',
      typeInventory: 'Склад',
      typePayments: 'Платежи',
      typeShipping: 'Доставка',
      typeManufacturing: 'Производство',
      typeWarnings: 'Предупреждения',
      typeErrors: 'Ошибки',
      typeSuccess: 'Успех',
      empty: 'Нет уведомлений',
      statusRead: 'Прочитано',
      statusNew: 'Новое',
      allNotifications: 'Все уведомления',
      minutesAgo: '{{m}} мин. назад',
      hoursAgo: '{{h}} ч. назад',
      daysAgo: '{{d}} дн. назад',
      errorMarkRead: 'Не удалось отметить как прочитанное',
      errorMarkAllRead: 'Не удалось отметить все как прочитанные',
      errorDelete: 'Не удалось удалить уведомление',
    },

    // Serials
    serials: {
      title: 'Серийные номера',
      addSerial: 'Добавить',
      filtersSearch: 'Фильтры и поиск',
      searchBySerial: 'Поиск по серийному номеру',
      reset: 'Сбросить',
      addSerialTitle: 'Добавить серийный номер',
      editSerialTitle: 'Редактировать серийный номер',
      serialNumber: 'Серийный номер',
      product: 'Товар',
      warehouse: 'Склад',
      receivedDate: 'Дата поступления',
      soldDate: 'Дата продажи',
      notes: 'Примечания',
      generate: 'Сгенерировать',
      productRequired: 'Товар *',
      serialRequired: 'Серийный номер *',
      inStock: 'В наличии',
      reserved: 'Зарезервирован',
      sold: 'Продан',
      returned: 'Возврат',
      defective: 'Брак',
      loadError: 'Не удалось загрузить серийные номера',
      loadErrorShort: 'Ошибка загрузки',
      notFound: 'Серийный номер не найден',
      fillRequired: 'Заполните обязательные поля',
      createError: 'Ошибка создания серийного номера',
      updateError: 'Ошибка обновления серийного номера',
      confirmDelete: 'Вы уверены, что хотите удалить этот серийный номер?',
      deleteError: 'Не удалось удалить серийный номер',
      purchaseDate: 'Дата поступления',
      saleDate: 'Дата продажи',
      filtersAndSearch: 'Фильтры и поиск',
      searchLabel: 'Поиск по серийному номеру',
      addTitle: 'Добавить серийный номер',
      editTitle: 'Редактировать серийный номер',
      requiredFields: 'Заполните обязательные поля',
      deleteConfirm: 'Вы уверены, что хотите удалить этот серийный номер?',
    },

    // Manufacturing
    manufacturing: {
      // Dashboard
      title: 'Производство',
      subtitle: 'Управление производственными заказами и спецификациями',
      refreshData: 'Обновить данные',
      bom: 'Спецификации',
      totalOrders: 'Всего заказов',
      allTime: 'За всё время',
      todaySuffix: 'сегодня',
      planned: 'Запланировано',
      forWeek: 'на неделю',
      successfullyDone: 'Успешно выполнено',
      activeOrders: 'Активные заказы',
      noActiveOrders: 'Нет активных заказов',
      createOrder: 'Создать заказ',
      orderNum: 'Заказ #{{id}}',
      pcs: 'шт.',
      quickActions: 'Быстрые действия',
      newBOM: 'Новая BOM',
      materials: 'Материалы',
      analytics: 'Аналитика',
      recentOrders: 'Недавние заказы',
      noOrders: 'Нет заказов',
      loadError: 'Не удалось загрузить данные производства',
      status_draft: 'Черновик',
      status_planned: 'Запланирован',
      status_in_progress: 'В работе',
      status_completed: 'Завершен',
      status_cancelled: 'Отменен',

      // Statuses
      statusDraft: 'Черновик',
      statusActive: 'Активная',
      statusArchived: 'В архиве',
      statusPlanned: 'Запланирован',
      statusInProgress: 'В работе',
      statusCompleted: 'Завершен',
      statusCancelled: 'Отменен',

      // Errors
      errorLoadBomList: 'Не удалось загрузить спецификации',
      errorLoadBom: 'Не удалось загрузить спецификацию',
      errorCannotDeleteActive: 'Нельзя удалить активную спецификацию. Сначала архивируйте её.',
      errorCannotDeleteUsed: 'Нельзя удалить — спецификация используется в производственных заказах.',
      errorBomNotFound: 'Спецификация не найдена',
      errorDeleteBom: 'Не удалось удалить спецификацию',
      errorActivateBom: 'Не удалось активировать спецификацию',
      errorArchiveBom: 'Не удалось архивировать спецификацию',
      errorCloneBom: 'Не удалось клонировать спецификацию',
      errorSelectProduct: 'Выберите производимый продукт',
      errorEnterBomName: 'Введите название спецификации',
      errorSaveBom: 'Не удалось сохранить спецификацию',
      errorLoadOrders: 'Ошибка загрузки заказов',
      errorStartProduction: 'Ошибка запуска производства',
      errorCompleteProduction: 'Ошибка завершения производства',
      errorCancelProduction: 'Ошибка отмены производства',
      errorLoadDictionaries: 'Не удалось загрузить справочники',
      errorSelectWarehouse: 'Выберите склад',
      errorAddItem: 'Добавьте хотя бы одну позицию с продуктом и количеством',
      errorCreateOrder: 'Не удалось создать заказ',
      errorLoadExplosion: 'Не удалось загрузить разузлование',
      errorLoadCosting: 'Не удалось загрузить калькуляцию',

      // BOM List
      bomListTitle: 'Спецификации (BOM)',
      newBom: 'Новая BOM',
      searchPlaceholder: 'Поиск по названию или продукту...',
      refreshList: 'Обновить список',
      bomName: 'Название BOM',
      product: 'Продукт',
      version: 'Версия',
      components: 'Компоненты',
      costPrice: 'Себестоимость',
      bomsNotFound: 'Спецификации не найдены',
      viewBom: 'Просмотр спецификации',
      costCalculation: 'Калькуляция себестоимости',
      moreActions: 'Ещё действия',
      clone: 'Клонировать',
      explosion: 'Разузлование',
      activate: 'Активировать',
      archive: 'Архивировать',
      archiveFirst: 'Сначала архивируйте',
      deleteBomTitle: 'Удалить спецификацию',
      deleteBomConfirm: 'Вы уверены? Это действие необратимо.',
      deleteBomWarning: 'Спецификация и все связанные данные будут удалены.',

      // BOM Create / Edit
      backToBomList: 'К списку BOM',
      editBom: 'Редактирование BOM',
      newBomTitle: 'Новая спецификация (BOM)',
      importFromExcel: 'Импорт из Excel',
      basicInfo: 'Основная информация',
      producedProduct: 'Производимый продукт',
      outputQuantity: 'Количество выхода',
      unitOfMeasure: 'Единица измерения',
      description: 'Описание',
      materialsAndComponents: 'Материалы и компоненты',
      addComponent: 'Добавить компонент',
      type: 'Тип',
      component: 'Компонент',
      quantity: 'Количество',
      unitPrice: 'Цена за ед.',
      sum: 'Сумма',
      noComponentsHint: 'Добавьте компоненты для расчёта себестоимости',
      material: 'Материал',
      productSemifinished: 'Продукт/Полуфабрикат',
      editMaterial: 'Редактировать материал',
      deleteMaterial: 'Удалить материал',
      productionOperations: 'Производственные операции',
      addOperation: 'Добавить операцию',
      operation: 'Операция',
      workCenter: 'Рабочий центр',
      timeMin: 'Время, мин',
      ratePerHour: 'Ставка/час',
      cost: 'Стоимость',
      noOperationsHint: 'Добавьте операции для полного расчёта себестоимости',
      editOperation: 'Редактировать операцию',
      deleteOperation: 'Удалить операцию',
      costSummary: 'Итого себестоимость',
      materialsLabel: 'Материалы',
      laborCosts: 'Трудозатраты',
      perUnit: 'За единицу',
      information: 'Информация',
      output: 'Выход',
      editComponent: 'Редактировать компонент',
      addComponentTitle: 'Добавить компонент',
      componentType: 'Тип компонента',
      unitShort: 'Ед.',
      wastePercent: 'Процент отходов',
      note: 'Примечание',
      editOperationTitle: 'Редактировать операцию',
      addOperationTitle: 'Добавить операцию',
      operationName: 'Название операции',
      laborTimeMin: 'Время труда, мин',
      machineTimeMin: 'Время машины, мин',
      setupTimeMin: 'Время наладки, мин',
      laborRate: 'Ставка труда',
      overheadRate: 'Накладные расходы/час',

      // BOM Detail
      bomNotFound: 'Спецификация не найдена',
      backToList: 'К списку',
      editBomAria: 'Редактировать BOM',
      cloneBomAria: 'Клонировать BOM',
      activateBomAria: 'Активировать BOM',
      archiveBomAria: 'Архивировать BOM',
      createOrder: 'Создать заказ',
      componentsAndMaterials: 'Компоненты и материалы',
      nameLabel: 'Название',
      price: 'Цена',
      noComponents: 'Нет компонентов',
      operations: 'Операции',
      level: 'Уровень',
      path: 'Путь',
      multilevelExplosion: 'Многоуровневое разузлование',
      levels: 'уровней',
      clickRefreshExplosion: 'Нажмите «Обновить» для загрузки',
      aggregatedComponents: 'Агрегированные компоненты',
      totalQuantity: 'Общее кол-во',
      costingTitle: 'Калькуляция себестоимости',
      overheadCosts: 'Накладные расходы',
      totalCost: 'Общая себестоимость',
      suggestedPrices: 'Рекомендуемые цены',
      margin: 'Маржа',
      breakdownByComponents: 'Разбивка по компонентам',
      share: 'Доля',
      loadCosting: 'Загрузить калькуляцию',
      created: 'Создано',
      updated: 'Обновлено',
      createManufacturingOrder: 'Создать производственный заказ',
      createOrderFromBom: 'Создать заказ на основе этой спецификации',
      warehouse: 'Склад',
      creating: 'Создание...',
      costing: 'Калькуляция',

      // Excel Import
      excelStepUpload: 'Загрузка файла',
      excelStepMapping: 'Сопоставление',
      excelStepConfirm: 'Подтверждение',
      excelErrorNoNameCol: 'В файле нет колонки с названием материала',
      excelErrorNoQtyCol: 'В файле нет колонки с количеством',
      excelErrorNoMaterials: 'Не найдено материалов в файле',
      excelErrorRead: 'Не удалось прочитать файл',
      excelErrorSelectProduct: 'Выберите продукт для BOM',
      excelErrorImport: 'Ошибка импорта',
      excelImportTitle: 'Импорт BOM из Excel',
      excelDragDrop: 'Перетащите Excel-файл сюда или нажмите для выбора',
      excelSupportedFormats: 'Поддерживаемые форматы: .xlsx, .xls',
      excelRequiredColumns: 'Обязательные колонки: название материала, количество',
      excelFound: 'Найдено',
      excelNotFound: 'Не найдено',
      excelCreateMissing: 'Создать недостающие материалы',
      excelFromFile: 'Из файла',
      excelMaterialInDb: 'Материал в БД',
      excelSelectMaterial: 'Выберите материал',
      excelMaterialFound: 'Найден в базе',
      excelWillCreate: 'Будет создан',
      excelMaterialNotFound: 'Не найден',
      excelCheckBeforeImport: 'Проверьте данные перед импортом',
      excelSelectProductForBom: 'Выберите продукт для BOM',
      excelSummary: 'Сводка',
      excelFile: 'Файл',
      excelTotalItems: 'Всего позиций',
      excelFoundInDb: 'Найдено в базе',
      excelWillBeCreated: 'Будет создано',
      excelEstimatedCost: 'Оценочная стоимость',
      excelImportBtn: 'Импортировать',

      // Manufacturing Orders
      ordersTitle: 'Производственные заказы',
      ordersSubtitle: 'Управление производственными заказами',
      orderNumber: '№ заказа',
      plan: 'План',
      progress: 'Прогресс',
      startDate: 'Начало',
      endDate: 'Конец',
      refreshOrderList: 'Обновить список заказов',
      newOrder: 'Новый заказ',
      searchOrderPlaceholder: 'Поиск по номеру заказа...',
      allStatuses: 'Все статусы',
      resetFilters: 'Сбросить фильтры',
      manageColumns: 'Управление столбцами',
      nothingFound: 'Ничего не найдено',
      noOrders: 'Производственных заказов пока нет',
      viewOrder: 'Просмотр заказа',
      cancelOrderTitle: 'Отменить заказ',
      cancelOrderConfirm: 'Вы уверены, что хотите отменить этот заказ?',
      cancelReason: 'Причина отмены',
      cancelOrderBtn: 'Отменить заказ',
      columnManagementTitle: 'Управление столбцами',
      productionStarted: 'Производство запущено',
      productionCompleted: 'Производство завершено',
      productionCancelled: 'Производство отменено',
      start: 'Запустить',
      complete: 'Завершить',

      // Manufacturing Order Create
      newManufacturingOrder: 'Новый производственный заказ',
      newOrderSubtitle: 'Заполните основные данные и позиции для запуска производства',
      basicData: 'Основные данные',
      selectWarehouse: 'Выберите склад',
      statusOnCreate: 'Статус при создании',
      orderItems: 'Позиции заказа',
      addItem: 'Добавить позицию',
      productId: 'ID продукта',
      productIdHelper: 'Найдите ID в списке продуктов или вставьте вручную',
      deleteItem: 'Удалить позицию',
      totals: 'Итоги',
      positions: 'Позиций',
      totalQuantity: 'Общее количество',
      estimatedCost: 'Оценочная стоимость',
      costHint: 'Стоимость не обязательна, но помогает в аналитике себестоимости.',
      orderCreated: 'Производственный заказ создан',
      productHints: 'Подсказки по продуктам',
      loadingProducts: 'Загружаем список продуктов...',
      noProducts: 'Нет доступных продуктов. Создайте их в разделе «Каталог».',
      goToCatalog: 'Перейти в каталог продуктов',
      openCatalog: 'Открыть каталог',
      consumptionCoefficient: 'Коэффициент расхода: {{value}}',
    },

    // Batches
    batches: {
      backToList: 'К списку',
      createNewBatch: 'Создать новую партию',
      createdSuccessfully: 'Партия успешно создана! Перенаправление...',
      batchInfo: 'Информация о партии',
      product: 'Продукт *',
      selectProductHelper: 'Выберите продукт для этой партии',
      variantOptional: 'Вариант (необязательно)',
      selectVariantHelper: 'Выберите вариант, если партия для конкретного варианта',
      warehouse: 'Склад *',
      selectWarehouseHelper: 'Выберите склад для хранения этой партии',
      batchNumber: 'Номер партии *',
      batchNumberHelper: 'Уникальный идентификатор партии',
      generate: 'Сгенерировать',
      manufactureDate: 'Дата производства',
      manufactureDateHelper: 'Когда была произведена эта партия?',
      expiryDate: 'Срок годности',
      expiryDateHelper: 'Когда истекает срок годности этой партии?',
      supplier: 'Поставщик',
      supplierHelper: 'Название поставщика или производителя',
      costPrice: 'Себестоимость (KGS)',
      costPriceHelper: 'Цена за единицу в KGS',
      quantity: 'Количество *',
      quantityHelper: 'Начальное количество для этой партии',
      creating: 'Создание...',
      createBatch: 'Создать партию',
      help: 'Помощь',
      batchNumberLabel: 'Номер партии',
      expiryDateLabel: 'Срок годности',
      costPriceLabel: 'Себестоимость',
      quantityLabel: 'Количество',
      helpBatchNumber: 'Уникальный идентификатор партии. Используйте кнопку «Сгенерировать» для автоматического создания.',
      helpExpiryDate: 'Важно для отслеживания FIFO/FEFO. Система приоритизирует отгрузки из партий с более ранним сроком годности.',
      helpCostPrice: 'Используется для расчёта себестоимости (COGS) и маржи прибыли.',
      helpQuantity: 'Начальное количество товара в партии. Будет добавлено к складским остаткам.',
      fillRequiredFields: 'Пожалуйста, заполните все обязательные поля',
      errorCreateBatch: 'Не удалось создать партию',
      errorLoadProducts: 'Не удалось загрузить список продуктов',
      errorLoadWarehouses: 'Не удалось загрузить список складов',
      errorLoadVariants: 'Не удалось загрузить варианты продукта',
      // BatchList
      title: 'Партии товаров',
      refresh: 'Обновить',
      filters: 'Фильтры',
      productId: 'ID продукта',
      warehouseId: 'ID склада',
      expiringSoon: 'Скоро истекает',
      all: 'Все',
      within7days: 'В течение 7 дней',
      within30days: 'В течение 30 дней',
      within60days: 'В течение 60 дней',
      within90days: 'В течение 90 дней',
      clearFilters: 'Сбросить фильтры',
      expiresInDays: 'Истекает через {{days}} дней',
      columnProduct: 'Продукт',
      columnWarehouse: 'Склад',
      reserved: 'зарезервировано',
      daysLeft: 'дней осталось',
      columnCreated: 'Создано',
      columnActions: 'Действия',
      viewBatch: 'Просмотр',
      viewBatchAria: 'Просмотреть партию',
      editBatch: 'Редактировать',
      editBatchAria: 'Редактировать партию',
      deleteBatch: 'Удалить',
      deleteBatchAria: 'Удалить партию',
      confirmDelete: 'Вы уверены, что хотите удалить эту партию?',
      errorDeleteBatch: 'Не удалось удалить партию',
      errorFetchBatches: 'Не удалось загрузить партии',
      detail: {
        title: 'Партия',
        backToList: 'Назад к списку',
        fetchError: 'Не удалось загрузить партию',
        updateError: 'Не удалось обновить партию',
        deleteConfirm: 'Вы уверены, что хотите удалить эту партию? Это действие нельзя отменить.',
        deleteError: 'Не удалось удалить партию',
        notFound: 'Партия не найдена',
        expiringSoon: 'Срок годности истекает! Осталось {{days}} дней.',
        batchInfo: 'Информация о партии',
        batchNumber: 'Номер партии',
        supplier: 'Поставщик',
        manufactureDate: 'Дата производства',
        expiryDate: 'Срок годности',
        costPrice: 'Себестоимость',
        costPriceKGS: 'Себестоимость (KGS)',
        quantity: 'Количество',
        reserved: 'Зарезервировано',
        available: 'Доступно',
        created: 'Создано',
        daysLeft: 'дней осталось',
        productStock: 'Товар и остатки',
        product: 'Товар',
        variant: 'Вариант',
        warehouse: 'Склад',
        movementHistory: 'История движений',
        noMovements: 'Нет записей о движениях',
        date: 'Дата',
        type: 'Тип',
        from: 'Откуда',
        to: 'Куда',
        reference: 'Ссылка',
        notes: 'Примечания',
      },
    },

    // Materials Database
    materials: {
      title: 'База материалов',
      subtitle: 'Управление сырьём, комплектующими и расходными материалами',
      currency: 'сом',
      // Categories
      categories: {
        ldsp: 'ЛДСП/Плиты',
        edge: 'Кромка',
        handles: 'Ручки',
        hinges: 'Петли',
        slides: 'Направляющие',
        fasteners: 'Крепёж',
        adhesives: 'Клеи',
        glass: 'Стекло',
        countertops: 'Столешницы',
        profiles: 'Профили',
        lighting: 'Освещение',
        packaging: 'Упаковка',
        other: 'Прочее',
      },
      // Units
      units: {
        pcs: 'Штуки (шт)',
        m: 'Метры (м)',
        m2: 'Квадратные метры (м²)',
        m3: 'Кубические метры (м³)',
        kg: 'Килограммы (кг)',
        l: 'Литры (л)',
        pack: 'Упаковки (уп)',
      },
      // Form
      materialName: 'Наименование',
      skuLabel: 'Артикул (SKU)',
      categoryLabel: 'Категория',
      allCategories: 'Все категории',
      unitOfMeasure: 'Единица измерения',
      unit: 'Единица',
      description: 'Описание',
      basicInfo: 'Основная информация',
      priceAndStock: 'Цена и запасы',
      costPrice: 'Себестоимость',
      minStock: 'Мин. запас',
      maxStock: 'Макс. запас',
      reorderPoint: 'Точка заказа',
      supplier: 'Поставщик',
      supplierName: 'Наименование поставщика',
      leadTimeDays: 'Срок поставки (дней)',
      notes: 'Примечания',
      requiredField: 'Обязательное поле',
      selectCategory: 'Выберите категорию',
      priceCannotBeNegative: 'Цена не может быть отрицательной',
      newMaterial: 'Новый материал',
      editMaterial: 'Редактировать материал',
      deleteMaterial: 'Удалить материал',
      // Price
      price: 'Цена',
      updatePrice: 'Обновить цену',
      updatePrices: 'Обновить цены',
      currentPrice: 'Текущая цена',
      newPrice: 'Новая цена',
      oldPrice: 'Старая цена',
      minPrice: 'Мин. цена',
      maxPrice: 'Макс. цена',
      change: 'Изменение',
      changesCount: 'Изменений',
      changeReason: 'Причина изменения',
      changeReasonPlaceholder: 'Укажите причину изменения цены...',
      was: 'Было',
      reason: 'Причина',
      user: 'Пользователь',
      system: 'Система',
      date: 'Дата',
      // History
      priceHistory: 'История цен',
      closePriceHistory: 'Закрыть историю цен',
      noPriceHistory: 'История изменений цен отсутствует',
      chart: 'График',
      table: 'Таблица',
      // Stock
      stockMovement: 'Движение остатков',
      noStockHistory: 'История движений отсутствует',
      received: 'Оприходовано',
      writtenOffProduction: 'Списано на производство',
      currentStock: 'Текущий остаток',
      receipt: 'Приход',
      consumption: 'Расход',
      balance: 'Остаток',
      receiptConsumptionByDay: 'Приход / Расход по дням',
      stockDynamics: 'Динамика остатков',
      // Stats
      totalMaterials: 'Всего материалов',
      categoriesCount: 'Категорий',
      totalValue: 'Общая стоимость',
      inStock: 'На складе',
      inStockShort: 'В наличии',
      lowStock: 'Низкий запас',
      needsOrdering: 'Требуют заказа',
      avgPrice: 'Средняя цена',
      perUnit: 'За единицу',
      materialsNeedRestock: 'материалов требуют пополнения запасов',
      needed: 'Нужно',
      min: 'Мин',
      show: 'Показать',
      hide: 'Скрыть',
      noMaterials: 'Материалы не найдены',
      searchPlaceholder: 'Поиск по названию или артикулу...',
      select: 'Выбрать',
      selectAll: 'Выбрать все',
      // CRUD messages
      materialCreated: 'Материал создан',
      materialUpdated: 'Материал обновлён',
      materialDeleted: 'Материал удалён',
      priceUpdated: 'Цена обновлена',
      // Delete
      deleteConfirmTitle: 'Подтверждение удаления',
      deleteConfirmText: 'Вы уверены, что хотите удалить материал',
      irreversibleAction: 'Это действие необратимо.',
      // Bulk
      bulkDelete: 'Массовое удаление',
      bulkDeleteConfirm: 'Вы уверены, что хотите удалить',
      bulkDeleteWarning: 'Это действие необратимо. Все выбранные материалы будут удалены.',
      materialsWord: 'материалов',
      bulkPriceUpdate: 'Массовое обновление цен',
      willApplyTo: 'Будет применено к',
      selectedMaterials: 'выбранным материалам',
      selectCategoryToFilter: 'Выберите категорию для фильтрации материалов',
      selectMaterialsOrCategory: 'Выберите материалы или укажите категорию',
      specifyChangeValue: 'Укажите значение изменения',
      updateType: 'Тип обновления',
      percentage: 'Процент (%)',
      fixedAmount: 'Фиксированная сумма (сом)',
      percentChange: 'Процент изменения',
      amountChange: 'Сумма изменения',
      priceChangeHelper: 'Положительное число увеличит цену, отрицательное — уменьшит',
      categoryOptional: 'Категория (опционально)',
      priceExample: 'Пример: материал стоимостью 100 сом станет',
      // Import/Export
      importJson: 'Импорт JSON',
      importExcel: 'Импорт Excel',
      importMaterials: 'Импорт материалов',
      importBtn: 'Импортировать',
      importCount: 'Импортировать',
      jsonData: 'JSON данные',
      jsonImportHint: 'Вставьте JSON с массивом материалов. Поля: name, sku, category, unit, cost_price',
      jsonMustContainArray: 'JSON должен содержать массив материалов',
      invalidJson: 'Некорректный JSON формат',
      jsonParseError: 'Ошибка парсинга JSON',
      foundMaterials: 'Найдено материалов',
      examples: 'Примеры',
      exported: 'Экспортировано',
      imported: 'Импортировано',
      created: 'создано',
      updated: 'обновлено',
      skipped: 'пропущено',
      // Excel
      excelImport: 'Импорт из Excel',
      excelImportComplete: 'Excel импорт завершён',
      excelStepUpload: 'Загрузка файла',
      excelStepPreview: 'Просмотр данных',
      excelStepDuplicates: 'Обработка дубликатов',
      excelDragDrop: 'Перетащите Excel файл сюда',
      excelClickToSelect: 'или нажмите для выбора файла',
      excelSupportedFormats: 'Поддерживаемые форматы: .xlsx, .xls',
      excelReadError: 'Ошибка чтения файла. Убедитесь, что это корректный Excel файл.',
      excelOnlyXlsx: 'Поддерживаются только файлы .xlsx и .xls',
      selected: 'Выбрано',
      showing50of: 'Показано 50 из',
      duplicate: 'Дубликат',
      new: 'Новый',
      foundDuplicates: 'Найдено материалов, которые уже существуют в базе',
      chooseDuplicateAction: 'Выберите действие для дубликатов',
      updateExisting: 'Обновить существующие',
      updateExistingDesc: 'Остаток и себестоимость будут обновлены из файла',
      skipDuplicates: 'Пропустить дубликаты',
      skipDuplicatesDesc: 'Будут импортированы только новые материалы',
      duplicatesLabel: 'Дубликаты',
      andMore: 'и ещё',
      startOver: 'Начать заново',
      currencyShort: 'с',
      bulkDeleted: 'Удалено: {{count}}',
      bulkPriceUpdated: 'Обновлено: {{count}} материалов',
    },

    // Finance
    finance: {
      payments: 'Платежи',
      newPayment: 'Новый платёж',
      editPaymentTitle: 'Редактировать платёж',
      editPayment: 'Редактировать платёж',
      cancelPayment: 'Отменить платёж',
      confirmCancelPayment: 'Вы уверены, что хотите отменить этот платёж?',
      fetchPaymentsError: 'Не удалось загрузить платежи',
      savePaymentError: 'Не удалось сохранить платёж',
      cancelPaymentError: 'Не удалось отменить платёж',
      fetchAccountsError: 'Не удалось загрузить счета',
      saveAccountError: 'Не удалось сохранить счёт',
      deleteAccountError: 'Не удалось удалить счёт',
      fetchDashboardError: 'Не удалось загрузить финансовые данные',
      specifyAmount: 'Укажите сумму',
      number: 'Номер',
      date: 'Дата',
      type: 'Тип',
      incoming: 'Приход',
      outgoing: 'Расход',
      amount: 'Сумма',
      counterparty: 'Контрагент',
      category: 'Категория',
      method: 'Способ оплаты',
      status: 'Статус',
      statusCompleted: 'Завершён',
      statusPending: 'Ожидание',
      statusCancelled: 'Отменён',
      statusRefunded: 'Возврат',
      paymentType: 'Тип платежа',
      incomingReceipt: 'Приход (поступление)',
      outgoingExpense: 'Расход (оплата)',
      paymentDate: 'Дата платежа',
      paymentMethod: 'Способ оплаты',
      accountCash: 'Счёт / Касса',
      notSelected: 'Не выбрано',
      description: 'Описание',
      documentNumber: 'Номер документа',
      methodCash: 'Наличные',
      methodBankTransfer: 'Банковский перевод',
      methodCard: 'Карта',
      methodMobileWallet: 'Мобильный кошелёк',
      methodOther: 'Другое',
      // Accounts
      accounts: 'Счета',
      totalBalance: 'Общий баланс',
      addAccount: 'Добавить счёт',
      newAccount: 'Новый счёт',
      editAccountTitle: 'Редактировать счёт',
      editAccount: 'Редактировать счёт',
      deleteAccount: 'Удалить счёт',
      confirmDeleteAccount: 'Вы уверены, что хотите удалить этот счёт?',
      specifyAccountName: 'Укажите название счёта',
      noAccounts: 'Счета не найдены. Создайте первый счёт.',
      default: 'Основной',
      accountName: 'Название счёта',
      accountType: 'Тип счёта',
      currency: 'Валюта',
      currencyKGS: 'КГС (сом)',
      currencyUSD: 'USD (доллар)',
      currencyRUB: 'RUB (рубль)',
      currencyEUR: 'EUR (евро)',
      bankName: 'Название банка',
      accountNumber: 'Номер счёта',
      walletNumber: 'Номер кошелька',
      defaultAccount: 'Счёт по умолчанию',
      typeCash: 'Касса',
      typeBank: 'Банковский счёт',
      typeMobileWallet: 'Мобильный кошелёк',
      typeCard: 'Карта',
      // Dashboard
      title: 'Финансы',
      monthlyIncome: 'Месячный доход',
      sinceMonthStart: 'С начала месяца',
      monthlyExpenses: 'Месячные расходы',
      profit: 'Прибыль',
      monthlyProfit: 'Месячная прибыль',
      allAccounts: 'Все счета',
      quickActions: 'Быстрые действия',
      managePayments: 'Управление платежами',
      cashOrders: 'Кассовые ордера',
      cashOrdersDesc: 'ПКО и РКО',
      transfers: 'Переводы',
      betweenAccounts: 'Между счетами',
      accountsDesc: 'Кассы и банковские счета',
      financialAccounts: 'Финансовые счета',
      noActiveAccounts: 'Нет активных счетов. Создайте первый счёт в разделе "Счета".',
      createAccount: 'Создать счёт',
      thisWeek: 'За эту неделю',
      weeklyIncome: 'Доходы за неделю',
      weeklyExpenses: 'Расходы за неделю',
      weeklyProfit: 'Прибыль за неделю',
      pendingPaymentsAlert: 'У вас {{count}} ожидающих подтверждения платежей.',
    },

    // Suppliers
    suppliers: {
      newSupplier: 'Новый поставщик',
      createSupplier: 'Создать поставщика',
      basicInfo: 'Основная информация',
      contactInfo: 'Контактная информация',
      addresses: 'Адреса',
      businessTerms: 'Условия сотрудничества',
      supplierCode: 'Код поставщика',
      legalName: 'Юридическое название',
      inn: 'ИНН',
      kpp: 'КПП',
      contactPerson: 'Контактное лицо',
      phone: 'Телефон',
      website: 'Веб-сайт',
      legalAddress: 'Юридический адрес',
      actualAddress: 'Фактический адрес',
      paymentTermsDays: 'Отсрочка платежа (дней)',
      minOrderAmount: 'Мин. сумма заказа',
      discountPercent: 'Скидка (%)',
      currency: 'Валюта',
      currencyKGS: 'KGS (Сом)',
      currencyUSD: 'USD (Доллар)',
      currencyEUR: 'EUR (Евро)',
      currencyRUB: 'RUB (Рубль)',
      supplierRating: 'Рейтинг поставщика',
      comment: 'Комментарий',
      nameRequired: 'Название обязательно',
      codeRequired: 'Код обязателен',
      invalidEmail: 'Неверный формат email',
      cannotBeNegative: 'Не может быть отрицательным',
      mustBe0to100: 'Должна быть от 0 до 100',
      createError: 'Ошибка создания поставщика',
      // SupplierList
      listTitle: 'Поставщики',
      addSupplier: 'Добавить поставщика',
      refresh: 'Обновить',
      searchPlaceholder: 'Поиск по названию, коду, ИНН...',
      statusLabel: 'Статус',
      filterAll: 'Все',
      filterActive: 'Активные',
      filterInactive: 'Неактивные',
      colCode: 'Код',
      colName: 'Название',
      colContacts: 'Контакты',
      colRating: 'Рейтинг',
      colOrders: 'Заказов',
      colOrderAmount: 'Сумма заказов',
      colStatus: 'Статус',
      colActions: 'Действия',
      notFound: 'Поставщики не найдены',
      active: 'Активен',
      inactive: 'Неактивен',
      viewTooltip: 'Просмотр',
      editTooltip: 'Редактировать',
      deleteTooltip: 'Удалить',
      deleteConfirm: 'Удалить поставщика',
      deleteError: 'Ошибка удаления',
      loadErrorList: 'Ошибка загрузки поставщиков',
      unknownError: 'Неизвестная ошибка',
      retry: 'Повторить',
      rowsPerPage: 'Записей на странице:',
      paginationOf: 'из',
      // SupplierDetail keys
      supplierNotFound: 'Поставщик не найден',
      backToList: 'Вернуться к списку',
      loadError: 'Ошибка загрузки поставщика',
      orderHistory: 'История заказов',
      orderNumber: 'Номер',
      date: 'Дата',
      warehouse: 'Склад',
      amount: 'Сумма',
      paymentDelay: 'Отсрочка платежа',
      days: 'дней',
      discountLabel: 'Скидка',
      ratingLabel: 'Рейтинг',
      statistics: 'Статистика',
      totalOrders: 'Всего заказов',
      completedOrders: 'Завершено',
      totalAmount: 'Общая сумма',
      avgDeliveryDelay: 'Средняя задержка доставки',
    },

    // Purchases
    purchases: {
      title: 'Закупки',
      newPurchase: 'Новая закупка',
      noPurchases: 'Нет закупок',
      loadError: 'Не удалось загрузить закупки',
      openPurchase: 'Открыть закупку',
      filters: 'Фильтры',
      search: 'Поиск',
      searchPlaceholder: 'Номер, поставщик…',
      searchEnterApply: 'Enter — применить',
      searchEscClear: 'Esc — очистить',
      reset: 'Сбросить',
      document: 'Документ',
      supplier: 'Поставщик',
      status: 'Статус',
      amount: 'Сумма',
      statusDraft: 'Черновик',
      statusConfirmed: 'Заказано',
      statusPartiallyReceived: 'Принято частично',
      statusReceived: 'Принято полностью',
      statusCancelled: 'Отменено',
      // PurchaseCreate keys
      formPrepareError: 'Не удалось подготовить форму',
      documentNumber: 'Номер документа',
      documentNumberHint: 'Можно оставить пустым — номер будет назначен автоматически (если поддерживается API)',
      warehouseLabel: 'Склад',
      responsibleLabel: 'Ответственный',
      expectedDate: 'Ожидаемая дата',
      commentLabel: 'Комментарий',
      items: 'Позиции',
      searchProductsLabel: 'Поиск товаров',
      searchProductsPlaceholder: 'Название / SKU…',
      scanModeHint: 'Scan mode: ON (Esc — очистить)',
      toggleScanMode: 'Переключить scan mode',
      productLabel: 'Товар',
      productLoading: 'Загрузка…',
      quantity: 'Кол-во',
      priceKgs: 'Цена (KGS)',
      addItem: 'Добавить',
      noItems: 'Пока нет позиций',
      enterNumber: 'Введите число',
      mustBePositive: 'Должно быть больше 0',
      cannotBeNegative: 'Не может быть меньше 0',
      removeItemAria: 'Удалить позицию: {{name}}',
      itemsTotal: 'Итого по позициям',
      creating: 'Создаём…',
      createBtn: 'Создать',
      createError: 'Не удалось создать закупку',
      itemRemoved: 'Позиция удалена',
      undo: 'Вернуть',
      qtyBump: 'кол-во',
      // PurchaseDetail keys
      detail: {
        title: 'Закупка',
        supplierLabel: 'Поставщик',
        statusLabel: 'Статус',
        createdLabel: 'Создано',
        sumLabel: 'Сумма',
        itemsTitle: 'Позиции',
        noItems: 'Нет позиций',
        notFound: 'Закупка не найдена',
        loadError: 'Не удалось загрузить закупку',
        receiveBtn: 'Принять на склад',
        receiveMoreBtn: 'Принять ещё',
        receivedCount: 'Принято позиций: {{count}}',
        receiveError: 'Ошибка при приёмке',
        pdfError: 'Ошибка при скачивании PDF',
      },
      // ReceiveModal keys
      receive: {
        title: 'Принять на склад',
        ordered: 'Заказано',
        received: 'Принято',
        remaining: 'Осталось',
        accept: 'Принять',
        max: 'Макс',
        allReceived: 'Все позиции уже приняты полностью.',
        specifyQty: 'Укажите количество хотя бы для одной позиции',
        error: 'Ошибка при приёмке',
      },
    },

    // Production Tracker
    production: {
      // Board UI
      title: 'Производственный трекер',
      board: 'Доска производства',
      create: 'Создать',
      createDialogTitle: 'Создать производственный трек',
      orderId: 'Номер заказа',
      orderIdHelper: 'Введите ID заказа из системы e-commerce',
      notes: 'Примечания',
      deadline: 'Дедлайн',
      creating: 'Создание...',
      createSuccess: 'Производственный трек создан',
      createError: 'Ошибка создания трека',
      total: 'Всего',
      kanban: 'Kanban',
      list: 'Список',
      myTasks: 'Мои задачи',
      search: 'Поиск...',
      noItems: 'Нет треков',
      noTasks: 'Нет задач',
      open: 'Открыть',
      stepsCompleted: 'этапов',

      // Status filters
      status: 'Статус',
      status_active: 'Активный',
      status_completed: 'Завершён',
      status_on_hold: 'На паузе',
      status_cancelled: 'Отменён',

      // Priority filters
      priority: 'Приоритет',
      priority_urgent: 'Срочный',
      priority_high: 'Высокий',
      priority_normal: 'Обычный',
      priority_low: 'Низкий',

      // Step names (snake_case — used dynamically via t(`production.step_${code}`))
      step: 'Этап',
      step_manager: 'Менеджер',
      step_constructor: 'Конструктор',
      step_purchaser: 'Закупщик',
      step_cutting: 'Раскрой',
      step_edging: 'Кромка',
      step_drilling: 'Сверление',
      step_assembly: 'Сборка',
      step_packaging: 'Упаковка',
      step_delivery: 'Доставка',
      step_accounting: 'Бухгалтерия',

      // Step names (camelCase — legacy)
      stepManager: 'Менеджер',
      stepConstructor: 'Конструктор',
      stepPurchaser: 'Закупщик',
      stepCutting: 'Раскрой',
      stepEdgeBanding: 'Кромка',
      stepDrilling: 'Сверление',
      stepAssembly: 'Сборка',
      stepPackaging: 'Упаковка',
      stepDelivery: 'Доставка',
      stepAccounting: 'Бухгалтерия',

      // Statuses (camelCase — legacy)
      statusPending: 'Ожидает',
      statusActive: 'В работе',
      statusCompleted: 'Завершён',
      statusSkipped: 'Пропущен',
      statusOnHold: 'На паузе',

      // Priorities (camelCase — legacy)
      priorityLow: 'Низкий',
      priorityNormal: 'Обычный',
      priorityHigh: 'Высокий',
      priorityUrgent: 'Срочный',

      // Detail / Pipeline
      detail: 'Детали конвейера',
      pipeline: 'Конвейер',
      pipelineNumber: 'Номер конвейера',
      createPipeline: 'Создать производственный трек',
      specification: 'Спецификация',
      noSpecification: 'Спецификация не заполнена',
      accounting: 'Себестоимость',

      // Step actions
      start: 'Начать',
      complete: 'Завершить',
      skip: 'Пропустить',
      confirm: 'Подтвердить',
      completeStep: 'Завершить этап',
      completeStepTitle: 'Завершить этап',
      startStep: 'Начать этап',
      skipStep: 'Пропустить этап',
      skipped: 'Пропущен',
      pending: 'Ожидает',
      inProgress: 'В работе',
      stepStarted: 'Этап начат',
      stepCompleted: 'Этап завершён',
      stepSkipped: 'Этап пропущен',
      role: 'Роль',
      duration: 'Длительность',
      minutes: 'мин',
      mm: 'мм',

      // Specification editor
      materials: 'Материалы',
      addMaterial: 'Добавить',
      materialName: 'Название',
      quantity: 'Кол-во',
      unit: 'Ед.',
      dimensions: 'Размеры',
      width: 'Ширина (мм)',
      height: 'Высота (мм)',
      depth: 'Глубина (мм)',
      additionalNotes: 'Доп. заметки',
      saveSpec: 'Сохранить спецификацию',
      specSaved: 'Спецификация сохранена',

      // Costs / Accounting
      costs: 'Себестоимость',
      costBreakdown: 'Разбивка затрат',
      materialCost: 'Материалы',
      laborCost: 'Трудозатраты',
      overheadCost: 'Накладные расходы',
      costPrice: 'Себестоимость',
      finalPrice: 'Конечная цена',
      margin: 'Маржа',
      saveCosts: 'Сохранить',
      costsSaved: 'Себестоимость сохранена',
      summary: 'Итого',
      specMaterials: 'Материалы из спецификации',

      // Purchase orders
      purchaseOrders: 'Закупки',
      noPurchaseOrders: 'Нет связанных закупок',
      goToPurchasing: 'Закупка материалов',
      purchaserTitle: 'Закупка материалов',
      purchasedItems: 'Закуплено',
      purchased: 'закуплено',
      purchasePrice: 'Цена закупки',
      purchaseTime: 'Время',
      receipts: 'Чеки',
      markPurchased: 'Отметить закупку',
      selectAll: 'Выбрать все',
      totalPurchaseCost: 'Сумма',
      savePurchaseData: 'Сохранить',
      purchaseTrackingSaved: 'Данные закупки сохранены',
      pipelineNotFound: 'Конвейер не найден',
      receiptUploaded: 'Чек загружен',
      receiptUploadError: 'Ошибка загрузки чека',
      attachReceipt: 'Прикрепить чек',
      noSpecForPurchase: 'Спецификация ещё не заполнена конструктором. Дождитесь загрузки спецификации.',
      constructorPhotos: 'Фото от конструктора',
      materialType: 'Тип',
      andMore: 'и ещё',

      // Constructor — specification upload
      uploadXmlSpec: 'Загрузка XML спецификации',
      xmlHelp: 'Загрузите XML файл из Bazis / К3-Мебель. Материалы будут автоматически извлечены.',
      selectXmlFile: 'Выбрать XML файл',
      invalidXmlFile: 'Выберите XML файл спецификации',
      xmlParsed: 'XML спецификация загружена',
      positions: 'позиций',
      project: 'Проект',
      specPhotos: 'Фото / Чертежи',
      uploadPhotos: 'Загрузить',
      photosUploaded: 'Загружено фото',
      noPhotos: 'Нет загруженных фото',
      xmlParseError: 'Ошибка парсинга XML',
      photoUploadError: 'Ошибка загрузки фото',

      // Notes
      notes: 'Заметки',
      completeConfirm: 'Завершить этап?',
      completeNotes: 'Комментарий к завершению',

      // Board views
      kanbanView: 'Канбан',
      listView: 'Список',
      allSteps: 'Все этапы',
      activeSteps: 'Активные',
      deadline: 'Дедлайн',
      assignedTo: 'Назначен',
      viewDetail: 'Подробнее',
      noPipelines: 'Конвейеры не найдены',

      // Stats
      stats: 'Статистика',
      totalPipelines: 'Всего конвейеров',
      completedToday: 'Завершено сегодня',
      overdue: 'Просрочено',
    },

    // Quality Control (QC)
    qc: {
      // Dashboard
      title: 'Контроль качества',
      subtitle: 'Управление проверками качества, дефектами и удержаниями',
      refreshData: 'Обновить данные',
      templates: 'Шаблоны',
      newInspection: 'Новая проверка',
      totalInspections: 'Всего проверок',
      allTime: 'За всё время',
      successful: 'успешно',
      defectsThisWeek: 'дефектов за неделю',
      needsAttention: 'Требуют внимания',
      qualityScore: 'Показатель качества',
      targetScore: 'Целевой показатель',
      outOf: 'из',
      inspections: 'проверок',
      recentInspections: 'Недавние проверки',
      noInspections: 'Нет проверок',
      createInspection: 'Создать проверку',
      inspectionNum: 'Проверка #{{id}}',
      inspector: 'Инспектор',
      quickActions: 'Быстрые действия',
      qcTemplates: 'Шаблоны QC',
      defects: 'Дефекты',
      holds: 'Удержания',
      reports: 'Отчёты',
      activeHolds: 'Активные удержания',
      noActiveHolds: 'Нет активных удержаний',
      holdNum: 'Удержание #{{id}}',
      pcs: 'шт.',
      loadError: 'Не удалось загрузить данные контроля качества',
      status_pending: 'Ожидает',
      status_in_progress: 'В процессе',
      status_passed: 'Пройдена',
      status_failed: 'Не пройдена',
      status_on_hold: 'На удержании',

      // Holds
      holdsTitle: 'Удержания',
      holdsSubtitle: 'Управление удержаниями товаров',
      createHold: 'Создать удержание',
      releaseHold: 'Снять удержание',
      holdActive: 'Активно',
      holdReleased: 'Снято',
      holdExpired: 'Истекло',
      severityLow: 'Низкая',
      severityMedium: 'Средняя',
      severityHigh: 'Высокая',
      severityCritical: 'Критическая',
      reasonQuality: 'Проблема качества',
      reasonDocumentation: 'Документация',
      reasonInspectionPending: 'Ожидает проверки',
      reasonCustomerRequest: 'Запрос клиента',
      reasonRegulatory: 'Регуляторные требования',
      reasonOther: 'Другое',
      productName: 'Название товара',
      quantity: 'Количество',
      severity: 'Серьёзность',
      reason: 'Причина',
      description: 'Описание',
      expectedResolutionDate: 'Ожидаемая дата решения',
      comment: 'Комментарий',
      confirmReleaseHold: 'Вы уверены, что хотите снять удержание?',
      releaseReasonPlaceholder: 'Укажите причину снятия...',
      loadHoldsError: 'Не удалось загрузить удержания',
      searchHolds: 'Поиск удержаний...',
      searchHoldsAria: 'Поиск удержаний',
      filterByStatus: 'По статусу',
      number: '№',
      product: 'Товар',
      date: 'Дата',
      holdsNotFound: 'Удержания не найдены',
      openHold: 'Открыть удержание',
      refreshHoldsList: 'Обновить список удержаний',

      // Templates
      categoryIncoming: 'Входящий',
      categoryInProcess: 'В процессе',
      categoryFinal: 'Финальный',
      categoryPackaging: 'Упаковка',
      categoryShipping: 'Отгрузка',
      editTemplate: 'Редактировать шаблон',
      newTemplateQC: 'Новый шаблон КК',
      category: 'Категория',
      checklist: 'Чеклист',
      addChecklistItemPlaceholder: 'Новый пункт чеклиста...',
      addChecklistHint: 'Нажмите Enter или + для добавления',
      deleteChecklistItem: 'Удалить пункт чеклиста',
      loadTemplatesError: 'Не удалось загрузить шаблоны',
      copy: 'Копия',
      templatesTitle: 'Шаблоны КК',
      templatesSubtitle: 'Управление шаблонами проверки качества',
      refreshTemplatesList: 'Обновить список шаблонов',
      newTemplate: 'Новый шаблон',
      searchTemplates: 'Поиск шаблонов...',
      searchTemplatesAria: 'Поиск шаблонов',
      filterByCategory: 'По категории',
      checklistItems: 'Чеклист',
      templatesNotFound: 'Шаблоны не найдены',
      duplicate: 'Дубликат',
      duplicateTemplate: 'Дублировать шаблон',
      editTemplateAria: 'Редактировать шаблон',
      deleteTemplateAria: 'Удалить шаблон',
      deleteTemplateTitle: 'Удалить шаблон?',
      deleteTemplateConfirm: 'Вы уверены, что хотите удалить этот шаблон?',

      // Inspections
      statusPending: 'Ожидает',
      statusInProgress: 'В процессе',
      statusPassed: 'Пройдена',
      statusFailed: 'Не пройдена',
      refPurchase: 'Закупка',
      refProduction: 'Производство',
      refInventory: 'Инвентаризация',
      refReturn: 'Возврат',
      refOther: 'Другое',
      selectTemplateError: 'Выберите шаблон',
      stepSelectTemplate: 'Выбор шаблона',
      stepInspectionData: 'Данные проверки',
      stepChecklist: 'Чеклист',
      editInspection: 'Редактирование проверки',
      newInspectionQC: 'Новая проверка КК',
      inspectionTemplate: 'Шаблон проверки',
      noDescription: 'Без описания',
      documentType: 'Тип документа',
      documentId: 'ID документа',
      notes: 'Примечания',
      fillChecklistResults: 'Заполните результаты по контрольному списку',
      required: 'обязательно',
      optional: 'опционально',
      commentOptional: 'Комментарий (необязательно)',
      createInspection: 'Создать проверку',
      inspectionsTitle: 'Проверки КК',
      inspectionsSubtitle: 'Контроль качества продукции',
      refreshInspectionsList: 'Обновить список проверок',
      newInspection: 'Новая проверка',
      searchInspections: 'Поиск проверок...',
      searchInspectionsAria: 'Поиск проверок',
      manageColumns: 'Настроить столбцы',
      inspectionsNotFound: 'Проверки не найдены',
      loadInspectionsError: 'Не удалось загрузить проверки',
      openInspection: 'Открыть проверку',
      columnManagementTitle: 'Настройка столбцов',
      type: 'Тип',
    },

    // CRM
    crm: {
      // Dashboard
      loadDashboardError: 'Не удалось загрузить данные дашборда',
      interactionCall: 'Звонок',
      interactionEmail: 'Email',
      interactionMeeting: 'Встреча',
      interactionNote: 'Заметка',
      interactionComplaint: 'Жалоба',
      interactionFeedback: 'Отзыв',
      interactionSms: 'СМС',
      interactionChat: 'Чат',
      loadingCrmData: 'Загрузка CRM данных...',
      dashboardTitle: 'CRM Дашборд',
      dashboardSubtitle: 'Управление взаимоотношениями с клиентами',
      segments: 'Сегменты',
      customers: 'Клиенты',
      activeTasks: 'Активные задачи',
      overdue: 'Просрочено',
      allOnTime: 'Все в срок',
      interactionsWeek: 'Взаимодействий за неделю',
      today: 'Сегодня',
      loyaltyMembers: 'Участников программы лояльности',
      points: 'баллов',
      tasks: 'Задачи',
      allTasks: 'Все задачи',
      awaitingExecution: 'Ожидают выполнения',
      tasksCount: 'задач',
      overdueTasks: 'Просроченные задачи',
      urgentTasks: 'Срочные задачи',
      createTask: 'Создать задачу',
      interactionsWeekTitle: 'Взаимодействия за неделю',
      history: 'История',
      noInteractionsWeek: 'Нет взаимодействий за эту неделю',
      addInteraction: 'Добавить взаимодействие',
      quickActions: 'Быстрые действия',
      interactions: 'Взаимодействия',
      loyalty: 'Лояльность',

      // Loyalty Programs
      loyaltyTitle: 'Программы лояльности',
      loyaltyRefresh: 'Обновить',
      loyaltyNewProgram: 'Новая программа',
      loyaltyLoading: 'Загрузка...',
      loyaltyNoPrograms: 'Нет программ лояльности',
      loyaltyNoProgramsHint: 'Создайте первую программу для начисления бонусов клиентам',
      loyaltyCreateProgram: 'Создать программу',
      loyaltyLoadError: 'Не удалось загрузить программы лояльности',
      loyaltyNameRequired: 'Введите название программы',
      loyaltyUpdated: 'Программа обновлена',
      loyaltyCreated: 'Программа создана',
      loyaltySaveError: 'Не удалось сохранить программу',
      loyaltyDeleted: 'Программа удалена',
      loyaltyDeleteError: 'Не удалось удалить программу',
      loyaltyTypePoints: 'Баллы',
      loyaltyTypeCashback: 'Кэшбэк',
      loyaltyTypeDiscountTiers: 'Уровни скидок',
      loyaltyTypeHybrid: 'Гибридная',
      loyaltyDefault: 'По умолчанию',
      loyaltyInactive: 'Неактивна',
      loyaltyEarning: 'Начисление',
      loyaltyPointPerSom: 'балл / 1 сом (KGS)',
      loyaltyRedeeming: 'Списание',
      loyaltyPointEqualsSom: '1 балл = ',
      loyaltySomKGS: ' сом (KGS)',
      loyaltyMinRedeem: 'Мин. для списания',
      loyaltyPointsUnit: 'баллов',
      loyaltyMaxPayment: 'Макс. оплата',
      loyaltyOfOrder: '% от заказа',
      loyaltyPointsExpiry: 'Срок действия баллов',
      loyaltyDays: 'дней',
      loyaltyParticipants: 'участников',
      loyaltyEditAria: 'Редактировать программу',
      loyaltyDeleteAria: 'Удалить программу',
      loyaltyEditProgram: 'Редактировать программу',
      loyaltyName: 'Название',
      loyaltyProgramType: 'Тип программы',
      loyaltyDescription: 'Описание',
      loyaltyEarnRules: 'Правила начисления',
      loyaltyPointsPerSom: 'Баллов за 1 сом (KGS)',
      loyaltyMinPurchase: 'Мин. сумма покупки',
      loyaltyRedeemRules: 'Правила списания',
      loyaltyPointValueSom: '1 балл = X сом (KGS)',
      loyaltyMinPointsRedeem: 'Мин. баллов для списания',
      loyaltyMaxOrderPercent: 'Макс. % от заказа',
      loyaltyExpireDays: 'Срок действия (дней)',
      loyaltyExpireHint: 'Оставьте пустым для бессрочных баллов',
      loyaltyActive: 'Активна',
      loyaltyCancel: 'Отмена',
      loyaltySaving: 'Сохранение...',
      loyaltySave: 'Сохранить',
      loyaltyDeleteTitle: 'Удалить программу?',
      loyaltyDeleteConfirm: 'Вы уверены, что хотите удалить программу "{{name}}"? Все данные участников и транзакции будут удалены.',
      loyaltyDelete: 'Удалить',

      // Tasks
      priorityLow: 'Низкий',
      priorityMedium: 'Средний',
      priorityHigh: 'Высокий',
      priorityUrgent: 'Срочный',
      statusPending: 'Ожидает',
      statusInProgress: 'В работе',
      statusCompleted: 'Выполнена',
      statusCancelled: 'Отменена',
      statusDeferred: 'Отложена',
      loadTasksError: 'Не удалось загрузить задачи',
      enterTaskName: 'Введите название задачи',
      taskUpdated: 'Задача обновлена',
      taskCreated: 'Задача создана',
      saveTaskError: 'Не удалось сохранить задачу',
      taskDeleted: 'Задача удалена',
      deleteTaskError: 'Не удалось удалить задачу',
      taskCompleted: 'Задача выполнена',
      completeTaskError: 'Не удалось завершить задачу',
      taskTitle: 'Задача',
      priority: 'Приоритет',
      assignee: 'Исполнитель',
      customer: 'Клиент',
      dueDate: 'Срок',
      complete: 'Завершить',
      completeTaskAria: 'Завершить задачу',
      editTaskAria: 'Редактировать задачу',
      deleteTaskAria: 'Удалить задачу',
      tasksTitle: 'Задачи CRM',
      newTask: 'Новая задача',
      editTask: 'Редактировать задачу',
      assigneeName: 'Имя исполнителя',
      customerName: 'Имя клиента',
      reminder: 'Напоминание',
      deleteTaskTitle: 'Удалить задачу?',
      deleteTaskConfirm: 'Вы уверены, что хотите удалить эту задачу?',

      // Segments
      segmentsTitle: 'Сегменты клиентов',
      newSegment: 'Новый сегмент',
      editSegment: 'Редактировать сегмент',
      discount: 'Скидка',
      discountPercent: 'Скидка (%)',
      paymentDelay: 'Отсрочка',
      paymentDelayDays: 'Отсрочка платежа (дней)',
      days: 'дн.',
      customersCount: 'Клиентов',
      color: 'Цвет',
      loadSegmentsError: 'Не удалось загрузить сегменты',
      enterSegmentName: 'Введите название сегмента',
      segmentUpdated: 'Сегмент обновлён',
      segmentCreated: 'Сегмент создан',
      saveSegmentError: 'Не удалось сохранить сегмент',
      segmentDeleted: 'Сегмент удалён',
      deleteSegmentError: 'Не удалось удалить сегмент',
      editSegmentAria: 'Редактировать сегмент',
      deleteSegmentAria: 'Удалить сегмент',
      deleteSegmentTitle: 'Удалить сегмент?',
      deleteSegmentConfirm: 'Вы уверены, что хотите удалить сегмент "{name}"? Все клиенты будут отвязаны от этого сегмента.',
    },

    // ============================================================
    // CHAT
    // ============================================================
    chat: {
      edited: '(ред.)',
      reply: 'Ответить',
      copy: 'Копировать',
      editMessage: 'Редактировать',
      pin: 'Закрепить',
      deleteMessage: 'Удалить',
      today: 'Сегодня',
      yesterday: 'Вчера',
      selectChat: 'Выберите чат',
      orStartNewConversation: 'или начните новый разговор',
      listenRadio: 'Слушать радио пока ждёте 🎵',
      online: 'в сети',
      wasRecentlyOnline: 'был(а) недавно в сети',
      members: 'участников',
      typingSingular: 'печатает...',
      typingPlural: 'печатают...',
      confirmDeleteMessage: 'Удалить сообщение?',
      messagePlaceholder: 'Сообщение...',
      editing: 'Редактирование',
      startConversation: 'Начните разговор!',
      attachFileAria: 'Прикрепить файл',
      stickersAria: 'Стикеры',
      formattingAria: 'Форматирование',
      emojiAria: 'Эмодзи',
      sendAria: 'Отправить',
      cancelAria: 'Отменить',
      openChatListAria: 'Открыть список чатов',
      chatInfoAria: 'Информация о чате',
      searchCtrlFAria: 'Поиск (Ctrl+F)',
      cancelEditAria: 'Отменить редактирование',
      replyToMessageAria: 'Ответить на сообщение',
      scrollToMessageAria: 'Прокрутить к сообщению',
      closeReplyAria: 'Закрыть ответ',
      messageActionsAria: 'Действия с сообщением',
      info: 'Информация',
      editNameAria: 'Редактировать название',
      channel: 'Канал',
      group: 'Группа',
      notifications: 'Уведомления',
      notificationsOff: 'Отключены',
      notificationsOn: 'Включены',
      pinChat: 'Закрепить чат',
      pinned: 'Закреплён',
      notPinned: 'Не закреплён',
      membersList: 'Участники',
      owner: 'Создатель',
      admin: 'Админ',
      mediaFilesLinks: 'Медиа, файлы, ссылки',
      comingSoon: 'Скоро будет доступно',
      confirmLeaveChat: 'Вы уверены, что хотите покинуть чат?',
      leaveChat: 'Покинуть чат',
      // Sidebar
      youPrefix: 'Вы: ',
      noMessages: 'Нет сообщений',
      chatAvatar: 'Аватар чата',
      chats: 'Чаты',
      newChat: 'Новый чат',
      search: 'Поиск...',
      tabAll: 'Все',
      tabPersonal: 'Личные',
      tabGroups: 'Группы',
      nothingFound: 'Ничего не найдено',
      noChats: 'Нет чатов',
      // Video player
      pauseAria: 'Пауза',
      playAria: 'Воспроизвести',
      unmuteAria: 'Включить звук',
      muteAria: 'Выключить звук',
      pipAria: 'Картинка в картинке',
      fullscreenAria: 'Полноэкранный режим',
      // File drop zone
      exceedsMaxSize: 'превышает 10MB',
      uploadErrors: 'Ошибки загрузки:',
      dropFilesHere: 'Отпустите файлы здесь',
      maxFilesHint: 'до {{count}} файлов, максимум 10MB каждый',
      removeImageAria: 'Удалить изображение',
      removeFileAria: 'Удалить файл',
      attachFileAria: 'Прикрепить файл',
      // Voice recorder
      micAccessError: 'Не удалось получить доступ к микрофону',
      cancelRecordingAria: 'Отменить запись',
      stopRecordingAria: 'Остановить запись',
      deleteRecordingAria: 'Удалить запись',
      sendRecordingAria: 'Отправить запись',
      recordVoiceAria: 'Записать голосовое сообщение',
      // ChatAnimations
      userTyping: '{{name}} печатает...',
      twoUsersTyping: '{{name1}} и {{name2}} печатают...',
      manyUsersTyping: '{{count}} человек печатают...',
      sending: 'Отправка...',
      newMessageSingular: 'новое сообщение',
      newMessagesPlural: 'новых сообщений',
      unreadMessages: 'Непрочитанные сообщения',
      messageDeleted: 'Сообщение удалено',
      // ChatSearch
      searchFilterAll: 'Все',
      searchFilterMedia: 'Медиа',
      searchFilterFiles: 'Файлы',
      searchFilterLinks: 'Ссылки',
      searchPlaceholder: 'Поиск в "{{name}}"...',
      searchDefaultChat: 'чате',
      clearSearchAria: 'Очистить поиск',
      previousResultAria: 'Предыдущий результат',
      nextResultAria: 'Следующий результат',
      closeSearchAria: 'Закрыть поиск',
      enterTextToSearch: 'Введите текст для поиска',
      attachmentPhoto: '📷 Фото',
      attachmentFile: '📎 Файл',
      kbdGoTo: 'перейти',
      kbdNavigation: 'навигация',
      kbdClose: 'закрыть',
      searchInChatAria: 'Поиск в чате',
      // ChatNotifications
      newMessageTitle: 'Новое сообщение',
      mediaMessage: 'Медиа сообщение',
      // EmojiPicker
      emojiRecent: 'Недавние',
      emojiSmileys: 'Смайлы',
      emojiGestures: 'Жесты',
      emojiAnimals: 'Животные',
      emojiFood: 'Еда',
      emojiTravel: 'Путешествия',
      emojiActivities: 'Активности',
      emojiObjects: 'Предметы',
      emojiSymbols: 'Символы',
      emojiFlags: 'Флаги',
      emojiSearchPlaceholder: 'Поиск эмодзи...',
      noRecentEmojis: 'Нет недавних эмодзи',
      selectEmojiAria: 'Выбрать эмодзи {{emoji}}',
      reactionEmojiAria: 'Реакция {{emoji}}',
      // ChatSidebar
      pressNewChatHint: 'Нажмите + чтобы начать новый чат',
      // NewChatDialog
      directMessage: 'Личное сообщение',
      groupNameLabel: 'Название группы',
      channelNameLabel: 'Название канала',
      descriptionOptional: 'Описание (опционально)',
      searchUsersPlaceholder: 'Поиск пользователей...',
      noUsersFound: 'Никого не найдено',
      noAvailableUsers: 'Нет доступных пользователей',
      createGroup: 'Создать группу',
      createChannel: 'Создать канал',
      userAvatarAlt: 'Аватар пользователя',
      // UserStatus
      userStatus: {
        presetAtWork: 'На работе',
        presetHome: 'Дома',
        presetSleeping: 'Сплю',
        presetGaming: 'Играю',
        presetStudying: 'Учусь',
        presetWatchingMovie: 'Смотрю фильм',
        presetListeningMusic: 'Слушаю музыку',
        presetLunch: 'Обедаю',
        presetTraining: 'Тренируюсь',
        presetTraveling: 'В путешествии',
        presetSick: 'Болею',
        presetDoNotDisturb: 'Не беспокоить',
        presetCelebrating: 'Праздную',
        presetCoffee: 'Пью кофе',
        presetOnTheRoad: 'В дороге',
        presetOnline: 'На связи',
        dur30min: '30 минут',
        dur1hour: '1 час',
        dur2hours: '2 часа',
        dur4hours: '4 часа',
        dur8hours: '8 часов',
        dur1day: '1 день',
        dur1week: '1 неделя',
        durUnlimited: 'Без ограничения',
        durMinutes: '{{m}} мин',
        durHours: '{{h}} ч',
        durDays: '{{d}} дн',
        setStatus: 'Установить статус',
        changeStatus: 'Изменить статус',
        whatAreYouDoing: 'Что вы делаете?',
        duration: 'Длительность',
        quickSelect: 'Быстрый выбор',
        clearStatus: 'Очистить статус',
        justNow: 'был(а) только что',
        minutesAgo: 'был(а) {{m}} мин назад',
        hoursAgo: 'был(а) {{h}} ч назад',
        recently: 'был(а) недавно',
      },
      // Radio Player
      radio: {
        countries: {
          russia: 'Россия',
          somafm: 'SomaFM',
          usa: 'США',
          uk: 'Великобритания',
          germany: 'Германия',
          france: 'Франция',
          japan: 'Япония',
          korea: 'Южная Корея',
          turkey: 'Турция',
          kazakhstan: 'Казахстан',
          uzbekistan: 'Узбекистан',
          world: 'Мировое',
        },
        title: 'Радио',
        searchStations: 'Поиск станций...',
        closeRadio: 'Закрыть радио',
        stop: 'Остановить',
        play: 'Воспроизвести',
        mute: 'Выключить звук',
        unmute: 'Включить звук',
        onAir: 'В эфире',
        share: 'Поделиться',
        favorites: 'Избранное',
        removeFromFavorites: 'Убрать из избранного',
        addToFavorites: 'Добавить в избранное',
        playing: 'Играет',
        openRadioPlaying: 'Открыть радио (играет)',
        openRadio: 'Открыть радио',
        listening: 'Слушает',
        stopRadio: 'Остановить радио',
        playRadio: 'Воспроизвести радио',
        streamError: 'Не удалось воспроизвести станцию',
        playbackError: 'Ошибка воспроизведения: {{error}}',
      },
      // Sticker Picker
      stickers: {
        categories: {
          recent: 'Недавние',
          popular: 'Популярные',
          emotions: 'Эмоции',
          animals: 'Животные',
          gestures: 'Жесты',
          celebration: 'Праздники',
          love: 'Любовь',
        },
        title: 'Стикеры',
        searchPlaceholder: 'Поиск стикеров...',
        closeStickers: 'Закрыть стикеры',
        noRecentStickers: 'Нет недавних стикеров',
        stickersNotFound: 'Стикеры не найдены',
        recentCount: '{{count}} недавних',
        stickersCount: '{{count}} стикеров',
      },
      // Text Formatter
      formatter: {
        bold: 'Жирный',
        italic: 'Курсив',
        underline: 'Подчёркнутый',
        strikethrough: 'Зачёркнутый',
        code: 'Код',
        codeBlock: 'Блок кода',
        title: 'Форматирование',
      },
      // Music Player
      music: {
        title: 'Музыка',
        audio: 'Аудио',
        pause: 'Пауза',
        play: 'Воспроизвести',
        share: 'Поделиться',
        close: 'Закрыть',
        listening: 'Слушает',
      },
      // Link Preview
      linkPreview: {
        removePreview: 'Удалить превью ссылки',
      },
      errorSaveSetting: 'Не удалось сохранить настройку',
      errorSaveName: 'Не удалось сохранить название чата',
      errorLeaveChat: 'Не удалось выйти из чата',
      errorUploadFiles: 'Не удалось загрузить файлы',
      errorDeleteMessage: 'Не удалось удалить сообщение',
      errorReaction: 'Не удалось добавить реакцию',
      errorPinMessage: 'Не удалось закрепить сообщение',
      errorLoadMembers: 'Не удалось загрузить участников',
      errorLoadUsers: 'Не удалось загрузить список пользователей',
      videoThumbnail: 'Превью видео',
      youtubeVideo: 'Видео YouTube',
      vimeoVideo: 'Видео Vimeo',
      tiktokVideo: 'Видео TikTok',
      youtubeMusic: 'YouTube Музыка',
    },

    // ============================================================
    // CUSTOMER SUPPORT
    // ============================================================
    support: {
      heading: 'Поддержка клиентов',
      total: 'Всего',
      active: 'Активных',
      waiting: 'Ожидают',
      statusNew: 'Новый',
      statusOpen: 'Открыт',
      statusPending: 'Ожидание',
      statusResolved: 'Решён',
      statusClosed: 'Закрыт',
      priorityLow: 'Низкий',
      priorityMedium: 'Средний',
      priorityHigh: 'Высокий',
      priorityCritical: 'Критический',
      searchPlaceholder: 'Поиск по обращениям...',
      tabAll: 'Все',
      tabNew: 'Новые',
      tabActive: 'Активные',
      tabResolved: 'Решённые',
      noTickets: 'Нет обращений',
      noNewTickets: 'Нет новых обращений',
      noActiveTickets: 'Нет активных обращений',
      noResolvedTickets: 'Нет решённых обращений',
      anonymous: 'Аноним',
      noMessages: 'Нет сообщений',
      selectChatFromList: 'Выберите чат из списка',
      order: 'Заказ:',
      take: 'Взять',
      assigned: 'Назначен',
      customerInfo: 'Информация о клиенте',
      name: 'Имя',
      email: 'Email',
      phone: 'Телефон',
      ordersCount: 'Заказов',
      totalSpent: 'Общая сумма',
      changeStatus: 'Изменить статус',
      changePriority: 'Изменить приоритет',
      closeTicket: 'Закрыть обращение',
      closeTicketTitle: 'Закрыть обращение?',
      closeTicketConfirm: 'Вы уверены, что хотите закрыть это обращение?',
      inputPlaceholder: 'Введите сообщение...',
      sendAria: 'Отправить',
      defaultCustomerName: 'Клиент',
      defaultManagerName: 'Менеджер',
      errorSendMessage: 'Не удалось отправить сообщение',
      errorStatusChange: 'Не удалось изменить статус',
      errorAssign: 'Не удалось назначить менеджера',
      errorLoadChats: 'Не удалось загрузить чаты',
      errorLoadMessages: 'Не удалось загрузить сообщения',
    },

    // ============================================================
    // INTEGRATIONS
    // ============================================================
    integrations: {
      // System names
      system1C: '1С:Управление торговлей',
      systemMoySklad: 'МойСклад',
      systemInternal: 'Внутренний учёт',
      ownAccounting: 'Собственный учёт',

      // General
      heading: 'Интеграции',
      subtitle: 'Управление подключениями к внешним системам',
      namespace: 'Пространство имён',
      externalId: 'Внешний ID',
      addIntegration: 'Добавить интеграцию',
      active: 'Активна',
      disabled: 'Отключена',
      system: 'Система:',
      lastSync: 'Последняя синхр.:',
      never: 'никогда',
      productsCount: 'товаров',
      viewProducts: 'Товары',
      settings: 'Настройки',
      logs: 'Журнал',
      webhooks: 'Вебхуки',
      confirmDeleteIntegration: 'Удалить интеграцию "{name}"? Это действие необратимо.',
      integrationDeleted: 'Интеграция удалена',
      deleteError: 'Ошибка удаления',
      error: 'Ошибка',

      // IntegrationsPage dialog
      createIntegration: 'Создать интеграцию',
      editIntegration: 'Редактировать интеграцию',
      integrationName: 'Название интеграции',
      integrationNameHelper: 'Понятное название для интеграции',
      systemType: 'Тип системы',
      namespace: 'Namespace',
      namespaceHelper: 'Уникальный идентификатор (латиница, цифры, дефис)',
      apiUrl: 'URL API',
      apiUrlHelper: 'Базовый URL для подключения к API',
      activeSwitch: 'Активна',
      integrationSaved: 'Интеграция сохранена',
      integrationCreated: 'Интеграция создана',
      saveError: 'Ошибка сохранения',
      editTooltip: 'Редактировать',
      editAria: 'Редактировать интеграцию',
      deleteTooltip: 'Удалить',
      deleteAria: 'Удалить интеграцию',
      settingsTooltip: 'Настройки',
      settingsAria: 'Настройки интеграции',
      logsTooltip: 'Журнал',
      logsAria: 'Журнал интеграции',
      webhooksTooltip: 'Вебхуки',
      webhooksAria: 'Вебхуки интеграции',
      productsTooltip: 'Товары',
      productsAria: 'Товары интеграции',
      noIntegrations: 'Нет интеграций',
      noIntegrationsHint: 'Нажмите "Добавить интеграцию" для начала',

      // 1C Integration
      oneCConnectionSettings: 'Настройки подключения 1С',
      oneCPlatformInfo: 'Интеграция с 1С:Управление торговлей через OData/REST API',
      urlApi: 'URL API',
      enterOneCUrl: 'Введите URL 1С',
      connectionMethod: 'Способ подключения',
      odata: 'OData',
      rest: 'REST API',
      authentication: 'Аутентификация',
      basic: 'Basic',
      token: 'Token',
      username: 'Имя пользователя',
      password: 'Пароль',
      bearerToken: 'Bearer Token',
      syncSettings: 'Настройки синхронизации',
      synchronize: 'Синхронизировать',
      syncSchedule: 'Расписание синхронизации',
      manual: 'Вручную',
      everyHour: 'Каждый час',
      everyDay: 'Каждый день',
      everyWeek: 'Каждую неделю',
      priceType: 'Тип цены',
      priceTypePlaceholder: 'Розничная',
      priceTypeHelper: 'Название типа цены в 1С',
      defaultWarehouse: 'Склад по умолчанию',
      warehousePlaceholder: 'Основной склад',
      warehouseHelper: 'Название или ID склада в 1С',
      testing: 'Проверка...',
      testConnectionBtn: 'Проверить подключение',
      saving: 'Сохранение...',
      saveSettings: 'Сохранить настройки',
      settings1CSaved: 'Настройки 1С сохранены',
      cannotConnect1C: 'Не удалось подключиться к 1С',
      tokenGenerateError: 'Ошибка генерации токена',

      // 1C Platform (SuperAdmin & Tenant)
      onecDatabasesTitle: '1C Базы данных',
      onecStatusActive: 'Активна',
      onecStatusProvisioning: 'Создание',
      onecStatusSuspended: 'Приостановлена',
      onecStatusError: 'Ошибка',
      onecStatusNot_configured: 'Не настроена',
      onecOrganization: 'Организация',
      onecServerUrl: 'URL сервера',
      onecDbName: 'Имя базы',
      onecLastSync: 'Последняя синхр.',
      onecErrorCount: 'Ошибки',
      onecSuccessRate: 'Успешность',
      onecNoDatabases: 'Нет баз данных 1C',
      onecActivate: 'Активировать',
      onecSuspend: 'Приостановить',
      onecRecreate: 'Пересоздать',
      onecConfirmDelete: 'Удалить базу данных?',
      onecConfirmDeleteText: 'Это действие необратимо. Все данные интеграции будут удалены.',
      onecConfirmSuspend: 'Приостановить базу данных?',
      onecConfirmActivate: 'Активировать базу данных?',
      onecConfirmRecreate: 'Пересоздать базу данных?',
      onecConfirmRecreateText: 'Текущая база будет удалена и создана заново.',
      onecMetricsTitle: '1C Метрики',
      onecActiveDbs: 'Активных БД',
      onecSuccessfulSyncs: 'Успешных синхр.',
      onecFailedSyncs: 'Неудачных синхр.',
      onecLast24h: 'За 24 часа',
      onecAvgDuration: 'Средняя длит.',
      onecRecords: 'записей',
      onecSyncChart: 'График синхронизации (24ч)',
      onecNoChartData: 'Нет данных для графика',
      onecPerOrgStatus: 'Статус по организациям',
      onecHealthTitle: '1C Здоровье системы',
      onecHealthy: 'Здорова',
      onecDegraded: 'Деградация',
      onecStale: 'Устарело',
      onecUnhealthy: 'Нездорова',
      onecHealthDb: 'База данных',
      onecHealthDatabases: '1C базы',
      onecHealthQueue: 'Очередь синхр.',
      onecHealthErrors: 'Ошибки',
      onecPendingItems: 'В очереди',
      onecLastHour: 'За час',
      onecHealthDetails: 'Подробности',
      onecDbBreakdown: 'Разбивка по БД',
      onecSystemInfo: 'Системная информация',
      onecLastCheck: 'Последняя проверка',
      onecAutoRefresh: 'Авто-обновление',
      onecPlatformStatus: 'Статус платформы',
      onecDatabaseStatus: 'Статус 1C базы',
      onecNotConfigured: '1C интеграция ещё не настроена для вашей организации',
      onecSyncSuccess: 'Успешных',
      onecSyncFailed: 'Ошибок',
      onecProvisioning: 'База данных создаётся...',
      onecSetupTools: 'Инструменты настройки',
      onecSetupTokenDesc: 'Токен для автоматической настройки 1C модуля',
      onecGenerateToken: 'Сгенерировать токен',
      onecInstallerDesc: 'Скачать установщик модуля обмена 1C',
      onecDownloadInstaller: 'Скачать установщик',
      onecSyncLogsTitle: '1C Журнал синхронизации',
      onecForceSyncAll: 'Синхронизировать все',
      onecQueued: 'В очереди',
      onecRecordsProcessed: 'Записей',
      onecDuration: 'Длительность',
      onecStartedAt: 'Начало',
      onecNoLogs: 'Нет записей',
      entityType: 'Тип сущности',
      direction: 'Направление',
      directionImport: 'Импорт',
      directionExport: 'Экспорт',

      // 1C Installer page
      installerTitle: 'Установщик 1C модуля',
      installerSubtitle: 'Пошаговая настройка подключения 1С к вашей организации',
      installerStep1: 'Системные требования',
      installerStep1Desc: 'Убедитесь, что ваша система соответствует минимальным требованиям',
      installerStep2: 'Получение токена настройки',
      installerStep2Desc: 'Сгенерируйте токен для автоматической настройки модуля обмена',
      installerStep3: 'Скачать установщик',
      installerStep3Desc: 'Скачайте и запустите установщик модуля обмена WASSER-1C',
      installerStep4: 'Установка и подключение',
      installerStep4Desc: 'Следуйте инструкции для завершения настройки',
      sysReq_platform: 'Платформа 1С',
      sysReq_config: 'Конфигурация',
      sysReq_protocol: 'Протокол',
      sysReq_network: 'Сеть',
      sysReqMin_platform: '1С:Предприятие 8.3.10+',
      sysReqMin_config: '1С:УТ 11.5.10+ / 1С:КА 2.5+',
      sysReqMin_protocol: 'REST API или OData',
      sysReqMin_network: 'HTTPS, порт 443',
      installerInstructions: '1. Запустите установщик WASSER-1C-Connector.exe\n2. Укажите путь к базе 1С\n3. Введите Setup Token (из шага 2)\n4. Выберите тип подключения: REST API / OData\n5. Нажмите "Подключить"\n6. Дождитесь сообщения "Подключение установлено"',
      generateSetupToken: 'Сгенерировать токен настройки',
      copyToken: 'Копировать токен',
      copied: 'Скопировано!',
      tokenExpiresInfo: 'Токен действителен 24 часа. После истечения сгенерируйте новый.',
      tokenGenerationFailed: 'Не удалось сгенерировать токен',
      downloadInstaller: 'Скачать установщик',
      downloadFullSetup: '1С Платформа + Коннектор (~530 МБ)',
      downloadConnectorOnly: 'Только коннектор (~0.03 МБ)',
      downloadPackagesInfo: 'Полный пакет включает 1С:Предприятие 8.3.19 + WASSER коннектор + автоустановщик. Только коннектор — для обновления при уже установленной 1С.',
      installerMockWarning: 'В демо-режиме скачивание недоступно. В проде здесь будет ссылка на установщик.',
      downloadSuperAdminOnly: 'Скачивание доступно только для SuperAdmin. Обратитесь к администратору платформы.',
      downloadFailed: 'Не удалось скачать установщик',
      autoConfigured: 'Подключение настраивается автоматически',
      nextStep: 'Далее',
      prevStep: 'Назад',

      // Connector OTA Settings
      connectorOtaTitle: 'Управление коннектором 1С',
      connectorOtaSubtitle: 'Централизованные настройки, мониторинг и обновления коннекторов',
      connectorOtaTabSettings: 'Настройки',
      connectorOtaTabInstances: 'Экземпляры',
      connectorOtaTabVersions: 'Версии',
      connectorOtaOrgIdFilter: 'ID организации',
      connectorOtaOrgIdPlaceholder: 'Пустое = платформенные настройки',
      connectorOtaSyncSettings: 'Настройки синхронизации',
      connectorOtaSyncInterval: 'Интервал синхронизации (мин)',
      connectorOtaSyncIntervalHelp: 'Как часто коннектор синхронизирует данные',
      connectorOtaBatchSize: 'Размер пакета',
      connectorOtaProductsEnabled: 'Синхронизация товаров',
      connectorOtaStockEnabled: 'Синхронизация остатков',
      connectorOtaPricesEnabled: 'Синхронизация цен',
      connectorOtaOrdersEnabled: 'Синхронизация заказов',
      connectorOtaCustomersEnabled: 'Синхронизация клиентов',
      connectorOtaStatusesEnabled: 'Синхронизация статусов',
      connectorOtaLoggingSettings: 'Настройки логирования',
      connectorOtaLogLevel: 'Уровень логирования',
      connectorOtaLogMaxSize: 'Макс. размер лога (МБ)',
      connectorOtaConnectorSettings: 'Настройки коннектора',
      connectorOtaAutoUpdate: 'Автоматические обновления',
      connectorOtaAutoUpdateHelp: 'Коннектор автоматически скачает и установит новые версии при перезапуске в 03:00',
      connectorOtaSettingsSaved: 'Настройки сохранены',
      connectorOtaNoInstances: 'Нет подключённых экземпляров коннектора',
      connectorOtaColOrg: 'Организация',
      connectorOtaColVersion: 'Версия',
      connectorOtaColHost: 'Хост',
      connectorOtaColStatus: 'Статус',
      connectorOtaColSyncs: 'Синхр.',
      connectorOtaColErrors: 'Ошибки',
      connectorOtaColLastHeartbeat: 'Последний heartbeat',
      connectorOtaStatusOnline: 'Онлайн',
      connectorOtaStatusOffline: 'Оффлайн',
      connectorOtaStatusUpdating: 'Обновляется',
      connectorOtaStatusError: 'Ошибка',
      connectorOtaColVersionName: 'Версия',
      connectorOtaColReleaseNotes: 'Что нового',
      connectorOtaColSize: 'Размер',
      connectorOtaColCritical: 'Критическое',
      connectorOtaColInstallCount: 'Установок',
      connectorOtaColCreated: 'Дата',
      connectorOtaCritical: 'Критическое',
      connectorOtaPublishVersion: 'Опубликовать версию',
      connectorOtaPublishNewVersion: 'Публикация новой версии',
      connectorOtaVersionNumber: 'Номер версии',
      connectorOtaReleaseNotes: 'Описание изменений',
      connectorOtaR2Key: 'R2 ключ файла',
      connectorOtaR2KeyHelp: 'Путь к ZIP в R2 хранилище',
      connectorOtaMarkCritical: 'Критическое обновление (принудительная установка)',
      connectorOtaPublish: 'Опубликовать',
      connectorOtaVersionPublished: 'Версия опубликована',
      connectorOtaNav: 'Настройки коннектора',

      // MoySklad Integration
      moySkladConnectionSettings: 'Настройки подключения МойСклад',
      moySkladInfo: 'Интеграция с МойСклад через JSON API 1.2',
      apiToken: 'API Токен',
      enterMoySkladToken: 'Введите токен МойСклад',
      moySkladTokenHelperText: 'Получите в МойСклад: Настройки → Пользователи и права → Токены доступа',
      optional: 'опционально',
      orgIdHelper: 'Оставьте пустым для автоматического определения',
      storeIdHelper: 'Оставьте пустым для склада по умолчанию',
      useVariants: 'Использовать модификации',
      settingsMoySkladSaved: 'Настройки МойСклад сохранены',
      cannotConnectMoySklad: 'Не удалось подключиться к МойСклад',

      // Sync entities (shared between 1C and MoySklad)
      syncProducts: 'Товары',
      syncPrices: 'Цены',
      syncStock: 'Остатки',
      syncOrders: 'Заказы',
      syncCategories: 'Категории',
      syncImages: 'Изображения',

      // Integration Logs
      logsHeading: 'Журнал синхронизации',
      manualSync: 'Ручная синхронизация',
      importProducts: 'Импорт товаров',
      importPrices: 'Импорт цен',
      importStock: 'Импорт остатков',
      importCategories: 'Импорт категорий',
      exportOrders: 'Экспорт заказов',
      exportCustomers: 'Экспорт клиентов',
      importImages: 'Импорт изображений',
      exportProducts: 'Экспорт товаров',
      logStatusSuccess: 'Успех',
      logStatusError: 'Ошибка',
      logStatusPending: 'Ожидание',
      logEntityProducts: 'Товары',
      logEntityOrders: 'Заказы',
      logEntityPrices: 'Цены',
      logEntityStock: 'Остатки',
      logEntityCategories: 'Категории',
      logEntityCustomers: 'Клиенты',
      logEntityImages: 'Изображения',
      logEntityAll: 'Все',
      logDate: 'Дата',
      logEntity: 'Сущность',
      logDirection: 'Направление',
      logRecords: 'Записей',
      logErrors: 'Ошибок',
      logDuration: 'Время',
      logStatus: 'Статус',
      noLogs: 'Нет записей в журнале',
      import: 'Импорт',
      export: 'Экспорт',
      rowsPerPage: 'Строк на странице:',
      logDetailsTitle: 'Детали синхронизации',
      logCloseAria: 'Закрыть',
      logDetailStatus: 'Статус:',
      logDetailEntity: 'Сущность:',
      logDetailDirection: 'Направление:',
      logDetailStatistics: 'Статистика',
      logDetailProcessed: 'Обработано:',
      logDetailErrors: 'Ошибок:',
      logDetailTime: 'Время',
      logDetailStarted: 'Начало:',
      logDetailCompleted: 'Завершено:',
      logDetailErrorMessage: 'Сообщение об ошибке:',
      logDetailErrorDetails: 'Детали ошибки:',
      retrySync: 'Повторить синхронизацию',
      importFromExternal: 'Импорт из',
      exportToExternal: 'Экспорт в',

      // Webhooks
      webhooksTitle: 'Вебхуки',
      webhooksSubtitle: 'Управление вебхуками для уведомлений о событиях',
      payload: 'Данные запроса',
      response: 'Ответ',
      noResponse: 'Нет ответа',
      secretKey: 'Секретный ключ',
      addWebhook: 'Добавить вебхук',
      totalWebhooks: 'Всего',
      activeWebhooks: 'Активных',
      successRate: 'Успешность',
      totalDeliveries: 'Доставок',
      tabWebhooks: 'Вебхуки',
      tabLogs: 'Журнал доставки',
      webhookName: 'Название',
      webhookUrl: 'URL',
      webhookEvents: 'События',
      webhookStatus: 'Статус',
      webhookActions: 'Действия',
      noWebhooks: 'Нет вебхуков',
      testWebhookTooltip: 'Тестировать',
      testWebhookAria: 'Тестировать вебхук',
      webhookLogsTooltip: 'Журнал',
      webhookLogsAria: 'Журнал вебхука',
      editWebhookTooltip: 'Редактировать',
      editWebhookAria: 'Редактировать вебхук',
      deleteWebhookTooltip: 'Удалить',
      deleteWebhookAria: 'Удалить вебхук',
      webhookStatusSuccess: 'Успех',
      webhookStatusError: 'Ошибка',
      webhookStatusPending: 'Ожидание',
      webhookSaved: 'Вебхук сохранён',
      webhookCreated: 'Вебхук создан',
      webhookSaveError: 'Ошибка сохранения вебхука',
      webhookDeleted: 'Вебхук удалён',
      webhookDeleteError: 'Ошибка удаления вебхука',
      webhookTestSent: 'Тестовый запрос отправлен',
      webhookTestError: 'Ошибка отправки тестового запроса',
      secretCopied: 'Секрет скопирован',
      secretCopyError: 'Ошибка копирования',
      webhookEnabled: 'Вебхук активирован',
      webhookDisabled: 'Вебхук деактивирован',
      webhookToggleError: 'Ошибка изменения статуса',
      confirmDeleteWebhook: 'Удалить вебхук "{name}"?',

      // Webhook logs tab
      logsRefresh: 'Обновить',
      logDeliveryDate: 'Дата',
      logDeliveryWebhook: 'Вебхук',
      logDeliveryEvent: 'Событие',
      logDeliveryStatus: 'Статус',
      logDeliveryCode: 'Код',
      logDeliveryTime: 'Время ответа',
      logDeliveryAttempt: 'Попытка',
      logDeliveryActions: 'Действия',
      noDeliveryLogs: 'Нет записей о доставке',
      expandDetailsAria: 'Развернуть детали',
      retryDeliveryTooltip: 'Повторить',
      retryDeliveryAria: 'Повторить отправку',
      deliveryRowsPerPage: 'Строк на странице:',

      // Webhook create/edit dialog
      createWebhook: 'Создать вебхук',
      editWebhookTitle: 'Редактировать вебхук',
      webhookNameLabel: 'Название вебхука',
      webhookUrlLabel: 'URL для отправки',
      webhookEventsLabel: 'События',
      selectEventsHelper: 'Выберите события для отправки уведомлений',
      webhookSecret: 'Секретный ключ',
      copySecretAria: 'Скопировать секрет',
      generateSecret: 'Сгенерировать',
      retryCount: 'Количество попыток',
      timeout: 'Таймаут (сек)',
      webhookActiveSwitch: 'Активен',

      // Webhook event categories & events
      eventCategoryOrders: 'Заказы',
      eventOrderCreated: 'Создан',
      eventOrderUpdated: 'Обновлён',
      eventOrderStatusChanged: 'Статус изменён',
      eventOrderCancelled: 'Отменён',
      eventCategoryProducts: 'Товары',
      eventProductCreated: 'Создан',
      eventProductUpdated: 'Обновлён',
      eventProductDeleted: 'Удалён',
      eventProductStockChanged: 'Остаток изменён',
      eventCategoryCustomers: 'Клиенты',
      eventCustomerCreated: 'Создан',
      eventCustomerUpdated: 'Обновлён',
      eventCategoryPayments: 'Платежи',
      eventPaymentReceived: 'Получен',
      eventPaymentRefunded: 'Возвращён',
      eventCategoryIntegrations: 'Интеграции',
      eventSyncCompleted: 'Синхронизация завершена',
      eventSyncFailed: 'Ошибка синхронизации',
      eventCategoryInventory: 'Склад',
      eventStockLow: 'Низкий остаток',
      eventStockOut: 'Нет в наличии',
      eventStockUpdated: 'Остаток обновлён',
      eventCategorySystem: 'Система',
      eventWebhookTest: 'Тестовое событие',
      eventSystemError: 'Системная ошибка',
      eventMaintenanceScheduled: 'Плановое обслуживание',
      eventRateLimitExceeded: 'Превышен лимит запросов',

      // Webhook delete dialog
      deleteWebhookTitle: 'Удалить вебхук',
      deleteWebhookContent: 'Вы уверены, что хотите удалить вебхук "{name}"? Это действие необратимо.',
      webhookLogsDialogClose: 'Закрыть',
      webhookNameHelper: 'Например: CRM Notification, Accounting Sync',
      webhookSecretHelper: 'Для подписи запросов (HMAC-SHA256)',
      urlPostHelper: 'URL для отправки POST-запросов',
      logsFor: 'Логи: {{name}}',
      requestFormatLabel: 'Формат запроса:',
      requestFormatValue: 'POST с JSON-телом',
      headersLabel: 'Заголовки:',
      ifSecretSet: 'если указан secret',
      loadProductsError: 'Не удалось загрузить товары',

      // Integration Products Page
      backToIntegrations: 'Назад к интеграциям',
      products: 'Товары',
      deleteAll: 'Удалить все',
      productsInMoySklad: 'Товары в МойСклад',
      synced: 'Синхронизированные',
      searchBySkuNameExternalId: 'Поиск по SKU, названию или external ID...',
      productName: 'Название',
      price: 'Цена',
      stock: 'Остаток',
      source: 'Источник',
      updated: 'Обновлен',
      productsNotFound: 'Товары не найдены',
      noSyncedProducts: 'Нет синхронизированных товаров',
      clickSyncToLoad: 'Нажмите "Синхронизировать" для загрузки товаров из',
      externalSystem: 'внешней системы',
      syncProductsFrom: 'Синхронизация товаров из',
      syncTokenInfo: 'Для синхронизации требуется API токен. Токен НЕ сохраняется на сервере и используется только для текущего запроса.',
      enterTokenForApi: 'Введите токен для доступа к API',
      enterApiToken: 'Введите токен API',
      syncCompleted: 'Синхронизация завершена!',
      syncResults: 'Результаты синхронизации',
      totalProcessed: 'Всего обработано',
      importedNew: 'Импортировано новых',
      updatedExisting: 'Обновлено существующих',
      skipped: 'Пропущено',
      errorsCount: 'Ошибок',
      performance: 'Производительность',
      totalTime: 'Общее время',
      speed: 'Скорость',
      productsPerSec: 'товаров/сек',
      avgTimePerProduct: 'Среднее время на товар',
      executionPhases: 'Этапы выполнения',
      phaseDataLoading: 'Загрузка данных',
      phaseProductProcessing: 'Обработка товаров',
      phaseFinalization: 'Завершение',
      network: 'Сеть',
      apiRequests: 'Запросов к API',
      dataReceived: 'Получено данных',
      apiResponseTime: 'Время ответа API',
      syncing: 'Синхронизация...',
      startSync: 'Начать синхронизацию',
      deleteAllProducts: 'Удалить все товары?',
      deleteAllWarning: 'Это действие удалит все {count} товаров из этой интеграции и не может быть отменено!',
      confirmDeleteAllProducts: 'Вы уверены, что хотите удалить все товары из интеграции "{namespace}"?',
      deleting: 'Удаление...',
      deleted: 'Удалено',

      // External Products Preview
      productsFrom: 'Товары из',
      fetched: 'Загружено',
      syncedStat: 'Синхронизировано',
      notSynced: 'Не синхронизировано',
      withPhotos: 'С фото',
      searchByNameOrSku: 'Поиск по названию или SKU...',
      selectAllOnPage: 'Выбрать все на странице',
      selectAll: 'Выбрать все',
      deselectAll: 'Снять все',
      selectOnlyNotSynced: 'Выбрать только несинхронизированные',
      notSyncedShort: 'Не синхр.',
      notSyncedFull: 'Несинхронизированные',
      clearSelection: 'Снять выделение',
      deselect: 'Снять',
      syncShort: 'Синхр.',
      syncSelected: 'Синхронизировать выбранные',
      syncAllShort: 'Синхр. все',
      syncAll: 'Синхронизировать все',
      doNotClosePage: 'Пожалуйста, не закрывайте страницу',
      processed: 'Обработано',
      imported: 'Импортировано',
      updatedStat: 'Обновлено',
      currentProduct: 'Текущий товар',
      elapsedTime: 'Прошло времени',
      remaining: 'Осталось',
      selectAllProducts: 'Выбрать все товары',
      selectProduct: 'Выбрать',
      photo: 'Фото',
      photosCount: 'фото',
      noPhoto: 'Нет фото',
      syncedStatus: 'Синхронизирован',
      notSyncedStatus: 'Не синхронизирован',
      noProductsToDisplay: 'Нет товаров для отображения',
      selectProductsForSync: 'Выберите товары для синхронизации',
      syncingProducts: 'Синхронизация {count} товаров...',
      sec: 'сек',
      min: 'мин',
      calculating: 'расчёт...',
      loadingDataFromMoySklad: 'Загрузка данных из МойСклад...',
      completed: 'Завершено',
      successCount: 'Успешно',
      syncError: 'Ошибка синхронизации',
      startingFullSync: 'Запуск полной синхронизации...',
      connectingToMoySklad: 'Подключение к МойСклад...',
      loadingProductList: 'Загрузка списка товаров...',
      fetchingDataFromApi: 'Получение данных из API',
      finishingSync: 'Завершение синхронизации...',
      fullSyncCompleted: 'Полная синхронизация завершена!',
      requested: 'Запрошено',
      successful: 'Успешно',
      errors: 'Ошибки',
      andMore: 'и ещё',
      executionTime: 'Время выполнения',
      secDot: 'сек.',
    },

    // Super Admin
    superAdmin: {
      // RevenueChart
      revenueLoadError: 'Ошибка загрузки данных о доходах',
      platformStatus: 'Статус платформы',
      platformStable: 'Работает стабильно',
      platformAttention: 'Требует внимания',
      apiRequests24h: 'API запросов за 24ч',
      activeOrganizations: 'Активных организаций',
      activity: {
        justNow: 'только что',
        minutesAgo: '{{count}} мин. назад',
        hoursAgo: '{{count}} ч. назад',
        daysAgo: '{{count}} дн. назад',
        system: 'Система',
      },
      revenueByOrgs: 'Доходы по организациям',
      period: 'Период',
      days7: '7 дней',
      days30: '30 дней',
      days90: '90 дней',
      year1: '1 год',
      totalGMV: 'Общий GMV за период',
      orgsWithSales: 'Организаций с продажами',
      revenue: 'Доход',
      ofTotal: 'от общего',
      ordersCount: 'Заказов',
      usersCount: 'Пользователей',
      productsCount: 'Товаров',
      noRevenueData: 'Нет данных о доходах за выбранный период',
      // OrganizationsTable
      orgsLoadError: 'Ошибка загрузки организаций',
      organization: 'Организация',
      plan: 'План',
      status: 'Статус',
      users: 'Пользователи',
      products: 'Товары',
      orders: 'Заказы',
      revenue30d: 'Доход (30д)',
      owner: 'Владелец',
      actions: 'Действия',
      ordersWord: 'заказов',
      view: 'Просмотр',
      features: 'Функции',
      rowsPerPage: 'Строк на странице:',
      of: 'из',
      moreThan: 'более',
      // FeatureFlagsManager
      featureManagement: 'Управление функциями',
      featureFlagsSubtitle: 'Feature Flags для организаций платформы',
      newFeature: 'Новая функция',
      allFeatures: 'Все функции',
      byOrgs: 'По организациям',
      searchFeatures: 'Поиск функций...',
      category: 'Категория',
      allCategories: 'Все категории',
      found: 'Найдено',
      functionsWord: 'функций',
      noDescription: 'Нет описания',
      flagType_boolean: 'Вкл/Выкл',
      flagType_plan_based: 'По плану',
      flagType_percentage: 'Процент',
      flagType_whitelist: 'Белый список',
      defaultOn: 'Вкл по умолч.',
      defaultOff: 'Выкл по умолч.',
      selectOrg: 'Выберите организацию',
      startTyping: 'Начните вводить название...',
      selectOrgForFeatures: 'Выберите организацию для настройки функций',
      unsavedChanges: 'Есть несохранённые изменения',
      saving: 'Сохранение...',
      changed: 'Изменено',
      createNewFeature: 'Создать новую функцию',
      keyField: 'Ключ (key)',
      keyFieldHelper: 'Только латинские буквы, цифры, подчёркивания',
      nameField: 'Название',
      descriptionField: 'Описание',
      type: 'Тип',
      minPlan: 'Мин. план',
      notSpecified: 'Не указан',
      defaultEnabled: 'По умолчанию включено',
      betaFeature: 'Beta функция',
      creating: 'Создание...',
      create: 'Создать',
      editFeature: 'Редактировать',
      defaultOnShort: 'По умолчанию вкл',
      beta: 'Beta',
      deprecated: 'Устаревший',
      deleteFeatureConfirm: 'Удалить функцию',
      // SuperAdmin Dashboard
      platformLoadError: 'Ошибка загрузки данных платформы: {{message}}',
      dashboardTitle: 'Панель управления платформой',
      dashboardSubtitle: 'Контроль организаций, доходов и функций платформы',
      thisMonth: 'за месяц',
      organizationsActive: 'Организации ({{count}} активных)',
      usersLabel: 'Пользователи',
      activeLastWeek: 'Активных за неделю',
      adminsCount: 'Админов',
      mrrLabel: 'MRR (ежемесячный доход)',
      growthLabel: 'Рост',
      arrLabel: 'ARR',
      gmv30d: 'GMV за 30 дней',
      ordersLabel: 'Заказов',
      avgOrder: 'Средний чек',
      tabOrganizations: 'Организации',
      tabRevenue: 'Доходы',
      tabActivity: 'Активность',
      syncLogsLoadError: 'Ошибка загрузки логов',
      onecRecreateFailed: 'Ошибка пересоздания базы данных 1С',
      onecSuspendFailed: 'Ошибка приостановки базы данных 1С',
      onecDeleteFailed: 'Ошибка удаления базы данных 1С',
      onecForceSyncFailed: 'Ошибка принудительной синхронизации',
      featureCreateFailed: 'Ошибка создания флага',
      featureUpdateFailed: 'Ошибка обновления флага',
      featureDeleteFailed: 'Ошибка удаления флага',
      orgFeaturesUpdateFailed: 'Ошибка обновления функций организации',
      activity: {
        loadError: 'Ошибка загрузки активности',
        title: 'Последняя активность на платформе',
        noActivity: 'Нет активности для отображения',
      },
    },

    // Customization Settings
    customization: {
      title: 'Кастомизация',
      subtitle: 'Настройка модулей, полей и интерфейса организации',
      tabModules: 'Модули',
      tabCustomFields: 'Кастомные поля',
      tabPermissions: 'Права',
      tabInterface: 'Интерфейс',
      tabIntegrations: 'Интеграции',
      availableModules: 'Доступные модули',
      modulesDescription: 'Включите или отключите модули для вашей организации. Доступность модулей зависит от вашего плана подписки.',
      moduleInventory: 'Склад',
      moduleInventoryDesc: 'Управление складом, остатками и партиями',
      moduleCRM: 'CRM',
      moduleCRMDesc: 'Управление клиентами, сделками и воронкой продаж',
      moduleAnalytics: 'Аналитика',
      moduleAnalyticsDesc: 'Расширенные отчёты и дашборды',
      moduleAccounting: 'Бухгалтерия',
      moduleAccountingDesc: 'Счета, акты, налоговая отчётность',
      moduleEnabled: 'Модуль включён',
      moduleDisabled: 'Модуль выключен',
      moduleToggleError: 'Ошибка при изменении модуля',
      customFields: 'Кастомные поля',
      customFieldsDesc: 'Добавьте дополнительные поля для товаров, заказов, пользователей и клиентов.',
      addField: 'Добавить поле',
      entityType: 'Тип сущности',
      entityProducts: 'Товары',
      entityOrders: 'Заказы',
      entityUsers: 'Пользователи',
      entityCustomers: 'Клиенты',
      noCustomFields: 'Нет кастомных полей',
      addFirstField: 'Добавьте первое поле для',
      fieldKey: 'Ключ',
      fieldName: 'Название',
      fieldType: 'Тип',
      fieldGroup: 'Группа',
      fieldRequired: 'Обязательное',
      fieldInForm: 'В форме',
      fieldInTable: 'В таблице',
      editField: 'Редактировать поле',
      newFieldFor: 'Новое поле для',
      fieldKeyLabel: 'Ключ поля (латиница)',
      fieldKeyHelper: 'Например: fabric_type, designer_name',
      fieldNameRu: 'Название (RU)',
      fieldNameEn: 'Название (EN)',
      fieldDescription: 'Описание',
      fieldTypeLabel: 'Тип поля',
      fieldTypeText: 'Текст',
      fieldTypeTextarea: 'Многострочный текст',
      fieldTypeNumber: 'Число (целое)',
      fieldTypeDecimal: 'Число (дробное)',
      fieldTypeSelect: 'Выпадающий список',
      fieldTypeMultiselect: 'Множественный выбор',
      fieldTypeCheckbox: 'Чекбокс',
      fieldTypeDate: 'Дата',
      fieldTypeDatetime: 'Дата и время',
      fieldTypeEmail: 'Email',
      fieldTypePhone: 'Телефон',
      fieldTypeUrl: 'URL',
      fieldTypeColor: 'Цвет',
      optionsLabel: 'Опции (через запятую)',
      optionsHelper: 'Хлопок, Лён, Шёлк, Синтетика',
      minValue: 'Мин. значение',
      maxValue: 'Макс. значение',
      minLength: 'Мин. длина',
      maxLength: 'Макс. длина',
      defaultValue: 'Значение по умолчанию',
      fieldGroupLabel: 'Группа (для группировки полей)',
      fieldGroupHelper: 'Например: dimensions, materials, specifications',
      display: 'Отображение',
      required: 'Обязательное',
      inForm: 'В форме',
      inTable: 'В таблице',
      inCatalog: 'В каталоге',
      entityForProducts: 'товаров',
      entityForOrders: 'заказов',
      entityForUsers: 'пользователей',
      entityForCustomers: 'клиентов',
      fieldUpdated: 'Поле обновлено',
      fieldAdded: 'Поле добавлено',
      fieldSaveError: 'Ошибка при сохранении поля',
      deleteFieldConfirm: 'Удалить это поле? Все значения будут потеряны.',
      fieldDeleted: 'Поле удалено',
      fieldDeleteError: 'Ошибка при удалении поля',
      adminPermissions: 'Административные права',
      exportData: 'Экспорт данных',
      apiAccess: 'Доступ к API',
      manageIntegrations: 'Управление интеграциями',
      userPermissions: 'Пользовательские права',
      seeB2BPrices: 'Видеть B2B цены',
      bulkOrders: 'Оптовые заказы',
      permissionsTitle: 'Права и разрешения',
      permissionsDesc: 'Настройте дополнительные права для вашей организации.',
      uiTitle: 'Настройки интерфейса',
      uiDesc: 'Настройте внешний вид витрины вашего магазина.',
      uiBusinessPlan: 'Расширенные настройки интерфейса доступны на плане Business и выше.',
      uiBasicSettings: 'Базовые настройки',
      uiInDevelopment: 'Функционал в разработке. Скоро здесь появятся настройки главной страницы, навигации и каталога.',
      integrationsTitle: 'Интеграции',
      integrationsDesc: 'Подключите внешние сервисы для расширения возможностей платформы.',
      syncProductsOrders: 'Синхронизация товаров и заказов',
      onlinePayments: 'Приём онлайн-платежей',
      emailNotifications: 'Email-рассылки и уведомления',
      smsNotifications: 'SMS-уведомления',
      available: 'Доступно',
      comingSoon: 'Скоро',
      configure: 'Настроить',
    },

    // Organization Settings
    orgSettings: {
      title: 'Настройки организации',
      managementOf: 'Управление',
      tabBasic: 'Основные',
      tabBranding: 'Брендинг',
      tabDomain: 'Домен',
      tabSubscription: 'Подписка',
      basicInfo: 'Основная информация',
      orgName: 'Название организации',
      description: 'Описание',
      subdomain: 'Поддомен',
      subdomainHelp: 'Поддомен нельзя изменить после создания',
      orgId: 'Идентификатор организации',
      copy: 'Скопировать',
      created: 'Создана',
      unknown: 'Неизвестно',
      saveChanges: 'Сохранить изменения',
      brandingTitle: 'Брендинг и оформление',
      logoUrl: 'URL логотипа',
      logoPreview: 'Предпросмотр логотипа',
      primaryColor: 'Основной цвет',
      secondaryColor: 'Вторичный цвет',
      font: 'Шрифт',
      fontHelper: 'Например: Inter, Roboto, Open Sans',
      preview: 'Предпросмотр',
      orgNameOrPlaceholder: 'Название организации',
      primaryButton: 'Основная кнопка',
      secondaryButton: 'Вторичная кнопка',
      saveBranding: 'Сохранить брендинг',
      domainSettings: 'Настройки домена',
      domainDefaultInfo: 'По умолчанию ваша организация доступна по адресу:',
      customDomain: 'Пользовательский домен',
      domainHelp: 'Укажите ваш домен без https:// и www',
      domainVerified: 'Домен подтвержден',
      domainPending: 'Ожидает подтверждения',
      saveDomain: 'Сохранить домен',
      setupGuide: 'Инструкция по настройке',
      currentPlan: 'Текущий план',
      planFree: 'Бесплатный',
      planStarter: 'Стартер',
      planBusiness: 'Бизнес',
      planEnterprise: 'Корпоративный',
      betaLabel: 'БЕТА',
      active: 'Активен',
      inactive: 'Неактивен',
      usageLimits: 'Использование лимитов',
      usersLabel: 'Пользователи',
      productsLabel: 'Товары',
      ordersLabel: 'Заказы',
      upgradePlan: 'Улучшить план',
      upgradeDesc: 'Расширьте возможности вашего магазина, перейдя на более высокий план.',
      contactSales: 'Связаться с отделом продаж',
      individualOffer: 'Свяжитесь с нами для получения индивидуального предложения.',
      domainSetupTitle: 'Настройка пользовательского домена',
      domainCnameInfo: 'Для использования собственного домена, добавьте следующую CNAME запись в DNS вашего домена:',
      dnsPropagation: 'Изменения DNS могут занять до 24 часов для полного распространения.',
      dnsType: 'Тип',
      dnsName: 'Имя',
      dnsValue: 'Значение',
      close: 'Закрыть',
      loadError: 'Ошибка загрузки организации',
      notFound: 'Организация не найдена',
      settingsSaved: 'Настройки успешно сохранены',
      saveError: 'Ошибка сохранения',
      domainSaved: 'Домен сохранен. Для активации необходимо подтверждение.',
      domainSaveError: 'Ошибка сохранения домена',
    },

    // Advanced Analytics
    advAnalytics: {
      title: 'Расширенная аналитика',
      subtitle: 'Комплексный анализ бизнес-показателей',
      period: 'Период',
      days7: '7 дней',
      days30: '30 дней',
      days90: '90 дней',
      year1: '1 год',
      tabOverview: 'Обзор',
      tabSales: 'Продажи',
      tabInventory: 'Запасы',
      tabOperations: 'Операции',
      tabCustomers: 'Клиенты',
      loadError: 'Ошибка загрузки данных',
      vsPrevPeriod: 'vs прошлый период',
      // Overview
      totalRevenue: 'Общая выручка',
      ordersCount: 'Заказов',
      customersCount: 'Клиентов',
      avgCheck: 'Средний чек',
      stockStatus: 'Статус запасов',
      stockHealthy: 'Нормальный',
      stockLow: 'Низкий',
      stockCritical: 'Критический',
      orderFulfillment: 'Выполнение заказов',
      fulfilled: 'Выполнено',
      inProgress: 'В работе',
      pending: 'Ожидают',
      quality: 'Качество',
      inspected: 'Проверено',
      onInspection: 'На проверке',
      rejected: 'Отклонено',
      topProducts: 'Топ товары',
      product: 'Товар',
      sold: 'Продано',
      revenueCol: 'Выручка',
      recentOrders: 'Последние заказы',
      // Sales
      revenueTitle: 'Выручка',
      ordersTitle: 'Количество заказов',
      avgCheckTitle: 'Средний чек',
      conversion: 'Конверсия',
      salesByCategory: 'Продажи по категориям',
      topProductsTitle: 'Топ продукты',
      qty: 'Кол-во',
      // Inventory
      totalProducts: 'Всего товаров',
      totalValue: 'Общая стоимость',
      lowStock: 'Низкий запас',
      ofAllProducts: 'от всех товаров',
      outOfStock: 'Нет в наличии',
      stockHealth: 'Здоровье запасов',
      normal: 'В норме',
      lowLevel: 'Низкий уровень',
      critical: 'Критический',
      attentionProducts: 'Товары требуют внимания',
      sku: 'SKU',
      name: 'Название',
      balance: 'Остаток',
      threshold: 'Мин. порог',
      statusCol: 'Статус',
      statusNone: 'Нет',
      statusLow: 'Мало',
      categoryDistribution: 'Распределение по категориям',
      productsWord: 'товаров',
      turnover: 'Оборачиваемость товаров',
      turnoverPerMonth: 'Оборот/мес',
      daysToZero: 'Дней до 0',
      // Operations
      ordersFulfillment: 'Выполнение заказов',
      avgFulfillmentTime: 'Ср. время выполнения',
      onTimeDelivery: 'Вовремя доставлено',
      returns: 'Возвратов',
      cancelled: 'Отмененных',
      production: 'Производство',
      activeOrders: 'Активных заказов',
      completed: 'Завершено',
      efficiency: 'Эффективность',
      defects: 'Дефектов',
      qualityControl: 'Контроль качества',
      inspections: 'Проверок',
      passed: 'Пройдено',
      onHold: 'На удержании',
      criticalDefects: 'Критических дефектов',
      daysShort: 'дн.',
      // Customers
      totalCustomers: 'Всего клиентов',
      newForPeriod: 'Новых за период',
      avgLTV: 'Ср. LTV',
      repeat: 'Повторных',
      customerSegments: 'Сегменты клиентов',
      customersWord: 'клиентов',
      topCustomers: 'Топ клиенты',
      client: 'Клиент',
      ordersCol: 'Заказов',
      amount: 'Сумма',
    },

    // Components (MaterialSelector, ProductCostCalculation, ProductBOMTab)
    components: {
      // MaterialSelector
      matSelectTitle: 'Выбор материалов из базы',
      matDbEmpty: 'База материалов пуста. Добавьте материалы в разделе "База сырья".',
      searchByNameOrCode: 'Поиск по названию или коду...',
      categoryLabel: 'Категория',
      allCategories: 'Все категории',
      catSheets: 'Листовые материалы',
      catEdge: 'Кромочные материалы',
      catFasteners: 'Крепеж',
      catFittings: 'Фурнитура',
      catPaint: 'Лакокрасочные',
      catFabric: 'Ткани',
      catGlass: 'Стекло и зеркала',
      catElectric: 'Электрика',
      catOther: 'Прочее',
      selectedCount: 'Выбрано материалов',
      colCode: 'Код',
      colName: 'Наименование',
      colCategory: 'Категория',
      colUnit: 'Ед.изм',
      colPrice: 'Цена',
      colSupplier: 'Поставщик',
      colStock: 'Остаток',
      colInfo: 'Инфо',
      stockLow: 'Мало',
      stockAvailable: 'В наличии',
      nothingFound: 'Ничего не найдено',
      noAvailableMaterials: 'Нет доступных материалов',
      tip: 'Совет:',
      tipText: 'Нажмите на материал для выбора. Количество можно будет указать после добавления в техкарту.',
      addSelected: 'Добавить выбранные',
      updatedAt: 'Обновлено',
      materialInfo: 'Информация о материале',
      purchasePrice: 'Закуп',
      // ProductCostCalculation
      costCalcTitle: 'Расчет себестоимости',
      productLabel: 'Товар',
      historyEntries: 'записей в истории',
      calcHistory: 'История расчетов',
      editMode: 'Режим редактирования',
      saveProductFirst: 'Для сохранения расчета себестоимости сначала сохраните товар.',
      apiConnected: 'Подключено к API',
      lastCalc: 'Последний расчет',
      costPrice: 'Себестоимость',
      loadTechCard: 'Загрузка технической карты',
      uploadExcel: 'Загрузить Excel',
      uploading: 'Загрузка...',
      downloadTemplate: 'Скачать шаблон',
      useExcelPrices: 'Использовать цены из Excel',
      autoCreateInDb: 'Авто-создание в базе',
      autoCreateEnabled: 'Авто-создание включено',
      autoCreateDesc: 'Новые материалы из Excel будут автоматически добавлены в базу',
      excelFormat: 'Формат Excel: Лист "Материалы" (Название, Ед.изм, Количество, Цена, Поставщик) и лист "Работы" (Название, Часы, Ставка)',
      materials: 'Материалы',
      fromDatabase: 'Из базы',
      checkPrices: 'Проверить цены',
      addManually: 'Добавить вручную',
      outdatedPricesWarning: 'Найдено материалов с устаревшими ценами',
      updatePrices: 'Обновить цены',
      colSku: 'Артикул',
      colNameMat: 'Наименование',
      colUnitMat: 'Ед.изм',
      colQty: 'Кол-во',
      colCoef: 'Коэф.',
      colPricePerUnit: 'Цена за ед.',
      colTotal: 'Сумма',
      colSupplierMat: 'Поставщик',
      colActions: 'Действия',
      noMaterials: 'Нет материалов. Загрузите из Excel или добавьте вручную.',
      totalMaterials: 'Итого материалы:',
      works: 'Работы',
      addWork: 'Добавить работу',
      colWorkName: 'Наименование работы',
      colHours: 'Часы',
      colRatePerHour: 'Ставка/час',
      colCost: 'Стоимость',
      colWorker: 'Исполнитель',
      colNote: 'Примечание',
      noWorks: 'Нет работ. Добавьте вручную или загрузите из Excel.',
      totalWorks: 'Итого работы:',
      calcParams: 'Параметры расчета',
      overheadExpenses: 'Накладные расходы',
      profitMargin: 'Наценка (прибыль)',
      vat: 'НДС',
      vatHelp: 'В КР мебель без НДС',
      transport: 'Транспорт',
      packaging: 'Упаковка',
      otherCosts: 'Прочие расходы',
      totalCostCalc: 'Итоговый расчет себестоимости',
      directCosts: 'Прямые затраты',
      materialsLabel: 'Материалы:',
      worksLabel: 'Работы:',
      totalDirect: 'Итого прямые:',
      indirectCosts: 'Косвенные затраты',
      overheadLabel: 'Накладные',
      transportLabel: 'Транспорт:',
      packagingLabel: 'Упаковка:',
      otherLabel: 'Прочие:',
      fullCostPrice: 'Полная себестоимость:',
      marginLabel: 'Наценка',
      vatLabel: 'НДС',
      recommendedPrice: 'Рекомендуемая цена:',
      history: 'История',
      exportExcel: 'Экспорт в Excel',
      createEstimate: 'Создать смету',
      saveTechCard: 'Сохранить техкарту',
      savingDots: 'Сохранение...',
      important: 'Важно:',
      disclaimerText: 'Данные расчеты являются ориентировочными. Окончательную цену устанавливает менеджер с учетом рыночной ситуации.',
      historyTitle: 'История расчетов себестоимости',
      historyEmpty: 'История пуста',
      load: 'Загрузить',
      author: 'Автор',
      techCardSaved: 'Техническая карта сохранена успешно!',
      noProductId: 'Не указан ID товара. Сохраните товар перед расчетом себестоимости.',
      apiErrorLocal: 'Ошибка API, данные сохранены локально',
      historyLoaded: 'Данные загружены из истории',
      historyLoadError: 'Ошибка загрузки данных из истории',
      localCacheLoaded: 'Данные загружены из локального кэша',
      historyLoadApiError: 'Ошибка загрузки истории',
      pdfGenerated: 'PDF смета успешно сгенерирована',
      pdfError: 'Ошибка при генерации PDF сметы',
      excelLoadedCount: 'Загружено',
      materialsWord: 'материалов',
      worksWord: 'работ',
      deleteMaterial: 'Удалить материал',
      deleteWork: 'Удалить работу',
      // ProductBOMTab
      bomTitle: 'Спецификация (BOM)',
      bomVersion: 'Версия',
      bomComponents: 'Компонентов',
      bomCostPrice: 'Себестоимость',
      bomNotCreated: 'Спецификация не создана',
      importExcel: 'Импорт Excel',
      edit: 'Редактировать',
      createBom: 'Создать',
      cancel: 'Отмена',
      save: 'Сохранить',
      bomMaterial: 'Материал',
      bomQty: 'Кол-во',
      bomUnit: 'Ед. изм.',
      bomPricePerUnit: 'Цена за ед.',
      bomTotal: 'Сумма',
      bomActions: 'Действия',
      selectMaterial: 'Выберите материал',
      notSpecified: 'Не указан',
      newItem: 'Новый',
      bomTotalCost: 'Итого себестоимость:',
      addMaterial: 'Добавить материал',
      bomEmptyTitle: 'Спецификация не создана',
      bomEmptyDesc: 'Создайте спецификацию вручную или импортируйте из Excel',
      importFromExcel: 'Импорт из Excel',
      createManually: 'Создать вручную',
      deleteMaterialTitle: 'Удалить материал?',
      deleteMaterialConfirm: 'Вы уверены, что хотите удалить этот материал из спецификации?',
      delete: 'Удалить',
      bomLoadError: 'Не удалось загрузить спецификацию',
      bomUpdated: 'Спецификация обновлена',
      bomCreated: 'Спецификация создана',
      bomSaveError: 'Не удалось сохранить спецификацию',
      bomImported: 'Спецификация импортирована из Excel',
      bomImportError: 'Ошибка импорта из Excel',
      bomAvailableForSaved: 'Спецификация доступна только для сохраненных товаров. Пожалуйста, сначала создайте товар.',
      unitPcs: 'шт',
      currencySom: 'сом',
      bomSpecName: 'Спецификация: {{name}}',
    },

    // Price List Export
    priceList: {
      dialogTitle: 'Настройка экспорта прайс-листа',
      companyInfo: 'Информация о компании',
      companyName: 'Название компании',
      phone: 'Телефон',
      email: 'Email',
      address: 'Адрес',
      website: 'Веб-сайт',
      heading: 'Заголовок',
      subtitle: 'Подзаголовок',
      fieldsToInclude: 'Поля для включения',
      sku: 'Артикул (SKU)',
      photo: 'Фото товара',
      productName: 'Название',
      description: 'Описание',
      category: 'Категория',
      retailPrice: 'Цена розничная',
      b2bPrice: 'Цена B2B',
      priceQty10: 'Цена за 10 шт',
      priceQty50: 'Цена за 50 шт',
      stock: 'Наличие',
      priceFormat: 'Формат цен',
      currency: 'Валюта',
      showVAT: 'Показывать НДС',
      vatRate: 'Ставка НДС (%)',
      footerSection: 'Нижний колонтитул',
      footerNote: 'Примечание в конце прайс-листа',
      cancel: 'Отмена',
      exportBtn: 'Экспортировать прайс-лист',
      defaultCompanyName: 'WASSER - Интернет-магазин сантехники',
      defaultAddress: 'г. Бишкек, Кыргызстан',
      defaultTitle: 'ПРАЙС-ЛИСТ',
      defaultSubtitle: 'Актуально на {{date}}',
      defaultFooter: 'Цены указаны в сомах. Наличие товара уточняйте у менеджеров.',
    },

    // Widgets
    widgets: {
      dateAndTime: 'Дата и время',
      bishkekTimezone: 'Бишкек (UTC+6)',
      weekNumber: 'Неделя {{n}}',
      dayNumber: 'День {{n}}',
      quarter: 'квартал',
      noData: 'Нет данных',
      exchange: {
        title: 'Курсы валют НБКР',
        usd: 'Доллар США',
        eur: 'Евро',
        rub: 'Российский рубль',
        kzt: 'Тенге',
        loadError: 'Не удалось загрузить курсы валют',
        dataSource: 'Данные предоставлены НБКР',
      },
      weather: {
        title: 'Погода',
        feelsLike: 'Ощущается как',
        loadError: 'Не удалось загрузить данные о погоде',
        defaultCity: 'Бишкек',
        partlyCloudy: 'Переменная облачность',
        windSpeed: 'м/с',
      },
    },

    // Sync Progress
    sync: {
      secSuffix: 'с',
      minSuffix: 'м',
      statusDone: 'Завершено',
      statusError: 'Ошибка',
      statusRunning: 'Выполняется',
      statusPending: 'Ожидание',
      statusUnknown: 'Неизвестно',
      syncTitle: 'Синхронизация',
      entityProducts: 'товаров',
      entityStock: 'остатков',
      entityOrders: 'заказов',
      disableAutoRefresh: 'Отключить автообновление',
      enableAutoRefresh: 'Включить автообновление',
      loadError: 'Ошибка загрузки:',
      completed: 'завершено',
      processed: 'Обработано',
      errors: 'Ошибки',
      time: 'Время',
      itemsPerSec: 'эл/сек',
      syncError: 'Ошибка синхронизации:',
      recentItems: 'Последние обработанные элементы:',
      successSuffix: 'успешно',
      started: 'Начато:',
      finished: 'Завершено:',
    },

    // Cost Calculation Utils (costCalculationUtils.js)
    costCalc: {
      // Sheet names
      sheetMaterials: 'Материалы',
      sheetLabor: 'Работы',
      sheetCalculation: 'Расчет',
      sheetInstructions: 'Инструкция',

      // Column headers - Materials
      colName: 'Наименование',
      colUnit: 'Ед.изм',
      colQuantity: 'Количество',
      colPricePerUnit: 'Цена за ед.',
      colTotal: 'Сумма',
      colSupplier: 'Поставщик',
      colNotes: 'Примечание',

      // Column headers - Labor
      colLaborName: 'Наименование работы',
      colHours: 'Часы',
      colRatePerHour: 'Ставка/час',
      colCost: 'Стоимость',
      colWorker: 'Исполнитель',

      // Cost calculation labels
      costTitle: 'Расчет себестоимости',
      directCosts: 'ПРЯМЫЕ ЗАТРАТЫ',
      materials: 'Материалы',
      laborLabel: 'Работы',
      directCostsTotal: 'Итого прямые затраты',
      indirectCosts: 'КОСВЕННЫЕ ЗАТРАТЫ',
      overheadCosts: 'Накладные расходы ({{percent}}%)',
      transportCosts: 'Транспортные расходы',
      packaging: 'Упаковка',
      otherCosts: 'Прочие расходы',
      totalCost: 'ПОЛНАЯ СЕБЕСТОИМОСТЬ',
      priceCalculation: 'РАСЧЕТ ЦЕНЫ',
      markup: 'Наценка ({{percent}}%)',
      vatLabel: 'НДС ({{percent}}%)',
      recommendedPrice: 'РЕКОМЕНДУЕМАЯ ЦЕНА',

      // Default units
      unitPcs: 'шт',
      unitHour: 'час',
      unitSqm: 'м²',
      unitLm: 'м.п.',
      unitPack: 'упак',

      // Error messages
      errorParsingExcel: 'Ошибка парсинга Excel: {{message}}',
      errorReadingFile: 'Ошибка чтения файла',
      errorLoadingExceljs: 'Ошибка загрузки библиотеки exceljs: {{message}}',
      errorExportExcel: 'Ошибка экспорта в Excel: {{message}}',
      errorCreatingTemplate: 'Ошибка создания шаблона: {{message}}',

      // Validation messages
      noMaterialsAdded: 'Не добавлены материалы',
      materialNoName: 'Материал {{index}}: не указано наименование',
      materialInvalidQty: 'Материал "{{name}}": неверное количество',
      materialInvalidPrice: 'Материал "{{name}}": неверная цена',
      noLaborAdded: 'Не добавлены работы',
      laborNoName: 'Работа {{index}}: не указано наименование',
      laborInvalidHours: 'Работа "{{name}}": неверное количество часов',
      laborInvalidRate: 'Работа "{{name}}": неверная ставка',

      // Compare categories
      catMaterials: 'Материалы',
      catLabor: 'Работы',
      catTotalCost: 'Итоговая себестоимость',

      // Template sample data
      samplePlywood: 'Фанера березовая 18мм',
      sampleEdgePVC: 'Кромка ПВХ 2мм белая',
      sampleScrews: 'Саморезы 4x16',
      sampleSupplier1: 'ООО "ЛесТорг"',
      sampleSupplier2: 'ООО "Мебель Комплект"',
      sampleSupplier3: 'Магазин "Крепеж"',
      sampleHighGrade: 'Высший сорт',
      samplePcsPerPack: '100 шт в упаковке',
      sampleCutting: 'Раскрой материала',
      sampleEdgeBanding: 'Кромление деталей',
      sampleAssembly: 'Сборка изделия',
      sampleMaster: 'Мастер',
      sampleCarpenter: 'Столяр 1 разряда',

      // Template instructions
      instrTitle: 'ИНСТРУКЦИЯ ПО ЗАПОЛНЕНИЮ ТЕХНИЧЕСКОЙ КАРТЫ',
      instrMaterialsSheet: 'Лист "Материалы":',
      instrMatName: '- Наименование: название материала или комплектующего',
      instrMatUnit: '- Ед.изм: единица измерения (м², м.п., шт, кг и т.д.)',
      instrMatQuantity: '- Количество: расход материала на единицу изделия',
      instrMatPrice: '- Цена за ед.: стоимость единицы материала в сомах',
      instrMatSupplier: '- Поставщик: название поставщика (необязательно)',
      instrMatNotes: '- Примечание: дополнительная информация (необязательно)',
      instrLaborSheet: 'Лист "Работы":',
      instrLabName: '- Наименование работы: описание выполняемой операции',
      instrLabHours: '- Часы: трудозатраты в часах',
      instrLabRate: '- Ставка/час: почасовая оплата в сомах',
      instrLabWorker: '- Исполнитель: должность/ФИО работника (необязательно)',
      instrLabNotes: '- Примечание: дополнительная информация (необязательно)',
      instrImportant: 'ВАЖНО:',
      instrKeepHeaders: '- Не удаляйте заголовки (первую строку на каждом листе)',
      instrStartRow2: '- Заполняйте данные со второй строки',
      instrEmptyRows: '- Пустые строки будут проигнорированы',
      instrDecimalPoint: '- Используйте точку как разделитель десятичных дробей (2.5, а не 2,5)',
      instrUpload: 'После заполнения загрузите файл через кнопку "Загрузить Excel" в системе',
    },

    // ProductCostCalculation component
    productCost: {
      currencyShort: 'с',
      currencyPerHour: 'с/час',
      currencyFull: 'сом',
      saveFailed: 'Не удалось сохранить техкарту',
      historyFailed: 'Не удалось получить историю техкарт',
      apiErrorLocalSaved: 'Ошибка API, данные сохранены локально',
      noDataInFile: 'Не найдены данные в файле. Проверьте структуру файла.',
      uploadError: 'Ошибка при загрузке файла',
      downloadError: 'Ошибка',
      templateDownloadError: 'Ошибка при скачивании шаблона',
      generalError: 'Общая ошибка',
      uploadedMaterials: 'Загружено: {{count}} материалов',
      uploadedLabor: ', {{count}} работ',
      orderLabel: 'Заказ',
      productLabel: 'Изделие',
      createdInDb: '✅ Создано в базе: {{count}} материалов',
      alreadyInDb: '📦 Уже в базе: {{count}}',
      errorsCount: '⚠️ Ошибок: {{count}}',
      fromDbChip: 'Из базы ({{code}})',
      supplierNote: 'Поставщик',
      dbEmpty: 'База материалов пуста',
      outdatedPricesConfirm: 'Найдено {{count}} материалов с устаревшими ценами. Обновить?',
      allPricesActual: 'Все цены актуальны!',
      pricesUpdated: 'Обновлено {{count}} материалов. Общая разница: {{diff}}',
      noMaterialsToUpdate: 'Нет материалов для обновления',
      recommendedPriceNote: 'Рекомендуемая цена: {{price}} сом',
      materialsCountNote: 'Материалов: {{count}}',
      worksCountNote: 'работ: {{count}}',
      markupNote: 'Наценка: {{percent}}%',
      pdfSubtitle: 'Мебель для ванных комнат',
      pdfDocTitle: 'СМЕТА / КОММЕРЧЕСКОЕ ПРЕДЛОЖЕНИЕ',
      pdfDate: 'Дата',
      pdfProduct: 'Товар',
      pdfMaterialsHeader: 'Материалы:',
      pdfWorksHeader: 'Работы:',
      pdfSummaryHeader: 'Итоговый расчет:',
      pdfColNum: '№',
      pdfColName: 'Наименование',
      pdfColUnit: 'Ед.',
      pdfColQty: 'Кол-во',
      pdfColPrice: 'Цена',
      pdfColTotal: 'Сумма',
      pdfColHours: 'Часы',
      pdfColRate: 'Ставка',
      pdfRowMaterials: 'Материалы',
      pdfRowWorks: 'Работы',
      pdfRowDirectCosts: 'Прямые затраты',
      pdfRowOverhead: 'Накладные расходы',
      pdfRowTransport: 'Транспорт',
      pdfRowPackaging: 'Упаковка',
      pdfRowOtherCosts: 'Прочие расходы',
      pdfRowCostPrice: 'СЕБЕСТОИМОСТЬ',
      pdfRowMarkup: 'Наценка',
      pdfRowTotalPayable: 'ИТОГО К ОПЛАТЕ',
      pdfDisclaimer1: '* Смета действительна в течение 14 дней с даты составления',
      pdfDisclaimer2: '* Цены указаны в кыргызских сомах (KGS)',
      pdfFilename: 'Смета',
      pdfDefaultProduct: 'товар',
      autoCreateTooltip: 'При загрузке Excel автоматически создавать отсутствующие материалы в базе данных',
    },

    // Materials Integration Utils
    materialsInt: {
      notFoundInDb: 'Не найден в базе',
      priceFormat: '{{price}} с/{{unit}}',
      sheetMaterials: 'Материалы',
      defaultCategoryOther: 'Прочее',
      defaultUnitPcs: 'шт',
      errorParsingExcel: 'Ошибка парсинга Excel: {{message}}',
      errorReadingFile: 'Ошибка чтения файла',
      errorLoadingLibrary: 'Ошибка загрузки библиотеки: {{message}}',
      sheetServices: 'Услуги',
      headerCode: 'Код',
      headerName: 'Наименование',
      headerCategory: 'Категория',
      headerUnit: 'Ед.изм',
      headerPrice: 'Цена',
      headerSupplierPrice: 'Цена пост.',
      headerSupplier: 'Поставщик',
      headerMinStock: 'Мин.остаток',
      headerStock: 'Остаток',
      headerNotes: 'Примечание',
      headerRate: 'Ставка',
      headerQualification: 'Квалификация',
      errorExport: 'Ошибка экспорта: {{message}}',
      examplePlywood: 'Фанера березовая 18мм',
      exampleCategorySheet: 'Листовые материалы',
      exampleUnitM2: 'м²',
      exampleSupplier1: 'ООО "ЛесТорг"',
      exampleNoteHighGrade: 'Высший сорт',
      examplePvcEdge: 'Кромка ПВХ 2мм белая',
      exampleCategoryEdge: 'Кромочные материалы',
      exampleUnitLm: 'м.п.',
      exampleSupplier2: 'Мебель Комплект',
      exampleScrews: 'Саморезы 4x16',
      exampleCategoryFasteners: 'Крепеж',
      exampleUnitPack: 'упак',
      exampleSupplier3: 'Крепеж Плюс',
      exampleNotePack100: '100 шт в упаковке',
      exampleCutting: 'Раскрой материала',
      exampleCategoryWoodwork: 'Столярные работы',
      exampleUnitHour: 'час',
      exampleQualMaster: 'Мастер',
      exampleNoteIncludesMarking: 'Включает разметку',
      exampleEdgeBanding: 'Кромление деталей',
      exampleAssembly: 'Сборка изделия',
      exampleCategoryAssembly: 'Сборка',
      exampleQualCarpenter: 'Столяр 1 разряда',
      sheetInstructions: 'Инструкция',
      instrTitle: 'ИНСТРУКЦИЯ ПО ЗАПОЛНЕНИЮ БАЗЫ МАТЕРИАЛОВ',
      instrMaterialsSheet: 'Лист "Материалы":',
      instrCode: '- Код: уникальный код материала (MAT-001, MAT-002 и т.д.)',
      instrName: '- Наименование: полное название материала',
      instrCategory: '- Категория: Листовые материалы, Крепеж, Фурнитура и т.д.',
      instrUnit: '- Ед.изм: единица измерения (м², м.п., шт, кг)',
      instrPrice: '- Цена: текущая цена продажи',
      instrSupplierPrice: '- Цена пост.: цена закупки у поставщика',
      instrSupplier: '- Поставщик: название компании-поставщика',
      instrMinStock: '- Мин.остаток: минимальный остаток для предупреждения',
      instrStock: '- Остаток: текущий остаток на складе',
      instrNotes: '- Примечание: дополнительная информация',
      instrServicesSheet: 'Лист "Услуги":',
      instrServiceCode: '- Код: уникальный код услуги (SRV-001, SRV-002 и т.д.)',
      instrServiceName: '- Наименование: название работы/операции',
      instrServiceCategory: '- Категория: Столярные работы, Сборка, Отделка и т.д.',
      instrServiceUnit: '- Ед.изм: единица измерения (час, шт)',
      instrServiceRate: '- Ставка: стоимость за единицу',
      instrServiceQualification: '- Квалификация: требуемая квалификация исполнителя',
      instrServiceNotes: '- Примечание: дополнительная информация',
      instrImportant: 'ВАЖНО:',
      instrNoDeleteHeaders: '- Не удаляйте заголовки (первую строку)',
      instrUniqueCodes: '- Коды должны быть уникальными',
      instrDecimalPoint: '- Используйте точку как разделитель дробных чисел (850.50)',
      instrEmptyRows: '- Пустые строки будут проигнорированы',
      errorCreatingTemplate: 'Ошибка создания шаблона: {{message}}',
      priceChangeReason: 'Изменение цены',
    },

    // Inventory Counting
    inventoryCounting: {
      status: {
        draft: 'Черновик',
        inProgress: 'В процессе',
        completed: 'Завершена',
        cancelled: 'Отменена',
      },
      detail: {
        notFound: 'Инвентаризация не найдена',
        backToList: 'Назад к списку',
        backToListAria: 'Назад к списку инвентаризаций',
        back: 'Назад',
        title: 'Инвентаризация',
        warehouse: 'Склад',
        responsible: 'Ответственный',
        startDate: 'Дата начала',
        endDate: 'Дата завершения',
        countProgress: 'Прогресс пересчета',
        report: 'Отчет',
        autoFill: 'Автозаполнение',
        startInventory: 'Начать инвентаризацию',
        completeCount: 'Завершить',
        cancel: 'Отменить',
        product: 'Товар',
        variant: 'Вариант',
        batch: 'Партия',
        expected: 'Ожидается',
        actual: 'Фактически',
        discrepancy: 'Расхождение',
        reason: 'Причина',
        actions: 'Действия',
        noItems: 'Позиций нет. Используйте автозаполнение или добавьте вручную.',
        recount: 'Пересчитать',
        delete: 'Удалить',
        recountTitle: 'Пересчет:',
        actualRequired: 'Фактически *',
        discrepancyReason: 'Причина расхождения',
        note: 'Примечание',
        reportDialogTitle: 'Отчет по инвентаризации',
        document: 'Документ:',
        totalItems: 'Всего позиций',
        counted: 'Подсчитано',
        expectedTotal: 'Ожидается:',
        actualTotal: 'Фактически:',
        totalDiscrepancy: 'Итоговое расхождение:',
        surplus: 'Излишки:',
        deficit: 'Недостачи:',
        generatedAt: 'Сгенерировано:',
        print: 'Печать',
        pdfDownloadError: 'Ошибка загрузки PDF: ',
        excelExportError: 'Ошибка экспорта Excel: ',
        csvProduct: 'Товар',
        csvSku: 'Артикул',
        csvVariant: 'Вариант',
        csvBatch: 'Партия',
        csvExpected: 'Ожидаемое',
        csvActual: 'Фактическое',
        csvDiscrepancy: 'Расхождение',
        completedAlert: 'Инвентаризация завершена. Остатки обновлены.',
        completeError: 'Ошибка завершения инвентаризации',
        reportGenerationError: 'Ошибка генерации отчета',
        confirmStart: 'Начать инвентаризацию? После начала нельзя будет редактировать документ.',
        confirmComplete: 'Завершить инвентаризацию? Остатки будут обновлены согласно фактическим данным. Это действие необратимо.',
        confirmCancel: 'Отменить инвентаризацию?',
        confirmAutoFill: 'Автоматически заполнить позиции из остатков? Существующие позиции будут удалены.',
        confirmDeleteItem: 'Удалить позицию?',
        printReportTitle: 'Отчет по инвентаризации',
        printWarehouse: 'Склад:',
        printResponsible: 'Ответственный:',
        printStatus: 'Статус:',
        printTotalItems: 'Всего позиций:',
        printCounted: 'Подсчитано:',
        printExpectedSum: 'Сумма ожидается:',
        printActualSum: 'Сумма фактически:',
        printTotalDiscrepancy: 'Итоговое расхождение:',
        excelIndicator: 'Показатель',
        excelValue: 'Значение',
        excelTotalItems: 'Всего позиций',
        excelCounted: 'Подсчитано',
        excelExpectedSum: 'Ожидается сумма',
        excelActualSum: 'Фактически сумма',
        excelTotalDiscrepancy: 'Итоговое расхождение',
        excelSurplus: 'Излишки',
        excelDeficit: 'Недостачи',
        excelUncounted: 'Не подсчитано',
        excelProduct: 'Товар',
        excelVariant: 'Вариант',
        excelBatch: 'Партия',
        excelExpected: 'Ожидается',
        excelActual: 'Фактически',
        excelDiscrepancy: 'Расхождение',
        excelReason: 'Причина',
        excelNote: 'Примечание',
        excelSummarySheet: 'Итоги',
        excelItemsSheet: 'Позиции',
        errorUpdateItem: 'Не удалось обновить позицию',
        errorDeleteItem: 'Не удалось удалить позицию',
        errorAutoFill: 'Не удалось автозаполнить позиции',
      },
      list: {
        title: 'Инвентаризация',
        create: 'Создать',
        exportExcel: 'Экспорт Excel',
        exporting: 'Экспорт...',
        exportAll: 'Экспорт всего (Excel)',
        status: 'Статус',
        all: 'Все',
        searchByNumber: 'Поиск по номеру',
        reset: 'Сбросить',
        documentNumber: 'Номер документа',
        warehouse: 'Склад',
        responsible: 'Ответственный',
        startDate: 'Дата начала',
        endDate: 'Дата завершения',
        positions: 'Позиций',
        counted: 'Пересчитано',
        actions: 'Действия',
        loading: 'Загрузка...',
        notFound: 'Инвентаризаций не найдено',
        view: 'Просмотр',
        edit: 'Редактировать',
        start: 'Начать',
        delete: 'Удалить',
        complete: 'Завершить',
        cancel: 'Отменить',
        rowsPerPage: 'Строк на странице:',
        displayedRows: '{{from}}-{{to}} из {{count}}',
        confirmDelete: 'Удалить инвентаризацию?',
        confirmStart: 'Начать инвентаризацию? После начала нельзя будет редактировать документ.',
        confirmComplete: 'Завершить инвентаризацию? Остатки будут обновлены согласно фактическим данным.',
        confirmCancel: 'Отменить инвентаризацию?',
        excelExportError: 'Ошибка экспорта Excel: ',
        fullExportError: 'Ошибка полного экспорта: ',
        excelNumber: 'Номер',
        excelWarehouse: 'Склад',
        excelResponsible: 'Ответственный',
        excelStatus: 'Статус',
        excelStart: 'Начало',
        excelEnd: 'Завершение',
        excelPositions: 'Позиции',
        excelCounted: 'Подсчитано',
        excelSheetName: 'Инвентаризации',
      },
      errorDelete: 'Не удалось удалить инвентаризацию',
      errorStart: 'Не удалось начать инвентаризацию',
      errorComplete: 'Не удалось завершить инвентаризацию',
      errorCancel: 'Не удалось отменить инвентаризацию',
      create: {
        title: 'Создать инвентаризацию',
        back: 'Назад',
        nextDocNumber: 'Следующий номер документа:',
        createError: 'Ошибка создания инвентаризации',
        selectWarehouse: 'Выберите склад',
        selectResponsible: 'Укажите ответственного',
        warehouseLabel: 'Склад *',
        startDate: 'Дата начала',
        comment: 'Комментарий',
        fillOptions: 'Заполнение позиций',
        autoFill: 'Автоматически заполнить позиции из остатков',
        includeZeroStock: 'Включить товары с нулевым остатком',
        creating: 'Создание...',
        createBtn: 'Создать',
      },
    },

    // Media
    media: {
      productMedia: 'Медиа товара',
      viewGallery: 'Просмотр галереи',
      images: 'Изображения',
      videos: 'Видео',
      initError: 'Не удалось инициализировать видеоплеер',
      hlsNotSupported: 'HLS не поддерживается в этом браузере',
      videoNotFound: 'Видео не найдено (404). Возможно, оно было удалено из Cloudflare Stream.',
      networkError: 'Ошибка сети: {{details}}',
      playbackError: 'Ошибка воспроизведения: {{details}}',
    },

    images: {
      uploadFailed: 'Не удалось загрузить изображения',
      deleteFailed: 'Не удалось удалить изображение',
    },

    // Error Boundary
    errors: {
      pageErrorTitle: 'Ошибка страницы',
      pageErrorMessage: 'На этой странице произошла ошибка. Попробуйте обновить или вернуться на главную.',
      retry: 'Повторить',
      goHome: 'На главную',
    },

    // Image Uploader
    imageUploader: {
      maxImagesReached: 'Максимум {{max}} изображений',
      partialUpload: 'Загружаем только {{uploading}} из {{total}} файлов ({{slots}} слотов доступно)',
      failedUploads: '{{count}} файл(ов) не удалось загрузить',
      dragDropTitle: 'Перетащите изображения или нажмите для выбора',
      dragDropHint: 'Много файлов • JPEG, PNG, WebP, GIF (макс 10МБ каждый)',
      uploadingProgress: 'Загрузка {{count}} файл(ов)... {{percent}}%',
      uploadedCount: 'Загружено ({{current}}/{{max}}) • Нажмите для просмотра, перетащите для пересортировки',
      firstIsMain: 'Первое = Главное',
      reorderTip: '💡 Подсказка: перетаскивайте изображения для изменения порядка. Первое изображение — главное.',
      maxReachedHint: 'Максимальное количество изображений ({{max}}). Удалите изображение, чтобы загрузить новое.',
      noImages: 'Изображения не загружены',
    },

    // Video Uploader
    video: {
      uploadFile: 'Загрузить файл',
      uploadFromUrl: 'Загрузить по ссылке',
      uploadFromUrlTitle: 'Загрузка видео по ссылке',
      hdLabel: 'HD',
      streamLabel: 'Stream',
      r2Label: 'R2',
      videoNamePlaceholder: 'Демо-видео товара',
      dragDropPrompt: 'Перетащите видео или нажмите для выбора',
      cloudflareHint: 'Загружается в Cloudflare Stream (автоматическое HD-перекодирование)',
      supportedFormats: 'Поддерживаемые форматы: MP4, WebM, MOV, AVI (макс. 1ГБ)',
      supportedHint: 'Поддерживается: MP4, WebM, MOV, AVI',
      videoUrl: 'URL видео',
      videoNameOptional: 'Название видео (необязательно)',
      videoFromUrl: 'Видео по ссылке',
      uploading: 'Загрузка... {{progress}}%',
      uploadedCount: 'Загруженные видео ({{count}}/{{max}})',
      statusProcessing: 'Обработка',
      statusReady: 'Готово',
      maxReached: 'Достигнуто максимальное количество видео ({{max}}). Удалите видео, чтобы загрузить новое.',
      uploadFailed: 'Не удалось загрузить видео',
      deleteFailed: 'Не удалось удалить видео',
      enterUrlError: 'Введите URL видео',
    },
  },

  en: {
    // Common
    common: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      search: 'Search',
      filter: 'Filter',
      export: 'Export',
      import: 'Import',
      loading: 'Loading...',
      noData: 'No data',
      error: 'Error',
      success: 'Success',
      confirm: 'Confirm',
      confirmTitle: 'Confirmation',
      confirmMessage: 'Are you sure?',
      yes: 'Yes',
      no: 'No',
      refresh: 'Refresh',
      active: 'Active',
      inactive: 'Inactive',
      saving: 'Saving...',
      update: 'Update',
      create: 'Create',
      actions: 'Actions',
      close: 'Close',
      back: 'Back',
      next: 'Next',
      all: 'All',
      status: 'Status',
      name: 'Name',
      total: 'Total',
      details: 'Details',
      unknownError: 'Unknown error',
      retry: 'Retry',
      view: 'View',
      rowsPerPage: 'Rows per page:',
      of: 'of',
      closeGallery: 'Close gallery',
      previousImage: 'Previous image',
      nextImage: 'Next image',
      deleteImage: 'Delete image',
      deleteVideo: 'Delete video',
      refreshWidget: 'Refresh widget',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      notifications: 'Notifications',
      changeLanguage: 'Change language',
      expand: 'Expand',
      collapse: 'Collapse',
      selectVideoQuality: 'Select video quality',
      previousMedia: 'Previous media',
      nextMedia: 'Next media',
      hideMenu: 'Hide menu',
      collapseMenu: 'Collapse menu',
      markAsRead: 'Mark as read',
      manageColumns: 'Manage columns',
      dragColumnsHint: 'Drag columns to reorder',
      resetOrder: 'Reset order',
      showAll: 'Show all',
      done: 'Done',
      noDataToDisplay: 'No data to display',
      tableUnavailable: 'Table temporarily unavailable',
      tryAgain: 'Try again',
      enableDataGrid: 'Enable table (DataGrid)',
      dataGridDisabled: 'DataGrid disabled due to render error. Showing simplified mode.',
      auto: 'Auto',
      autoAdaptive: 'Auto (Adaptive)',
      videoQuality: 'Video quality',
      currencyKGS: 'som',
      ms: 'ms',
      seconds: 's',
      displayedRows: '{{from}}–{{to}} of {{count}}',
      product: 'Product',
      email: 'Email',
      video: 'Video',
      image: 'Image',
      upload: 'Upload',
      statusSuccess: 'Success',
      statusError: 'Error',
      statusPending: 'Pending',
      statusProcessing: 'Processing',
      currencyCode: 'KGS',
      none: 'None',
    },
    profile: {
      open: 'Open profile',
    },

    // Navigation
    nav: {
      dashboard: 'Dashboard',
      products: 'Products',
      inventory: 'Inventory',
      orders: 'Orders',
      users: 'Users',
      analytics: 'Analytics',
      settings: 'Settings',
      logout: 'Logout',
      openMenu: 'Open menu',
      more: 'More',
      notifications: 'Notifications',
      language: 'Language',
      categories: 'Categories',
      batches: 'Product Batches',
      roles: 'Roles & Permissions',
      badges: 'Product Badges',
      counting: 'Stock Counting',
      serials: 'Serial Numbers',
      purchases: 'Purchases',
      bom: 'Bill of Materials (BOM)',
      manufacturing: 'Manufacturing',
      production: 'Production Tracker',
      materials: 'Materials',
      qualityControl: 'Quality Control',
      finance: 'Finance',
      messenger: 'Messenger',
      customerSupport: 'Customer Support',
      integrations: 'Integrations',
      suppliers: 'Suppliers',
      advancedAnalytics: 'Advanced Analytics',
      organizations: 'Organizations',
      onecDatabases: '1C Databases',
      onecMetrics: '1C Metrics',
      onecHealth: '1C Health',
      onecSyncLogs: '1C Logs',
      onecInstaller: 'Download 1C',
      connectorSettings: 'Connector Settings',
      newBatch: 'New Batch',
      newCounting: 'New Counting',
      pin: 'Pin',
      unpin: 'Unpin',
      pinAction: 'Pin action: {{label}}',
      unpinAction: 'Unpin action: {{label}}',
      pinHint: 'To pin an action: tap the 📌 or long-press the icon.',
      myProfile: 'My Profile',
      home: 'Home',
      superAdmin: 'SUPER ADMIN',
      featureFlags: 'Feature Flags',
      adminPanel: 'Admin Panel',
      mobileHome: 'Home',
      mobileOrders: 'Orders',
      mobileInventory: 'Inventory',
      mobileAnalytics: 'Analytics',
      mobileMenu: 'Menu',
    },

    // Theme
    theme: {
      lightTheme: 'Light theme',
      darkTheme: 'Dark theme',
      toggle: 'Toggle theme',
    },

    // Export (Excel price lists)
    export: {
      priceList: 'Price List',
      sku: 'SKU',
      photo: 'Photo',
      productName: 'Product Name',
      description: 'Description',
      category: 'Category',
      priceWithCurrency: 'Price ({{currency}})',
      priceB2B: 'B2B Price ({{currency}})',
      priceQty10: 'Price for 10 pcs ({{currency}})',
      priceQty50: 'Price for 50 pcs ({{currency}})',
      stock: 'Availability',
      inStock: 'In stock',
      toOrder: 'To order',
      phone: 'Phone',
      address: 'Address',
      website: 'Website',
      report: 'Report',
      generated: 'Generated',
      page: 'Page',
      orderNumber: 'Order',
      status: 'Status',
      customerInformation: 'Customer Information',
      customerName: 'Name',
      email: 'Email',
      orderItems: 'Order Items',
      productCol: 'Product',
      skuCol: 'SKU',
      qtyCol: 'Qty',
      priceCol: 'Price',
      totalCol: 'Total',
      orderSummary: 'Order Summary',
      subtotal: 'Subtotal',
      shipping: 'Shipping',
      discount: 'Discount',
      totalLabel: 'Total',
      notes: 'Notes',
      platformName: 'WASSER E-commerce Platform',
      emailAttachedReport: 'Please find the attached report',
      emailRegards: 'Best regards,',
    },

    // Products
    products: {
      title: 'Product Management',
      addProduct: 'Add Product',
      editProduct: 'Edit Product',
      columnName: 'Name',
      columnCategory: 'Category',
      columnPrice: 'Price',
      columnStock: 'Balance',
      columnStatus: 'Status',
      columnActions: 'Actions',
      editVariant: 'Edit variant',
      deleteVariant: 'Delete variant',
      variantName: 'Variant Name',
      variantUpdated: 'Variant updated',
      variantCreated: 'Variant created',
      variantDeleted: 'Variant deleted',
      confirmDeleteVariant: 'Delete this variant?',
      productVariants: 'Product Variants',
      addVariant: 'Add Variant',
      editVariantTitle: 'Edit Variant',
      addVariantTitle: 'Add Variant',
      failedToLoadData: 'Failed to load data',
      failedToSave: 'Failed to save product',
      deleteProduct: 'Delete Product',
      noMedia: 'No media available for this product',
      openMedia: 'Open media',
      productName: 'Product Name',
      sku: 'SKU',
      price: 'Price',
      stock: 'Stock',
      stockAvailable: 'Available',
      stockOnHand: 'On hand',
      stockReserved: 'Reserved',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      lowStock: 'Low Stock',
      outOfStock: 'Out of Stock',
      category: 'Category',
      description: 'Description',
      images: 'Images',
      specifications: 'Specifications',
      pricing: 'Pricing',
      b2bPrice: 'B2B Price',
      volumePrice: 'Volume Price',
      qty10Price: 'Price for 10+ pcs',
      qty50Price: 'Price for 50+ pcs',
      stockQuantity: 'Stock Quantity',
      confirmDelete: 'Are you sure you want to delete this product?',
      deleteSuccess: 'Product successfully deleted',
      saveSuccess: 'Product successfully saved',
      totalCountLabel: 'Active products',
      featured: 'Featured',
      featuredBadge: 'Highlighted in storefront',
      noLowStock: 'No low-stock items',
      createProduct: 'Create Product',
      deleteAll: 'Delete All',
      basicInfo: 'Basic Information',
      noCategory: 'No category',
      nameRu: 'Name (Russian)',
      nameEn: 'Name (English)',
      nameKy: 'Name (Kyrgyz)',
      descriptionRu: 'Description (Russian)',
      descriptionEn: 'Description (English)',
      descriptionKy: 'Description (Kyrgyz)',
      retailPrice: 'Retail Price',
      quantity: 'Stock Quantity',
      lowThreshold: 'Low Stock Threshold',
      isActive: 'Active (visible to customers)',
      isFeatured: 'Featured (show on homepage)',
      errors: {
        skuRequired: 'SKU is required',
      },
      // Product management page
      columnName: 'Name',
      columnActions: 'Actions',
      viewMode: 'View mode',
      viewGridLarge: 'Large grid',
      viewGridSmall: 'Small grid',
      viewListPhoto: 'List with photos',
      viewTable: 'Table',
      sorting: 'Sort',
      sortByName: 'By name',
      sortByPrice: 'By price',
      sortByDate: 'By date',
      sortByStock: 'By stock',
      sortByStatus: 'By status',
      sortAsc: 'Ascending',
      sortDesc: 'Descending',
      sortAscLabel: 'Sort ascending',
      sortDescLabel: 'Sort descending',
      filters: 'Filters',
      resetAll: 'Reset all',
      allStatuses: 'All statuses',
      activeFilter: 'Active',
      inactiveFilter: 'Inactive',
      allCategories: 'All categories',
      openFilters: 'Open filters',
      searchPlaceholder: 'Search by name, SKU or category...',
      clearSearch: 'Clear search',
      productBundles: 'Product Bundles',
      exportExcel: 'Export Excel',
      manageColumns: 'Manage columns',
      variants: 'Variants',
      manageVariants: 'Manage product variants',
      openVariants: 'Open product variants',
      exportWithPhotos: 'Full export with photos',
      exportWithoutPhotos: 'Full export without photos',
      exportPriceListCustom: 'Price list (customizable)',
      shown: 'Shown',
      productUpdated: 'Product "{{name}}" successfully updated',
      productCreated: 'Product "{{name}}" successfully created',
      missingSlug: 'Error: product slug/id is missing',
      confirmDeleteProduct: 'Delete product "{{name}}"? This action cannot be undone.',
      productDeleted: 'Product "{{name}}" deleted.',
      cannotDeleteLinked: 'Cannot delete product "{{name}}".\n\nProduct is used in orders or other related records. Delete related data first.',
      deleteError: 'Delete error',
      confirmDeleteAllProducts: 'Delete ALL products? This action cannot be undone.',
      deletedCount: 'Products deleted: {{count}}',
      bulkDeleteError: 'Bulk delete error',
      noProductsToExport: 'No products to export',
      exportError: 'Export error',
      priceListExportError: 'Price list export error',
      noMatchingProducts: 'No products match the filters. Try changing search parameters.',
      authRequired: 'Authorization required',
      closeDialog: 'Close dialog',
      exportPhoto: 'Photo',
      exportNameRu: 'Name (RU)',
      exportNameEn: 'Name (EN)',
      exportNameKy: 'Name (KY)',
      exportPriceKgs: 'Price (KGS)',
      exportPriceB2b: 'B2B Price (KGS)',
      exportStockCol: 'Stock',
      exportAvailable: 'Available',
      exportOnHand: 'On hand',
      exportReserved: 'Reserved',
      exportCategory: 'Category',
      exportStatus: 'Status',
      exportFeatured: 'Featured',
      exportCreated: 'Created',
      exportUpdated: 'Updated',
      exportDescRu: 'Description (RU)',
      exportDescEn: 'Description (EN)',
      exportDescKy: 'Description (KY)',
      exportQty10: 'Price for 10 pcs (KGS)',
      exportQty50: 'Price for 50 pcs (KGS)',
      // ProductForm
      form: {
        changesSaved: 'Changes saved',
        tabBasicInfo: 'Basic Information',
        tabPricing: 'Pricing',
        tabStock: 'Stock',
        tabMedia: 'Media',
        tabBom: 'BOM Specification',
        tabCost: 'Cost Price',
        skuNoChange: 'SKU cannot be changed after creation',
        skuHint: 'Unique product code',
        skuPlaceholder: 'E.g.: PROD-001',
        nameRuPlaceholder: 'Enter name in Russian',
        nameEnPlaceholder: 'Enter name in English',
        nameKyPlaceholder: 'Enter name in Kyrgyz',
        descRuPlaceholder: 'Detailed product description in Russian...',
        descEnPlaceholder: 'Detailed product description in English...',
        descKyPlaceholder: 'Detailed product description in Kyrgyz...',
        chars: 'characters',
        currencySom: 'som',
        retailPriceHint: 'Main price for customers',
        b2bPriceHint: 'Price for wholesale customers',
        qty10Hint: 'When buying 10+ units',
        qty50Hint: 'When buying 50+ units',
        pcs: 'pcs',
        stockQtyHint: 'Current warehouse stock quantity',
        lowThresholdHint: 'Warning when this level is reached',
        lowStockWarning: 'Product is running low! Current stock: {{qty}} pcs',
        bomUnavailable: 'BOM is only available for saved products. Please create the product first.',
        costUnavailable: 'Cost calculation is only available for saved products. Please create the product first.',
        editingProduct: 'Editing product',
        creatingProduct: 'Creating new product',
        productFallback: 'Product',
      },
    },

    // Badges
    badges: {
      title: 'Product Badge Management',
      subtitle: 'Assign promotional badges to products: Hot, New, Black Friday, New Year Sale, etc.',
      loadError: 'Failed to load products',
      addError: 'Failed to add badge',
      deleteConfirm: 'Delete this badge?',
      deleteError: 'Failed to delete badge',
      bulkDeleteConfirm: 'Remove badge "{{badge}}" from {{count}} products?',
      bulkDeleteError: 'Failed to remove badges',
      columnProduct: 'Product',
      noName: 'Untitled',
      columnStatus: 'Status',
      statusActive: 'Active',
      statusHidden: 'Hidden',
      columnBadges: 'Badges',
      noBadges: 'No badges',
      columnActions: 'Actions',
      addBadge: 'Add badge',
      selected: 'Selected: {{count}} products',
      removeBadge: 'Remove badge',
      filterAll: 'All',
      dialogTitleBulk: 'Add badge to {{count}} products',
      dialogTitleSingle: 'Add badge: {{name}}',
      badgeType: 'Badge type',
      discountPercent: 'Discount percentage',
      discountHint: 'Optional: will be shown on badge',
      startDate: 'Start date (optional)',
      endDate: 'End date (optional)',
      customImageUrl: 'Badge image URL (PNG)',
      customImageHint: 'Upload PNG and paste the link',
      customText: 'Badge text',
      customPlaceholder: 'Custom text',
      preview: 'Preview:',
      types: {
        hot: { label: 'Hot 🔥', description: 'Popular product' },
        new: { label: 'New ✨', description: 'New product in catalog' },
        sale: { label: 'Sale 💰', description: 'Discounted product' },
        black_friday: { label: 'Black Friday 🖤', description: 'Black Friday promotion' },
        new_year: { label: 'New Year Sale 🎄', description: 'New Year promotion' },
        limited: { label: 'Limited ⏰', description: 'Limited offer' },
        bestseller: { label: 'Bestseller ⭐', description: 'Sales leader' },
        custom: { label: 'Custom 🏷️', description: 'Custom badge with PNG' },
      },
    },

    // Bundles
    bundles: {
      title: 'Product Bundles',
      subtitle: 'Create and manage product bundles with special pricing',
      loadError: 'Failed to load bundles',
      updated: 'Bundle updated',
      created: 'Bundle created',
      saveError: 'Save error',
      deleteConfirm: 'Delete this bundle?',
      deleted: 'Bundle deleted',
      deleteError: 'Delete error',
      backToProducts: 'Back to products',
      createBundle: 'Create bundle',
      empty: 'No bundles yet. Create a bundle to offer customers a set of products at a special price.',
      statusActive: 'Active',
      statusInactive: 'Inactive',
      itemsCount: 'Products in bundle: {{count}}',
      composition: 'Contents:',
      dialogEdit: 'Edit bundle',
      dialogCreate: 'Create bundle',
      nameLabel: 'Bundle name',
      nameHint: 'E.g.: Premium Bathroom Set',
      skuHint: 'Bundle SKU',
      priceLabel: 'Bundle price',
      currencySom: 'som',
      descriptionLabel: 'Description',
      itemsTitle: 'Products in bundle',
      selectProduct: 'Select product',
      quantity: 'Qty',
      addItem: 'Add',
      removeItemAria: 'Remove product from bundle',
      noItemsWarning: 'Add at least one product to the bundle',
      totalSeparate: 'Individual items total:',
      bundlePrice: 'Bundle price:',
      savings: 'Savings:',
      isActive: 'Bundle active',
      nameRequired: 'Enter bundle name',
      itemsRequired: 'Add at least one product to the bundle',
      deleteMessage: 'This action cannot be undone',
    },
    dashboard: {
      title: 'Dashboard',
      welcome: 'Welcome to the Furniture E-commerce Admin Panel',
      totalUsers: 'Total Users',
      products: 'Products',
      ordersToday: 'Orders Today',
      revenue: 'Revenue',
  revenue30d: '30-Day Revenue',
      recentActivity: 'Recent Activity',
      activityChart: 'Activity chart and recent orders would be displayed here',
      quickActions: 'Quick Actions',
      addNewProduct: 'Add New Product',
      viewPendingOrders: 'View Pending Orders',
      userManagement: 'User Management',
  activeUsersLabel: 'Active',
  lowStockLabel: 'Low stock',
  pendingOrdersLabel: 'In progress',
  revenueTodayLabel: 'Today',
  lowStockTitle: 'Low-stock products',
  unknownDate: 'Unknown date',
      subtitle: 'Business Management Panel (ERP-light)',
      refresh: 'Refresh',
      dataPartialWarning: 'Some data is unavailable. Dashboard will show fallback values.',
      revenueMtd: 'Revenue (MTD)',
      vsPrevMonth: 'vs prev month',
      ordersToday: 'Orders Today',
      vsYesterday: 'vs yesterday',
      conversionPct: 'Conversion (%)',
      marginPct: 'Margin (%)',
      salesRevenue: 'Sales / Revenue',
      additionalMetrics: 'Additional Metrics',
      ordersVolume: 'Operations — Orders Volume',
      inventoryAlerts: 'Inventory Alerts',
      inventoryHealth: 'Inventory Health',
      orderFlow: 'Order Flow',
      activityFeed: 'Activity / Signal Feed',
      createPurchase: 'Create Purchase',
      justNow: 'just now',
      minutesAgo: '{{m}} min ago',
      hoursAgo: '{{h}} h ago',
      daysAgo: '{{d}} d ago',
      noEvents: 'No events.',
      event: 'Event',
      // Dashboard components
      inventoryRiskTitle: 'Inventory as Financial Risk',
      inventoryHealthAria: 'Segmented inventory health indicator',
      okStock: 'OK stock',
      lowStock: 'Low stock',
      outOfStock: 'Out of stock',
      severityCritical: 'CRITICAL',
      severityWarning: 'WARNING',
      severityInfo: 'INFO',
      noInventoryAlerts: 'No inventory alerts.',
      productFallback: 'Product',
      createPurchaseAria: 'Create purchase for SKU',
      purchaseBtn: 'Purchase',
      stockRemaining: 'Stock',
      pctVsPrevDay: '{{pct}}% vs previous day',
      revenueRangeAria: 'Select revenue period',
      avgOrderValue: 'Avg Order Value',
      ordersMtd: 'Orders (MTD)',
      avgFulfillmentTime: 'Avg Fulfillment Time',
      days: 'days',
      thisMonth: 'this month',
      today: 'today',
      topProducts: 'Top 5 Products',
      noTopProducts: 'No product data available',
      orders: 'orders',
    },

    // Orders
    orders: {
      title: 'Order Management',
      subtitle: 'Manage B2B and B2C customer orders',
      confirmBulkDelete: 'Delete {{count}} orders?',
      orderId: 'Order ID',
      orderNumber: 'Order Number',
      customer: 'Customer',
      date: 'Date',
      total: 'Total',
      type: 'Type',
      status: 'Status',
      actions: 'Actions',
      pending: 'Pending',
      confirmed: 'Confirmed',
      processing: 'Processing',
      shipped: 'Shipped',
      delivered: 'Delivered',
      cancelled: 'Cancelled',
      view: 'View',
      viewDetails: 'View Details',
      quickConfirm: 'Confirm',
      quickProcess: 'Process',
      updateStatus: 'Update Status',
      noRecentOrders: 'No recent orders',
      // API-related
      errorLoadOrders: 'Failed to load orders',
      filterByStatus: 'Filter by status',
      filterByType: 'Customer type',
      filterByDate: 'Period',
      searchPlaceholder: 'Search by number, name, phone...',
      allOrders: 'Total',
      todayOrders: 'Today',
      period_all: 'All time',
      period_today: 'Today',
      period_week: 'Week',
      period_month: 'Month',
      period_quarter: 'Quarter',
      guest: 'Guest',
      // Status translations (with status_ prefix for dynamic lookup)
      status_pending: 'Pending',
      status_processing: 'Processing',
      status_shipped: 'Shipped',
      status_delivered: 'Delivered',
      status_cancelled: 'Cancelled',
      // PDF Export
      pdf: {
        orderTitle: 'ORDER',
        date: 'Date',
        orderInfo: 'Order Information',
        status: 'Status',
        type: 'Type',
        payment: 'Payment',
        paymentMethod: 'Payment Method',
        customer: 'Customer',
        customerName: 'Name',
        phone: 'Phone',
        shippingAddress: 'Shipping Address',
        orderItems: 'Order Items',
        product: 'Product',
        qty: 'Qty',
        price: 'Price',
        total: 'Total',
        subtotal: 'Subtotal',
        tax: 'Tax',
        shipping: 'Shipping',
        grandTotal: 'TOTAL',
        orderHistory: 'Order History',
        note: 'Note',
        footer: 'Generated automatically by the management system | Page {{current}} of {{total}}',
        currencyShort: 's',
        email: 'Email',
        sku: 'SKU',
      },
      // Kanban view
      kanbanTitle: 'Orders Kanban Board',
      kanbanView: 'Kanban',
      tableView: 'Table',
      noOrders: 'No orders',
      unknownCustomer: 'Unknown customer',
      loadError: 'Failed to load orders',
      statusUpdateError: 'Failed to update status',
      changeStatusTitle: 'Change Order Status',
      changeStatusConfirm: 'Move order #{{orderId}} to "{{newStatus}}"?',
      cancelReason: 'Cancellation reason',
      status_confirmed: 'Confirmed',
      moveTo_confirmed: 'Confirm',
      moveTo_processing: 'To Processing',
      moveTo_shipped: 'Ship',
      moveTo_delivered: 'Mark Delivered',
      moveTo_cancelled: 'Cancel',
      statusUpdatedToast: 'Order #{{orderId}} updated: {{status}}',
      overdue: 'SLA Breach',
      saveView: 'Save View',
      viewNamePlaceholder: 'View name...',
      viewSaved: 'View saved',
      savedViews: 'Saved Views',
    },

    // Users
    users: {
      title: 'User Management',
      addUser: 'Add User',
      name: 'Name',
      email: 'Email',
      role: 'Role',
      status: 'Status',
      actions: 'Actions',
      admin: 'Administrator',
      b2b: 'B2B Client',
      b2bVerified: 'B2B Verified',
      b2bCandidate: 'B2B Candidate',
      b2c: 'B2C Client',
      b2cCustomer: 'B2C Customer',
      createdAt: 'Registration Date',
      lastLogin: 'Last Login',
      active: 'Active',
      pending: 'Pending',
      blocked: 'Blocked',
      subtitle: 'Manage B2C and B2B customers',
    },

    // Roles Management
    roles: {
      title: 'Role Management',
      subtitle: 'Configure roles and user access permissions',
      newRole: 'New Role',
      editRole: 'Edit Role',
      searchPlaceholder: 'Search by name, code or description...',
      manageColumns: 'Manage Columns',
      colRole: 'Role',
      colCode: 'Code',
      colDescription: 'Description',
      colPermissions: 'Permissions',
      colUsers: 'Users',
      colActions: 'Actions',
      module_products: 'Products',
      module_orders: 'Orders',
      module_customers: 'Customers',
      module_inventory: 'Warehouse',
      module_manufacturing: 'Manufacturing',
      module_bom: 'BOM Specifications',
      module_materials: 'Materials',
      module_qc: 'Quality Control',
      module_purchases: 'Purchases',
      module_analytics: 'Analytics',
      module_reports: 'Reports',
      module_settings: 'Settings',
      module_integrations: 'Integrations',
      module_users: 'Users',
      module_roles: 'Roles',
      perm_view: 'View',
      perm_create: 'Create',
      perm_edit: 'Edit',
      perm_delete: 'Delete',
      perm_export: 'Export',
      perm_import: 'Import',
      perm_cancel: 'Cancel',
      perm_approve: 'Approve',
      perm_adjust: 'Adjust',
      perm_count: 'Inventory Count',
      perm_start: 'Start',
      perm_complete: 'Complete',
      perm_price_update: 'Price Update',
      perm_schedule: 'Schedule',
      perm_roles: 'Role Management',
      perm_assign: 'Assign',
      perm_hold: 'Hold',
      perm_release: 'Release',
      perm_receive: 'Receive',
      perm_sync: 'Sync',
      perm_advanced: 'Advanced',
      basicInfo: 'Basic Information',
      nameLabel: 'Name *',
      codeLabel: 'Code *',
      descriptionLabel: 'Description',
      permissionsSection: 'Access Permissions',
      validationRequired: 'Required field',
      validationCodeFormat: 'Latin letters and _ only',
      codeHelperText: 'Unique identifier (Latin)',
      generateCode: 'Generate code',
      create: 'Create',
      system: 'System',
      notFound: 'Nothing found',
      noRoles: 'No roles',
      viewUsers: 'View users',
      editTooltip: 'Edit',
      copyTooltip: 'Copy',
      deleteTooltip: 'Delete',
      editRoleLabel: 'Edit role',
      copyRoleLabel: 'Copy role',
      deleteRoleLabel: 'Delete role',
      deleteTitle: 'Delete Role?',
      deleteConfirmText: 'Are you sure you want to delete role',
      deleteWarningText: 'This role has users. They will lose access permissions.',
      usersWithRole: 'Users with role',
      noUsersWithRole: 'No users with this role',
      roleUpdated: 'Role updated successfully',
      roleCreated: 'Role created successfully',
      roleDeleted: 'Role deleted',
      roleCloned: 'Role cloned',
      loadError: 'Failed to load roles',
      saveError: 'Save error',
      deleteError: 'Delete error',
      cloneError: 'Clone error',
      serverError: 'Server error',
      // Role names (fallback)
      roleName_super_admin: 'Super Admin',
      roleName_admin: 'Administrator',
      roleName_manager: 'Manager',
      roleName_operator: 'Operator',
      roleName_warehouse: 'Warehouse Keeper',
      roleName_qc_inspector: 'QC Inspector',
      roleName_purchaser: 'Purchaser',
      roleName_analyst: 'Analyst',
      roleName_viewer: 'Viewer',
      // Role descriptions (fallback)
      roleDesc_super_admin: 'Full access to all features',
      roleDesc_admin: 'System management without system settings',
      roleDesc_manager: 'Work with orders and customers',
      roleDesc_operator: 'Order processing',
      roleDesc_warehouse: 'Warehouse management',
      roleDesc_qc_inspector: 'Product quality control',
      roleDesc_purchaser: 'Purchase management',
      roleDesc_analyst: 'Access to reports and analytics',
      roleDesc_viewer: 'View-only access',
    },

    // Analytics
    analytics: {
      title: 'Analytics & Reporting',
      totalRevenue: 'Total Revenue',
      b2bRevenue: 'B2B Revenue',
      b2cRevenue: 'B2C Revenue',
      newCustomers: 'New Customers',
      revenue: 'Revenue',
      orders: 'Orders',
      customers: 'Customers',
      products: 'Products',
      thisMonth: 'This Month',
      lastMonth: 'Last Month',
      growthRate: 'Growth',
      topProducts: 'Top Products',
      recentOrders: 'Recent Orders',
      b2bVsB2c: 'B2B vs B2C Performance',
      b2bPerformance: 'B2B accounts for 71% of total revenue with higher average order value. B2C shows steady growth in customer acquisition.',
      topProductsDesc: 'Executive furniture and office solutions lead sales. Standing desks show 25% growth in B2B segment.',
      overview: 'Overview',
      qualityControl: 'Quality Control',
      manufacturing: 'Manufacturing',
      purchasesTab: 'Purchases',
      qcDataUnavailable: 'QC data unavailable',
      totalInspections: 'Total Inspections',
      passed: 'Passed',
      successful: 'successful',
      failed: 'Failed',
      activeHolds: 'Active Holds',
      qualityScore: 'Quality Score',
      targetScore: 'Target score',
      manufacturingDataUnavailable: 'Manufacturing data unavailable',
      totalOrders: 'Total Orders',
      inProgress: 'In Progress',
      today: 'today',
      planned: 'Planned',
      forWeek: 'for the week',
      completed: 'Completed',
      demoProduct1: 'Modern Cabinet 60cm',
      demoProduct2: 'LED Mirror 80x60',
      demoProduct3: 'Toilet WASSER Pro',
      demoProduct4: 'Faucet Cascade',
      sales: 'sales',
      purchasesComingSoon: 'Purchase analytics will be available in the next update',
    },

    // Settings
    settings: {
      title: 'Settings',
      customization: 'Customization',
      customizationDesc: 'Modules, custom fields, access rights and integrations',
      general: 'General Settings',
      generalSettings: 'General Settings',
      systemSettings: 'System Settings',
      apiConfiguration: 'API Configuration',
      siteName: 'Site Name',
      adminEmail: 'Admin Email',
      supportEmail: 'Support Email',
      saveChanges: 'Save Changes',
      updateApiSettings: 'Update API Settings',
      enableB2b: 'Enable B2B Registration',
      emailNotifications: 'Email Notifications',
      maintenanceMode: 'Maintenance Mode',
      autoApproveB2b: 'Auto-approve B2B Applications',
      realtimeInventory: 'Real-time Inventory Updates',
      apiBaseUrl: 'API Base URL',
      stripeApiKey: 'Stripe API Key',
      profile: 'Profile',
      security: 'Security',
      notifications: 'Notifications',
      language: 'Language',
      theme: 'Theme',
      light: 'Light',
      dark: 'Dark',
      comingSoon: 'Coming soon',
    },

    // Inventory
    inventory: {
      tabs: { warehouses: 'Warehouses', stock: 'Stock', movements: 'Movements', history: 'History' },
      warehouses: {
        list: 'Warehouses',
        empty: 'No warehouses yet',
        seed: 'Seed default warehouse',
        create: 'Create warehouse',
        all: 'All warehouses',
      },
      stock: { title: 'Stock', columns: { onHandReserved: 'On hand / Reserved', available: 'Available' } },
      movements: { title: 'Stock Movement', submit: 'Submit', result: 'Result' },
      history: {
        title: 'Movement History',
        empty: 'No movement history',
        allTypes: 'All types',
        columns: {
          date: 'Date',
          type: 'Type',
          warehouse: 'Warehouse',
          qty: 'Qty',
          product: 'Product',
        },
      },
      movementType: {
        RECEIVE: 'Receive',
        ISSUE: 'Issue',
        TRANSFER: 'Transfer',
        RESERVE: 'Reserve',
        RELEASE: 'Release',
        ADJUST: 'Adjust',
      },
      fields: {
        name: 'Name',
        code: 'Code',
        warehouse: 'Warehouse',
        warehouseTo: 'Destination Warehouse',
        productId: 'Product ID',
        qty: 'Quantity',
        type: 'Movement type',
        reason: 'Reason',
      },
      subtitle: 'Manage warehouses, stock levels and product movements',
      status: {
        draft: 'Draft',
        inProgress: 'In Progress',
        completed: 'Completed',
        cancelled: 'Cancelled',
        active: 'Active',
        completedFem: 'Completed',
        cancelledFem: 'Cancelled',
      },
      list: {
        title: 'Inventory',
        subtitle: 'Warehouse inventory management',
        refresh: 'Refresh',
        create: 'Create Inventory',
        searchPlaceholder: 'Search by number...',
        authRequired: 'Authorization required to access inventory',
        deleteError: 'Delete error: {{message}}',
        deleteDraftOnly: 'Only drafts can be deleted',
        confirmDelete: 'Delete inventory {{number}}?',
        reportCompletedOnly: 'Report is only available for completed inventories',
        colDocumentNumber: 'Document Number',
        colStatus: 'Status',
        colWarehouse: 'Warehouse',
        colResponsible: 'Responsible',
        colStartDate: 'Start Date',
        colEndDate: 'End Date',
        colPositions: 'Items',
        colCounted: 'Counted',
        colDiscrepancies: 'Discrepancies',
        colActions: 'Actions',
        tooltipView: 'View',
        tooltipEdit: 'Edit',
        tooltipDownload: 'Download Report',
        tooltipDelete: 'Delete',
        filterStatus: 'Status',
        filterWarehouse: 'Warehouse',
        allStatuses: 'All Statuses',
        allWarehouses: 'All Warehouses',
      },
      create: {
        title: 'Create Inventory',
        subtitle: 'Create a new warehouse inventory',
        back: 'Back',
        errorCreate: 'Error creating inventory',
        selectWarehouse: 'Select warehouse',
        selectResponsible: 'Select responsible person',
        specifyStartDate: 'Specify start date',
        warehouseLabel: 'Warehouse',
        responsibleLabel: 'Responsible',
        startDateLabel: 'Start Date',
        commentLabel: 'Comment',
        commentPlaceholder: 'Additional information about the inventory...',
        loading: 'Loading...',
        fillOptions: 'Fill Options',
        autoFill: 'Auto-fill with warehouse items',
        includeZeroStock: 'Include items with zero stock',
        cancel: 'Cancel',
        filling: 'Filling items...',
        creating: 'Creating...',
        createDraft: 'Create Draft',
      },
      detail: {
        back: 'Back',
        title: 'Inventory',
        notFound: 'Inventory not found',
        confirmCancel: 'Are you sure you want to cancel the inventory?',
        start: 'Start',
        complete: 'Complete',
        cancel: 'Cancel',
        report: 'Report',
        infoTitle: 'Inventory Information',
        warehouse: 'Warehouse',
        responsible: 'Responsible',
        createdDate: 'Created Date',
        startDate: 'Start Date',
        endDate: 'End Date',
        comment: 'Comment',
        statsTitle: 'Statistics',
        totalPositions: 'Total items',
        checkedPositions: 'Items checked',
        withDiscrepancies: 'With discrepancies',
        checkProgress: 'Check progress',
        itemsTitle: 'Inventory Items',
        addItem: 'Add Item',
        product: 'Product',
        sku: 'SKU',
        expected: 'Expected',
        actual: 'Actual',
        discrepancy: 'Discrepancy',
        commentCol: 'Comment',
        actionsCol: 'Actions',
        noItems: 'No items found',
        commentPlaceholder: 'Comment',
        errorSaveEdit: 'Failed to save changes',
        errorStart: 'Failed to start inventory',
        errorComplete: 'Failed to complete inventory',
        errorCancel: 'Failed to cancel inventory',
      },
      report: {
        title: 'Inventory Reports',
        refresh: 'Refresh',
        noExportData: 'No data to export',
        downloadError: 'Error downloading report',
        totalInventories: 'Total inventories',
        withDiscrepancies: 'With discrepancies',
        totalPositions: 'Total items',
        valueDifference: 'Value difference',
        filters: 'Filters',
        clear: 'Clear',
        reportType: 'Report Type',
        typeSummary: 'Summary',
        typeDetailed: 'Detailed',
        typeDiscrepancies: 'Discrepancies only',
        warehouseLabel: 'Warehouse',
        statusLabel: 'Status',
        responsibleLabel: 'Responsible',
        dateFrom: 'Date from',
        dateTo: 'Date to',
        allWarehouses: 'All warehouses',
        allStatuses: 'All statuses',
        allUsers: 'All users',
        onlyDiscrepancies: 'Only with discrepancies',
        noData: 'No data to display. Try changing filters.',
        colId: 'ID',
        colWarehouse: 'Warehouse',
        colStatus: 'Status',
        colResponsible: 'Responsible',
        colCreatedDate: 'Created Date',
        colEndDate: 'End Date',
        colPositions: 'Items',
        colDiscrepancies: 'Discrepancies',
        colValueDiff: 'Difference (KGS)',
        hasDiscrepancies: 'Yes',
        noDiscrepancies: 'No',
      },
      errorCreateWarehouse: 'Error creating warehouse',
      errorSeedDefault: 'Error creating default warehouse',
      errorPostMovement: 'Error creating inventory movement',
    },

    // Auth
    auth: {
      login: 'Login',
      logout: 'Logout',
      email: 'Email Address',
      emailAddress: 'Email Address',
      password: 'Password',
      signIn: 'Sign In',
      signingIn: 'Signing In...',
      adminLogin: 'Admin Login',
      adminPanel: 'Furniture E-commerce Admin Panel',
      demoCredentials: 'Demo Credentials:',
      loginFailed: 'Login Failed',
      invalidCredentials: 'Invalid Credentials',
      loginRequired: 'Administrator login required for changes.',
    },

    // Order Detail
    orderDetail: {
      backToList: 'Back to list',
      order: 'Order',
      createdAt: 'Created: ',
      orderActions: 'Order actions',
      print: 'Print',
      downloading: 'Loading...',
      savePdf: 'Save as PDF',
      orderInfo: 'Order Information',
      status: 'Status',
      orderStatus: 'Order Status',
      type: 'Type',
      payment: 'Payment',
      paymentMethod: 'Payment Method',
      orderHistory: 'Order History',
      customer: 'Customer',
      deliveryAddress: 'Delivery Address',
      deliveryMap: 'Delivery Map',
      orderItems: 'Order Items',
      subtotal: 'Subtotal',
      tax: 'Tax',
      shipping: 'Shipping',
      total: 'Total',
      product: 'Product',
      qty: 'Qty',
      price: 'Price',
      clickToCopy: 'Click to copy',
      copied: 'Copied',
      copyFailed: 'Copy failed. Hold SKU to select manually.',
      orderNotFound: 'Order with ID {id} not found in the system.',
      pdfError: 'PDF creation failed. Try again later.',
      creditCard: 'Credit Card',
      bankTransfer: 'Bank Transfer',
      cash: 'Cash',
      paid: 'Paid',
      paidOnDelivery: 'Paid on Delivery',
      created: 'Created',
      orderCreated: 'Order created',
      orderProcessing: 'Order processing',
      orderShipped: 'Order shipped',
      orderDelivered: 'Order delivered',
      statusUpdated: 'Status updated successfully',
      statusUpdateError: 'Error updating status',
      startProcessing: 'Start Processing',
      markShipped: 'Mark as Shipped',
      markDelivered: 'Mark as Delivered',
      cancelOrder: 'Cancel Order',
      cancelConfirmation: 'Are you sure you want to cancel order #{orderId}?',
      cancelReason: 'Cancellation reason',
      confirmCancel: 'Confirm Cancellation',
      noHistory: 'No history yet',
      // Internal notes
      internalNotes: 'Internal Notes',
      internalNotesHint: 'Staff-only notes, not visible to customer',
      notesPlaceholder: 'Add internal notes about this order...',
      notesSaved: 'Notes saved',
      notesSaveError: 'Failed to save notes',
    },

    // Categories
    categories: {
      title: 'Product Categories',
      addCategory: 'Add Category',
      editCategory: 'Edit Category',
      newCategory: 'New Category',
      noCategories: 'No categories yet',
      createFirst: 'Create first category',
      nameRu: 'Name (RU)',
      nameEn: 'Name (EN)',
      slug: 'Slug (URL)',
      slugHelp: 'Latin letters, numbers and hyphens',
      parentCategory: 'Parent Category',
      noParent: 'None (root)',
      sortOrder: 'Sort Order',
      activeInCatalog: 'Active (visible in catalog)',
      hidden: 'Hidden',
      deleteCategory: 'Delete category?',
      confirmDelete: 'Are you sure you want to delete category "{name}"?',
      hasSubcategories: 'This category has subcategories. They will also be deleted!',
      categoryUpdated: 'Category updated',
      categoryCreated: 'Category created',
      categoryDeleted: 'Category deleted',
      loadError: 'Error loading categories',
      saveError: 'Error saving category',
      deleteError: 'Error deleting category',
      statusError: 'Error changing status',
      nameRequired: 'Enter category name',
      categoryHidden: 'Category "{name}" hidden',
      categoryActivated: 'Category "{name}" activated',
    },

    // Profile
    profile: {
      open: 'Open profile',
      title: 'Admin Profile',
      subtitle: 'Manage personal info and account settings',
      uploadPhoto: 'Upload photo',
      chooseAvatar: 'Choose avatar',
      administrator: 'Administrator',
      phone: 'Phone',
      activity: 'Activity',
      lastLogin: 'Last login',
      ordersProcessed: 'Orders processed',
      productsAdded: 'Products added',
      personalInfo: 'Personal Information',
      firstName: 'First Name',
      lastName: 'Last Name',
      position: 'Position',
      positionPlaceholder: 'E.g.: Chief Administrator',
      security: 'Security',
      changePassword: 'Change Password',
      twoFactor: 'Two-Factor Authentication',
      extraProtection: 'Additional account protection',
      notConfigured: 'Not configured',
      activeSessions: 'Active Sessions',
      oneDevice: '1 device',
      view: 'View',
      notifications: 'Notifications',
      emailNotifications: 'Email Notifications',
      receiveByEmail: 'Receive notifications by email',
      orderNotifications: 'Order Notifications',
      orderNotificationsDesc: 'New orders and status changes',
      productNotifications: 'Product Notifications',
      productNotificationsDesc: 'Low stock and critical situations',
      systemUpdates: 'System Updates',
      systemUpdatesDesc: 'New features and system changes',
      profileUpdated: 'Profile updated successfully!',
      updateSuccess: 'Profile updated successfully!',
      updateError: 'Error updating profile',
      fileTooLarge: 'File size must not exceed 5MB',
      fileSizeError: 'File size must not exceed 5MB',
      roleAdmin: 'Administrator',
      todayTime: 'Today, 10:30',
      twoFactorDesc: 'Additional account protection',
      emailNotificationsDesc: 'Receive notifications by email',
      email: 'Email',
    },

    // Organizations
    orgs: {
      title: 'Organizations',
      subtitle: 'Manage platform tenant companies',
      createOrg: 'Create Organization',
      searchPlaceholder: 'Search by name, domain...',
      plan: 'Plan',
      planFree: 'Free',
      planStarter: 'Starter',
      planBusiness: 'Business',
      planEnterprise: 'Enterprise',
      all: 'All',
      active: 'Active',
      trial: 'Trial',
      cancelled: 'Cancelled',
      disabled: 'Disabled',
      refreshList: 'Refresh list',
      organization: 'Organization',
      domain: 'Domain',
      users: 'Users',
      products: 'Products',
      orders: 'Orders',
      notFound: 'No organizations found',
      viewOrg: 'View organization',
      editOrg: 'Edit organization',
      deactivate: 'Deactivate',
      deactivateOrg: 'Deactivate organization',
      activate: 'Activate',
      activateOrg: 'Activate organization',
      perPage: 'Per page:',
      accessDenied: 'Access denied. Super Admin only.',
      confirmDeactivate: 'Deactivate organization "{name}"? Users will lose access.',
      confirmActivate: 'Activate organization "{name}"?',
      loadError: 'Loading error: ',
      unknownError: 'Unknown error',
      retry: 'Retry',
      orgNotFound: 'Organization not found',
      backToList: 'To list',
      back: 'Back',
      disabledBadge: 'DISABLED',
      deactivateQuestion: 'Deactivate organization?',
      deactivateWarning: 'All users of organization "{name}" will lose access.',
      deactivating: 'Deactivating...',
      activating: 'Activating...',
      openAdminPanel: 'Open organization admin panel',
      orgCreated: 'Organization created successfully!',
      tabGeneral: 'General',
      tabLimits: 'Limits',
      tabBranding: 'Branding',
      tabStats: 'Statistics',
      info: 'Information',
      name: 'Name',
      description: 'Description',
      subdomain: 'Subdomain',
      customDomain: 'Custom Domain',
      verified: 'Verified',
      owner: 'Owner',
      createdDate: 'Created',
      updatedDate: 'Updated',
      planTitle: 'Pricing Plan',
      currentPlan: 'Current Plan',
      subscriptionStatus: 'Subscription Status',
      maxUsers: 'Max Users',
      maxProducts: 'Max Products',
      maxOrders: 'Max Orders',
      userLimit: 'User Limit',
      productLimit: 'Product Limit',
      orderLimit: 'Order Limit',
      branding: 'Branding',
      logoUrl: 'Logo URL',
      primaryColor: 'Primary Color',
      secondaryColor: 'Secondary Color',
      logo: 'Logo',
      notSet: 'Not set',
      usersCount: 'Users',
      productsCount: 'Products',
      ordersCount: 'Orders',
      activeStatus: 'Active',
      disabledStatus: 'Disabled',
      createTitle: 'Create Organization',
      orgData: 'Organization Data',
      companyName: 'Company Name',
      subdomainHelp: 'Latin letters, numbers and hyphens only',
      ownerAdmin: 'Owner (Admin)',
      ownerEmail: 'Owner Email',
      password: 'Password',
      minChars: 'Minimum 8 characters',
      required: 'Required field',
      requiredField: 'Required field',
      creating: 'Creating...',
      limits: 'Limits',
      deactivateConfirm: 'Deactivate organization',
      reactivateConfirm: 'Activate organization',
      statusActive: 'Active',
      statusTrial: 'Trial',
      statusCancelled: 'Cancelled',
      usersShort: 'Users',
      tariffPlan: 'Pricing Plan',
      subdomainValidation: 'Latin letters, numbers and hyphens only',
      toList: 'To list',
      openAdmin: 'Open organization admin panel',
      createSuccess: 'Organization created successfully!',
      tabBasic: 'General',
      information: 'Information',
      created: 'Created',
      updated: 'Updated',
      deactivated: 'Disabled',
      deactivateTitle: 'Deactivate organization?',
    },

    // Notifications
    notif: {
      title: 'Notifications',
      subtitle: 'Manage system notifications',
      readAll: 'Mark all as read',
      type: 'Type',
      all: 'All',
      info: 'Information',
      ordersType: 'Orders',
      warehouse: 'Warehouse',
      payments: 'Payments',
      delivery: 'Delivery',
      production: 'Production',
      warnings: 'Warnings',
      errors: 'Errors',
      successType: 'Success',
      statusFilter: 'Status',
      unread: 'Unread',
      read: 'Read',
      loadError: 'Error loading notifications: ',
      heading: 'Heading',
      message: 'Message',
      date: 'Date',
      noNotifications: 'No notifications',
      readStatus: 'Read',
      newStatus: 'New',
      markRead: 'Mark as read',
      deleteNotif: 'Delete notification',
      rowsPerPage: 'Rows per page:',
      markAllRead: 'Mark all as read',
      typeInfo: 'Information',
      typeOrders: 'Orders',
      typeInventory: 'Warehouse',
      typePayments: 'Payments',
      typeShipping: 'Delivery',
      typeManufacturing: 'Production',
      typeWarnings: 'Warnings',
      typeErrors: 'Errors',
      typeSuccess: 'Success',
      empty: 'No notifications',
      statusRead: 'Read',
      statusNew: 'New',
      allNotifications: 'All notifications',
      minutesAgo: '{{m}} min. ago',
      hoursAgo: '{{h}} h. ago',
      daysAgo: '{{d}} d. ago',
      errorMarkRead: 'Failed to mark as read',
      errorMarkAllRead: 'Failed to mark all as read',
      errorDelete: 'Failed to delete notification',
    },

    // Serials
    serials: {
      title: 'Serial Numbers',
      addSerial: 'Add',
      filtersSearch: 'Filters & Search',
      searchBySerial: 'Search by serial number',
      reset: 'Reset',
      addSerialTitle: 'Add Serial Number',
      editSerialTitle: 'Edit Serial Number',
      serialNumber: 'Serial Number',
      product: 'Product',
      warehouse: 'Warehouse',
      receivedDate: 'Received Date',
      soldDate: 'Sold Date',
      notes: 'Notes',
      generate: 'Generate',
      productRequired: 'Product *',
      serialRequired: 'Serial Number *',
      inStock: 'In Stock',
      reserved: 'Reserved',
      sold: 'Sold',
      returned: 'Returned',
      defective: 'Defective',
      loadError: 'Failed to load serial numbers',
      loadErrorShort: 'Loading error',
      notFound: 'Serial number not found',
      fillRequired: 'Please fill in required fields',
      createError: 'Error creating serial number',
      updateError: 'Error updating serial number',
      confirmDelete: 'Are you sure you want to delete this serial number?',
      deleteError: 'Failed to delete serial number',
      purchaseDate: 'Received Date',
      saleDate: 'Sold Date',
      filtersAndSearch: 'Filters & Search',
      searchLabel: 'Search by serial number',
      addTitle: 'Add Serial Number',
      editTitle: 'Edit Serial Number',
      requiredFields: 'Please fill in required fields',
      deleteConfirm: 'Are you sure you want to delete this serial number?',
    },

    // Manufacturing
    manufacturing: {
      // Dashboard
      title: 'Manufacturing',
      subtitle: 'Manage manufacturing orders and specifications',
      refreshData: 'Refresh data',
      bom: 'Specifications',
      totalOrders: 'Total orders',
      allTime: 'All time',
      todaySuffix: 'today',
      planned: 'Planned',
      forWeek: 'for the week',
      successfullyDone: 'Successfully completed',
      activeOrders: 'Active orders',
      noActiveOrders: 'No active orders',
      createOrder: 'Create order',
      orderNum: 'Order #{{id}}',
      pcs: 'pcs',
      quickActions: 'Quick actions',
      newBOM: 'New BOM',
      materials: 'Materials',
      analytics: 'Analytics',
      recentOrders: 'Recent orders',
      noOrders: 'No orders',
      loadError: 'Failed to load manufacturing data',
      status_draft: 'Draft',
      status_planned: 'Planned',
      status_in_progress: 'In progress',
      status_completed: 'Completed',
      status_cancelled: 'Cancelled',

      // Statuses
      statusDraft: 'Draft',
      statusActive: 'Active',
      statusArchived: 'Archived',
      statusPlanned: 'Planned',
      statusInProgress: 'In Progress',
      statusCompleted: 'Completed',
      statusCancelled: 'Cancelled',

      // Errors
      errorLoadBomList: 'Failed to load BOMs',
      errorLoadBom: 'Failed to load BOM',
      errorCannotDeleteActive: 'Cannot delete an active BOM. Archive it first.',
      errorCannotDeleteUsed: 'Cannot delete — BOM is used in manufacturing orders.',
      errorBomNotFound: 'BOM not found',
      errorDeleteBom: 'Failed to delete BOM',
      errorActivateBom: 'Failed to activate BOM',
      errorArchiveBom: 'Failed to archive BOM',
      errorCloneBom: 'Failed to clone BOM',
      errorSelectProduct: 'Select a product',
      errorEnterBomName: 'Enter BOM name',
      errorSaveBom: 'Failed to save BOM',
      errorLoadOrders: 'Error loading orders',
      errorStartProduction: 'Error starting production',
      errorCompleteProduction: 'Error completing production',
      errorCancelProduction: 'Error cancelling production',
      errorLoadDictionaries: 'Failed to load dictionaries',
      errorSelectWarehouse: 'Select a warehouse',
      errorAddItem: 'Add at least one item with product and quantity',
      errorCreateOrder: 'Failed to create order',
      errorLoadExplosion: 'Failed to load BOM explosion',
      errorLoadCosting: 'Failed to load costing',

      // BOM List
      bomListTitle: 'Bill of Materials (BOM)',
      newBom: 'New BOM',
      searchPlaceholder: 'Search by name or product...',
      refreshList: 'Refresh list',
      bomName: 'BOM Name',
      product: 'Product',
      version: 'Version',
      components: 'Components',
      costPrice: 'Cost Price',
      bomsNotFound: 'No BOMs found',
      viewBom: 'View BOM',
      costCalculation: 'Cost Calculation',
      moreActions: 'More actions',
      clone: 'Clone',
      explosion: 'Explosion',
      activate: 'Activate',
      archive: 'Archive',
      archiveFirst: 'Archive first',
      deleteBomTitle: 'Delete BOM',
      deleteBomConfirm: 'Are you sure? This action is irreversible.',
      deleteBomWarning: 'The BOM and all related data will be deleted.',

      // BOM Create / Edit
      backToBomList: 'Back to BOM list',
      editBom: 'Edit BOM',
      newBomTitle: 'New Bill of Materials (BOM)',
      importFromExcel: 'Import from Excel',
      basicInfo: 'Basic Information',
      producedProduct: 'Produced Product',
      outputQuantity: 'Output Quantity',
      unitOfMeasure: 'Unit of Measure',
      description: 'Description',
      materialsAndComponents: 'Materials & Components',
      addComponent: 'Add Component',
      type: 'Type',
      component: 'Component',
      quantity: 'Quantity',
      unitPrice: 'Unit Price',
      sum: 'Total',
      noComponentsHint: 'Add components to calculate cost',
      material: 'Material',
      productSemifinished: 'Product/Semi-finished',
      editMaterial: 'Edit material',
      deleteMaterial: 'Delete material',
      productionOperations: 'Production Operations',
      addOperation: 'Add Operation',
      operation: 'Operation',
      workCenter: 'Work Center',
      timeMin: 'Time, min',
      ratePerHour: 'Rate/hour',
      cost: 'Cost',
      noOperationsHint: 'Add operations for full cost calculation',
      editOperation: 'Edit operation',
      deleteOperation: 'Delete operation',
      costSummary: 'Total Cost',
      materialsLabel: 'Materials',
      laborCosts: 'Labor Costs',
      perUnit: 'Per unit',
      information: 'Information',
      output: 'Output',
      editComponent: 'Edit component',
      addComponentTitle: 'Add Component',
      componentType: 'Component Type',
      unitShort: 'Unit',
      wastePercent: 'Waste Percentage',
      note: 'Note',
      editOperationTitle: 'Edit Operation',
      addOperationTitle: 'Add Operation',
      operationName: 'Operation Name',
      laborTimeMin: 'Labor time, min',
      machineTimeMin: 'Machine time, min',
      setupTimeMin: 'Setup time, min',
      laborRate: 'Labor rate',
      overheadRate: 'Overhead rate/hour',

      // BOM Detail
      bomNotFound: 'BOM not found',
      backToList: 'Back to list',
      editBomAria: 'Edit BOM',
      cloneBomAria: 'Clone BOM',
      activateBomAria: 'Activate BOM',
      archiveBomAria: 'Archive BOM',
      createOrder: 'Create Order',
      componentsAndMaterials: 'Components & Materials',
      nameLabel: 'Name',
      price: 'Price',
      noComponents: 'No components',
      operations: 'Operations',
      level: 'Level',
      path: 'Path',
      multilevelExplosion: 'Multi-level Explosion',
      levels: 'levels',
      clickRefreshExplosion: 'Click Refresh to load',
      aggregatedComponents: 'Aggregated Components',
      totalQuantity: 'Total Quantity',
      costingTitle: 'Cost Calculation',
      overheadCosts: 'Overhead Costs',
      totalCost: 'Total Cost',
      suggestedPrices: 'Suggested Prices',
      margin: 'Margin',
      breakdownByComponents: 'Breakdown by Components',
      share: 'Share',
      loadCosting: 'Load Costing',
      created: 'Created',
      updated: 'Updated',
      createManufacturingOrder: 'Create Manufacturing Order',
      createOrderFromBom: 'Create order based on this BOM',
      warehouse: 'Warehouse',
      creating: 'Creating...',
      costing: 'Costing',

      // Excel Import
      excelStepUpload: 'Upload File',
      excelStepMapping: 'Mapping',
      excelStepConfirm: 'Confirmation',
      excelErrorNoNameCol: 'No material name column found in the file',
      excelErrorNoQtyCol: 'No quantity column found in the file',
      excelErrorNoMaterials: 'No materials found in the file',
      excelErrorRead: 'Failed to read the file',
      excelErrorSelectProduct: 'Select a product for BOM',
      excelErrorImport: 'Import error',
      excelImportTitle: 'Import BOM from Excel',
      excelDragDrop: 'Drag and drop an Excel file here or click to select',
      excelSupportedFormats: 'Supported formats: .xlsx, .xls',
      excelRequiredColumns: 'Required columns: material name, quantity',
      excelFound: 'Found',
      excelNotFound: 'Not found',
      excelCreateMissing: 'Create missing materials',
      excelFromFile: 'From file',
      excelMaterialInDb: 'Material in DB',
      excelSelectMaterial: 'Select material',
      excelMaterialFound: 'Found in database',
      excelWillCreate: 'Will be created',
      excelMaterialNotFound: 'Not found',
      excelCheckBeforeImport: 'Review data before importing',
      excelSelectProductForBom: 'Select a product for BOM',
      excelSummary: 'Summary',
      excelFile: 'File',
      excelTotalItems: 'Total items',
      excelFoundInDb: 'Found in database',
      excelWillBeCreated: 'Will be created',
      excelEstimatedCost: 'Estimated cost',
      excelImportBtn: 'Import',

      // Manufacturing Orders
      ordersTitle: 'Manufacturing Orders',
      ordersSubtitle: 'Manage manufacturing orders',
      orderNumber: 'Order #',
      plan: 'Plan',
      progress: 'Progress',
      startDate: 'Start',
      endDate: 'End',
      refreshOrderList: 'Refresh order list',
      newOrder: 'New Order',
      searchOrderPlaceholder: 'Search by order number...',
      allStatuses: 'All statuses',
      resetFilters: 'Reset filters',
      manageColumns: 'Manage Columns',
      nothingFound: 'Nothing found',
      noOrders: 'No manufacturing orders yet',
      viewOrder: 'View order',
      cancelOrderTitle: 'Cancel Order',
      cancelOrderConfirm: 'Are you sure you want to cancel this order?',
      cancelReason: 'Cancellation reason',
      cancelOrderBtn: 'Cancel order',
      columnManagementTitle: 'Column Management',
      productionStarted: 'Production started',
      productionCompleted: 'Production completed',
      productionCancelled: 'Production cancelled',
      start: 'Start',
      complete: 'Complete',

      // Manufacturing Order Create
      newManufacturingOrder: 'New Manufacturing Order',
      newOrderSubtitle: 'Fill in the details and items to start production',
      basicData: 'Basic Data',
      selectWarehouse: 'Select warehouse',
      statusOnCreate: 'Status on creation',
      orderItems: 'Order Items',
      addItem: 'Add item',
      productId: 'Product ID',
      productIdHelper: 'Find ID in the product list or enter manually',
      deleteItem: 'Delete item',
      totals: 'Totals',
      positions: 'Items',
      totalQuantity: 'Total quantity',
      estimatedCost: 'Estimated cost',
      costHint: 'Cost is optional but helps with cost analytics.',
      orderCreated: 'Manufacturing order created',
      productHints: 'Product Hints',
      loadingProducts: 'Loading product list...',
      noProducts: 'No products available. Create them in the Catalog section.',
      goToCatalog: 'Go to product catalog',
      openCatalog: 'Open Catalog',
      consumptionCoefficient: 'Consumption coefficient: {{value}}',
    },

    // Batches
    batches: {
      backToList: 'Back to List',
      createNewBatch: 'Create New Batch',
      createdSuccessfully: 'Batch created successfully! Redirecting...',
      batchInfo: 'Batch Information',
      product: 'Product *',
      selectProductHelper: 'Select the product for this batch',
      variantOptional: 'Variant (Optional)',
      selectVariantHelper: 'Select a variant if this batch is for a specific variant',
      warehouse: 'Warehouse *',
      selectWarehouseHelper: 'Select the warehouse where this batch will be stored',
      batchNumber: 'Batch Number *',
      batchNumberHelper: 'Unique identifier for this batch',
      generate: 'Generate',
      manufactureDate: 'Manufacture Date',
      manufactureDateHelper: 'When was this batch manufactured?',
      expiryDate: 'Expiry Date',
      expiryDateHelper: 'When does this batch expire?',
      supplier: 'Supplier',
      supplierHelper: 'Supplier or manufacturer name',
      costPrice: 'Cost Price (KGS)',
      costPriceHelper: 'Unit cost price in KGS',
      quantity: 'Quantity *',
      quantityHelper: 'Initial quantity for this batch',
      creating: 'Creating...',
      createBatch: 'Create Batch',
      help: 'Help',
      batchNumberLabel: 'Batch Number',
      expiryDateLabel: 'Expiry Date',
      costPriceLabel: 'Cost Price',
      quantityLabel: 'Quantity',
      helpBatchNumber: 'A unique identifier for this batch. Use the Generate button for an auto-generated number.',
      helpExpiryDate: 'Important for FIFO/FEFO tracking. The system will prioritize shipments from batches with earlier expiry dates.',
      helpCostPrice: 'Used for calculating COGS (Cost of Goods Sold) and profit margins.',
      helpQuantity: 'The initial stock quantity for this batch. This will be added to the warehouse inventory.',
      fillRequiredFields: 'Please fill in all required fields',
      errorCreateBatch: 'Failed to create batch',
      errorLoadProducts: 'Failed to load products',
      errorLoadWarehouses: 'Failed to load warehouses',
      errorLoadVariants: 'Failed to load product variants',
      // BatchList
      title: 'Product Batches',
      refresh: 'Refresh',
      filters: 'Filters',
      productId: 'Product ID',
      warehouseId: 'Warehouse ID',
      expiringSoon: 'Expiring Soon',
      all: 'All',
      within7days: 'Within 7 days',
      within30days: 'Within 30 days',
      within60days: 'Within 60 days',
      within90days: 'Within 90 days',
      clearFilters: 'Clear Filters',
      expiresInDays: 'Expires in {{days}} days',
      columnProduct: 'Product',
      columnWarehouse: 'Warehouse',
      reserved: 'reserved',
      daysLeft: 'days left',
      columnCreated: 'Created',
      columnActions: 'Actions',
      viewBatch: 'View',
      viewBatchAria: 'View batch',
      editBatch: 'Edit',
      editBatchAria: 'Edit batch',
      deleteBatch: 'Delete',
      deleteBatchAria: 'Delete batch',
      confirmDelete: 'Are you sure you want to delete this batch?',
      errorDeleteBatch: 'Failed to delete batch',
      errorFetchBatches: 'Failed to fetch batches',
      detail: {
        title: 'Batch',
        backToList: 'Back to List',
        fetchError: 'Failed to fetch batch',
        updateError: 'Failed to update batch',
        deleteConfirm: 'Are you sure you want to delete this batch? This action cannot be undone.',
        deleteError: 'Failed to delete batch',
        notFound: 'Batch not found',
        expiringSoon: 'This batch is expiring soon! Only {{days}} days left.',
        batchInfo: 'Batch Information',
        batchNumber: 'Batch Number',
        supplier: 'Supplier',
        manufactureDate: 'Manufacture Date',
        expiryDate: 'Expiry Date',
        costPrice: 'Cost Price',
        costPriceKGS: 'Cost Price (KGS)',
        quantity: 'Quantity',
        reserved: 'Reserved',
        available: 'Available',
        created: 'Created',
        daysLeft: 'days left',
        productStock: 'Product & Stock',
        product: 'Product',
        variant: 'Variant',
        warehouse: 'Warehouse',
        movementHistory: 'Movement History',
        noMovements: 'No movements recorded',
        date: 'Date',
        type: 'Type',
        from: 'From',
        to: 'To',
        reference: 'Reference',
        notes: 'Notes',
      },
    },

    // Materials Database
    materials: {
      title: 'Materials Database',
      subtitle: 'Manage raw materials, components and consumables',
      currency: 'som',
      categories: {
        ldsp: 'Chipboard/Panels',
        edge: 'Edge Banding',
        handles: 'Handles',
        hinges: 'Hinges',
        slides: 'Drawer Slides',
        fasteners: 'Fasteners',
        adhesives: 'Adhesives',
        glass: 'Glass',
        countertops: 'Countertops',
        profiles: 'Profiles',
        lighting: 'Lighting',
        packaging: 'Packaging',
        other: 'Other',
      },
      units: {
        pcs: 'Pieces (pcs)',
        m: 'Meters (m)',
        m2: 'Square meters (m²)',
        m3: 'Cubic meters (m³)',
        kg: 'Kilograms (kg)',
        l: 'Liters (l)',
        pack: 'Packages (pkg)',
      },
      materialName: 'Name',
      skuLabel: 'SKU',
      categoryLabel: 'Category',
      allCategories: 'All categories',
      unitOfMeasure: 'Unit of measure',
      unit: 'Unit',
      description: 'Description',
      basicInfo: 'Basic Information',
      priceAndStock: 'Price & Stock',
      costPrice: 'Cost Price',
      minStock: 'Min Stock',
      maxStock: 'Max Stock',
      reorderPoint: 'Reorder Point',
      supplier: 'Supplier',
      supplierName: 'Supplier Name',
      leadTimeDays: 'Lead Time (days)',
      notes: 'Notes',
      requiredField: 'Required field',
      selectCategory: 'Select category',
      priceCannotBeNegative: 'Price cannot be negative',
      newMaterial: 'New Material',
      editMaterial: 'Edit Material',
      deleteMaterial: 'Delete Material',
      price: 'Price',
      updatePrice: 'Update Price',
      updatePrices: 'Update Prices',
      currentPrice: 'Current Price',
      newPrice: 'New Price',
      oldPrice: 'Old Price',
      minPrice: 'Min Price',
      maxPrice: 'Max Price',
      change: 'Change',
      changesCount: 'Changes',
      changeReason: 'Change Reason',
      changeReasonPlaceholder: 'Specify the reason for price change...',
      was: 'Was',
      reason: 'Reason',
      user: 'User',
      system: 'System',
      date: 'Date',
      priceHistory: 'Price History',
      closePriceHistory: 'Close price history',
      noPriceHistory: 'No price change history',
      chart: 'Chart',
      table: 'Table',
      stockMovement: 'Stock Movement',
      noStockHistory: 'No movement history',
      received: 'Received',
      writtenOffProduction: 'Written off to production',
      currentStock: 'Current Stock',
      receipt: 'Receipt',
      consumption: 'Consumption',
      balance: 'Balance',
      receiptConsumptionByDay: 'Receipt / Consumption by Day',
      stockDynamics: 'Stock Dynamics',
      totalMaterials: 'Total Materials',
      categoriesCount: 'Categories',
      totalValue: 'Total Value',
      inStock: 'In Stock',
      inStockShort: 'In Stock',
      lowStock: 'Low Stock',
      needsOrdering: 'Needs ordering',
      avgPrice: 'Average Price',
      perUnit: 'Per unit',
      materialsNeedRestock: 'materials need restocking',
      needed: 'Needed',
      min: 'Min',
      show: 'Show',
      hide: 'Hide',
      noMaterials: 'No materials found',
      searchPlaceholder: 'Search by name or SKU...',
      select: 'Select',
      selectAll: 'Select all',
      materialCreated: 'Material created',
      materialUpdated: 'Material updated',
      materialDeleted: 'Material deleted',
      priceUpdated: 'Price updated',
      deleteConfirmTitle: 'Confirm Deletion',
      deleteConfirmText: 'Are you sure you want to delete material',
      irreversibleAction: 'This action is irreversible.',
      bulkDelete: 'Bulk Delete',
      bulkDeleteConfirm: 'Are you sure you want to delete',
      bulkDeleteWarning: 'This action is irreversible. All selected materials will be deleted.',
      materialsWord: 'materials',
      bulkPriceUpdate: 'Bulk Price Update',
      willApplyTo: 'Will be applied to',
      selectedMaterials: 'selected materials',
      selectCategoryToFilter: 'Select a category to filter materials',
      selectMaterialsOrCategory: 'Select materials or specify a category',
      specifyChangeValue: 'Specify the change value',
      updateType: 'Update Type',
      percentage: 'Percentage (%)',
      fixedAmount: 'Fixed Amount (som)',
      percentChange: 'Percentage Change',
      amountChange: 'Amount Change',
      priceChangeHelper: 'Positive number increases price, negative decreases it',
      categoryOptional: 'Category (optional)',
      priceExample: 'Example: a material costing 100 som will become',
      importJson: 'Import JSON',
      importExcel: 'Import Excel',
      importMaterials: 'Import Materials',
      importBtn: 'Import',
      importCount: 'Import',
      jsonData: 'JSON Data',
      jsonImportHint: 'Paste JSON with materials array. Fields: name, sku, category, unit, cost_price',
      jsonMustContainArray: 'JSON must contain an array of materials',
      invalidJson: 'Invalid JSON format',
      jsonParseError: 'JSON parse error',
      foundMaterials: 'Materials found',
      examples: 'Examples',
      exported: 'Exported',
      imported: 'Imported',
      created: 'created',
      updated: 'updated',
      skipped: 'skipped',
      excelImport: 'Import from Excel',
      excelImportComplete: 'Excel import complete',
      excelStepUpload: 'Upload File',
      excelStepPreview: 'Preview Data',
      excelStepDuplicates: 'Handle Duplicates',
      excelDragDrop: 'Drag and drop Excel file here',
      excelClickToSelect: 'or click to select a file',
      excelSupportedFormats: 'Supported formats: .xlsx, .xls',
      excelReadError: 'Error reading file. Make sure it is a valid Excel file.',
      excelOnlyXlsx: 'Only .xlsx and .xls files are supported',
      selected: 'Selected',
      showing50of: 'Showing 50 of',
      duplicate: 'Duplicate',
      new: 'New',
      foundDuplicates: 'Found materials that already exist in the database',
      chooseDuplicateAction: 'Choose action for duplicates',
      updateExisting: 'Update existing',
      updateExistingDesc: 'Stock and cost price will be updated from file',
      skipDuplicates: 'Skip duplicates',
      skipDuplicatesDesc: 'Only new materials will be imported',
      duplicatesLabel: 'Duplicates',
      andMore: 'and more',
      startOver: 'Start over',
      currencyShort: 's',
      bulkDeleted: 'Deleted: {{count}}',
      bulkPriceUpdated: 'Updated: {{count}} materials',
    },

    // Finance
    finance: {
      payments: 'Payments',
      newPayment: 'New Payment',
      editPaymentTitle: 'Edit Payment',
      editPayment: 'Edit payment',
      cancelPayment: 'Cancel payment',
      confirmCancelPayment: 'Are you sure you want to cancel this payment?',
      fetchPaymentsError: 'Failed to fetch payments',
      savePaymentError: 'Failed to save payment',
      cancelPaymentError: 'Failed to cancel payment',
      fetchAccountsError: 'Failed to fetch accounts',
      saveAccountError: 'Failed to save account',
      deleteAccountError: 'Failed to delete account',
      fetchDashboardError: 'Failed to fetch finance data',
      specifyAmount: 'Specify the amount',
      number: 'Number',
      date: 'Date',
      type: 'Type',
      incoming: 'Incoming',
      outgoing: 'Outgoing',
      amount: 'Amount',
      counterparty: 'Counterparty',
      category: 'Category',
      method: 'Payment method',
      status: 'Status',
      statusCompleted: 'Completed',
      statusPending: 'Pending',
      statusCancelled: 'Cancelled',
      statusRefunded: 'Refunded',
      paymentType: 'Payment type',
      incomingReceipt: 'Incoming (receipt)',
      outgoingExpense: 'Outgoing (expense)',
      paymentDate: 'Payment date',
      paymentMethod: 'Payment method',
      accountCash: 'Account / Cash',
      notSelected: 'Not selected',
      description: 'Description',
      documentNumber: 'Document number',
      methodCash: 'Cash',
      methodBankTransfer: 'Bank transfer',
      methodCard: 'Card',
      methodMobileWallet: 'Mobile wallet',
      methodOther: 'Other',
      // Accounts
      accounts: 'Accounts',
      totalBalance: 'Total balance',
      addAccount: 'Add Account',
      newAccount: 'New Account',
      editAccountTitle: 'Edit Account',
      editAccount: 'Edit account',
      deleteAccount: 'Delete account',
      confirmDeleteAccount: 'Are you sure you want to delete this account?',
      specifyAccountName: 'Specify account name',
      noAccounts: 'No accounts found. Create your first account.',
      default: 'Default',
      accountName: 'Account name',
      accountType: 'Account type',
      currency: 'Currency',
      currencyKGS: 'KGS (som)',
      currencyUSD: 'USD (dollar)',
      currencyRUB: 'RUB (ruble)',
      currencyEUR: 'EUR (euro)',
      bankName: 'Bank name',
      accountNumber: 'Account number',
      walletNumber: 'Wallet number',
      defaultAccount: 'Default account',
      typeCash: 'Cash register',
      typeBank: 'Bank account',
      typeMobileWallet: 'Mobile wallet',
      typeCard: 'Card',
      // Dashboard
      title: 'Finance',
      monthlyIncome: 'Monthly Income',
      sinceMonthStart: 'Since month start',
      monthlyExpenses: 'Monthly Expenses',
      profit: 'Profit',
      monthlyProfit: 'Monthly Profit',
      allAccounts: 'All accounts',
      quickActions: 'Quick Actions',
      managePayments: 'Manage Payments',
      cashOrders: 'Cash Orders',
      cashOrdersDesc: 'Incoming & Outgoing',
      transfers: 'Transfers',
      betweenAccounts: 'Between accounts',
      accountsDesc: 'Cash registers & bank accounts',
      financialAccounts: 'Financial Accounts',
      noActiveAccounts: 'No active accounts. Create your first account in the "Accounts" section.',
      createAccount: 'Create Account',
      thisWeek: 'This Week',
      weeklyIncome: 'Weekly Income',
      weeklyExpenses: 'Weekly Expenses',
      weeklyProfit: 'Weekly Profit',
      pendingPaymentsAlert: 'You have {{count}} payments pending confirmation.',
    },

    // Suppliers
    suppliers: {
      newSupplier: 'New Supplier',
      createSupplier: 'Create Supplier',
      basicInfo: 'Basic Information',
      contactInfo: 'Contact Information',
      addresses: 'Addresses',
      businessTerms: 'Business Terms',
      supplierCode: 'Supplier Code',
      legalName: 'Legal Name',
      inn: 'TIN',
      kpp: 'KPP',
      contactPerson: 'Contact Person',
      phone: 'Phone',
      website: 'Website',
      legalAddress: 'Legal Address',
      actualAddress: 'Actual Address',
      paymentTermsDays: 'Payment Terms (days)',
      minOrderAmount: 'Min. Order Amount',
      discountPercent: 'Discount (%)',
      currency: 'Currency',
      currencyKGS: 'KGS (Som)',
      currencyUSD: 'USD (Dollar)',
      currencyEUR: 'EUR (Euro)',
      currencyRUB: 'RUB (Ruble)',
      supplierRating: 'Supplier Rating',
      comment: 'Comment',
      nameRequired: 'Name is required',
      codeRequired: 'Code is required',
      invalidEmail: 'Invalid email format',
      cannotBeNegative: 'Cannot be negative',
      mustBe0to100: 'Must be between 0 and 100',
      createError: 'Supplier creation error',
      // SupplierList
      listTitle: 'Suppliers',
      addSupplier: 'Add Supplier',
      refresh: 'Refresh',
      searchPlaceholder: 'Search by name, code, TIN...',
      statusLabel: 'Status',
      filterAll: 'All',
      filterActive: 'Active',
      filterInactive: 'Inactive',
      colCode: 'Code',
      colName: 'Name',
      colContacts: 'Contacts',
      colRating: 'Rating',
      colOrders: 'Orders',
      colOrderAmount: 'Order Amount',
      colStatus: 'Status',
      colActions: 'Actions',
      notFound: 'No suppliers found',
      active: 'Active',
      inactive: 'Inactive',
      viewTooltip: 'View',
      editTooltip: 'Edit',
      deleteTooltip: 'Delete',
      deleteConfirm: 'Delete supplier',
      deleteError: 'Delete error',
      loadErrorList: 'Failed to load suppliers',
      unknownError: 'Unknown error',
      retry: 'Retry',
      rowsPerPage: 'Rows per page:',
      paginationOf: 'of',
      // SupplierDetail keys
      supplierNotFound: 'Supplier not found',
      backToList: 'Back to list',
      loadError: 'Error loading supplier',
      orderHistory: 'Order History',
      orderNumber: 'Number',
      date: 'Date',
      warehouse: 'Warehouse',
      amount: 'Amount',
      paymentDelay: 'Payment delay',
      days: 'days',
      discountLabel: 'Discount',
      ratingLabel: 'Rating',
      statistics: 'Statistics',
      totalOrders: 'Total orders',
      completedOrders: 'Completed',
      totalAmount: 'Total amount',
      avgDeliveryDelay: 'Avg delivery delay',
    },

    // Purchases
    purchases: {
      title: 'Purchases',
      newPurchase: 'New Purchase',
      noPurchases: 'No purchases',
      loadError: 'Failed to load purchases',
      openPurchase: 'Open purchase',
      filters: 'Filters',
      search: 'Search',
      searchPlaceholder: 'Number, supplier…',
      searchEnterApply: 'Enter — apply',
      searchEscClear: 'Esc — clear',
      reset: 'Reset',
      document: 'Document',
      supplier: 'Supplier',
      status: 'Status',
      amount: 'Amount',
      statusDraft: 'Draft',
      statusConfirmed: 'Ordered',
      statusPartiallyReceived: 'Partially received',
      statusReceived: 'Fully received',
      statusCancelled: 'Cancelled',
      // PurchaseCreate keys
      formPrepareError: 'Failed to prepare form',
      documentNumber: 'Document number',
      documentNumberHint: 'Leave empty — number will be assigned automatically (if supported by API)',
      warehouseLabel: 'Warehouse',
      responsibleLabel: 'Responsible',
      expectedDate: 'Expected date',
      commentLabel: 'Comment',
      items: 'Items',
      searchProductsLabel: 'Search products',
      searchProductsPlaceholder: 'Name / SKU…',
      scanModeHint: 'Scan mode: ON (Esc — clear)',
      toggleScanMode: 'Toggle scan mode',
      productLabel: 'Product',
      productLoading: 'Loading…',
      quantity: 'Qty',
      priceKgs: 'Price (KGS)',
      addItem: 'Add',
      noItems: 'No items yet',
      enterNumber: 'Enter a number',
      mustBePositive: 'Must be greater than 0',
      cannotBeNegative: 'Cannot be less than 0',
      removeItemAria: 'Remove item: {{name}}',
      itemsTotal: 'Items total',
      creating: 'Creating…',
      createBtn: 'Create',
      createError: 'Failed to create purchase',
      itemRemoved: 'Item removed',
      undo: 'Undo',
      qtyBump: 'qty',
      detail: {
        title: 'Purchase',
        supplierLabel: 'Supplier',
        statusLabel: 'Status',
        createdLabel: 'Created',
        sumLabel: 'Amount',
        itemsTitle: 'Items',
        noItems: 'No items',
        notFound: 'Purchase not found',
        loadError: 'Failed to load purchase',
        receiveBtn: 'Receive to warehouse',
        receiveMoreBtn: 'Receive more',
        receivedCount: 'Received items: {{count}}',
        receiveError: 'Receiving error',
        pdfError: 'PDF download error',
      },
      receive: {
        title: 'Receive to warehouse',
        ordered: 'Ordered',
        received: 'Received',
        remaining: 'Remaining',
        accept: 'Receive',
        max: 'Max',
        allReceived: 'All items have been fully received.',
        specifyQty: 'Specify quantity for at least one item',
        error: 'Receiving error',
      },
    },

    // Production Tracker
    production: {
      // Board UI
      title: 'Production Tracker',
      board: 'Production Board',
      create: 'Create',
      createDialogTitle: 'Create Production Track',
      orderId: 'Order ID',
      orderIdHelper: 'Enter e-commerce order ID',
      notes: 'Notes',
      deadline: 'Deadline',
      creating: 'Creating...',
      createSuccess: 'Production track created',
      createError: 'Failed to create track',
      total: 'Total',
      kanban: 'Kanban',
      list: 'List',
      myTasks: 'My Tasks',
      search: 'Search...',
      noItems: 'No tracks',
      noTasks: 'No tasks',
      open: 'Open',
      stepsCompleted: 'steps',

      // Status filters
      status: 'Status',
      status_active: 'Active',
      status_completed: 'Completed',
      status_on_hold: 'On Hold',
      status_cancelled: 'Cancelled',

      // Priority filters
      priority: 'Priority',
      priority_urgent: 'Urgent',
      priority_high: 'High',
      priority_normal: 'Normal',
      priority_low: 'Low',

      // Step names (snake_case — used dynamically via t(`production.step_${code}`))
      step: 'Step',
      step_manager: 'Manager',
      step_constructor: 'Constructor',
      step_purchaser: 'Purchaser',
      step_cutting: 'Cutting',
      step_edging: 'Edge Banding',
      step_drilling: 'Drilling',
      step_assembly: 'Assembly',
      step_packaging: 'Packaging',
      step_delivery: 'Delivery',
      step_accounting: 'Accounting',

      // Step names (camelCase — legacy)
      stepManager: 'Manager',
      stepConstructor: 'Constructor',
      stepPurchaser: 'Purchaser',
      stepCutting: 'Cutting',
      stepEdgeBanding: 'Edge Banding',
      stepDrilling: 'Drilling',
      stepAssembly: 'Assembly',
      stepPackaging: 'Packaging',
      stepDelivery: 'Delivery',
      stepAccounting: 'Accounting',

      // Statuses (camelCase — legacy)
      statusPending: 'Pending',
      statusActive: 'Active',
      statusCompleted: 'Completed',
      statusSkipped: 'Skipped',
      statusOnHold: 'On Hold',

      // Priorities (camelCase — legacy)
      priorityLow: 'Low',
      priorityNormal: 'Normal',
      priorityHigh: 'High',
      priorityUrgent: 'Urgent',

      // Detail / Pipeline
      detail: 'Pipeline Details',
      pipeline: 'Pipeline',
      pipelineNumber: 'Pipeline Number',
      createPipeline: 'Create Production Track',
      specification: 'Specification',
      noSpecification: 'No specification filled',
      accounting: 'Cost Accounting',

      // Step actions
      start: 'Start',
      complete: 'Complete',
      skip: 'Skip',
      confirm: 'Confirm',
      completeStep: 'Complete Step',
      completeStepTitle: 'Complete Step',
      startStep: 'Start Step',
      skipStep: 'Skip Step',
      skipped: 'Skipped',
      pending: 'Pending',
      inProgress: 'In Progress',
      stepStarted: 'Step started',
      stepCompleted: 'Step completed',
      stepSkipped: 'Step skipped',
      role: 'Role',
      duration: 'Duration',
      minutes: 'min',
      mm: 'mm',
      mm: 'mm',

      // Specification editor
      materials: 'Materials',
      addMaterial: 'Add',
      materialName: 'Name',
      quantity: 'Qty',
      unit: 'Unit',
      dimensions: 'Dimensions',
      width: 'Width (mm)',
      height: 'Height (mm)',
      depth: 'Depth (mm)',
      additionalNotes: 'Additional notes',
      saveSpec: 'Save specification',
      specSaved: 'Specification saved',

      // Costs / Accounting
      costs: 'Cost Price',
      costBreakdown: 'Cost Breakdown',
      materialCost: 'Materials',
      laborCost: 'Labor',
      overheadCost: 'Overhead',
      costPrice: 'Cost Price',
      finalPrice: 'Final Price',
      margin: 'Margin',
      saveCosts: 'Save',
      costsSaved: 'Costs saved',
      summary: 'Summary',
      specMaterials: 'Specification Materials',

      // Purchase orders
      purchaseOrders: 'Purchase Orders',
      noPurchaseOrders: 'No related purchases',
      goToPurchasing: 'Material Purchasing',
      purchaserTitle: 'Material Purchasing',
      purchasedItems: 'Purchased',
      purchased: 'purchased',
      purchasePrice: 'Purchase Price',
      purchaseTime: 'Time',
      receipts: 'Receipts',
      markPurchased: 'Mark as purchased',
      selectAll: 'Select all',
      totalPurchaseCost: 'Total',
      savePurchaseData: 'Save',
      purchaseTrackingSaved: 'Purchase data saved',
      pipelineNotFound: 'Pipeline not found',
      receiptUploaded: 'Receipt uploaded',
      receiptUploadError: 'Receipt upload error',
      attachReceipt: 'Attach receipt',
      noSpecForPurchase: 'Specification not yet filled by constructor. Wait for specification upload.',
      constructorPhotos: 'Photos from constructor',
      materialType: 'Type',
      andMore: 'and more',

      // Constructor — specification upload
      uploadXmlSpec: 'Upload XML specification',
      xmlHelp: 'Upload XML file from Bazis / K3-Furniture. Materials will be extracted automatically.',
      selectXmlFile: 'Select XML file',
      invalidXmlFile: 'Please select an XML specification file',
      xmlParsed: 'XML specification loaded',
      positions: 'positions',
      project: 'Project',
      specPhotos: 'Photos / Drawings',
      uploadPhotos: 'Upload',
      photosUploaded: 'Photos uploaded',
      noPhotos: 'No uploaded photos',
      xmlParseError: 'XML parse error',
      photoUploadError: 'Photo upload error',

      // Notes
      notes: 'Notes',
      completeConfirm: 'Complete this step?',
      completeNotes: 'Completion notes',

      // Board views
      kanbanView: 'Kanban',
      listView: 'List',
      allSteps: 'All Steps',
      activeSteps: 'Active',
      deadline: 'Deadline',
      assignedTo: 'Assigned To',
      viewDetail: 'View Details',
      noPipelines: 'No pipelines found',

      // Stats
      stats: 'Statistics',
      totalPipelines: 'Total Pipelines',
      completedToday: 'Completed Today',
      overdue: 'Overdue',
    },

    // Quality Control (QC)
    qc: {
      // Dashboard
      title: 'Quality Control',
      subtitle: 'Manage quality inspections, defects and holds',
      refreshData: 'Refresh data',
      templates: 'Templates',
      newInspection: 'New inspection',
      totalInspections: 'Total inspections',
      allTime: 'All time',
      successful: 'successful',
      defectsThisWeek: 'defects this week',
      needsAttention: 'Need attention',
      qualityScore: 'Quality score',
      targetScore: 'Target score',
      outOf: 'of',
      inspections: 'inspections',
      recentInspections: 'Recent inspections',
      noInspections: 'No inspections',
      createInspection: 'Create inspection',
      inspectionNum: 'Inspection #{{id}}',
      inspector: 'Inspector',
      quickActions: 'Quick actions',
      qcTemplates: 'QC Templates',
      defects: 'Defects',
      holds: 'Holds',
      reports: 'Reports',
      activeHolds: 'Active holds',
      noActiveHolds: 'No active holds',
      holdNum: 'Hold #{{id}}',
      pcs: 'pcs',
      loadError: 'Failed to load quality control data',
      status_pending: 'Pending',
      status_in_progress: 'In progress',
      status_passed: 'Passed',
      status_failed: 'Failed',
      status_on_hold: 'On hold',

      // Holds
      holdsTitle: 'Holds',
      holdsSubtitle: 'Manage product holds',
      createHold: 'Create Hold',
      releaseHold: 'Release Hold',
      holdActive: 'Active',
      holdReleased: 'Released',
      holdExpired: 'Expired',
      severityLow: 'Low',
      severityMedium: 'Medium',
      severityHigh: 'High',
      severityCritical: 'Critical',
      reasonQuality: 'Quality Issue',
      reasonDocumentation: 'Documentation',
      reasonInspectionPending: 'Pending Inspection',
      reasonCustomerRequest: 'Customer Request',
      reasonRegulatory: 'Regulatory Requirements',
      reasonOther: 'Other',
      productName: 'Product name',
      quantity: 'Quantity',
      severity: 'Severity',
      reason: 'Reason',
      description: 'Description',
      expectedResolutionDate: 'Expected resolution date',
      comment: 'Comment',
      confirmReleaseHold: 'Are you sure you want to release this hold?',
      releaseReasonPlaceholder: 'Specify release reason...',
      loadHoldsError: 'Failed to load holds',
      searchHolds: 'Search holds...',
      searchHoldsAria: 'Search holds',
      filterByStatus: 'By status',
      number: '#',
      product: 'Product',
      date: 'Date',
      holdsNotFound: 'No holds found',
      openHold: 'Open hold',
      refreshHoldsList: 'Refresh holds list',

      // Templates
      categoryIncoming: 'Incoming',
      categoryInProcess: 'In Process',
      categoryFinal: 'Final',
      categoryPackaging: 'Packaging',
      categoryShipping: 'Shipping',
      editTemplate: 'Edit Template',
      newTemplateQC: 'New QC Template',
      category: 'Category',
      checklist: 'Checklist',
      addChecklistItemPlaceholder: 'New checklist item...',
      addChecklistHint: 'Press Enter or + to add',
      deleteChecklistItem: 'Delete checklist item',
      loadTemplatesError: 'Failed to load templates',
      copy: 'Copy',
      templatesTitle: 'QC Templates',
      templatesSubtitle: 'Manage quality control templates',
      refreshTemplatesList: 'Refresh templates list',
      newTemplate: 'New Template',
      searchTemplates: 'Search templates...',
      searchTemplatesAria: 'Search templates',
      filterByCategory: 'By category',
      checklistItems: 'Checklist',
      templatesNotFound: 'No templates found',
      duplicate: 'Duplicate',
      duplicateTemplate: 'Duplicate template',
      editTemplateAria: 'Edit template',
      deleteTemplateAria: 'Delete template',
      deleteTemplateTitle: 'Delete template?',
      deleteTemplateConfirm: 'Are you sure you want to delete this template?',

      // Inspections
      statusPending: 'Pending',
      statusInProgress: 'In Progress',
      statusPassed: 'Passed',
      statusFailed: 'Failed',
      refPurchase: 'Purchase',
      refProduction: 'Production',
      refInventory: 'Inventory',
      refReturn: 'Return',
      refOther: 'Other',
      selectTemplateError: 'Select a template',
      stepSelectTemplate: 'Select Template',
      stepInspectionData: 'Inspection Data',
      stepChecklist: 'Checklist',
      editInspection: 'Edit Inspection',
      newInspectionQC: 'New QC Inspection',
      inspectionTemplate: 'Inspection template',
      noDescription: 'No description',
      documentType: 'Document type',
      documentId: 'Document ID',
      notes: 'Notes',
      fillChecklistResults: 'Fill in checklist results',
      required: 'required',
      optional: 'optional',
      commentOptional: 'Comment (optional)',
      createInspection: 'Create Inspection',
      inspectionsTitle: 'QC Inspections',
      inspectionsSubtitle: 'Product quality control',
      refreshInspectionsList: 'Refresh inspections list',
      newInspection: 'New Inspection',
      searchInspections: 'Search inspections...',
      searchInspectionsAria: 'Search inspections',
      manageColumns: 'Manage columns',
      inspectionsNotFound: 'No inspections found',
      loadInspectionsError: 'Failed to load inspections',
      openInspection: 'Open inspection',
      columnManagementTitle: 'Column Management',
      type: 'Type',
    },

    // CRM
    crm: {
      // Dashboard
      loadDashboardError: 'Failed to load dashboard data',
      interactionCall: 'Call',
      interactionEmail: 'Email',
      interactionMeeting: 'Meeting',
      interactionNote: 'Note',
      interactionComplaint: 'Complaint',
      interactionFeedback: 'Feedback',
      interactionSms: 'SMS',
      interactionChat: 'Chat',
      loadingCrmData: 'Loading CRM data...',
      dashboardTitle: 'CRM Dashboard',
      dashboardSubtitle: 'Customer relationship management',
      segments: 'Segments',
      customers: 'Customers',
      activeTasks: 'Active tasks',
      overdue: 'Overdue',
      allOnTime: 'All on time',
      interactionsWeek: 'Interactions this week',
      today: 'Today',
      loyaltyMembers: 'Loyalty program members',
      points: 'points',
      tasks: 'Tasks',
      allTasks: 'All tasks',
      awaitingExecution: 'Awaiting execution',
      tasksCount: 'tasks',
      overdueTasks: 'Overdue tasks',
      urgentTasks: 'Urgent tasks',
      createTask: 'Create task',
      interactionsWeekTitle: 'Interactions this week',
      history: 'History',
      noInteractionsWeek: 'No interactions this week',
      addInteraction: 'Add interaction',
      quickActions: 'Quick actions',
      interactions: 'Interactions',
      loyalty: 'Loyalty',

      // Loyalty Programs
      loyaltyTitle: 'Loyalty Programs',
      loyaltyRefresh: 'Refresh',
      loyaltyNewProgram: 'New Program',
      loyaltyLoading: 'Loading...',
      loyaltyNoPrograms: 'No loyalty programs',
      loyaltyNoProgramsHint: 'Create your first program to award bonuses to customers',
      loyaltyCreateProgram: 'Create Program',
      loyaltyLoadError: 'Failed to load loyalty programs',
      loyaltyNameRequired: 'Enter program name',
      loyaltyUpdated: 'Program updated',
      loyaltyCreated: 'Program created',
      loyaltySaveError: 'Failed to save program',
      loyaltyDeleted: 'Program deleted',
      loyaltyDeleteError: 'Failed to delete program',
      loyaltyTypePoints: 'Points',
      loyaltyTypeCashback: 'Cashback',
      loyaltyTypeDiscountTiers: 'Discount Tiers',
      loyaltyTypeHybrid: 'Hybrid',
      loyaltyDefault: 'Default',
      loyaltyInactive: 'Inactive',
      loyaltyEarning: 'Earning',
      loyaltyPointPerSom: 'point / 1 som (KGS)',
      loyaltyRedeeming: 'Redeeming',
      loyaltyPointEqualsSom: '1 point = ',
      loyaltySomKGS: ' som (KGS)',
      loyaltyMinRedeem: 'Min. to redeem',
      loyaltyPointsUnit: 'points',
      loyaltyMaxPayment: 'Max. payment',
      loyaltyOfOrder: '% of order',
      loyaltyPointsExpiry: 'Points expiry',
      loyaltyDays: 'days',
      loyaltyParticipants: 'participants',
      loyaltyEditAria: 'Edit program',
      loyaltyDeleteAria: 'Delete program',
      loyaltyEditProgram: 'Edit Program',
      loyaltyName: 'Name',
      loyaltyProgramType: 'Program type',
      loyaltyDescription: 'Description',
      loyaltyEarnRules: 'Earning Rules',
      loyaltyPointsPerSom: 'Points per 1 som (KGS)',
      loyaltyMinPurchase: 'Min. purchase amount',
      loyaltyRedeemRules: 'Redeeming Rules',
      loyaltyPointValueSom: '1 point = X som (KGS)',
      loyaltyMinPointsRedeem: 'Min. points to redeem',
      loyaltyMaxOrderPercent: 'Max. % of order',
      loyaltyExpireDays: 'Expiry (days)',
      loyaltyExpireHint: 'Leave empty for permanent points',
      loyaltyActive: 'Active',
      loyaltyCancel: 'Cancel',
      loyaltySaving: 'Saving...',
      loyaltySave: 'Save',
      loyaltyDeleteTitle: 'Delete program?',
      loyaltyDeleteConfirm: 'Are you sure you want to delete program "{{name}}"? All member data and transactions will be deleted.',
      loyaltyDelete: 'Delete',

      // Tasks
      priorityLow: 'Low',
      priorityMedium: 'Medium',
      priorityHigh: 'High',
      priorityUrgent: 'Urgent',
      statusPending: 'Pending',
      statusInProgress: 'In Progress',
      statusCompleted: 'Completed',
      statusCancelled: 'Cancelled',
      statusDeferred: 'Deferred',
      loadTasksError: 'Failed to load tasks',
      enterTaskName: 'Enter task name',
      taskUpdated: 'Task updated',
      taskCreated: 'Task created',
      saveTaskError: 'Failed to save task',
      taskDeleted: 'Task deleted',
      deleteTaskError: 'Failed to delete task',
      taskCompleted: 'Task completed',
      completeTaskError: 'Failed to complete task',
      taskTitle: 'Task',
      priority: 'Priority',
      assignee: 'Assignee',
      customer: 'Customer',
      dueDate: 'Due date',
      complete: 'Complete',
      completeTaskAria: 'Complete task',
      editTaskAria: 'Edit task',
      deleteTaskAria: 'Delete task',
      tasksTitle: 'CRM Tasks',
      newTask: 'New Task',
      editTask: 'Edit Task',
      assigneeName: 'Assignee name',
      customerName: 'Customer name',
      reminder: 'Reminder',
      deleteTaskTitle: 'Delete task?',
      deleteTaskConfirm: 'Are you sure you want to delete this task?',

      // Segments
      segmentsTitle: 'Customer Segments',
      newSegment: 'New Segment',
      editSegment: 'Edit Segment',
      discount: 'Discount',
      discountPercent: 'Discount (%)',
      paymentDelay: 'Payment delay',
      paymentDelayDays: 'Payment delay (days)',
      days: 'days',
      customersCount: 'Customers',
      color: 'Color',
      loadSegmentsError: 'Failed to load segments',
      enterSegmentName: 'Enter segment name',
      segmentUpdated: 'Segment updated',
      segmentCreated: 'Segment created',
      saveSegmentError: 'Failed to save segment',
      segmentDeleted: 'Segment deleted',
      deleteSegmentError: 'Failed to delete segment',
      editSegmentAria: 'Edit segment',
      deleteSegmentAria: 'Delete segment',
      deleteSegmentTitle: 'Delete segment?',
      deleteSegmentConfirm: 'Are you sure you want to delete segment "{name}"? All customers will be unlinked from this segment.',
    },

    // ============================================================
    // CHAT
    // ============================================================
    chat: {
      edited: '(edited)',
      reply: 'Reply',
      copy: 'Copy',
      editMessage: 'Edit',
      pin: 'Pin',
      deleteMessage: 'Delete',
      today: 'Today',
      yesterday: 'Yesterday',
      selectChat: 'Select a chat',
      orStartNewConversation: 'or start a new conversation',
      listenRadio: 'Listen to radio while waiting 🎵',
      online: 'online',
      wasRecentlyOnline: 'was recently online',
      members: 'members',
      typingSingular: 'is typing...',
      typingPlural: 'are typing...',
      confirmDeleteMessage: 'Delete message?',
      messagePlaceholder: 'Message...',
      editing: 'Editing',
      startConversation: 'Start a conversation!',
      attachFileAria: 'Attach file',
      stickersAria: 'Stickers',
      formattingAria: 'Formatting',
      emojiAria: 'Emoji',
      sendAria: 'Send',
      cancelAria: 'Cancel',
      openChatListAria: 'Open chat list',
      chatInfoAria: 'Chat info',
      searchCtrlFAria: 'Search (Ctrl+F)',
      cancelEditAria: 'Cancel editing',
      replyToMessageAria: 'Reply to message',
      scrollToMessageAria: 'Scroll to message',
      closeReplyAria: 'Close reply',
      messageActionsAria: 'Message actions',
      info: 'Info',
      editNameAria: 'Edit name',
      channel: 'Channel',
      group: 'Group',
      notifications: 'Notifications',
      notificationsOff: 'Disabled',
      notificationsOn: 'Enabled',
      pinChat: 'Pin Chat',
      pinned: 'Pinned',
      notPinned: 'Not pinned',
      membersList: 'Members',
      owner: 'Owner',
      admin: 'Admin',
      mediaFilesLinks: 'Media, files, links',
      comingSoon: 'Coming soon',
      confirmLeaveChat: 'Are you sure you want to leave this chat?',
      leaveChat: 'Leave Chat',
      // Sidebar
      youPrefix: 'You: ',
      noMessages: 'No messages',
      chatAvatar: 'Chat avatar',
      chats: 'Chats',
      newChat: 'New chat',
      search: 'Search...',
      tabAll: 'All',
      tabPersonal: 'Personal',
      tabGroups: 'Groups',
      nothingFound: 'Nothing found',
      noChats: 'No chats',
      // Video player
      pauseAria: 'Pause',
      playAria: 'Play',
      unmuteAria: 'Unmute',
      muteAria: 'Mute',
      pipAria: 'Picture in picture',
      fullscreenAria: 'Fullscreen',
      // File drop zone
      exceedsMaxSize: 'exceeds 10MB',
      uploadErrors: 'Upload errors:',
      dropFilesHere: 'Drop files here',
      maxFilesHint: 'up to {{count}} files, 10MB max each',
      removeImageAria: 'Remove image',
      removeFileAria: 'Remove file',
      attachFileAria: 'Attach file',
      // Voice recorder
      micAccessError: 'Could not access the microphone',
      cancelRecordingAria: 'Cancel recording',
      stopRecordingAria: 'Stop recording',
      deleteRecordingAria: 'Delete recording',
      sendRecordingAria: 'Send recording',
      recordVoiceAria: 'Record voice message',
      // ChatAnimations
      userTyping: '{{name}} is typing...',
      twoUsersTyping: '{{name1}} and {{name2}} are typing...',
      manyUsersTyping: '{{count}} people are typing...',
      sending: 'Sending...',
      newMessageSingular: 'new message',
      newMessagesPlural: 'new messages',
      unreadMessages: 'Unread messages',
      messageDeleted: 'Message deleted',
      // ChatSearch
      searchFilterAll: 'All',
      searchFilterMedia: 'Media',
      searchFilterFiles: 'Files',
      searchFilterLinks: 'Links',
      searchPlaceholder: 'Search in "{{name}}"...',
      searchDefaultChat: 'chat',
      clearSearchAria: 'Clear search',
      previousResultAria: 'Previous result',
      nextResultAria: 'Next result',
      closeSearchAria: 'Close search',
      enterTextToSearch: 'Enter text to search',
      attachmentPhoto: '📷 Photo',
      attachmentFile: '📎 File',
      kbdGoTo: 'go to',
      kbdNavigation: 'navigation',
      kbdClose: 'close',
      searchInChatAria: 'Search in chat',
      // ChatNotifications
      newMessageTitle: 'New message',
      mediaMessage: 'Media message',
      // EmojiPicker
      emojiRecent: 'Recent',
      emojiSmileys: 'Smileys',
      emojiGestures: 'Gestures',
      emojiAnimals: 'Animals',
      emojiFood: 'Food',
      emojiTravel: 'Travel',
      emojiActivities: 'Activities',
      emojiObjects: 'Objects',
      emojiSymbols: 'Symbols',
      emojiFlags: 'Flags',
      emojiSearchPlaceholder: 'Search emoji...',
      noRecentEmojis: 'No recent emojis',
      selectEmojiAria: 'Select emoji {{emoji}}',
      reactionEmojiAria: 'Reaction {{emoji}}',
      errorLoadChats: 'Failed to load chats',
      errorLoadMessages: 'Failed to load messages',
      errorSendMessage: 'Failed to send message',
      errorCreateChat: 'Failed to create chat',
      // ChatSidebar
      pressNewChatHint: 'Press + to start a new chat',
      // NewChatDialog
      directMessage: 'Direct message',
      groupNameLabel: 'Group name',
      channelNameLabel: 'Channel name',
      descriptionOptional: 'Description (optional)',
      searchUsersPlaceholder: 'Search users...',
      noUsersFound: 'No one found',
      noAvailableUsers: 'No available users',
      createGroup: 'Create group',
      createChannel: 'Create channel',
      userAvatarAlt: 'User avatar',
      // UserStatus
      userStatus: {
        presetAtWork: 'At work',
        presetHome: 'At home',
        presetSleeping: 'Sleeping',
        presetGaming: 'Gaming',
        presetStudying: 'Studying',
        presetWatchingMovie: 'Watching a movie',
        presetListeningMusic: 'Listening to music',
        presetLunch: 'Having lunch',
        presetTraining: 'Working out',
        presetTraveling: 'Traveling',
        presetSick: 'Feeling sick',
        presetDoNotDisturb: 'Do not disturb',
        presetCelebrating: 'Celebrating',
        presetCoffee: 'Having coffee',
        presetOnTheRoad: 'On the road',
        presetOnline: 'Available',
        dur30min: '30 minutes',
        dur1hour: '1 hour',
        dur2hours: '2 hours',
        dur4hours: '4 hours',
        dur8hours: '8 hours',
        dur1day: '1 day',
        dur1week: '1 week',
        durUnlimited: 'Unlimited',
        durMinutes: '{{m}} min',
        durHours: '{{h}} h',
        durDays: '{{d}} d',
        setStatus: 'Set status',
        changeStatus: 'Change status',
        whatAreYouDoing: 'What are you doing?',
        duration: 'Duration',
        quickSelect: 'Quick select',
        clearStatus: 'Clear status',
        justNow: 'just now',
        minutesAgo: '{{m}} min ago',
        hoursAgo: '{{h}} h ago',
        recently: 'recently',
      },
      // Radio Player
      radio: {
        countries: {
          russia: 'Russia',
          somafm: 'SomaFM',
          usa: 'USA',
          uk: 'United Kingdom',
          germany: 'Germany',
          france: 'France',
          japan: 'Japan',
          korea: 'South Korea',
          turkey: 'Turkey',
          kazakhstan: 'Kazakhstan',
          uzbekistan: 'Uzbekistan',
          world: 'World',
        },
        title: 'Radio',
        searchStations: 'Search stations...',
        closeRadio: 'Close radio',
        stop: 'Stop',
        play: 'Play',
        mute: 'Mute',
        unmute: 'Unmute',
        onAir: 'On Air',
        share: 'Share',
        favorites: 'Favorites',
        removeFromFavorites: 'Remove from favorites',
        addToFavorites: 'Add to favorites',
        playing: 'Playing',
        openRadioPlaying: 'Open radio (playing)',
        openRadio: 'Open radio',
        listening: 'Listening to',
        stopRadio: 'Stop radio',
        playRadio: 'Play radio',
        streamError: 'Failed to play station',
        playbackError: 'Playback error: {{error}}',
      },
      // Sticker Picker
      stickers: {
        categories: {
          recent: 'Recent',
          popular: 'Popular',
          emotions: 'Emotions',
          animals: 'Animals',
          gestures: 'Gestures',
          celebration: 'Celebration',
          love: 'Love',
        },
        title: 'Stickers',
        searchPlaceholder: 'Search stickers...',
        closeStickers: 'Close stickers',
        noRecentStickers: 'No recent stickers',
        stickersNotFound: 'Stickers not found',
        recentCount: '{{count}} recent',
        stickersCount: '{{count}} stickers',
      },
      // Text Formatter
      formatter: {
        bold: 'Bold',
        italic: 'Italic',
        underline: 'Underline',
        strikethrough: 'Strikethrough',
        code: 'Code',
        codeBlock: 'Code block',
        title: 'Formatting',
      },
      // Music Player
      music: {
        title: 'Music',
        audio: 'Audio',
        pause: 'Pause',
        play: 'Play',
        share: 'Share',
        close: 'Close',
        listening: 'Listening',
      },
      // Link Preview
      linkPreview: {
        removePreview: 'Remove link preview',
      },
      errorSaveSetting: 'Failed to save setting',
      errorSaveName: 'Failed to save chat name',
      errorLeaveChat: 'Failed to leave chat',
      errorUploadFiles: 'Failed to upload files',
      errorDeleteMessage: 'Failed to delete message',
      errorReaction: 'Failed to add reaction',
      errorPinMessage: 'Failed to pin message',
      errorLoadMembers: 'Failed to load members',
      errorLoadUsers: 'Failed to load user list',
      videoThumbnail: 'Video thumbnail',
      youtubeVideo: 'YouTube video',
      vimeoVideo: 'Vimeo video',
      tiktokVideo: 'TikTok video',
      youtubeMusic: 'YouTube Music',
    },

    // ============================================================
    // CUSTOMER SUPPORT
    // ============================================================
    support: {
      heading: 'Customer Support',
      total: 'Total',
      active: 'Active',
      waiting: 'Waiting',
      statusNew: 'New',
      statusOpen: 'Open',
      statusPending: 'Pending',
      statusResolved: 'Resolved',
      statusClosed: 'Closed',
      priorityLow: 'Low',
      priorityMedium: 'Medium',
      priorityHigh: 'High',
      priorityCritical: 'Critical',
      searchPlaceholder: 'Search tickets...',
      tabAll: 'All',
      tabNew: 'New',
      tabActive: 'Active',
      tabResolved: 'Resolved',
      noTickets: 'No tickets',
      noNewTickets: 'No new tickets',
      noActiveTickets: 'No active tickets',
      noResolvedTickets: 'No resolved tickets',
      anonymous: 'Anonymous',
      noMessages: 'No messages',
      selectChatFromList: 'Select a chat from the list',
      order: 'Order:',
      take: 'Take',
      assigned: 'Assigned',
      customerInfo: 'Customer Info',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      ordersCount: 'Orders',
      totalSpent: 'Total spent',
      changeStatus: 'Change status',
      changePriority: 'Change priority',
      closeTicket: 'Close ticket',
      closeTicketTitle: 'Close ticket?',
      closeTicketConfirm: 'Are you sure you want to close this ticket?',
      inputPlaceholder: 'Type a message...',
      sendAria: 'Send',
      defaultCustomerName: 'Customer',
      defaultManagerName: 'Manager',
      errorSendMessage: 'Failed to send message',
      errorStatusChange: 'Failed to change status',
      errorAssign: 'Failed to assign manager',
      errorLoadChats: 'Failed to load chats',
      errorLoadMessages: 'Failed to load messages',
    },

    // ============================================================
    // INTEGRATIONS
    // ============================================================
    integrations: {
      // System names
      system1C: '1C:Trade Management',
      systemMoySklad: 'MoySklad',
      systemInternal: 'Internal accounting',
      ownAccounting: 'Own accounting',

      // General
      heading: 'Integrations',
      subtitle: 'Manage connections to external systems',
      namespace: 'Namespace',
      externalId: 'External ID',
      addIntegration: 'Add Integration',
      active: 'Active',
      disabled: 'Disabled',
      system: 'System:',
      lastSync: 'Last sync:',
      never: 'never',
      productsCount: 'products',
      viewProducts: 'Products',
      settings: 'Settings',
      logs: 'Logs',
      webhooks: 'Webhooks',
      confirmDeleteIntegration: 'Delete integration "{name}"? This action cannot be undone.',
      integrationDeleted: 'Integration deleted',
      deleteError: 'Delete error',
      error: 'Error',

      // IntegrationsPage dialog
      createIntegration: 'Create Integration',
      editIntegration: 'Edit Integration',
      integrationName: 'Integration Name',
      integrationNameHelper: 'Clear name for the integration',
      systemType: 'System Type',
      namespace: 'Namespace',
      namespaceHelper: 'Unique identifier (latin letters, numbers, hyphen)',
      apiUrl: 'API URL',
      apiUrlHelper: 'Base URL for API connection',
      activeSwitch: 'Active',
      integrationSaved: 'Integration saved',
      integrationCreated: 'Integration created',
      saveError: 'Save error',
      editTooltip: 'Edit',
      editAria: 'Edit integration',
      deleteTooltip: 'Delete',
      deleteAria: 'Delete integration',
      settingsTooltip: 'Settings',
      settingsAria: 'Integration settings',
      logsTooltip: 'Logs',
      logsAria: 'Integration logs',
      webhooksTooltip: 'Webhooks',
      webhooksAria: 'Integration webhooks',
      productsTooltip: 'Products',
      productsAria: 'Integration products',
      noIntegrations: 'No integrations',
      noIntegrationsHint: 'Click "Add Integration" to get started',

      // 1C Integration
      oneCConnectionSettings: '1C Connection Settings',
      oneCPlatformInfo: 'Integration with 1C:Trade Management via OData/REST API',
      urlApi: 'API URL',
      enterOneCUrl: 'Enter 1C URL',
      connectionMethod: 'Connection Method',
      odata: 'OData',
      rest: 'REST API',
      authentication: 'Authentication',
      basic: 'Basic',
      token: 'Token',
      username: 'Username',
      password: 'Password',
      bearerToken: 'Bearer Token',
      syncSettings: 'Sync Settings',
      synchronize: 'Synchronize',
      syncSchedule: 'Sync Schedule',
      manual: 'Manual',
      everyHour: 'Every hour',
      everyDay: 'Every day',
      everyWeek: 'Every week',
      priceType: 'Price Type',
      priceTypePlaceholder: 'Retail',
      priceTypeHelper: 'Name of price type in 1C',
      defaultWarehouse: 'Default Warehouse',
      warehousePlaceholder: 'Main warehouse',
      warehouseHelper: 'Warehouse name or ID in 1C',
      testing: 'Testing...',
      testConnectionBtn: 'Test Connection',
      saving: 'Saving...',
      saveSettings: 'Save Settings',
      settings1CSaved: '1C settings saved',
      cannotConnect1C: 'Cannot connect to 1C',
      tokenGenerateError: 'Token generation error',

      // 1C Platform (SuperAdmin & Tenant)
      onecDatabasesTitle: '1C Databases',
      onecStatusActive: 'Active',
      onecStatusProvisioning: 'Provisioning',
      onecStatusSuspended: 'Suspended',
      onecStatusError: 'Error',
      onecStatusNot_configured: 'Not configured',
      onecOrganization: 'Organization',
      onecServerUrl: 'Server URL',
      onecDbName: 'Database Name',
      onecLastSync: 'Last Sync',
      onecErrorCount: 'Errors',
      onecSuccessRate: 'Success Rate',
      onecNoDatabases: 'No 1C databases found',
      onecActivate: 'Activate',
      onecSuspend: 'Suspend',
      onecRecreate: 'Recreate',
      onecConfirmDelete: 'Delete database?',
      onecConfirmDeleteText: 'This action is irreversible. All integration data will be deleted.',
      onecConfirmSuspend: 'Suspend database?',
      onecConfirmActivate: 'Activate database?',
      onecConfirmRecreate: 'Recreate database?',
      onecConfirmRecreateText: 'Current database will be deleted and recreated.',
      onecMetricsTitle: '1C Metrics',
      onecActiveDbs: 'Active DBs',
      onecSuccessfulSyncs: 'Successful Syncs',
      onecFailedSyncs: 'Failed Syncs',
      onecLast24h: 'Last 24 hours',
      onecAvgDuration: 'Avg Duration',
      onecRecords: 'records',
      onecSyncChart: 'Sync Chart (24h)',
      onecNoChartData: 'No chart data available',
      onecPerOrgStatus: 'Per-Organization Status',
      onecHealthTitle: '1C System Health',
      onecHealthy: 'Healthy',
      onecDegraded: 'Degraded',
      onecStale: 'Stale',
      onecUnhealthy: 'Unhealthy',
      onecHealthDb: 'Database',
      onecHealthDatabases: '1C Databases',
      onecHealthQueue: 'Sync Queue',
      onecHealthErrors: 'Errors',
      onecPendingItems: 'Pending',
      onecLastHour: 'Last hour',
      onecHealthDetails: 'Details',
      onecDbBreakdown: 'DB Breakdown',
      onecSystemInfo: 'System Info',
      onecLastCheck: 'Last Check',
      onecAutoRefresh: 'Auto-refresh',
      onecPlatformStatus: 'Platform Status',
      onecDatabaseStatus: '1C Database Status',
      onecNotConfigured: '1C integration is not yet configured for your organization',
      onecSyncSuccess: 'Successful',
      onecSyncFailed: 'Failed',
      onecProvisioning: 'Database is being created...',
      onecSetupTools: 'Setup Tools',
      onecSetupTokenDesc: 'Token for automatic 1C module setup',
      onecGenerateToken: 'Generate Token',
      onecInstallerDesc: 'Download 1C exchange module installer',
      onecDownloadInstaller: 'Download Installer',
      onecSyncLogsTitle: '1C Sync Logs',
      onecForceSyncAll: 'Force Sync All',
      onecQueued: 'Queued',
      onecRecordsProcessed: 'Records',
      onecDuration: 'Duration',
      onecStartedAt: 'Started',
      onecNoLogs: 'No log entries',
      entityType: 'Entity Type',
      direction: 'Direction',
      directionImport: 'Import',
      directionExport: 'Export',

      // 1C Installer page
      installerTitle: '1C Module Installer',
      installerSubtitle: 'Step-by-step guide to connect 1C to your organization',
      installerStep1: 'System Requirements',
      installerStep1Desc: 'Make sure your system meets minimum requirements',
      installerStep2: 'Get Setup Token',
      installerStep2Desc: 'Generate a token for automatic module configuration',
      installerStep3: 'Download Installer',
      installerStep3Desc: 'Download and run the WASSER-1C exchange module installer',
      installerStep4: 'Install & Connect',
      installerStep4Desc: 'Follow the instructions to complete the setup',
      sysReq_platform: '1C Platform',
      sysReq_config: 'Configuration',
      sysReq_protocol: 'Protocol',
      sysReq_network: 'Network',
      sysReqMin_platform: '1C:Enterprise 8.3.10+',
      sysReqMin_config: '1C:UT 11.5.10+ / 1C:KA 2.5+',
      sysReqMin_protocol: 'REST API or OData',
      sysReqMin_network: 'HTTPS, port 443',
      installerInstructions: '1. Run the installer WASSER-1C-Connector.exe\n2. Specify the path to 1C database\n3. Enter the Setup Token (from step 2)\n4. Select connection type: REST API / OData\n5. Click "Connect"\n6. Wait for the message "Connection established"',
      generateSetupToken: 'Generate Setup Token',
      copyToken: 'Copy Token',
      copied: 'Copied!',
      tokenExpiresInfo: 'Token is valid for 24 hours. Generate a new one after expiration.',
      tokenGenerationFailed: 'Failed to generate token',
      downloadInstaller: 'Download Installer',
      downloadFullSetup: '1C Platform + Connector (~530 MB)',
      downloadConnectorOnly: 'Connector only (~0.03 MB)',
      downloadPackagesInfo: 'Full package includes 1C:Enterprise 8.3.19 + WASSER connector + auto-installer. Connector only - for updating when 1C is already installed.',
      installerMockWarning: 'Download unavailable in demo mode. In production, installer link will be here.',
      downloadSuperAdminOnly: 'Download is available for SuperAdmin only. Contact the platform administrator.',
      downloadFailed: 'Failed to download the installer',
      autoConfigured: 'Connection is configured automatically',
      nextStep: 'Next',
      prevStep: 'Back',

      // Connector OTA Settings
      connectorOtaTitle: '1C Connector Management',
      connectorOtaSubtitle: 'Centralized settings, monitoring and updates for connectors',
      connectorOtaTabSettings: 'Settings',
      connectorOtaTabInstances: 'Instances',
      connectorOtaTabVersions: 'Versions',
      connectorOtaOrgIdFilter: 'Organization ID',
      connectorOtaOrgIdPlaceholder: 'Empty = platform defaults',
      connectorOtaSyncSettings: 'Sync Settings',
      connectorOtaSyncInterval: 'Sync interval (min)',
      connectorOtaSyncIntervalHelp: 'How often the connector syncs data',
      connectorOtaBatchSize: 'Batch size',
      connectorOtaProductsEnabled: 'Products sync',
      connectorOtaStockEnabled: 'Stock sync',
      connectorOtaPricesEnabled: 'Prices sync',
      connectorOtaOrdersEnabled: 'Orders sync',
      connectorOtaCustomersEnabled: 'Customers sync',
      connectorOtaStatusesEnabled: 'Statuses sync',
      connectorOtaLoggingSettings: 'Logging Settings',
      connectorOtaLogLevel: 'Log level',
      connectorOtaLogMaxSize: 'Max log size (MB)',
      connectorOtaConnectorSettings: 'Connector Settings',
      connectorOtaAutoUpdate: 'Auto-update',
      connectorOtaAutoUpdateHelp: 'Connector will automatically download and install new versions during restart at 03:00',
      connectorOtaSettingsSaved: 'Settings saved',
      connectorOtaNoInstances: 'No connected connector instances',
      connectorOtaColOrg: 'Organization',
      connectorOtaColVersion: 'Version',
      connectorOtaColHost: 'Host',
      connectorOtaColStatus: 'Status',
      connectorOtaColSyncs: 'Syncs',
      connectorOtaColErrors: 'Errors',
      connectorOtaColLastHeartbeat: 'Last heartbeat',
      connectorOtaStatusOnline: 'Online',
      connectorOtaStatusOffline: 'Offline',
      connectorOtaStatusUpdating: 'Updating',
      connectorOtaStatusError: 'Error',
      connectorOtaColVersionName: 'Version',
      connectorOtaColReleaseNotes: 'Release Notes',
      connectorOtaColSize: 'Size',
      connectorOtaColCritical: 'Critical',
      connectorOtaColInstallCount: 'Installs',
      connectorOtaColCreated: 'Date',
      connectorOtaCritical: 'Critical',
      connectorOtaPublishVersion: 'Publish Version',
      connectorOtaPublishNewVersion: 'Publish New Version',
      connectorOtaVersionNumber: 'Version number',
      connectorOtaReleaseNotes: 'Release notes',
      connectorOtaR2Key: 'R2 file key',
      connectorOtaR2KeyHelp: 'Path to ZIP in R2 storage',
      connectorOtaMarkCritical: 'Critical update (forced install)',
      connectorOtaPublish: 'Publish',
      connectorOtaVersionPublished: 'Version published',
      connectorOtaNav: 'Connector Settings',

      // MoySklad Integration
      moySkladConnectionSettings: 'MoySklad Connection Settings',
      moySkladInfo: 'Integration with MoySklad via JSON API 1.2',
      apiToken: 'API Token',
      enterMoySkladToken: 'Enter MoySklad token',
      moySkladTokenHelperText: 'Get it in MoySklad: Settings → Users and Rights → Access Tokens',
      optional: 'optional',
      orgIdHelper: 'Leave empty for automatic detection',
      storeIdHelper: 'Leave empty for default store',
      useVariants: 'Use variants',
      settingsMoySkladSaved: 'MoySklad settings saved',
      cannotConnectMoySklad: 'Cannot connect to MoySklad',

      // Sync entities
      syncProducts: 'Products',
      syncPrices: 'Prices',
      syncStock: 'Stock',
      syncOrders: 'Orders',
      syncCategories: 'Categories',
      syncImages: 'Images',

      // Integration Logs
      logsHeading: 'Sync Log',
      manualSync: 'Manual Sync',
      importProducts: 'Import Products',
      importPrices: 'Import Prices',
      importStock: 'Import Stock',
      importCategories: 'Import Categories',
      exportOrders: 'Export Orders',
      exportCustomers: 'Export Customers',
      importImages: 'Import Images',
      exportProducts: 'Export Products',
      logStatusSuccess: 'Success',
      logStatusError: 'Error',
      logStatusPending: 'Pending',
      logEntityProducts: 'Products',
      logEntityOrders: 'Orders',
      logEntityPrices: 'Prices',
      logEntityStock: 'Stock',
      logEntityCategories: 'Categories',
      logEntityCustomers: 'Customers',
      logEntityImages: 'Images',
      logEntityAll: 'All',
      logDate: 'Date',
      logEntity: 'Entity',
      logDirection: 'Direction',
      logRecords: 'Records',
      logErrors: 'Errors',
      logDuration: 'Duration',
      logStatus: 'Status',
      noLogs: 'No log entries',
      import: 'Import',
      export: 'Export',
      rowsPerPage: 'Rows per page:',
      logDetailsTitle: 'Sync Details',
      logCloseAria: 'Close',
      logDetailStatus: 'Status:',
      logDetailEntity: 'Entity:',
      logDetailDirection: 'Direction:',
      logDetailStatistics: 'Statistics',
      logDetailProcessed: 'Processed:',
      logDetailErrors: 'Errors:',
      logDetailTime: 'Time',
      logDetailStarted: 'Started:',
      logDetailCompleted: 'Completed:',
      logDetailErrorMessage: 'Error message:',
      logDetailErrorDetails: 'Error details:',
      retrySync: 'Retry Sync',
      importFromExternal: 'Import from',
      exportToExternal: 'Export to',

      // Webhooks
      webhooksTitle: 'Webhooks',
      webhooksSubtitle: 'Manage webhooks for event notifications',
      payload: 'Payload',
      response: 'Response',
      noResponse: 'No response',
      secretKey: 'Secret Key',
      addWebhook: 'Add Webhook',
      totalWebhooks: 'Total',
      activeWebhooks: 'Active',
      successRate: 'Success Rate',
      totalDeliveries: 'Deliveries',
      tabWebhooks: 'Webhooks',
      tabLogs: 'Delivery Log',
      webhookName: 'Name',
      webhookUrl: 'URL',
      webhookEvents: 'Events',
      webhookStatus: 'Status',
      webhookActions: 'Actions',
      noWebhooks: 'No webhooks',
      testWebhookTooltip: 'Test',
      testWebhookAria: 'Test webhook',
      webhookLogsTooltip: 'Logs',
      webhookLogsAria: 'Webhook logs',
      editWebhookTooltip: 'Edit',
      editWebhookAria: 'Edit webhook',
      deleteWebhookTooltip: 'Delete',
      deleteWebhookAria: 'Delete webhook',
      webhookStatusSuccess: 'Success',
      webhookStatusError: 'Error',
      webhookStatusPending: 'Pending',
      webhookSaved: 'Webhook saved',
      webhookCreated: 'Webhook created',
      webhookSaveError: 'Webhook save error',
      webhookDeleted: 'Webhook deleted',
      webhookDeleteError: 'Webhook delete error',
      webhookTestSent: 'Test request sent',
      webhookTestError: 'Test request error',
      secretCopied: 'Secret copied',
      secretCopyError: 'Copy error',
      webhookEnabled: 'Webhook enabled',
      webhookDisabled: 'Webhook disabled',
      webhookToggleError: 'Status toggle error',
      confirmDeleteWebhook: 'Delete webhook "{name}"?',

      // Webhook logs tab
      logsRefresh: 'Refresh',
      logDeliveryDate: 'Date',
      logDeliveryWebhook: 'Webhook',
      logDeliveryEvent: 'Event',
      logDeliveryStatus: 'Status',
      logDeliveryCode: 'Code',
      logDeliveryTime: 'Response Time',
      logDeliveryAttempt: 'Attempt',
      logDeliveryActions: 'Actions',
      noDeliveryLogs: 'No delivery records',
      expandDetailsAria: 'Expand details',
      retryDeliveryTooltip: 'Retry',
      retryDeliveryAria: 'Retry delivery',
      deliveryRowsPerPage: 'Rows per page:',

      // Webhook create/edit dialog
      createWebhook: 'Create Webhook',
      editWebhookTitle: 'Edit Webhook',
      webhookNameLabel: 'Webhook Name',
      webhookUrlLabel: 'Delivery URL',
      webhookEventsLabel: 'Events',
      selectEventsHelper: 'Select events to send notifications',
      webhookSecret: 'Secret Key',
      copySecretAria: 'Copy secret',
      generateSecret: 'Generate',
      retryCount: 'Retry Count',
      timeout: 'Timeout (sec)',
      webhookActiveSwitch: 'Active',

      // Webhook event categories & events
      eventCategoryOrders: 'Orders',
      eventOrderCreated: 'Created',
      eventOrderUpdated: 'Updated',
      eventOrderStatusChanged: 'Status changed',
      eventOrderCancelled: 'Cancelled',
      eventCategoryProducts: 'Products',
      eventProductCreated: 'Created',
      eventProductUpdated: 'Updated',
      eventProductDeleted: 'Deleted',
      eventProductStockChanged: 'Stock changed',
      eventCategoryCustomers: 'Customers',
      eventCustomerCreated: 'Created',
      eventCustomerUpdated: 'Updated',
      eventCategoryPayments: 'Payments',
      eventPaymentReceived: 'Received',
      eventPaymentRefunded: 'Refunded',
      eventCategoryIntegrations: 'Integrations',
      eventSyncCompleted: 'Sync completed',
      eventSyncFailed: 'Sync failed',
      eventCategoryInventory: 'Inventory',
      eventStockLow: 'Low stock',
      eventStockOut: 'Out of stock',
      eventStockUpdated: 'Stock updated',
      eventCategorySystem: 'System',
      eventWebhookTest: 'Test event',
      eventSystemError: 'System error',
      eventMaintenanceScheduled: 'Maintenance scheduled',
      eventRateLimitExceeded: 'Rate limit exceeded',

      // Webhook delete dialog
      deleteWebhookTitle: 'Delete Webhook',
      deleteWebhookContent: 'Are you sure you want to delete webhook "{name}"? This action cannot be undone.',
      webhookLogsDialogClose: 'Close',
      webhookNameHelper: 'Example: CRM Notification, Accounting Sync',
      webhookSecretHelper: 'For request signing (HMAC-SHA256)',
      urlPostHelper: 'URL for sending POST requests',
      logsFor: 'Logs: {{name}}',
      requestFormatLabel: 'Request format:',
      requestFormatValue: 'POST with JSON body',
      headersLabel: 'Headers:',
      ifSecretSet: 'if secret is set',
      loadProductsError: 'Failed to load products',

      // Integration Products Page
      backToIntegrations: 'Back to Integrations',
      products: 'Products',
      deleteAll: 'Delete All',
      productsInMoySklad: 'Products in MoySklad',
      synced: 'Synced',
      searchBySkuNameExternalId: 'Search by SKU, name or external ID...',
      productName: 'Name',
      price: 'Price',
      stock: 'Stock',
      source: 'Source',
      updated: 'Updated',
      productsNotFound: 'Products not found',
      noSyncedProducts: 'No synced products',
      clickSyncToLoad: 'Click "Synchronize" to load products from',
      externalSystem: 'external system',
      syncProductsFrom: 'Sync products from',
      syncTokenInfo: 'An API token is required for synchronization. The token is NOT stored on the server and is used only for the current request.',
      enterTokenForApi: 'Enter token for API access',
      enterApiToken: 'Enter API token',
      syncCompleted: 'Sync completed!',
      syncResults: 'Sync Results',
      totalProcessed: 'Total processed',
      importedNew: 'Imported new',
      updatedExisting: 'Updated existing',
      skipped: 'Skipped',
      errorsCount: 'Errors',
      performance: 'Performance',
      totalTime: 'Total time',
      speed: 'Speed',
      productsPerSec: 'products/sec',
      avgTimePerProduct: 'Avg time per product',
      executionPhases: 'Execution Phases',
      phaseDataLoading: 'Data loading',
      phaseProductProcessing: 'Product processing',
      phaseFinalization: 'Finalization',
      network: 'Network',
      apiRequests: 'API requests',
      dataReceived: 'Data received',
      apiResponseTime: 'API response time',
      syncing: 'Syncing...',
      startSync: 'Start Sync',
      deleteAllProducts: 'Delete all products?',
      deleteAllWarning: 'This action will delete all {count} products from this integration and cannot be undone!',
      confirmDeleteAllProducts: 'Are you sure you want to delete all products from integration "{namespace}"?',
      deleting: 'Deleting...',
      deleted: 'Deleted',

      // External Products Preview
      productsFrom: 'Products from',
      fetched: 'Fetched',
      syncedStat: 'Synced',
      notSynced: 'Not synced',
      withPhotos: 'With photos',
      searchByNameOrSku: 'Search by name or SKU...',
      selectAllOnPage: 'Select all on page',
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
      selectOnlyNotSynced: 'Select only not synced',
      notSyncedShort: 'Not synced',
      notSyncedFull: 'Not synced',
      clearSelection: 'Clear selection',
      deselect: 'Deselect',
      syncShort: 'Sync',
      syncSelected: 'Sync selected',
      syncAllShort: 'Sync all',
      syncAll: 'Sync all',
      doNotClosePage: 'Please do not close the page',
      processed: 'Processed',
      imported: 'Imported',
      updatedStat: 'Updated',
      currentProduct: 'Current product',
      elapsedTime: 'Elapsed time',
      remaining: 'Remaining',
      selectAllProducts: 'Select all products',
      selectProduct: 'Select',
      photo: 'Photo',
      photosCount: 'photos',
      noPhoto: 'No photo',
      syncedStatus: 'Synced',
      notSyncedStatus: 'Not synced',
      noProductsToDisplay: 'No products to display',
      selectProductsForSync: 'Select products for synchronization',
      syncingProducts: 'Syncing {count} products...',
      sec: 'sec',
      min: 'min',
      calculating: 'calculating...',
      loadingDataFromMoySklad: 'Loading data from MoySklad...',
      completed: 'Completed',
      successCount: 'Successful',
      syncError: 'Sync error',
      startingFullSync: 'Starting full sync...',
      connectingToMoySklad: 'Connecting to MoySklad...',
      loadingProductList: 'Loading product list...',
      fetchingDataFromApi: 'Fetching data from API',
      finishingSync: 'Finishing sync...',
      fullSyncCompleted: 'Full sync completed!',
      requested: 'Requested',
      successful: 'Successful',
      errors: 'Errors',
      andMore: 'and more',
      executionTime: 'Execution time',
      secDot: 'sec.',
    },

    // Super Admin
    superAdmin: {
      revenueLoadError: 'Error loading revenue data',
      platformStatus: 'Platform status',
      platformStable: 'Running stable',
      platformAttention: 'Needs attention',
      apiRequests24h: 'API requests 24h',
      activeOrganizations: 'Active organizations',
      activity: {
        justNow: 'just now',
        minutesAgo: '{{count}} min ago',
        hoursAgo: '{{count}} h ago',
        daysAgo: '{{count}} d ago',
        system: 'System',
      },
      revenueByOrgs: 'Revenue by organizations',
      period: 'Period',
      days7: '7 days',
      days30: '30 days',
      days90: '90 days',
      year1: '1 year',
      totalGMV: 'Total GMV for period',
      orgsWithSales: 'Organizations with sales',
      revenue: 'Revenue',
      ofTotal: 'of total',
      ordersCount: 'Orders',
      usersCount: 'Users',
      productsCount: 'Products',
      noRevenueData: 'No revenue data for selected period',
      orgsLoadError: 'Error loading organizations',
      organization: 'Organization',
      plan: 'Plan',
      status: 'Status',
      users: 'Users',
      products: 'Products',
      orders: 'Orders',
      revenue30d: 'Revenue (30d)',
      owner: 'Owner',
      actions: 'Actions',
      ordersWord: 'orders',
      view: 'View',
      features: 'Features',
      rowsPerPage: 'Rows per page:',
      of: 'of',
      moreThan: 'more than',
      featureManagement: 'Feature Management',
      featureFlagsSubtitle: 'Feature Flags for platform organizations',
      newFeature: 'New Feature',
      allFeatures: 'All Features',
      byOrgs: 'By Organizations',
      searchFeatures: 'Search features...',
      category: 'Category',
      allCategories: 'All categories',
      found: 'Found',
      functionsWord: 'features',
      noDescription: 'No description',
      flagType_boolean: 'On/Off',
      flagType_plan_based: 'Plan based',
      flagType_percentage: 'Percentage',
      flagType_whitelist: 'Whitelist',
      defaultOn: 'On by default',
      defaultOff: 'Off by default',
      selectOrg: 'Select organization',
      startTyping: 'Start typing name...',
      selectOrgForFeatures: 'Select an organization to configure features',
      unsavedChanges: 'Unsaved changes',
      saving: 'Saving...',
      changed: 'Changed',
      createNewFeature: 'Create new feature',
      keyField: 'Key',
      keyFieldHelper: 'Latin letters, numbers, underscores only',
      nameField: 'Name',
      descriptionField: 'Description',
      type: 'Type',
      minPlan: 'Min. plan',
      notSpecified: 'Not specified',
      defaultEnabled: 'Enabled by default',
      betaFeature: 'Beta feature',
      creating: 'Creating...',
      create: 'Create',
      editFeature: 'Edit',
      defaultOnShort: 'Default on',
      beta: 'Beta',
      deprecated: 'Deprecated',
      deleteFeatureConfirm: 'Delete feature',
      // SuperAdmin Dashboard
      platformLoadError: 'Platform data load error: {{message}}',
      dashboardTitle: 'Platform Dashboard',
      dashboardSubtitle: 'Control organizations, revenue and platform features',
      thisMonth: 'this month',
      organizationsActive: 'Organizations ({{count}} active)',
      usersLabel: 'Users',
      activeLastWeek: 'Active this week',
      adminsCount: 'Admins',
      mrrLabel: 'MRR (monthly recurring revenue)',
      growthLabel: 'Growth',
      arrLabel: 'ARR',
      gmv30d: 'GMV for 30 days',
      ordersLabel: 'Orders',
      avgOrder: 'Avg. order',
      tabOrganizations: 'Organizations',
      tabRevenue: 'Revenue',
      tabActivity: 'Activity',
      syncLogsLoadError: 'Sync logs load error',
      onecRecreateFailed: 'Error recreating 1C database',
      onecSuspendFailed: 'Error suspending 1C database',
      onecDeleteFailed: 'Error deleting 1C database',
      onecForceSyncFailed: 'Error during forced synchronization',
      featureCreateFailed: 'Error creating feature flag',
      featureUpdateFailed: 'Error updating feature flag',
      featureDeleteFailed: 'Error deleting feature flag',
      orgFeaturesUpdateFailed: 'Error updating organization features',
      activity: {
        loadError: 'Activity loading error',
        title: 'Recent platform activity',
        noActivity: 'No activity to display',
      },
    },

    customization: {
      title: 'Customization',
      subtitle: 'Configure modules, fields and interface for your organization',
      tabModules: 'Modules',
      tabCustomFields: 'Custom Fields',
      tabPermissions: 'Permissions',
      tabInterface: 'Interface',
      tabIntegrations: 'Integrations',
      availableModules: 'Available Modules',
      modulesDescription: 'Enable or disable modules for your organization. Module availability depends on your subscription plan.',
      moduleInventory: 'Inventory',
      moduleInventoryDesc: 'Warehouse, stock and batch management',
      moduleCRM: 'CRM',
      moduleCRMDesc: 'Customer management, deals and sales funnel',
      moduleAnalytics: 'Analytics',
      moduleAnalyticsDesc: 'Advanced reports and dashboards',
      moduleAccounting: 'Accounting',
      moduleAccountingDesc: 'Invoices, acts, tax reporting',
      moduleEnabled: 'Module enabled',
      moduleDisabled: 'Module disabled',
      moduleToggleError: 'Error changing module',
      customFields: 'Custom Fields',
      customFieldsDesc: 'Add additional fields for products, orders, users and customers.',
      addField: 'Add Field',
      entityType: 'Entity Type',
      entityProducts: 'Products',
      entityOrders: 'Orders',
      entityUsers: 'Users',
      entityCustomers: 'Customers',
      noCustomFields: 'No custom fields',
      addFirstField: 'Add first field for',
      fieldKey: 'Key',
      fieldName: 'Name',
      fieldType: 'Type',
      fieldGroup: 'Group',
      fieldRequired: 'Required',
      fieldInForm: 'In Form',
      fieldInTable: 'In Table',
      editField: 'Edit Field',
      newFieldFor: 'New field for',
      fieldKeyLabel: 'Field key (latin)',
      fieldKeyHelper: 'Example: fabric_type, designer_name',
      fieldNameRu: 'Name (RU)',
      fieldNameEn: 'Name (EN)',
      fieldDescription: 'Description',
      fieldTypeLabel: 'Field Type',
      fieldTypeText: 'Text',
      fieldTypeTextarea: 'Multiline text',
      fieldTypeNumber: 'Number (integer)',
      fieldTypeDecimal: 'Number (decimal)',
      fieldTypeSelect: 'Dropdown',
      fieldTypeMultiselect: 'Multi-select',
      fieldTypeCheckbox: 'Checkbox',
      fieldTypeDate: 'Date',
      fieldTypeDatetime: 'Date and time',
      fieldTypeEmail: 'Email',
      fieldTypePhone: 'Phone',
      fieldTypeUrl: 'URL',
      fieldTypeColor: 'Color',
      optionsLabel: 'Options (comma separated)',
      optionsHelper: 'Cotton, Linen, Silk, Synthetic',
      minValue: 'Min. value',
      maxValue: 'Max. value',
      minLength: 'Min. length',
      maxLength: 'Max. length',
      defaultValue: 'Default value',
      fieldGroupLabel: 'Group (for grouping fields)',
      fieldGroupHelper: 'Example: dimensions, materials, specifications',
      display: 'Display',
      required: 'Required',
      inForm: 'In Form',
      inTable: 'In Table',
      inCatalog: 'In Catalog',
      entityForProducts: 'products',
      entityForOrders: 'orders',
      entityForUsers: 'users',
      entityForCustomers: 'customers',
      fieldUpdated: 'Field updated',
      fieldAdded: 'Field added',
      fieldSaveError: 'Error saving field',
      deleteFieldConfirm: 'Delete this field? All values will be lost.',
      fieldDeleted: 'Field deleted',
      fieldDeleteError: 'Error deleting field',
      adminPermissions: 'Admin Permissions',
      exportData: 'Export Data',
      apiAccess: 'API Access',
      manageIntegrations: 'Manage Integrations',
      userPermissions: 'User Permissions',
      seeB2BPrices: 'See B2B Prices',
      bulkOrders: 'Bulk Orders',
      permissionsTitle: 'Permissions',
      permissionsDesc: 'Configure additional permissions for your organization.',
      uiTitle: 'Interface Settings',
      uiDesc: 'Customize the appearance of your store.',
      uiBusinessPlan: 'Advanced interface settings available on Business plan and above.',
      uiBasicSettings: 'Basic Settings',
      uiInDevelopment: 'Functionality in development. Homepage, navigation and catalog settings coming soon.',
      integrationsTitle: 'Integrations',
      integrationsDesc: 'Connect external services to extend platform capabilities.',
      syncProductsOrders: 'Products and orders synchronization',
      onlinePayments: 'Online payments',
      emailNotifications: 'Email newsletters and notifications',
      smsNotifications: 'SMS notifications',
      available: 'Available',
      comingSoon: 'Coming soon',
      configure: 'Configure',
    },

    orgSettings: {
      title: 'Organization Settings',
      managementOf: 'Management of',
      tabBasic: 'General',
      tabBranding: 'Branding',
      tabDomain: 'Domain',
      tabSubscription: 'Subscription',
      basicInfo: 'Basic Information',
      orgName: 'Organization Name',
      description: 'Description',
      subdomain: 'Subdomain',
      subdomainHelp: 'Subdomain cannot be changed after creation',
      orgId: 'Organization ID',
      copy: 'Copy',
      created: 'Created',
      unknown: 'Unknown',
      saveChanges: 'Save Changes',
      brandingTitle: 'Branding & Design',
      logoUrl: 'Logo URL',
      logoPreview: 'Logo Preview',
      primaryColor: 'Primary Color',
      secondaryColor: 'Secondary Color',
      font: 'Font',
      fontHelper: 'Example: Inter, Roboto, Open Sans',
      preview: 'Preview',
      orgNameOrPlaceholder: 'Organization Name',
      primaryButton: 'Primary Button',
      secondaryButton: 'Secondary Button',
      saveBranding: 'Save Branding',
      domainSettings: 'Domain Settings',
      domainDefaultInfo: 'By default your organization is available at:',
      customDomain: 'Custom Domain',
      domainHelp: 'Enter your domain without https:// and www',
      domainVerified: 'Domain verified',
      domainPending: 'Pending verification',
      saveDomain: 'Save Domain',
      setupGuide: 'Setup Guide',
      currentPlan: 'Current Plan',
      planFree: 'Free',
      planStarter: 'Starter',
      planBusiness: 'Business',
      planEnterprise: 'Enterprise',
      betaLabel: 'BETA',
      active: 'Active',
      inactive: 'Inactive',
      usageLimits: 'Usage Limits',
      usersLabel: 'Users',
      productsLabel: 'Products',
      ordersLabel: 'Orders',
      upgradePlan: 'Upgrade Plan',
      upgradeDesc: 'Expand your store capabilities by upgrading to a higher plan.',
      contactSales: 'Contact Sales',
      individualOffer: 'Contact us for an individual offer.',
      domainSetupTitle: 'Custom Domain Setup',
      domainCnameInfo: 'To use a custom domain, add the following CNAME record to your domain\'s DNS:',
      dnsPropagation: 'DNS changes may take up to 24 hours to fully propagate.',
      dnsType: 'Type',
      dnsName: 'Name',
      dnsValue: 'Value',
      close: 'Close',
      loadError: 'Error loading organization',
      notFound: 'Organization not found',
      settingsSaved: 'Settings saved successfully',
      saveError: 'Save error',
      domainSaved: 'Domain saved. Verification required for activation.',
      domainSaveError: 'Error saving domain',
    },

    advAnalytics: {
      title: 'Advanced Analytics',
      subtitle: 'Comprehensive business analysis',
      period: 'Period',
      days7: '7 days',
      days30: '30 days',
      days90: '90 days',
      year1: '1 year',
      tabOverview: 'Overview',
      tabSales: 'Sales',
      tabInventory: 'Inventory',
      tabOperations: 'Operations',
      tabCustomers: 'Customers',
      loadError: 'Error loading data',
      vsPrevPeriod: 'vs previous period',
      totalRevenue: 'Total Revenue',
      ordersCount: 'Orders',
      customersCount: 'Customers',
      avgCheck: 'Average Check',
      stockStatus: 'Stock Status',
      stockHealthy: 'Healthy',
      stockLow: 'Low',
      stockCritical: 'Critical',
      orderFulfillment: 'Order Fulfillment',
      fulfilled: 'Fulfilled',
      inProgress: 'In Progress',
      pending: 'Pending',
      quality: 'Quality',
      inspected: 'Inspected',
      onInspection: 'On Inspection',
      rejected: 'Rejected',
      topProducts: 'Top Products',
      product: 'Product',
      sold: 'Sold',
      revenueCol: 'Revenue',
      recentOrders: 'Recent Orders',
      revenueTitle: 'Revenue',
      ordersTitle: 'Orders Count',
      avgCheckTitle: 'Average Check',
      conversion: 'Conversion',
      salesByCategory: 'Sales by Category',
      topProductsTitle: 'Top Products',
      qty: 'Qty',
      totalProducts: 'Total Products',
      totalValue: 'Total Value',
      lowStock: 'Low Stock',
      ofAllProducts: 'of all products',
      outOfStock: 'Out of Stock',
      stockHealth: 'Stock Health',
      normal: 'Normal',
      lowLevel: 'Low Level',
      critical: 'Critical',
      attentionProducts: 'Products Need Attention',
      sku: 'SKU',
      name: 'Name',
      balance: 'Balance',
      threshold: 'Min. Threshold',
      statusCol: 'Status',
      statusNone: 'None',
      statusLow: 'Low',
      categoryDistribution: 'Category Distribution',
      productsWord: 'products',
      turnover: 'Product Turnover',
      turnoverPerMonth: 'Turnover/mo',
      daysToZero: 'Days to 0',
      ordersFulfillment: 'Order Fulfillment',
      avgFulfillmentTime: 'Avg. Fulfillment Time',
      onTimeDelivery: 'On-Time Delivery',
      returns: 'Returns',
      cancelled: 'Cancelled',
      production: 'Production',
      activeOrders: 'Active Orders',
      completed: 'Completed',
      efficiency: 'Efficiency',
      defects: 'Defects',
      qualityControl: 'Quality Control',
      inspections: 'Inspections',
      passed: 'Passed',
      onHold: 'On Hold',
      criticalDefects: 'Critical Defects',
      daysShort: 'days',
      totalCustomers: 'Total Customers',
      newForPeriod: 'New for Period',
      avgLTV: 'Avg. LTV',
      repeat: 'Repeat',
      customerSegments: 'Customer Segments',
      customersWord: 'customers',
      topCustomers: 'Top Customers',
      client: 'Customer',
      ordersCol: 'Orders',
      amount: 'Amount',
    },

    components: {
      matSelectTitle: 'Select Materials from Database',
      matDbEmpty: 'Material database is empty. Add materials in the "Raw Materials" section.',
      searchByNameOrCode: 'Search by name or code...',
      categoryLabel: 'Category',
      allCategories: 'All Categories',
      catSheets: 'Sheet Materials',
      catEdge: 'Edge Materials',
      catFasteners: 'Fasteners',
      catFittings: 'Fittings',
      catPaint: 'Paints & Coatings',
      catFabric: 'Fabrics',
      catGlass: 'Glass & Mirrors',
      catElectric: 'Electrical',
      catOther: 'Other',
      selectedCount: 'Materials selected',
      colCode: 'Code',
      colName: 'Name',
      colCategory: 'Category',
      colUnit: 'Unit',
      colPrice: 'Price',
      colSupplier: 'Supplier',
      colStock: 'Stock',
      colInfo: 'Info',
      stockLow: 'Low',
      stockAvailable: 'In stock',
      nothingFound: 'Nothing found',
      noAvailableMaterials: 'No available materials',
      tip: 'Tip:',
      tipText: 'Click on a material to select it. Quantity can be specified after adding to the tech card.',
      addSelected: 'Add Selected',
      updatedAt: 'Updated',
      materialInfo: 'Material Information',
      purchasePrice: 'Purchase',
      costCalcTitle: 'Cost Calculation',
      productLabel: 'Product',
      historyEntries: 'history entries',
      calcHistory: 'Calculation History',
      editMode: 'Edit mode',
      saveProductFirst: 'Save the product first before saving cost calculation.',
      apiConnected: 'Connected to API',
      lastCalc: 'Last calculation',
      costPrice: 'Cost price',
      loadTechCard: 'Load Tech Card',
      uploadExcel: 'Upload Excel',
      uploading: 'Uploading...',
      downloadTemplate: 'Download Template',
      useExcelPrices: 'Use prices from Excel',
      autoCreateInDb: 'Auto-create in DB',
      autoCreateEnabled: 'Auto-create enabled',
      autoCreateDesc: 'New materials from Excel will be automatically added to the database',
      excelFormat: 'Excel format: Sheet "Materials" (Name, Unit, Quantity, Price, Supplier) and sheet "Works" (Name, Hours, Rate)',
      materials: 'Materials',
      fromDatabase: 'From Database',
      checkPrices: 'Check Prices',
      addManually: 'Add Manually',
      outdatedPricesWarning: 'Materials with outdated prices found',
      updatePrices: 'Update Prices',
      colSku: 'SKU',
      colNameMat: 'Name',
      colUnitMat: 'Unit',
      colQty: 'Qty',
      colCoef: 'Coef.',
      colPricePerUnit: 'Price/unit',
      colTotal: 'Total',
      colSupplierMat: 'Supplier',
      colActions: 'Actions',
      noMaterials: 'No materials. Upload from Excel or add manually.',
      totalMaterials: 'Total materials:',
      works: 'Works',
      addWork: 'Add Work',
      colWorkName: 'Work Name',
      colHours: 'Hours',
      colRatePerHour: 'Rate/hour',
      colCost: 'Cost',
      colWorker: 'Worker',
      colNote: 'Note',
      noWorks: 'No works. Add manually or upload from Excel.',
      totalWorks: 'Total works:',
      calcParams: 'Calculation Parameters',
      overheadExpenses: 'Overhead Expenses',
      profitMargin: 'Profit Margin',
      vat: 'VAT',
      vatHelp: 'In KR furniture is VAT-free',
      transport: 'Transport',
      packaging: 'Packaging',
      otherCosts: 'Other Costs',
      totalCostCalc: 'Total Cost Calculation',
      directCosts: 'Direct Costs',
      materialsLabel: 'Materials:',
      worksLabel: 'Works:',
      totalDirect: 'Total direct:',
      indirectCosts: 'Indirect Costs',
      overheadLabel: 'Overhead',
      transportLabel: 'Transport:',
      packagingLabel: 'Packaging:',
      otherLabel: 'Other:',
      fullCostPrice: 'Full cost price:',
      marginLabel: 'Margin',
      vatLabel: 'VAT',
      recommendedPrice: 'Recommended price:',
      history: 'History',
      exportExcel: 'Export to Excel',
      createEstimate: 'Create Estimate',
      saveTechCard: 'Save Tech Card',
      savingDots: 'Saving...',
      important: 'Important:',
      disclaimerText: 'These calculations are approximate. The final price is set by the manager taking into account market conditions.',
      historyTitle: 'Cost Calculation History',
      historyEmpty: 'History is empty',
      load: 'Load',
      author: 'Author',
      techCardSaved: 'Tech card saved successfully!',
      noProductId: 'No product ID specified. Save the product before cost calculation.',
      apiErrorLocal: 'API error, data saved locally',
      historyLoaded: 'Data loaded from history',
      historyLoadError: 'Error loading data from history',
      localCacheLoaded: 'Data loaded from local cache',
      historyLoadApiError: 'Error loading history',
      pdfGenerated: 'PDF estimate generated successfully',
      pdfError: 'Error generating PDF estimate',
      excelLoadedCount: 'Loaded',
      materialsWord: 'materials',
      worksWord: 'works',
      deleteMaterial: 'Delete material',
      deleteWork: 'Delete work',
      bomTitle: 'Bill of Materials (BOM)',
      bomVersion: 'Version',
      bomComponents: 'Components',
      bomCostPrice: 'Cost Price',
      bomNotCreated: 'BOM not created',
      importExcel: 'Import Excel',
      edit: 'Edit',
      createBom: 'Create',
      cancel: 'Cancel',
      save: 'Save',
      bomMaterial: 'Material',
      bomQty: 'Qty',
      bomUnit: 'Unit',
      bomPricePerUnit: 'Price/unit',
      bomTotal: 'Total',
      bomActions: 'Actions',
      selectMaterial: 'Select material',
      notSpecified: 'Not specified',
      newItem: 'New',
      bomTotalCost: 'Total cost:',
      addMaterial: 'Add Material',
      bomEmptyTitle: 'BOM not created',
      bomEmptyDesc: 'Create BOM manually or import from Excel',
      importFromExcel: 'Import from Excel',
      createManually: 'Create Manually',
      deleteMaterialTitle: 'Delete material?',
      deleteMaterialConfirm: 'Are you sure you want to delete this material from the BOM?',
      delete: 'Delete',
      bomLoadError: 'Failed to load BOM',
      bomUpdated: 'BOM updated',
      bomCreated: 'BOM created',
      bomSaveError: 'Failed to save BOM',
      bomImported: 'BOM imported from Excel',
      bomImportError: 'Error importing from Excel',
      bomAvailableForSaved: 'BOM is only available for saved products. Please create the product first.',
      unitPcs: 'pcs',
      currencySom: 'KGS',
      bomSpecName: 'Specification: {{name}}',
    },

    // Price List Export
    priceList: {
      dialogTitle: 'Price List Export Settings',
      companyInfo: 'Company Information',
      companyName: 'Company Name',
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      website: 'Website',
      heading: 'Title',
      subtitle: 'Subtitle',
      fieldsToInclude: 'Fields to Include',
      sku: 'SKU',
      photo: 'Product Photo',
      productName: 'Name',
      description: 'Description',
      category: 'Category',
      retailPrice: 'Retail Price',
      b2bPrice: 'B2B Price',
      priceQty10: 'Price for 10 pcs',
      priceQty50: 'Price for 50 pcs',
      stock: 'Availability',
      priceFormat: 'Price Format',
      currency: 'Currency',
      showVAT: 'Show VAT',
      vatRate: 'VAT Rate (%)',
      footerSection: 'Footer',
      footerNote: 'Note at the end of the price list',
      cancel: 'Cancel',
      exportBtn: 'Export Price List',
      defaultCompanyName: 'WASSER - Online Plumbing Store',
      defaultAddress: 'Bishkek, Kyrgyzstan',
      defaultTitle: 'PRICE LIST',
      defaultSubtitle: 'Valid as of {{date}}',
      defaultFooter: 'Prices are in KGS. Check product availability with our managers.',
    },

    // Widgets
    widgets: {
      dateAndTime: 'Date & Time',
      bishkekTimezone: 'Bishkek (UTC+6)',
      weekNumber: 'Week {{n}}',
      dayNumber: 'Day {{n}}',
      quarter: 'quarter',
      noData: 'No data',
      exchange: {
        title: 'NBKR Exchange Rates',
        usd: 'US Dollar',
        eur: 'Euro',
        rub: 'Russian Ruble',
        kzt: 'Tenge',
        loadError: 'Failed to load exchange rates',
        dataSource: 'Data provided by NBKR',
      },
      weather: {
        title: 'Weather',
        feelsLike: 'Feels like',
        loadError: 'Failed to load weather data',
        defaultCity: 'Bishkek',
        partlyCloudy: 'Partly cloudy',
        windSpeed: 'm/s',
      },
    },

    // Sync Progress
    sync: {
      secSuffix: 's',
      minSuffix: 'm',
      statusDone: 'Completed',
      statusError: 'Error',
      statusRunning: 'Running',
      statusPending: 'Pending',
      statusUnknown: 'Unknown',
      syncTitle: 'Synchronization',
      entityProducts: 'products',
      entityStock: 'stock',
      entityOrders: 'orders',
      disableAutoRefresh: 'Disable auto-refresh',
      enableAutoRefresh: 'Enable auto-refresh',
      loadError: 'Loading error:',
      completed: 'completed',
      processed: 'Processed',
      errors: 'Errors',
      time: 'Time',
      itemsPerSec: 'items/sec',
      syncError: 'Sync error:',
      recentItems: 'Recently processed items:',
      successSuffix: 'successfully',
      started: 'Started:',
      finished: 'Finished:',
    },

    // Cost Calculation Utils (costCalculationUtils.js)
    costCalc: {
      // Sheet names
      sheetMaterials: 'Materials',
      sheetLabor: 'Labor',
      sheetCalculation: 'Calculation',
      sheetInstructions: 'Instructions',

      // Column headers - Materials
      colName: 'Name',
      colUnit: 'Unit',
      colQuantity: 'Quantity',
      colPricePerUnit: 'Price per unit',
      colTotal: 'Total',
      colSupplier: 'Supplier',
      colNotes: 'Notes',

      // Column headers - Labor
      colLaborName: 'Labor name',
      colHours: 'Hours',
      colRatePerHour: 'Rate/hour',
      colCost: 'Cost',
      colWorker: 'Worker',

      // Cost calculation labels
      costTitle: 'Cost Calculation',
      directCosts: 'DIRECT COSTS',
      materials: 'Materials',
      laborLabel: 'Labor',
      directCostsTotal: 'Total direct costs',
      indirectCosts: 'INDIRECT COSTS',
      overheadCosts: 'Overhead costs ({{percent}}%)',
      transportCosts: 'Transport costs',
      packaging: 'Packaging',
      otherCosts: 'Other costs',
      totalCost: 'TOTAL COST',
      priceCalculation: 'PRICE CALCULATION',
      markup: 'Markup ({{percent}}%)',
      vatLabel: 'VAT ({{percent}}%)',
      recommendedPrice: 'RECOMMENDED PRICE',

      // Default units
      unitPcs: 'pcs',
      unitHour: 'hour',
      unitSqm: 'm²',
      unitLm: 'l.m.',
      unitPack: 'pack',

      // Error messages
      errorParsingExcel: 'Excel parsing error: {{message}}',
      errorReadingFile: 'File reading error',
      errorLoadingExceljs: 'Error loading exceljs library: {{message}}',
      errorExportExcel: 'Excel export error: {{message}}',
      errorCreatingTemplate: 'Template creation error: {{message}}',

      // Validation messages
      noMaterialsAdded: 'No materials added',
      materialNoName: 'Material {{index}}: name not specified',
      materialInvalidQty: 'Material "{{name}}": invalid quantity',
      materialInvalidPrice: 'Material "{{name}}": invalid price',
      noLaborAdded: 'No labor items added',
      laborNoName: 'Labor {{index}}: name not specified',
      laborInvalidHours: 'Labor "{{name}}": invalid hours',
      laborInvalidRate: 'Labor "{{name}}": invalid rate',

      // Compare categories
      catMaterials: 'Materials',
      catLabor: 'Labor',
      catTotalCost: 'Total cost',

      // Template sample data
      samplePlywood: 'Birch plywood 18mm',
      sampleEdgePVC: 'PVC edge 2mm white',
      sampleScrews: 'Screws 4x16',
      sampleSupplier1: 'Timber Trading LLC',
      sampleSupplier2: 'Furniture Parts LLC',
      sampleSupplier3: 'Hardware Store',
      sampleHighGrade: 'Premium grade',
      samplePcsPerPack: '100 pcs per pack',
      sampleCutting: 'Material cutting',
      sampleEdgeBanding: 'Edge banding',
      sampleAssembly: 'Product assembly',
      sampleMaster: 'Master',
      sampleCarpenter: 'Carpenter 1st class',

      // Template instructions
      instrTitle: 'COST CARD FILLING INSTRUCTIONS',
      instrMaterialsSheet: '"Materials" sheet:',
      instrMatName: '- Name: material or component name',
      instrMatUnit: '- Unit: unit of measurement (m², l.m., pcs, kg, etc.)',
      instrMatQuantity: '- Quantity: material consumption per product unit',
      instrMatPrice: '- Price per unit: unit cost in soms',
      instrMatSupplier: '- Supplier: supplier name (optional)',
      instrMatNotes: '- Notes: additional information (optional)',
      instrLaborSheet: '"Labor" sheet:',
      instrLabName: '- Labor name: description of the operation',
      instrLabHours: '- Hours: labor hours',
      instrLabRate: '- Rate/hour: hourly rate in soms',
      instrLabWorker: '- Worker: position/name of worker (optional)',
      instrLabNotes: '- Notes: additional information (optional)',
      instrImportant: 'IMPORTANT:',
      instrKeepHeaders: '- Do not delete headers (first row on each sheet)',
      instrStartRow2: '- Fill in data from the second row',
      instrEmptyRows: '- Empty rows will be ignored',
      instrDecimalPoint: '- Use a dot as a decimal separator (2.5, not 2,5)',
      instrUpload: 'After filling in, upload the file via the "Upload Excel" button in the system',
    },

    // ProductCostCalculation component
    productCost: {
      currencyShort: 'KGS',
      currencyPerHour: 'KGS/hr',
      currencyFull: 'som',
      saveFailed: 'Failed to save cost card',
      historyFailed: 'Failed to load cost card history',
      apiErrorLocalSaved: 'API error, data saved locally',
      noDataInFile: 'No data found in file. Check file structure.',
      uploadError: 'Error uploading file',
      downloadError: 'Error',
      templateDownloadError: 'Error downloading template',
      generalError: 'General error',
      uploadedMaterials: 'Loaded: {{count}} materials',
      uploadedLabor: ', {{count}} labor items',
      orderLabel: 'Order',
      productLabel: 'Product',
      createdInDb: '✅ Created in DB: {{count}} materials',
      alreadyInDb: '📦 Already in DB: {{count}}',
      errorsCount: '⚠️ Errors: {{count}}',
      fromDbChip: 'From DB ({{code}})',
      supplierNote: 'Supplier',
      dbEmpty: 'Materials database is empty',
      outdatedPricesConfirm: 'Found {{count}} materials with outdated prices. Update?',
      allPricesActual: 'All prices are up to date!',
      pricesUpdated: 'Updated {{count}} materials. Total difference: {{diff}}',
      noMaterialsToUpdate: 'No materials to update',
      recommendedPriceNote: 'Recommended price: {{price}} som',
      materialsCountNote: 'Materials: {{count}}',
      worksCountNote: 'works: {{count}}',
      markupNote: 'Markup: {{percent}}%',
      pdfSubtitle: 'Bathroom furniture',
      pdfDocTitle: 'ESTIMATE / COMMERCIAL OFFER',
      pdfDate: 'Date',
      pdfProduct: 'Product',
      pdfMaterialsHeader: 'Materials:',
      pdfWorksHeader: 'Works:',
      pdfSummaryHeader: 'Final calculation:',
      pdfColNum: '#',
      pdfColName: 'Name',
      pdfColUnit: 'Unit',
      pdfColQty: 'Qty',
      pdfColPrice: 'Price',
      pdfColTotal: 'Total',
      pdfColHours: 'Hours',
      pdfColRate: 'Rate',
      pdfRowMaterials: 'Materials',
      pdfRowWorks: 'Works',
      pdfRowDirectCosts: 'Direct costs',
      pdfRowOverhead: 'Overhead costs',
      pdfRowTransport: 'Transport',
      pdfRowPackaging: 'Packaging',
      pdfRowOtherCosts: 'Other costs',
      pdfRowCostPrice: 'COST PRICE',
      pdfRowMarkup: 'Markup',
      pdfRowTotalPayable: 'TOTAL PAYABLE',
      pdfDisclaimer1: '* Estimate valid for 14 days from the date of issue',
      pdfDisclaimer2: '* Prices are in Kyrgyz soms (KGS)',
      pdfFilename: 'Estimate',
      pdfDefaultProduct: 'product',
      autoCreateTooltip: 'When loading Excel, automatically create missing materials in the database',
    },

    // Materials Integration Utils
    materialsInt: {
      notFoundInDb: 'Not found in database',
      priceFormat: '{{price}} KGS/{{unit}}',
      sheetMaterials: 'Materials',
      defaultCategoryOther: 'Other',
      defaultUnitPcs: 'pcs',
      errorParsingExcel: 'Excel parsing error: {{message}}',
      errorReadingFile: 'File reading error',
      errorLoadingLibrary: 'Library loading error: {{message}}',
      sheetServices: 'Services',
      headerCode: 'Code',
      headerName: 'Name',
      headerCategory: 'Category',
      headerUnit: 'Unit',
      headerPrice: 'Price',
      headerSupplierPrice: 'Supplier price',
      headerSupplier: 'Supplier',
      headerMinStock: 'Min. stock',
      headerStock: 'Stock',
      headerNotes: 'Notes',
      headerRate: 'Rate',
      headerQualification: 'Qualification',
      errorExport: 'Export error: {{message}}',
      examplePlywood: 'Birch plywood 18mm',
      exampleCategorySheet: 'Sheet materials',
      exampleUnitM2: 'm²',
      exampleSupplier1: 'WoodTrade LLC',
      exampleNoteHighGrade: 'Premium grade',
      examplePvcEdge: 'PVC edge 2mm white',
      exampleCategoryEdge: 'Edge materials',
      exampleUnitLm: 'l.m.',
      exampleSupplier2: 'Furniture Supply',
      exampleScrews: 'Screws 4x16',
      exampleCategoryFasteners: 'Fasteners',
      exampleUnitPack: 'pack',
      exampleSupplier3: 'Fastener Plus',
      exampleNotePack100: '100 pcs per pack',
      exampleCutting: 'Material cutting',
      exampleCategoryWoodwork: 'Woodworking',
      exampleUnitHour: 'hour',
      exampleQualMaster: 'Master',
      exampleNoteIncludesMarking: 'Includes marking',
      exampleEdgeBanding: 'Edge banding',
      exampleAssembly: 'Product assembly',
      exampleCategoryAssembly: 'Assembly',
      exampleQualCarpenter: 'Carpenter 1st grade',
      sheetInstructions: 'Instructions',
      instrTitle: 'INSTRUCTIONS FOR FILLING MATERIALS DATABASE',
      instrMaterialsSheet: 'Sheet "Materials":',
      instrCode: '- Code: unique material code (MAT-001, MAT-002, etc.)',
      instrName: '- Name: full material name',
      instrCategory: '- Category: Sheet materials, Fasteners, Hardware, etc.',
      instrUnit: '- Unit: unit of measurement (m², l.m., pcs, kg)',
      instrPrice: '- Price: current selling price',
      instrSupplierPrice: '- Supplier price: purchase price from supplier',
      instrSupplier: '- Supplier: supplier company name',
      instrMinStock: '- Min. stock: minimum stock level for warning',
      instrStock: '- Stock: current stock level',
      instrNotes: '- Notes: additional information',
      instrServicesSheet: 'Sheet "Services":',
      instrServiceCode: '- Code: unique service code (SRV-001, SRV-002, etc.)',
      instrServiceName: '- Name: operation/work name',
      instrServiceCategory: '- Category: Woodworking, Assembly, Finishing, etc.',
      instrServiceUnit: '- Unit: unit of measurement (hour, pcs)',
      instrServiceRate: '- Rate: cost per unit',
      instrServiceQualification: '- Qualification: required performer qualification',
      instrServiceNotes: '- Notes: additional information',
      instrImportant: 'IMPORTANT:',
      instrNoDeleteHeaders: '- Do not delete headers (first row)',
      instrUniqueCodes: '- Codes must be unique',
      instrDecimalPoint: '- Use a dot as decimal separator (850.50)',
      instrEmptyRows: '- Empty rows will be ignored',
      errorCreatingTemplate: 'Template creation error: {{message}}',
      priceChangeReason: 'Price change',
    },

    // Inventory Counting
    inventoryCounting: {
      status: {
        draft: 'Draft',
        inProgress: 'In Progress',
        completed: 'Completed',
        cancelled: 'Cancelled',
      },
      detail: {
        notFound: 'Inventory counting not found',
        backToList: 'Back to list',
        backToListAria: 'Back to inventory counting list',
        back: 'Back',
        title: 'Inventory Counting',
        warehouse: 'Warehouse',
        responsible: 'Responsible',
        startDate: 'Start Date',
        endDate: 'End Date',
        countProgress: 'Counting Progress',
        report: 'Report',
        autoFill: 'Auto-fill',
        startInventory: 'Start Inventory Counting',
        completeCount: 'Complete',
        cancel: 'Cancel',
        product: 'Product',
        variant: 'Variant',
        batch: 'Batch',
        expected: 'Expected',
        actual: 'Actual',
        discrepancy: 'Discrepancy',
        reason: 'Reason',
        actions: 'Actions',
        noItems: 'No items. Use auto-fill or add manually.',
        recount: 'Recount',
        delete: 'Delete',
        recountTitle: 'Recount:',
        actualRequired: 'Actual *',
        discrepancyReason: 'Discrepancy Reason',
        note: 'Note',
        reportDialogTitle: 'Inventory Counting Report',
        document: 'Document:',
        totalItems: 'Total Items',
        counted: 'Counted',
        expectedTotal: 'Expected:',
        actualTotal: 'Actual:',
        totalDiscrepancy: 'Total Discrepancy:',
        surplus: 'Surplus:',
        deficit: 'Deficit:',
        generatedAt: 'Generated:',
        print: 'Print',
        pdfDownloadError: 'PDF download error: ',
        excelExportError: 'Excel export error: ',
        csvProduct: 'Product',
        csvSku: 'SKU',
        csvVariant: 'Variant',
        csvBatch: 'Batch',
        csvExpected: 'Expected',
        csvActual: 'Actual',
        csvDiscrepancy: 'Discrepancy',
        completedAlert: 'Inventory counting completed. Stock has been updated.',
        completeError: 'Error completing inventory counting',
        reportGenerationError: 'Report generation error',
        confirmStart: 'Start inventory counting? After starting, the document cannot be edited.',
        confirmComplete: 'Complete inventory counting? Stock will be updated according to actual data. This action is irreversible.',
        confirmCancel: 'Cancel inventory counting?',
        confirmAutoFill: 'Auto-fill items from stock? Existing items will be deleted.',
        confirmDeleteItem: 'Delete item?',
        printReportTitle: 'Inventory Counting Report',
        printWarehouse: 'Warehouse:',
        printResponsible: 'Responsible:',
        printStatus: 'Status:',
        printTotalItems: 'Total Items:',
        printCounted: 'Counted:',
        printExpectedSum: 'Expected Total:',
        printActualSum: 'Actual Total:',
        printTotalDiscrepancy: 'Total Discrepancy:',
        excelIndicator: 'Indicator',
        excelValue: 'Value',
        excelTotalItems: 'Total Items',
        excelCounted: 'Counted',
        excelExpectedSum: 'Expected Total',
        excelActualSum: 'Actual Total',
        excelTotalDiscrepancy: 'Total Discrepancy',
        excelSurplus: 'Surplus',
        excelDeficit: 'Deficit',
        excelUncounted: 'Uncounted',
        excelProduct: 'Product',
        excelVariant: 'Variant',
        excelBatch: 'Batch',
        excelExpected: 'Expected',
        excelActual: 'Actual',
        excelDiscrepancy: 'Discrepancy',
        excelReason: 'Reason',
        excelNote: 'Note',
        excelSummarySheet: 'Summary',
        excelItemsSheet: 'Items',
        errorUpdateItem: 'Failed to update item',
        errorDeleteItem: 'Failed to delete item',
        errorAutoFill: 'Failed to auto-fill items',
      },
      list: {
        title: 'Inventory Counting',
        create: 'Create',
        exportExcel: 'Export Excel',
        exporting: 'Exporting...',
        exportAll: 'Export All (Excel)',
        status: 'Status',
        all: 'All',
        searchByNumber: 'Search by number',
        reset: 'Reset',
        documentNumber: 'Document Number',
        warehouse: 'Warehouse',
        responsible: 'Responsible',
        startDate: 'Start Date',
        endDate: 'End Date',
        positions: 'Items',
        counted: 'Counted',
        actions: 'Actions',
        loading: 'Loading...',
        notFound: 'No inventory countings found',
        view: 'View',
        edit: 'Edit',
        start: 'Start',
        delete: 'Delete',
        complete: 'Complete',
        cancel: 'Cancel',
        rowsPerPage: 'Rows per page:',
        displayedRows: '{{from}}-{{to}} of {{count}}',
        confirmDelete: 'Delete inventory counting?',
        confirmStart: 'Start inventory counting? After starting, the document cannot be edited.',
        confirmComplete: 'Complete inventory counting? Stock will be updated according to actual data.',
        confirmCancel: 'Cancel inventory counting?',
        excelExportError: 'Excel export error: ',
        fullExportError: 'Full export error: ',
        excelNumber: 'Number',
        excelWarehouse: 'Warehouse',
        excelResponsible: 'Responsible',
        excelStatus: 'Status',
        excelStart: 'Start',
        excelEnd: 'End',
        excelPositions: 'Items',
        excelCounted: 'Counted',
        excelSheetName: 'Inventory Countings',
      },
      errorDelete: 'Failed to delete inventory counting',
      errorStart: 'Failed to start inventory counting',
      errorComplete: 'Failed to complete inventory counting',
      errorCancel: 'Failed to cancel inventory counting',
      create: {
        title: 'Create Inventory Counting',
        back: 'Back',
        nextDocNumber: 'Next document number:',
        createError: 'Error creating inventory counting',
        selectWarehouse: 'Select a warehouse',
        selectResponsible: 'Specify responsible person',
        warehouseLabel: 'Warehouse *',
        startDate: 'Start Date',
        comment: 'Comment',
        fillOptions: 'Item Fill Options',
        autoFill: 'Auto-fill items from stock',
        includeZeroStock: 'Include items with zero stock',
        creating: 'Creating...',
        createBtn: 'Create',
      },
    },

    // Media
    media: {
      productMedia: 'Product Media',
      viewGallery: 'View Gallery',
      images: 'Images',
      videos: 'Videos',
      initError: 'Failed to initialize video player',
      hlsNotSupported: 'HLS not supported in this browser',
      videoNotFound: 'Video not found (404). It may have been deleted from Cloudflare Stream.',
      networkError: 'Network error: {{details}}',
      playbackError: 'Playback error: {{details}}',
    },

    images: {
      uploadFailed: 'Failed to upload images',
      deleteFailed: 'Failed to delete image',
    },

    // Image Uploader
    imageUploader: {
      maxImagesReached: 'Maximum {{max}} images reached',
      partialUpload: 'Only uploading {{uploading}} of {{total}} files ({{slots}} slots available)',
      failedUploads: '{{count}} file(s) failed to upload',
      dragDropTitle: 'Drag & drop images or click to browse',
      dragDropHint: 'Multiple files supported • JPEG, PNG, WebP, GIF (max 10MB each)',
      uploadingProgress: 'Uploading {{count}} file(s)... {{percent}}%',
      uploadedCount: 'Uploaded ({{current}}/{{max}}) • Click to view, drag to reorder',
      firstIsMain: 'First = Main',
      reorderTip: '💡 Tip: Drag images to reorder. First image is the main product image.',
      maxReachedHint: 'Maximum number of images reached ({{max}}). Delete an image to upload a new one.',
      noImages: 'No images uploaded',
    },

    // Error Boundary
    errors: {
      pageErrorTitle: 'Page Error',
      pageErrorMessage: 'An error occurred on this page. Try refreshing or go back to the home page.',
      retry: 'Retry',
      goHome: 'Go Home',
    },

    // Video Uploader
    video: {
      uploadFile: 'Upload File',
      uploadFromUrl: 'Upload from URL',
      uploadFromUrlTitle: 'Upload Video from URL',
      hdLabel: 'HD',
      streamLabel: 'Stream',
      r2Label: 'R2',
      videoNamePlaceholder: 'Product Demo Video',
      dragDropPrompt: 'Drag & drop video or click to browse',
      cloudflareHint: 'Uploads to Cloudflare Stream (automatic HD transcoding)',
      supportedFormats: 'Supported formats: MP4, WebM, MOV, AVI (max 1GB)',
      supportedHint: 'Supported: MP4, WebM, MOV, AVI',
      videoUrl: 'Video URL',
      videoNameOptional: 'Video Name (optional)',
      videoFromUrl: 'Video from URL',
      uploading: 'Uploading... {{progress}}%',
      uploadedCount: 'Uploaded Videos ({{count}}/{{max}})',
      statusProcessing: 'Processing',
      statusReady: 'Ready',
      maxReached: 'Maximum number of videos reached ({{max}}). Delete a video to upload a new one.',
      uploadFailed: 'Failed to upload video',
      deleteFailed: 'Failed to delete video',
      enterUrlError: 'Please enter a video URL',
    },
  },

  // ============================================================
  // KYRGYZ (KY) - Кыргызча
  // ============================================================
  ky: {
    // Common
    common: {
      save: 'Сактоо',
      cancel: 'Жокко чыгаруу',
      delete: 'Өчүрүү',
      edit: 'Өзгөртүү',
      add: 'Кошуу',
      search: 'Издөө',
      filter: 'Чыпкалоо',
      export: 'Экспорт',
      import: 'Импорт',
      loading: 'Жүктөлүүдө...',
      noData: 'Маалымат жок',
      error: 'Ката',
      success: 'Ийгиликтүү',
      confirm: 'Ырастоо',
      confirmTitle: 'Ырастоо',
      confirmMessage: 'Ишенесизби?',
      yes: 'Ооба',
      no: 'Жок',
      refresh: 'Жаңылоо',
      active: 'Активдүү',
      inactive: 'Активдүү эмес',
      saving: 'Сакталууда...',
      update: 'Жаңылоо',
      create: 'Түзүү',
      actions: 'Аракеттер',
      close: 'Жабуу',
      back: 'Артка',
      next: 'Кийинки',
      all: 'Бардыгы',
      status: 'Статус',
      name: 'Аталыш',
      total: 'Жалпы',
      details: 'Деталдар',
      unknownError: 'Белгисиз ката',
      retry: 'Кайталоо',
      view: 'Көрүү',
      rowsPerPage: 'Саптар бетте:',
      of: 'ичинен',
      closeGallery: 'Галереяны жабуу',
      previousImage: 'Мурунку сүрөт',
      nextImage: 'Кийинки сүрөт',
      deleteImage: 'Сүрөттү өчүрүү',
      deleteVideo: 'Видеону өчүрүү',
      refreshWidget: 'Виджетти жаңылоо',
      openMenu: 'Менюну ачуу',
      closeMenu: 'Менюну жабуу',
      notifications: 'Билдирүүлөр',
      changeLanguage: 'Тилди алмаштыруу',
      expand: 'Жайып көрсөтүү',
      collapse: 'Жыйыштыруу',
      selectVideoQuality: 'Видеонун сапатын тандоо',
      previousMedia: 'Мурунку медиафайл',
      nextMedia: 'Кийинки медиафайл',
      hideMenu: 'Менюну жашыруу',
      collapseMenu: 'Менюну жыйыштыруу',
      markAsRead: 'Окулду деп белгилөө',
      manageColumns: 'Тилкелерди башкаруу',
      dragColumnsHint: 'Тилкелерди иреттөө үчүн сүйрөңүз',
      resetOrder: 'Иретти баштапкыга кайтаруу',
      showAll: 'Баарын көрсөтүү',
      done: 'Даяр',
      noDataToDisplay: 'Көрсөтүүгө маалымат жок',
      tableUnavailable: 'Таблица убактылуу жеткиликсиз',
      tryAgain: 'Кайра аракет кылуу',
      enableDataGrid: 'DataGrid күйгүзүү',
      dataGridDisabled: 'DataGrid рендер катасы боюнча өчүрүлдү. Жөнөкөйлөтүлгөн режим көрсөтүлүүдө.',
      auto: 'Авто',
      autoAdaptive: 'Авто (Адаптивдүү)',
      videoQuality: 'Видеонун сапаты',
      currencyKGS: 'сом',
      ms: 'мс',
      seconds: 'с',
      displayedRows: '{{from}}–{{to}} ичинен {{count}}',
      product: 'Продукт',
      email: 'Email',
      video: 'Видео',
      image: 'Сүрөт',
      upload: 'Жүктөө',
      statusSuccess: 'Ийгиликтүү',
      statusError: 'Ката',
      statusPending: 'Күтүүдө',
      statusProcessing: 'Иштетилүүдө',
      currencyCode: 'KGS',
      none: 'Тандалган жок',
    },
    theme: {
      toggle: 'Теманы алмаштыруу',
      lightTheme: 'Жарык тема',
      darkTheme: 'Караңгы тема',
    },

    // Export (Excel price lists)
    export: {
      priceList: 'Прайс-лист',
      sku: 'Артикул',
      photo: 'Сүрөт',
      productName: 'Аталышы',
      description: 'Сүрөттөмө',
      category: 'Категория',
      priceWithCurrency: 'Баасы ({{currency}})',
      priceB2B: 'B2B Баасы ({{currency}})',
      priceQty10: '10 даана үчүн баа ({{currency}})',
      priceQty50: '50 даана үчүн баа ({{currency}})',
      stock: 'Болушу',
      inStock: 'Бар',
      toOrder: 'Буйрутма менен',
      phone: 'Тел',
      address: 'Дарек',
      website: 'Сайт',
      report: 'Отчет',
      generated: 'Түзүлгөн',
      page: 'Барак',
      orderNumber: 'Буйрутма',
      status: 'Статус',
      customerInformation: 'Кардар жөнүндө маалымат',
      customerName: 'Аты',
      email: 'Email',
      orderItems: 'Буйрутмадагы товарлар',
      productCol: 'Товар',
      skuCol: 'Артикул',
      qtyCol: 'Саны',
      priceCol: 'Баасы',
      totalCol: 'Сумма',
      orderSummary: 'Буйрутма жыйынтыгы',
      subtotal: 'Аралык жыйынтык',
      shipping: 'Жеткирүү',
      discount: 'Арзандатуу',
      totalLabel: 'Жалпы',
      notes: 'Эскертүүлөр',
      platformName: 'WASSER E-commerce Platform',
      emailAttachedReport: 'Тиркелген отчетту караңыз',
      emailRegards: 'Урмат менен,',
    },

    // Profile
    profile: {
      open: 'Профилди ачуу',
    },

    // Navigation
    nav: {
      dashboard: 'Башкаруу панели',
      products: 'Товарлар',
      inventory: 'Инвентаризация',
      orders: 'Буйрутмалар',
      users: 'Колдонуучулар',
      analytics: 'Аналитика',
      settings: 'Жөндөөлөр',
      logout: 'Чыгуу',
      openMenu: 'Менюну ачуу',
      more: 'Көбүрөөк',
      notifications: 'Эскертмелер',
      language: 'Тил',
      categories: 'Категориялар',
      batches: 'Товар партиялары',
      roles: 'Ролдор жана укуктар',
      badges: 'Товар бейдждери',
      counting: 'Товарларды кайра саноо',
      serials: 'Сериялык номерлер',
      purchases: 'Сатып алуулар',
      bom: 'Спецификациялар (BOM)',
      manufacturing: 'Өндүрүш',
      production: 'Өндүрүш трекери',
      materials: 'Материалдар',
      qualityControl: 'Сапат контролу',
      finance: 'Финанс',
      messenger: 'Мессенджер',
      customerSupport: 'Кардарларды колдоо',
      integrations: 'Интеграциялар',
      suppliers: 'Жеткизүүчүлөр',
      advancedAnalytics: 'Кеңейтилген аналитика',
      organizations: 'Уюштуруулар',
      onecDatabases: '1C Базалар',
      onecMetrics: '1C Метрикалар',
      onecHealth: '1C Ден соолук',
      onecSyncLogs: '1C Логдор',
      onecInstaller: '1C жүктөө',
      connectorSettings: 'Коннектор жөндөөлөрү',
      newBatch: 'Жаңы партия',
      newCounting: 'Жаңы эсептөө',
      pin: 'Бекитүү',
      unpin: 'Бошотуу',
      pinAction: 'Аракетти бекитүү: {{label}}',
      unpinAction: 'Аракетти бошотуу: {{label}}',
      pinHint: 'Аракетти бекитүү үчүн: 📌 басыңыз же иконканы узак басыңыз.',
      myProfile: 'Менин профилим',
      home: 'Башкы',
      superAdmin: 'СУПЕР АДМИН',
      featureFlags: 'Feature Flags',
      adminPanel: 'Башкаруу панели',
      mobileHome: 'Башкы',
      mobileOrders: 'Буйрутмалар',
      mobileInventory: 'Кампа',
      mobileAnalytics: 'Аналитика',
      mobileMenu: 'Меню',
    },

    // Products
    products: {
      title: 'Товарларды башкаруу',
      addProduct: 'Товар кошуу',
      editProduct: 'Товарды өзгөртүү',
      columnName: 'Аталышы',
      columnCategory: 'Категория',
      columnPrice: 'Баасы',
      columnStock: 'Калдык',
      columnStatus: 'Статус',
      columnActions: 'Аракеттер',
      editVariant: 'Вариантты өзгөртүү',
      deleteVariant: 'Вариантты өчүрүү',
      variantName: 'Варианттын аталышы',
      variantUpdated: 'Вариант жаңыланды',
      variantCreated: 'Вариант түзүлдү',
      variantDeleted: 'Вариант өчүрүлдү',
      confirmDeleteVariant: 'Бул вариантты өчүрөсүзбү?',
      productVariants: 'Товар варианттары',
      addVariant: 'Вариант кошуу',
      editVariantTitle: 'Вариантты өзгөртүү',
      addVariantTitle: 'Вариант кошуу',
      failedToLoadData: 'Маалыматтарды жүктөө мүмкүн болбоду',
      failedToSave: 'Товарды сактоо мүмкүн болбоду',
      deleteProduct: 'Товарды өчүрүү',
      noMedia: 'Бул товар үчүн медиа файлдар жок',
      openMedia: 'Медианы ачуу',
      productName: 'Товар аталышы',
      sku: 'Артикул',
      price: 'Баасы',
      stock: 'Калдык',
      stockAvailable: 'Жеткөлүктүү',
      stockOnHand: 'Колдо',
      stockReserved: 'Резерв',
      status: 'Статус',
      active: 'Активдүү',
      inactive: 'Активдүү эмес',
      lowStock: 'Аз калды',
      outOfStock: 'Жок',
      category: 'Категория',
      description: 'Сүрөттөмө',
      images: 'Сүрөттөр',
      specifications: 'Мүнөздөмөлөр',
      pricing: 'Баалар',
      b2bPrice: 'B2B баасы',
      volumePrice: 'Дүң баасы',
      qty10Price: '10+ дана баасы',
      qty50Price: '50+ дана баасы',
      stockQuantity: 'Кампадагы саны',
      confirmDelete: 'Бул товарды өчүргүңүз келеби?',
      deleteSuccess: 'Товар ийгиликтүү өчүрүлдү',
      saveSuccess: 'Товар ийгиликтүү сакталды',
      totalCountLabel: 'Активдүү товарлар',
      featured: 'Хит',
      featuredBadge: 'Витринада белгиленген',
      noLowStock: 'Аз калдык товар жок',
      createProduct: 'Товар түзүү',
      deleteAll: 'Бардыгын өчүрүү',
      basicInfo: 'Негизги маалымат',
      noCategory: 'Категориясыз',
      nameRu: 'Аталышы (Орусча)',
      nameEn: 'Аталышы (Англисче)',
      nameKy: 'Аталышы (Кыргызча)',
      descriptionRu: 'Сүрөттөмө (Орусча)',
      descriptionEn: 'Сүрөттөмө (Англисче)',
      descriptionKy: 'Сүрөттөмө (Кыргызча)',
      retailPrice: 'Чекене баасы',
      quantity: 'Кампадагы саны',
      lowThreshold: 'Минималдуу калдык',
      isActive: 'Активдүү (сатып алуучуларга көрүнөт)',
      isFeatured: 'Хит (башкы бетте көрсөтүү)',
      errors: {
        skuRequired: 'Артикул милдеттүү',
      },
      // Product management page
      columnName: 'Аталышы',
      columnActions: 'Аракеттер',
      viewMode: 'Көрүнүш режими',
      viewGridLarge: 'Чоң плитка',
      viewGridSmall: 'Кичине плитка',
      viewListPhoto: 'Сүрөттөр менен тизме',
      viewTable: 'Таблица',
      sorting: 'Иреттөө',
      sortByName: 'Аталышы боюнча',
      sortByPrice: 'Баасы боюнча',
      sortByDate: 'Күнү боюнча',
      sortByStock: 'Калдыгы боюнча',
      sortByStatus: 'Статусу боюнча',
      sortAsc: 'Өсүү тартибинде',
      sortDesc: 'Кемүү тартибинде',
      sortAscLabel: 'Өсүү тартибинде иреттөө',
      sortDescLabel: 'Кемүү тартибинде иреттөө',
      filters: 'Чыпкалар',
      resetAll: 'Баарын тазалоо',
      allStatuses: 'Бардык статустар',
      activeFilter: 'Активдүү',
      inactiveFilter: 'Активдүү эмес',
      allCategories: 'Бардык категориялар',
      openFilters: 'Чыпкаларды ачуу',
      searchPlaceholder: 'Аталышы, SKU же категория боюнча издөө...',
      clearSearch: 'Издөөнү тазалоо',
      productBundles: 'Товар комплекттери',
      exportExcel: 'Excel экспорт',
      manageColumns: 'Мамычаларды башкаруу',
      variants: 'Варианттар',
      manageVariants: 'Товар варианттарын башкаруу',
      openVariants: 'Товар варианттарын ачуу',
      exportWithPhotos: 'Сүрөттөр менен толук экспорт',
      exportWithoutPhotos: 'Сүрөтсүз толук экспорт',
      exportPriceListCustom: 'Прайс-лист (ыңгайлаштырылган)',
      shown: 'Көрсөтүлдү',
      productUpdated: '"{{name}}" товар ийгиликтүү жаңыланды',
      productCreated: '"{{name}}" товар ийгиликтүү түзүлдү',
      missingSlug: 'Ката: товардын slug/id жок',
      confirmDeleteProduct: '"{{name}}" товарды өчүрүү керекпи? Бул аракетти артка кайтаруу мүмкүн эмес.',
      productDeleted: '"{{name}}" товар өчүрүлдү.',
      cannotDeleteLinked: '"{{name}}" товарды өчүрүү мүмкүн эмес.\n\nТовар буйрутмаларда же башка жазууларда колдонулат. Адегенде байланышкан маалыматтарды өчүрүңүз.',
      deleteError: 'Өчүрүү катасы',
      confirmDeleteAllProducts: 'БАРДЫК товарларды өчүрүүнү каалайсызбы? Бул аракетти артка кайтаруу мүмкүн эмес.',
      deletedCount: 'Өчүрүлгөн товарлар: {{count}}',
      bulkDeleteError: 'Жалпы өчүрүү катасы',
      noProductsToExport: 'Экспорттоо үчүн товар жок',
      exportError: 'Экспорт катасы',
      priceListExportError: 'Прайс-лист экспорт катасы',
      noMatchingProducts: 'Чыпкаларга туура келген товарлар жок. Издөө параметрлерин өзгөртүп көрүңүз.',
      authRequired: 'Авторизация талап кылынат',
      closeDialog: 'Диалогду жабуу',
      exportPhoto: 'Сүрөт',
      exportNameRu: 'Аталышы (RU)',
      exportNameEn: 'Аталышы (EN)',
      exportNameKy: 'Аталышы (KY)',
      exportPriceKgs: 'Баасы (KGS)',
      exportPriceB2b: 'B2B баасы (KGS)',
      exportStockCol: 'Калдык',
      exportAvailable: 'Жеткиликтүү',
      exportOnHand: 'Кампада',
      exportReserved: 'Резервделген',
      exportCategory: 'Категория',
      exportStatus: 'Статус',
      exportFeatured: 'Сунушталган',
      exportCreated: 'Түзүлдү',
      exportUpdated: 'Жаңыланды',
      exportDescRu: 'Сүрөттөмө (RU)',
      exportDescEn: 'Сүрөттөмө (EN)',
      exportDescKy: 'Сүрөттөмө (KY)',
      exportQty10: '10 дана баасы (KGS)',
      exportQty50: '50 дана баасы (KGS)',
      // ProductForm
      form: {
        changesSaved: 'Өзгөрүүлөр сакталды',
        tabBasicInfo: 'Негизги маалымат',
        tabPricing: 'Баалар',
        tabStock: 'Калдыктар',
        tabMedia: 'Медиа',
        tabBom: 'Спецификация',
        tabCost: 'Өздүк наркы',
        skuNoChange: 'SKU түзүлгөндөн кийин өзгөртүүгө болбойт',
        skuHint: 'Уникалдуу товар коду',
        skuPlaceholder: 'Мисалы: PROD-001',
        nameRuPlaceholder: 'Орусча аталышын жазыңыз',
        nameEnPlaceholder: 'Англисче аталышын жазыңыз',
        nameKyPlaceholder: 'Кыргызча аталышын киргизиңиз',
        descRuPlaceholder: 'Товардын толук сүрөттөмөсү орусча...',
        descEnPlaceholder: 'Товардын толук сүрөттөмөсү англисче...',
        descKyPlaceholder: 'Товардын толук сүрөттөмөсү кыргызча...',
        chars: 'белги',
        currencySom: 'сом',
        retailPriceHint: 'Сатып алуучулар үчүн негизги баа',
        b2bPriceHint: 'Дүң сатып алуучулар үчүн баа',
        qty10Hint: '10 бирдиктен сатып алганда',
        qty50Hint: '50 бирдиктен сатып алганда',
        pcs: 'даана',
        stockQtyHint: 'Кампадагы учурдагы товар саны',
        lowThresholdHint: 'Бул деңгээлге жеткенде эскертүү',
        lowStockWarning: 'Товар кампада бүтүп баратат! Учурдагы калдык: {{qty}} даана',
        bomUnavailable: 'Спецификация сакталган товарлар үчүн гана жеткиликтүү. Адегенде товарды түзүңүз.',
        costUnavailable: 'Өздүк наркты эсептөө сакталган товарлар үчүн гана жеткиликтүү. Адегенде товарды түзүңүз.',
        editingProduct: 'Товарды өзгөртүү',
        creatingProduct: 'Жаңы товар түзүү',
        productFallback: 'Товар',
      },
    },

    // Badges
    badges: {
      title: 'Товар бейдждерин башкаруу',
      subtitle: 'Товарларга акциялык бейдждерди белгилеңиз: Хит, Жаңылык, Кара жума, Жаңы жыл скидкасы ж.б.',
      loadError: 'Товарларды жүктөө мүмкүн болгон жок',
      addError: 'Бейдж кошуу мүмкүн болгон жок',
      deleteConfirm: 'Бул бейджди өчүрүү керекпи?',
      deleteError: 'Бейджди өчүрүү мүмкүн болгон жок',
      bulkDeleteConfirm: '{{count}} товардан "{{badge}}" бейджин өчүрүү керекпи?',
      bulkDeleteError: 'Бейдждерди өчүрүү мүмкүн болгон жок',
      columnProduct: 'Товар',
      noName: 'Аталышы жок',
      columnStatus: 'Статус',
      statusActive: 'Активдүү',
      statusHidden: 'Жашырылган',
      columnBadges: 'Бейдждер',
      noBadges: 'Бейдждер жок',
      columnActions: 'Аракеттер',
      addBadge: 'Бейдж кошуу',
      selected: 'Тандалды: {{count}} товар',
      removeBadge: 'Бейджди өчүрүү',
      filterAll: 'Бардыгы',
      dialogTitleBulk: '{{count}} товарга бейдж кошуу',
      dialogTitleSingle: 'Бейдж кошуу: {{name}}',
      badgeType: 'Бейдж түрү',
      discountPercent: 'Скидка пайызы',
      discountHint: 'Милдеттүү эмес: бейджде көрсөтүлөт',
      startDate: 'Башталыш датасы (милдеттүү эмес)',
      endDate: 'Аяктоо датасы (милдеттүү эмес)',
      customImageUrl: 'Бейдж сүрөтүнүн URL (PNG)',
      customImageHint: 'PNG жүктөп, шилтемени чаптаңыз',
      customText: 'Бейдж тексти',
      customPlaceholder: 'Өзүңүздүн текст',
      preview: 'Алдын ала көрүү:',
      types: {
        hot: { label: 'Хит 🔥', description: 'Популярдуу товар' },
        new: { label: 'Жаңылык ✨', description: 'Каталогдогу жаңы товар' },
        sale: { label: 'Скидка 💰', description: 'Скидкалуу товар' },
        black_friday: { label: 'Кара жума 🖤', description: 'Кара жума акциясы' },
        new_year: { label: 'Жаңы жыл скидкасы 🎄', description: 'Жаңы жыл акциясы' },
        limited: { label: 'Чектелген ⏰', description: 'Чектелген сунуш' },
        bestseller: { label: 'Бестселлер ⭐', description: 'Сатуу лидери' },
        custom: { label: 'Колдонуучунун 🏷️', description: 'PNG менен өзүнүн бейджи' },
      },
    },

    // Bundles
    bundles: {
      title: 'Товар комплекттери',
      subtitle: 'Атайын баалар менен товар комплекттерин түзүңүз жана башкарыңыз',
      loadError: 'Комплекттерди жүктөө катасы',
      updated: 'Комплект жаңыланды',
      created: 'Комплект түзүлдү',
      saveError: 'Сактоо катасы',
      deleteConfirm: 'Бул комплектти өчүрүү керекпи?',
      deleted: 'Комплект өчүрүлдү',
      deleteError: 'Өчүрүү катасы',
      backToProducts: 'Товарларга кайтуу',
      createBundle: 'Комплект түзүү',
      empty: 'Комплекттер азырынча жок. Сатып алуучуларга атайын бааларда товар топтомун сунуштоо үчүн комплект түзүңүз.',
      statusActive: 'Активдүү',
      statusInactive: 'Активдүү эмес',
      itemsCount: 'Комплекттеги товарлар: {{count}}',
      composition: 'Курамы:',
      dialogEdit: 'Комплектти өзгөртүү',
      dialogCreate: 'Комплект түзүү',
      nameLabel: 'Комплект аталышы',
      nameHint: 'Мисалы: Ванна бөлмөсү Премиум комплекти',
      skuHint: 'Комплект артикулу',
      priceLabel: 'Комплект баасы',
      currencySom: 'сом',
      descriptionLabel: 'Сүрөттөмө',
      itemsTitle: 'Комплекттеги товарлар',
      selectProduct: 'Товар тандаңыз',
      quantity: 'Саны',
      addItem: 'Кошуу',
      removeItemAria: 'Товарды комплекттен өчүрүү',
      noItemsWarning: 'Комплектке жок дегенде бир товар кошуңуз',
      totalSeparate: 'Товарлардын жалпы баасы:',
      bundlePrice: 'Комплект баасы:',
      savings: 'Үнөмдөө:',
      isActive: 'Комплект активдүү',
      nameRequired: 'Комплект аталышын жазыңыз',
      itemsRequired: 'Комплектке жок дегенде бир товар кошуңуз',
      deleteMessage: 'Бул аракетти артка кайтаруу мүмкүн эмес',
    },
    dashboard: {
      title: 'Башкаруу панели',
      welcome: 'Эмерек дүкөнүнүн админ панелине кош келиңиз',
      totalUsers: 'Жалпы колдонуучулар',
      products: 'Товарлар',
      ordersToday: 'Бүгүнкү буйрутмалар',
      revenue: 'Киреше',
      revenue30d: '30 күндүк киреше',
      recentActivity: 'Акыркы аракеттер',
      activityChart: 'Аракет графигы жана акыркы буйрутмалар бул жерде көрсөтүлөт',
      quickActions: 'Ыкчам аракеттер',
      addNewProduct: 'Жаңы товар кошуу',
      viewPendingOrders: 'Күтүүдөгү буйрутмалар',
      userManagement: 'Колдонуучуларды башкаруу',
      activeUsersLabel: 'Активдүү',
      lowStockLabel: 'Аз калдык',
      pendingOrdersLabel: 'Процессте',
      revenueTodayLabel: 'Бүгүн',
      lowStockTitle: 'Аз калдык товарлар',
      unknownDate: 'Күнү белгисиз',
      subtitle: 'Бизнести башкаруу панели (ERP-light)',
      refresh: 'Жаңылоо',
      dataPartialWarning: 'Маалыматтын бир бөлүгү жеткиликсиз. Dashboard демейки маанилерди көрсөтөт.',
      revenueMtd: 'Киреше (MTD)',
      vsPrevMonth: 'өткөн айга салыштырмалуу',
      ordersToday: 'Бүгүнкү буйрутмалар',
      vsYesterday: 'кечеге салыштырмалуу',
      conversionPct: 'Конверсия (%)',
      marginPct: 'Маржа (%)',
      salesRevenue: 'Сатуулар / Киреше',
      additionalMetrics: 'Кошумча көрсөткүчтөр',
      ordersVolume: 'Операциялар — Буйрутмалардын көлөмү',
      inventoryAlerts: 'Запастар жөнүндө эскертмелер',
      inventoryHealth: 'Запастардын абалы',
      orderFlow: 'Буйрутма агымы',
      activityFeed: 'Активдүүлүк / Сигналдар',
      createPurchase: 'Сатып алуу түзүү',
      justNow: 'жаңы эле',
      minutesAgo: '{{m}} мүн мурун',
      hoursAgo: '{{h}} с мурун',
      daysAgo: '{{d}} күн мурун',
      noEvents: 'Окуялар жок.',
      event: 'Окуя',
      // Dashboard components
      inventoryRiskTitle: 'Кампа финансылык тобокелдик катары',
      inventoryHealthAria: 'Кампанын ден соолук көрсөткүчү',
      okStock: 'Норма',
      lowStock: 'Аз',
      outOfStock: 'Жок',
      severityCritical: 'КРИТИКАЛЫК',
      severityWarning: 'ЭСКЕРТҮҮ',
      severityInfo: 'МААЛЫМАТ',
      noInventoryAlerts: 'Кампа боюнча эскертмелер жок.',
      productFallback: 'Товар',
      createPurchaseAria: 'SKU боюнча сатып алуу түзүү',
      purchaseBtn: 'Сатып алуу',
      stockRemaining: 'Калдык',
      pctVsPrevDay: '{{pct}}% мурунку күнгө',
      revenueRangeAria: 'Киреше мезгилин тандоо',
      avgOrderValue: 'Орточо буйрутма',
      ordersMtd: 'Буйрутмалар (MTD)',
      avgFulfillmentTime: 'Орточо аткаруу убактысы',
      days: 'күн',
      thisMonth: 'бул айда',
      today: 'бүгүн',
      topProducts: 'Топ-5 товарлар',
      noTopProducts: 'Товарлар жөнүндө маалымат жок',
      orders: 'буйрутмалар',
    },

    // Orders
    orders: {
      title: 'Буйрутмаларды башкаруу',
      subtitle: 'B2B жана B2C кардарлардын буйрутмаларын башкаруу',
      confirmBulkDelete: '{{count}} буйрутманы өчүрүү?',
      orderId: 'Буйрутма ID',
      orderNumber: 'Буйрутма номери',
      customer: 'Кардар',
      date: 'Күнү',
      total: 'Жалпы',
      type: 'Түрү',
      status: 'Статус',
      actions: 'Аракеттер',
      pending: 'Күтүүдө',
      confirmed: 'Ырасталды',
      processing: 'Процессте',
      shipped: 'Жөнөтүлдү',
      delivered: 'Жеткирилди',
      cancelled: 'Жокко чыгарылды',
      view: 'Көрүү',
      viewDetails: 'Деталдарын көрүү',
      quickConfirm: 'Ырастоо',
      quickProcess: 'Иштетүү',
      updateStatus: 'Статусту жаңылоо',
      noRecentOrders: 'Акыркы буйрутмалар жок',
      // API-related
      errorLoadOrders: 'Буйрутмаларды жүктөөдө ката',
      filterByStatus: 'Статус боюнча чыпка',
      filterByType: 'Кардар түрү',
      filterByDate: 'Мезгил',
      searchPlaceholder: 'Номер, аты, телефон боюнча издөө...',
      allOrders: 'Бардыгы',
      todayOrders: 'Бүгүн',
      period_all: 'Бардык убакыт',
      period_today: 'Бүгүн',
      period_week: 'Жума',
      period_month: 'Ай',
      period_quarter: 'Чейрек',
      guest: 'Конок',
      // Status translations (with status_ prefix for dynamic lookup)
      status_pending: 'Күтүүдө',
      status_processing: 'Процессте',
      status_shipped: 'Жөнөтүлдү',
      status_delivered: 'Жеткирилди',
      status_cancelled: 'Жокко чыгарылды',
      // PDF Export
      pdf: {
        orderTitle: 'БУЙРУТМА',
        date: 'Күнү',
        orderInfo: 'Буйрутма жөнүндө маалымат',
        status: 'Статус',
        type: 'Түрү',
        payment: 'Төлөм',
        paymentMethod: 'Төлөм ыкмасы',
        customer: 'Кардар',
        customerName: 'Аты',
        phone: 'Телефон',
        shippingAddress: 'Жеткирүү дареги',
        orderItems: 'Буйрутмадагы товарлар',
        product: 'Товар',
        qty: 'Саны',
        price: 'Баа',
        total: 'Жалпы',
        subtotal: 'Аралык жыйынтык',
        tax: 'Салык',
        shipping: 'Жеткирүү',
        grandTotal: 'ЖАЛПЫ',
        orderHistory: 'Буйрутма тарыхы',
        note: 'Эскертүү',
        footer: 'Башкаруу системасы тарабынан автоматтык түрдө түзүлдү | Барак {{current}} / {{total}}',
        currencyShort: 'с',
        email: 'Email',
        sku: 'Артикул',
      },
      // Kanban view
      kanbanTitle: 'Буйрутмалар Канбан-тактасы',
      kanbanView: 'Канбан',
      tableView: 'Таблица',
      noOrders: 'Буйрутмалар жок',
      unknownCustomer: 'Белгисиз кардар',
      loadError: 'Буйрутмаларды жүктөөдө ката',
      statusUpdateError: 'Статусту жаңылоодо ката',
      changeStatusTitle: 'Буйрутма статусун өзгөртүү',
      changeStatusConfirm: '#{{orderId}} буйрутманы "{{newStatus}}" статусуна көчүрүү?',
      cancelReason: 'Жокко чыгаруу себеби',
      status_confirmed: 'Ырасталды',
      moveTo_confirmed: 'Ырастоо',
      moveTo_processing: 'Иштетүүгө',
      moveTo_shipped: 'Жөнөтүү',
      moveTo_delivered: 'Жеткирилди',
      moveTo_cancelled: 'Жокко чыгаруу',
      statusUpdatedToast: 'Буйрутма #{{orderId}} жаңыланды: {{status}}',
      overdue: 'Мөөнөтү өткөн',
      saveView: 'Көрүнүштү сактоо',
      viewNamePlaceholder: 'Көрүнүш аты...',
      viewSaved: 'Көрүнүш сакталды',
      savedViews: 'Сакталган көрүнүштөр',
    },

    // Users
    users: {
      title: 'Колдонуучуларды башкаруу',
      addUser: 'Колдонуучу кошуу',
      name: 'Аты',
      email: 'Email',
      role: 'Роль',
      status: 'Статус',
      actions: 'Аракеттер',
      admin: 'Администратор',
      b2b: 'B2B кардар',
      b2bVerified: 'B2B Ырасталды',
      b2bCandidate: 'B2B Кандидат',
      b2c: 'B2C кардар',
      b2cCustomer: 'B2C Кардар',
      createdAt: 'Катталган күнү',
      lastLogin: 'Акыркы кирүү',
      active: 'Активдүү',
      pending: 'Күтүүдө',
      blocked: 'Бөгөттөлгөн',
      subtitle: 'B2C жана B2B кардарларды башкаруу',
    },

    // Roles Management
    roles: {
      title: 'Ролдорду башкаруу',
      subtitle: 'Ролдорду жана колдонуучулардын жетки укуктарын жөндөө',
      newRole: 'Жаңы рол',
      editRole: 'Ролду өзгөртүү',
      searchPlaceholder: 'Аталыш, код же сүрөттөмө боюнча издөө...',
      manageColumns: 'Мамычаларды башкаруу',
      colRole: 'Рол',
      colCode: 'Код',
      colDescription: 'Сүрөттөмө',
      colPermissions: 'Укуктар',
      colUsers: 'Колдонуучулар',
      colActions: 'Аракеттер',
      module_products: 'Товарлар',
      module_orders: 'Буйрутмалар',
      module_customers: 'Кардарлар',
      module_inventory: 'Склад',
      module_manufacturing: 'Өндүрүш',
      module_bom: 'BOM спецификациялары',
      module_materials: 'Материалдар',
      module_qc: 'Сапат контролу',
      module_purchases: 'Сатып алуулар',
      module_analytics: 'Аналитика',
      module_reports: 'Отчёттор',
      module_settings: 'Жөндөөлөр',
      module_integrations: 'Интеграциялар',
      module_users: 'Колдонуучулар',
      module_roles: 'Ролдор',
      perm_view: 'Көрүү',
      perm_create: 'Түзүү',
      perm_edit: 'Өзгөртүү',
      perm_delete: 'Жок кылуу',
      perm_export: 'Экспорт',
      perm_import: 'Импорт',
      perm_cancel: 'Жокко чыгаруу',
      perm_approve: 'Бекитүү',
      perm_adjust: 'Тууралоо',
      perm_count: 'Инвентаризация',
      perm_start: 'Баштоо',
      perm_complete: 'Аяктоо',
      perm_price_update: 'Баа жаңылоо',
      perm_schedule: 'Пландоо',
      perm_roles: 'Ролдорду башкаруу',
      perm_assign: 'Дайындоо',
      perm_hold: 'Кармоо',
      perm_release: 'Чыгаруу',
      perm_receive: 'Кабыл алуу',
      perm_sync: 'Синхрондоо',
      perm_advanced: 'Кеңейтилген',
      basicInfo: 'Негизги маалымат',
      nameLabel: 'Аталыш *',
      codeLabel: 'Код *',
      descriptionLabel: 'Сүрөттөмө',
      permissionsSection: 'Жетки укуктары',
      validationRequired: 'Милдеттүү талаа',
      validationCodeFormat: 'Латын тамгалары жана _ гана',
      codeHelperText: 'Уникалдуу идентификатор (латын)',
      generateCode: 'Код түзүү',
      create: 'Түзүү',
      system: 'Системалык',
      notFound: 'Эч нерсе табылган жок',
      noRoles: 'Ролдор жок',
      viewUsers: 'Колдонуучуларды көрүү',
      editTooltip: 'Өзгөртүү',
      copyTooltip: 'Көчүрүү',
      deleteTooltip: 'Жок кылуу',
      editRoleLabel: 'Ролду өзгөртүү',
      copyRoleLabel: 'Ролду көчүрүү',
      deleteRoleLabel: 'Ролду жок кылуу',
      deleteTitle: 'Ролду жок кылуу?',
      deleteConfirmText: 'Сиз чын эле ролду жок кылгыңыз келеби',
      deleteWarningText: 'Бул ролдо колдонуучулар бар. Алар жетки укуктарын жоготот.',
      usersWithRole: 'Рол менен колдонуучулар',
      noUsersWithRole: 'Бул ролдо колдонуучулар жок',
      roleUpdated: 'Рол ийгиликтүү жаңыланды',
      roleCreated: 'Рол ийгиликтүү түзүлдү',
      roleDeleted: 'Рол жок кылынды',
      roleCloned: 'Рол көчүрүлдү',
      loadError: 'Ролдорду жүктөө мүмкүн болгон жок',
      saveError: 'Сактоо катасы',
      deleteError: 'Жок кылуу катасы',
      cloneError: 'Көчүрүү катасы',
      serverError: 'Сервер катасы',
      // Role names (fallback)
      roleName_super_admin: 'Супер Админ',
      roleName_admin: 'Администратор',
      roleName_manager: 'Менеджер',
      roleName_operator: 'Оператор',
      roleName_warehouse: 'Кампачы',
      roleName_qc_inspector: 'Сапат инспектору',
      roleName_purchaser: 'Сатып алуучу',
      roleName_analyst: 'Аналитик',
      roleName_viewer: 'Көрүү',
      // Role descriptions (fallback)
      roleDesc_super_admin: 'Бардык функцияларга толук жетки',
      roleDesc_admin: 'Системалык жөндөөлөрсүз системаны башкаруу',
      roleDesc_manager: 'Буйрутмалар жана кардарлар менен иштөө',
      roleDesc_operator: 'Буйрутмаларды иштетүү',
      roleDesc_warehouse: 'Складды башкаруу',
      roleDesc_qc_inspector: 'Продукция сапатын контролдоо',
      roleDesc_purchaser: 'Сатып алууларды башкаруу',
      roleDesc_analyst: 'Отчётторго жана аналитикага жетки',
      roleDesc_viewer: 'Маалыматтарды гана көрүү',
    },

    // Analytics
    analytics: {
      title: 'Аналитика жана отчеттор',
      totalRevenue: 'Жалпы киреше',
      b2bRevenue: 'B2B киреше',
      b2cRevenue: 'B2C киреше',
      newCustomers: 'Жаңы кардарлар',
      revenue: 'Киреше',
      orders: 'Буйрутмалар',
      customers: 'Кардарлар',
      products: 'Товарлар',
      thisMonth: 'Бул ай',
      lastMonth: 'Өткөн ай',
      growthRate: 'Өсүү',
      topProducts: 'Топ товарлар',
      recentOrders: 'Акыркы буйрутмалар',
      b2bVsB2c: 'B2B vs B2C көрсөткүчтөрү',
      b2bPerformance: 'B2B жалпы кирешенин 71% түзөт. B2C кардарларды тартууда туруктуу өсүү көрсөтүүдө.',
      topProductsDesc: 'Жетекчи эмерек жана офис чечимдери сатууда лидер. Турган столдор B2B сегментинде 25% өсүү көрсөтүүдө.',
      overview: 'Сереп',
      qualityControl: 'Сапатты контролдоо',
      manufacturing: 'Өндүрүш',
      purchasesTab: 'Сатып алуулар',
      qcDataUnavailable: 'QC маалыматтары жеткиликсиз',
      totalInspections: 'Жалпы текшерүүлөр',
      passed: 'Өткөн',
      successful: 'ийгиликтүү',
      failed: 'Өтпөгөн',
      activeHolds: 'Активдүү кармоолор',
      qualityScore: 'Сапат көрсөткүчү',
      targetScore: 'Максаттуу көрсөткүч',
      manufacturingDataUnavailable: 'Өндүрүш маалыматтары жеткиликсиз',
      totalOrders: 'Жалпы буйрутмалар',
      inProgress: 'Иштелүүдө',
      today: 'бүгүн',
      planned: 'Пландалган',
      forWeek: 'жумага',
      completed: 'Аяктаган',
      demoProduct1: 'Модерн тумба 60см',
      demoProduct2: 'LED күзгү 80x60',
      demoProduct3: 'Унитаз WASSER Pro',
      demoProduct4: 'Смеситель Cascade',
      sales: 'сатуу',
      purchasesComingSoon: 'Сатып алуу аналитикасы кийинки жаңыртууда жеткиликтүү болот',
    },

    // Settings
    settings: {
      title: 'Жөндөөлөр',
      customization: 'Кастомизация',
      customizationDesc: 'Модулдар, кастом талаалар, кирүү укуктары жана интеграциялар',
      general: 'Жалпы жөндөөлөр',
      generalSettings: 'Жалпы жөндөөлөр',
      systemSettings: 'Системалык жөндөөлөр',
      apiConfiguration: 'API конфигурациясы',
      siteName: 'Сайттын аталышы',
      adminEmail: 'Админ Email',
      supportEmail: 'Колдоо Email',
      saveChanges: 'Өзгөрүүлөрдү сактоо',
      updateApiSettings: 'API жөндөөлөрүн жаңылоо',
      enableB2b: 'B2B каттоону иштетүү',
      emailNotifications: 'Email эскертмелер',
      maintenanceMode: 'Тейлөө режими',
      autoApproveB2b: 'B2B арыздарын авто-кабыл алуу',
      realtimeInventory: 'Реал-убакыт инвентар жаңылоо',
      apiBaseUrl: 'API базалык URL',
      stripeApiKey: 'Stripe API ачкычы',
      profile: 'Профиль',
      security: 'Коопсуздук',
      notifications: 'Эскертмелер',
      language: 'Тил',
      theme: 'Тема',
      light: 'Жарык',
      dark: 'Караңгы',
      comingSoon: 'Жакында жеткиликтүү болот',
    },

    // Inventory
    inventory: {
      tabs: { warehouses: 'Кампалар', stock: 'Калдыктар', movements: 'Кыймылдар', history: 'Тарых' },
      warehouses: {
        list: 'Кампалар тизмеси',
        empty: 'Кампалар жок',
        seed: 'Демейки кампа түзүү',
        create: 'Кампа түзүү',
        all: 'Бардык кампалар',
      },
      stock: { title: 'Калдыктар', columns: { onHandReserved: 'Кампада / Резерв', available: 'Жеткиликтүү' } },
      movements: { title: 'Товар кыймылы', submit: 'Өткөрүү', result: 'Жыйынтык' },
      history: {
        title: 'Кыймыл тарыхы',
        empty: 'Кыймыл тарыхы бош',
        allTypes: 'Бардык түрлөр',
        columns: {
          date: 'Күнү',
          type: 'Түрү',
          warehouse: 'Кампа',
          qty: 'Саны',
          product: 'Товар',
        },
      },
      movementType: {
        RECEIVE: 'Кирим',
        ISSUE: 'Чыгым',
        TRANSFER: 'Которуу',
        RESERVE: 'Резерв',
        RELEASE: 'Бошотуу',
        ADJUST: 'Оңдоо',
      },
      fields: {
        name: 'Аталыш',
        code: 'Код',
        warehouse: 'Кампа',
        warehouseTo: 'Көздөгөн кампа',
        productId: 'Товар ID',
        qty: 'Саны',
        type: 'Кыймыл түрү',
        reason: 'Себеби',
      },
      subtitle: 'Кампаларды, калдыктарды жана товар кыймылдарын башкаруу',
      status: {
        draft: 'Черновик',
        inProgress: 'Жүрүп жатат',
        completed: 'Аяктады',
        cancelled: 'Жокко чыгарылды',
        active: 'Жигердүү',
        completedFem: 'Аяктады',
        cancelledFem: 'Жокко чыгарылды',
      },
      list: {
        title: 'Инвентаризация',
        subtitle: 'Кампа инвентаризациясын башкаруу',
        refresh: 'Жаңылоо',
        create: 'Инвентаризация түзүү',
        searchPlaceholder: 'Номер боюнча издөө...',
        authRequired: 'Инвентаризацияга кирүү үчүн авторизация талап кылынат',
        deleteError: 'Өчүрүү катасы: {{message}}',
        deleteDraftOnly: 'Черновиктерди гана өчүрсө болот',
        confirmDelete: '{{number}} инвентаризацияны өчүрөсүзбү?',
        reportCompletedOnly: 'Отчет аяктаган инвентаризациялар үчүн гана жеткиликтүү',
        colDocumentNumber: 'Документ номери',
        colStatus: 'Статус',
        colWarehouse: 'Кампа',
        colResponsible: 'Жооптуу',
        colStartDate: 'Башталган күнү',
        colEndDate: 'Аяктаган күнү',
        colPositions: 'Позициялар',
        colCounted: 'Саналды',
        colDiscrepancies: 'Дал келбегендер',
        colActions: 'Аракеттер',
        tooltipView: 'Көрүү',
        tooltipEdit: 'Оңдоо',
        tooltipDownload: 'Отчетту жүктөө',
        tooltipDelete: 'Өчүрүү',
        filterStatus: 'Статус',
        filterWarehouse: 'Кампа',
        allStatuses: 'Бардык статустар',
        allWarehouses: 'Бардык кампалар',
      },
      create: {
        title: 'Инвентаризация түзүү',
        subtitle: 'Жаңы кампа инвентаризациясын түзүңүз',
        back: 'Артка',
        errorCreate: 'Инвентаризация түзүүдө ката',
        selectWarehouse: 'Кампаны тандаңыз',
        selectResponsible: 'Жооптуу адамды тандаңыз',
        specifyStartDate: 'Башталуу күнүн көрсөтүңүз',
        warehouseLabel: 'Кампа',
        responsibleLabel: 'Жооптуу',
        startDateLabel: 'Башталуу күнү',
        commentLabel: 'Комментарий',
        commentPlaceholder: 'Инвентаризация жөнүндө кошумча маалымат...',
        loading: 'Жүктөлүүдө...',
        fillOptions: 'Толтуруу параметрлери',
        autoFill: 'Кампа товарлары менен авто-толтуруу',
        includeZeroStock: 'Нөл калдыктуу товарларды кошуу',
        cancel: 'Жокко чыгаруу',
        filling: 'Позициялар толтурулууда...',
        creating: 'Түзүлүүдө...',
        createDraft: 'Черновик түзүү',
      },
      detail: {
        back: 'Артка',
        title: 'Инвентаризация',
        notFound: 'Инвентаризация табылган жок',
        confirmCancel: 'Инвентаризацияны жокко чыгарууну каалайсызбы?',
        start: 'Баштоо',
        complete: 'Аяктоо',
        cancel: 'Жокко чыгаруу',
        report: 'Отчет',
        infoTitle: 'Инвентаризация маалыматы',
        warehouse: 'Кампа',
        responsible: 'Жооптуу',
        createdDate: 'Түзүлгөн күнү',
        startDate: 'Башталуу күнү',
        endDate: 'Аяктаган күнү',
        comment: 'Комментарий',
        statsTitle: 'Статистика',
        totalPositions: 'Жалпы позиция саны',
        checkedPositions: 'Текшерилген позициялар',
        withDiscrepancies: 'Дал келбегендер менен',
        checkProgress: 'Текшерүү прогресси',
        itemsTitle: 'Инвентаризация позициялары',
        addItem: 'Позиция кошуу',
        product: 'Товар',
        sku: 'SKU',
        expected: 'Күтүлгөн',
        actual: 'Иш жүзүндө',
        discrepancy: 'Дал келбегендик',
        commentCol: 'Комментарий',
        actionsCol: 'Аракеттер',
        noItems: 'Позициялар табылган жок',
        commentPlaceholder: 'Комментарий',
        errorSaveEdit: 'Өзгөртүүлөрдү сактоо мүмкүн болбоду',
        errorStart: 'Инвентаризацияны баштоо мүмкүн болбоду',
        errorComplete: 'Инвентаризацияны аяктоо мүмкүн болбоду',
        errorCancel: 'Инвентаризацияны жокко чыгаруу мүмкүн болбоду',
      },
      report: {
        title: 'Инвентаризация отчеттору',
        refresh: 'Жаңылоо',
        noExportData: 'Экспорттоо үчүн маалымат жок',
        downloadError: 'Отчетту жүктөөдө ката',
        totalInventories: 'Жалпы инвентаризациялар',
        withDiscrepancies: 'Дал келбегендер менен',
        totalPositions: 'Жалпы позиция саны',
        valueDifference: 'Наркындагы айырма',
        filters: 'Чыпкалар',
        clear: 'Тазалоо',
        reportType: 'Отчет түрү',
        typeSummary: 'Жыйынтык',
        typeDetailed: 'Толук',
        typeDiscrepancies: 'Дал келбегендер гана',
        warehouseLabel: 'Кампа',
        statusLabel: 'Статус',
        responsibleLabel: 'Жооптуу',
        dateFrom: 'Күнүнөн',
        dateTo: 'Күнүнө чейин',
        allWarehouses: 'Бардык кампалар',
        allStatuses: 'Бардык статустар',
        allUsers: 'Бардык колдонуучулар',
        onlyDiscrepancies: 'Дал келбегендер менен гана',
        noData: 'Көрсөтүү үчүн маалымат жок. Чыпкаларды өзгөртүп көрүңүз.',
        colId: 'ID',
        colWarehouse: 'Кампа',
        colStatus: 'Статус',
        colResponsible: 'Жооптуу',
        colCreatedDate: 'Түзүлгөн күнү',
        colEndDate: 'Аяктаган күнү',
        colPositions: 'Позициялар',
        colDiscrepancies: 'Дал келбегендер',
        colValueDiff: 'Айырма (KGS)',
        hasDiscrepancies: 'Бар',
        noDiscrepancies: 'Жок',
      },
      errorCreateWarehouse: 'Кампа түзүүдө каталык',
      errorSeedDefault: 'Баштапкы кампа түзүүдө каталык',
      errorPostMovement: 'Товар кыймылын түзүүдө каталык',
    },

    // Auth
    auth: {
      login: 'Кирүү',
      logout: 'Чыгуу',
      email: 'Email дареги',
      emailAddress: 'Email дареги',
      password: 'Сырсөз',
      signIn: 'Кирүү',
      signingIn: 'Киргизилүүдө...',
      adminLogin: 'Админ кирүү',
      adminPanel: 'Эмерек дүкөнү админ панели',
      demoCredentials: 'Демо маалыматтар:',
      loginFailed: 'Кирүү ишке ашкан жок',
      invalidCredentials: 'Туура эмес маалыматтар',
      loginRequired: 'Өзгөртүүлөр үчүн админ катары менен кирүү керек.',
    },

    // Order Detail
    orderDetail: {
      backToList: 'Тизмеге кайтуу',
      order: 'Буйрутма',
      createdAt: 'Түзүлгөн: ',
      orderActions: 'Буйрутма аракеттери',
      print: 'Басып чыгаруу',
      downloading: 'Жүктөлүүдө...',
      savePdf: 'PDF сактоо',
      orderInfo: 'Буйрутма жөнүндө маалымат',
      status: 'Статус',
      orderStatus: 'Буйрутма статусу',
      type: 'Түрү',
      payment: 'Төлөм',
      paymentMethod: 'Төлөм ыкмасы',
      orderHistory: 'Буйрутма тарыхы',
      customer: 'Кардар',
      deliveryAddress: 'Жеткирүү дареги',
      deliveryMap: 'Жеткирүү картасы',
      orderItems: 'Буйрутмадагы товарлар',
      subtotal: 'Аралык жыйынтык',
      tax: 'Салык',
      shipping: 'Жеткирүү',
      total: 'Жалпы',
      product: 'Товар',
      qty: 'Саны',
      price: 'Баасы',
      clickToCopy: 'Көчүрүү үчүн бас',
      copied: 'Көчүрүлдү',
      copyFailed: 'Көчүрүү мүмкүн болбоду. SKU кармап, кол менен тандаңыз.',
      orderNotFound: '{id} ID менен буйрутма табылган жок.',
      pdfError: 'PDF түзүүдө ката. Кийинчерээк аракет кылыңыз.',
      creditCard: 'Кредит картасы',
      bankTransfer: 'Банк которуу',
      cash: 'Накталай',
      paid: 'Төлөндү',
      paidOnDelivery: 'Алганда төлөндү',
      created: 'Түзүлдү',
      orderCreated: 'Буйрутма түзүлдү',
      orderProcessing: 'Буйрутма иштелүүдө',
      orderShipped: 'Буйрутма жөнөтүлдү',
      orderDelivered: 'Буйрутма жеткирилди',
      statusUpdated: 'Статус ийгиликтүү жаңыланды',
      statusUpdateError: 'Статусту жаңылоодо ката',
      startProcessing: 'Иштөөнү баштоо',
      markShipped: 'Жөнөтүлдү деп белгилөө',
      markDelivered: 'Жеткирилди деп белгилөө',
      cancelOrder: 'Буйрутманы жокко чыгаруу',
      cancelConfirmation: '#{orderId} буйрутмасын жокко чыгарууга ишенесизби?',
      cancelReason: 'Жокко чыгаруу себеби',
      confirmCancel: 'Жокко чыгарууну ырастоо',
      noHistory: 'Тарых жок',
      // Internal notes
      internalNotes: 'Ички белгилер',
      internalNotesHint: 'Кызматкерлер үчүн гана белгилер, кардарга көрүнбөйт',
      notesPlaceholder: 'Бул буйрутма үчүн ички белгилерди кошуңуз...',
      notesSaved: 'Белгилер сакталды',
      notesSaveError: 'Белгилерди сактоо мүмкүн болбоду',
    },

    // Categories
    categories: {
      title: 'Товар категориялары',
      addCategory: 'Категория кошуу',
      editCategory: 'Категорияны өзгөртүү',
      newCategory: 'Жаңы категория',
      noCategories: 'Категориялар жок',
      createFirst: 'Биринчи категория түзүү',
      nameRu: 'Аталышы (Орусча)',
      nameEn: 'Аталышы (Англисче)',
      slug: 'Slug (URL)',
      slugHelp: 'Латын тамгалар, сандар жана дефис',
      parentCategory: 'Ата-энелик категория',
      noParent: 'Жок (түпкү)',
      sortOrder: 'Иреттөө тартиби',
      activeInCatalog: 'Активдүү (каталогдо көрүнөт)',
      hidden: 'Жашыруун',
      deleteCategory: 'Категорияны өчүрүү?',
      confirmDelete: '"{name}" категориясын өчүргүңүз келеби?',
      hasSubcategories: 'Бул категорияда подкатегориялар бар. Алар да өчүрүлөт!',
      categoryUpdated: 'Категория жаңыланды',
      categoryCreated: 'Категория түзүлдү',
      categoryDeleted: 'Категория өчүрүлдү',
      loadError: 'Категорияларды жүктөөдө ката',
      saveError: 'Категорияны сактоодо ката',
      deleteError: 'Категорияны өчүрүүдө ката',
      statusError: 'Статусту өзгөртүүдө ката',
      nameRequired: 'Категория аталышын жазыңыз',
      categoryHidden: '"{name}" категориясы жашырылды',
      categoryActivated: '"{name}" категориясы активдештирилди',
    },

    // Profile
    profile: {
      open: 'Профилди ачуу',
      title: 'Администратор профили',
      subtitle: 'Жеке маалыматты жана аккаунт жөндөөлөрүн башкаруу',
      uploadPhoto: 'Сүрөт жүктөө',
      chooseAvatar: 'Аватар тандоо',
      administrator: 'Администратор',
      phone: 'Телефон',
      activity: 'Активдүүлүк',
      lastLogin: 'Акыркы кирүү',
      ordersProcessed: 'Иштелген буйрутмалар',
      productsAdded: 'Кошулган товарлар',
      personalInfo: 'Жеке маалымат',
      firstName: 'Аты',
      lastName: 'Фамилиясы',
      position: 'Кызматы',
      positionPlaceholder: 'Мисалы: Башкы администратор',
      security: 'Коопсуздук',
      changePassword: 'Сырсөздү өзгөртүү',
      twoFactor: 'Эки факторлуу аутентификация',
      extraProtection: 'Кошумча аккаунт коргоосу',
      notConfigured: 'Тууланган жок',
      activeSessions: 'Активдүү сессиялар',
      oneDevice: '1 түзмөк',
      view: 'Көрүү',
      notifications: 'Эскертмелер',
      emailNotifications: 'Email эскертмелер',
      receiveByEmail: 'Почтага эскертмелерди алуу',
      orderNotifications: 'Буйрутма эскертмелери',
      orderNotificationsDesc: 'Жаңы буйрутмалар жана статус өзгөрүүлөрү',
      productNotifications: 'Товар эскертмелери',
      productNotificationsDesc: 'Аз калдык жана критикалык кырдаалдар',
      systemUpdates: 'Системалык жаңылоолор',
      systemUpdatesDesc: 'Жаңы функциялар жана система өзгөрүүлөрү',
      profileUpdated: 'Профиль ийгиликтүү жаңыланды!',
      updateSuccess: 'Профиль ийгиликтүү жаңыланды!',
      updateError: 'Профилди жаңылоодо ката',
      fileTooLarge: 'Файл өлчөмү 5MB ашпашы керек',
      fileSizeError: 'Файл өлчөмү 5MB ашпашы керек',
      roleAdmin: 'Администратор',
      todayTime: 'Бүгүн, 10:30',
      twoFactorDesc: 'Кошумча аккаунт коргоосу',
      emailNotificationsDesc: 'Почтага эскертмелерди алуу',
      email: 'Email',
    },

    // Organizations
    orgs: {
      title: 'Уюштуруулар',
      subtitle: 'Платформа ижарачы компанияларды башкаруу',
      createOrg: 'Уюштуруу түзүү',
      searchPlaceholder: 'Аталыш, домен боюнча издөө...',
      plan: 'Тариф',
      planFree: 'Акысыз',
      planStarter: 'Стартер',
      planBusiness: 'Бизнес',
      planEnterprise: 'Корпоративдик',
      all: 'Бардыгы',
      active: 'Активдүү',
      trial: 'Сыноо',
      cancelled: 'Жокко чыгарылган',
      disabled: 'Өчүрүлгөн',
      refreshList: 'Тизмени жаңылоо',
      organization: 'Уюштуруу',
      domain: 'Домен',
      users: 'Колдонуучулар',
      products: 'Товарлар',
      orders: 'Буйрутмалар',
      notFound: 'Уюштуруулар табылган жок',
      viewOrg: 'Уюштурууну көрүү',
      editOrg: 'Уюштурууну өзгөртүү',
      deactivate: 'Өчүрүү',
      deactivateOrg: 'Уюштурууну өчүрүү',
      activate: 'Иштетүү',
      activateOrg: 'Уюштурууну иштетүү',
      perPage: 'Бетте:',
      accessDenied: 'Кирүү тыюу салынган. Super Admin гана.',
      confirmDeactivate: '"{name}" уюштуруусун өчүрүүбү? Колдонуучулар кирүүдөн ажырайт.',
      confirmActivate: '"{name}" уюштуруусун иштетүүбү?',
      loadError: 'Жүктөөдө ката: ',
      unknownError: 'Белгисиз ката',
      retry: 'Кайталоо',
      orgNotFound: 'Уюштуруу табылган жок',
      backToList: 'Тизмеге',
      back: 'Артка',
      disabledBadge: 'ӨЧҮРҮЛГӨН',
      deactivateQuestion: 'Уюштурууну өчүрүүбү?',
      deactivateWarning: '"{name}" уюштуруусунун бардык колдонуучулары кирүүдөн ажырайт.',
      deactivating: 'Өчүрүлүүдө...',
      activating: 'Иштетилүүдө...',
      openAdminPanel: 'Уюштуруу админ панелин ачуу',
      orgCreated: 'Уюштуруу ийгиликтүү түзүлдү!',
      tabGeneral: 'Негизги',
      tabLimits: 'Лимиттер',
      tabBranding: 'Брендинг',
      tabStats: 'Статистика',
      info: 'Маалымат',
      name: 'Аталыш',
      description: 'Сүрөттөмө',
      subdomain: 'Субдомен',
      customDomain: 'Кастомдук домен',
      verified: 'Ырасталган',
      owner: 'Ээси',
      createdDate: 'Түзүлгөн',
      updatedDate: 'Жаңыланган',
      planTitle: 'Тарифтик план',
      currentPlan: 'Учурдагы план',
      subscriptionStatus: 'Жазылуу статусу',
      maxUsers: 'Макс. колдонуучулар',
      maxProducts: 'Макс. товарлар',
      maxOrders: 'Макс. буйрутмалар',
      userLimit: 'Колдонуучу лимити',
      productLimit: 'Товар лимити',
      orderLimit: 'Буйрутма лимити',
      branding: 'Брендинг',
      logoUrl: 'Логотип URL',
      primaryColor: 'Негизги түс',
      secondaryColor: 'Кошумча түс',
      logo: 'Логотип',
      notSet: 'Коюлган эмес',
      usersCount: 'Колдонуучулар',
      productsCount: 'Товарлар',
      ordersCount: 'Буйрутмалар',
      activeStatus: 'Активдүү',
      disabledStatus: 'Өчүрүлгөн',
      createTitle: 'Уюштуруу түзүү',
      orgData: 'Уюштуруу маалыматтары',
      companyName: 'Компания аталышы',
      subdomainHelp: 'Латын тамгалар, сандар жана дефис гана',
      ownerAdmin: 'Ээси (Admin)',
      ownerEmail: 'Ээсинин Email',
      password: 'Сырсөз',
      minChars: 'Минимум 8 белги',
      required: 'Милдеттүү талаа',
      requiredField: 'Милдеттүү талаа',
      creating: 'Түзүлүүдө...',
      limits: 'Лимиттер',
      deactivateConfirm: 'Уюштурууну өчүрүү',
      reactivateConfirm: 'Уюштурууну иштетүү',
      statusActive: 'Активдүү',
      statusTrial: 'Сыноо',
      statusCancelled: 'Жокко чыгарылган',
      usersShort: 'Колдонуучулар',
      tariffPlan: 'Тарифтик план',
      subdomainValidation: 'Латын тамгалар, сандар жана дефис гана',
      toList: 'Тизмеге',
      openAdmin: 'Уюштуруу админ панелин ачуу',
      createSuccess: 'Уюштуруу ийгиликтүү түзүлдү!',
      tabBasic: 'Негизги',
      information: 'Маалымат',
      created: 'Түзүлгөн',
      updated: 'Жаңыланган',
      deactivated: 'Өчүрүлгөн',
      deactivateTitle: 'Уюштурууну өчүрүүбү?',
    },

    // Notifications
    notif: {
      title: 'Эскертмелер',
      subtitle: 'Система эскертмелерин башкаруу',
      readAll: 'Баарын окулду деп белгилөө',
      type: 'Түрү',
      all: 'Бардыгы',
      info: 'Маалымат',
      ordersType: 'Буйрутмалар',
      warehouse: 'Кампа',
      payments: 'Төлөмдөр',
      delivery: 'Жеткирүү',
      production: 'Өндүрүш',
      warnings: 'Эскертүүлөр',
      errors: 'Каталар',
      successType: 'Ийгилик',
      statusFilter: 'Статус',
      unread: 'Окулбаган',
      read: 'Окулган',
      loadError: 'Эскертмелерди жүктөөдө ката: ',
      heading: 'Аталыш',
      message: 'Билдирүү',
      date: 'Күнү',
      noNotifications: 'Эскертмелер жок',
      readStatus: 'Окулду',
      newStatus: 'Жаңы',
      markRead: 'Окулду деп белгилөө',
      deleteNotif: 'Эскертмени өчүрүү',
      rowsPerPage: 'Саптар бетте:',
      markAllRead: 'Баарын окулду деп белгилөө',
      typeInfo: 'Маалымат',
      typeOrders: 'Буйрутмалар',
      typeInventory: 'Кампа',
      typePayments: 'Төлөмдөр',
      typeShipping: 'Жеткирүү',
      typeManufacturing: 'Өндүрүш',
      typeWarnings: 'Эскертүүлөр',
      typeErrors: 'Каталар',
      typeSuccess: 'Ийгилик',
      empty: 'Эскертмелер жок',
      statusRead: 'Окулду',
      statusNew: 'Жаңы',
      allNotifications: 'Бардык эскертмелер',
      minutesAgo: '{{m}} мүн. мурун',
      hoursAgo: '{{h}} с. мурун',
      daysAgo: '{{d}} күн. мурун',
      errorMarkRead: 'Окулду деп белгилөө мүмкүн болбоду',
      errorMarkAllRead: 'Баарын окулду деп белгилөө мүмкүн болбоду',
      errorDelete: 'Эскертмени өчүрүү мүмкүн болбоду',
    },

    // Serials
    serials: {
      title: 'Сериялык номерлер',
      addSerial: 'Кошуу',
      filtersSearch: 'Чыпкалар жана издөө',
      searchBySerial: 'Сериялык номер боюнча издөө',
      reset: 'Тазалоо',
      addSerialTitle: 'Сериялык номер кошуу',
      editSerialTitle: 'Сериялык номерди өзгөртүү',
      serialNumber: 'Сериялык номер',
      product: 'Товар',
      warehouse: 'Кампа',
      receivedDate: 'Келген күнү',
      soldDate: 'Сатылган күнү',
      notes: 'Эскертмелер',
      generate: 'Генерациялоо',
      productRequired: 'Товар *',
      serialRequired: 'Сериялык номер *',
      inStock: 'Бар',
      reserved: 'Резервде',
      sold: 'Сатылды',
      returned: 'Кайтарылды',
      defective: 'Брак',
      loadError: 'Сериялык номерлерди жүктөө мүмкүн болбоду',
      loadErrorShort: 'Жүктөөдө ката',
      notFound: 'Сериялык номер табылган жок',
      fillRequired: 'Милдеттүү талааларды толтуруңуз',
      createError: 'Сериялык номер түзүүдө ката',
      updateError: 'Сериялык номер жаңылоодо ката',
      confirmDelete: 'Бул сериялык номерди өчүргүңүз келеби?',
      deleteError: 'Сериялык номерди өчүрүү мүмкүн болбоду',
      purchaseDate: 'Келген күнү',
      saleDate: 'Сатылган күнү',
      filtersAndSearch: 'Чыпкалар жана издөө',
      searchLabel: 'Сериялык номер боюнча издөө',
      addTitle: 'Сериялык номер кошуу',
      editTitle: 'Сериялык номерди өзгөртүү',
      requiredFields: 'Милдеттүү талааларды толтуруңуз',
      deleteConfirm: 'Бул сериялык номерди өчүргүңүз келеби?',
    },

    // Manufacturing
    manufacturing: {
      // Dashboard
      title: 'Өндүрүш',
      subtitle: 'Өндүрүш буйрутмаларын жана спецификацияларды башкаруу',
      refreshData: 'Маалыматтарды жаңылоо',
      bom: 'Спецификациялар',
      totalOrders: 'Жалпы буйрутмалар',
      allTime: 'Бардык убакыт',
      todaySuffix: 'бүгүн',
      planned: 'Пландалган',
      forWeek: 'жума үчүн',
      successfullyDone: 'Ийгиликтүү аяктаган',
      activeOrders: 'Активдүү буйрутмалар',
      noActiveOrders: 'Активдүү буйрутмалар жок',
      createOrder: 'Буйрутма түзүү',
      orderNum: 'Буйрутма #{{id}}',
      pcs: 'даана',
      quickActions: 'Тез аракеттер',
      newBOM: 'Жаңы спецификация',
      materials: 'Материалдар',
      analytics: 'Аналитика',
      recentOrders: 'Акыркы буйрутмалар',
      noOrders: 'Буйрутмалар жок',
      loadError: 'Өндүрүш маалыматтарын жүктөө мүмкүн болгон жок',
      status_draft: 'Долбоор',
      status_planned: 'Пландалган',
      status_in_progress: 'Иштөөдө',
      status_completed: 'Аяктаган',
      status_cancelled: 'Жокко чыгарылган',

      // Statuses
      statusDraft: 'Долбоор',
      statusActive: 'Активдүү',
      statusArchived: 'Архивде',
      statusPlanned: 'Пландалган',
      statusInProgress: 'Иштөөдө',
      statusCompleted: 'Аяктаган',
      statusCancelled: 'Жокко чыгарылган',

      // Errors
      errorLoadBomList: 'Спецификацияларды жүктөө мүмкүн болбоду',
      errorLoadBom: 'Спецификацияны жүктөө мүмкүн болбоду',
      errorCannotDeleteActive: 'Активдүү спецификацияны өчүрүү мүмкүн эмес. Адегенде архивдеңиз.',
      errorCannotDeleteUsed: 'Өчүрүү мүмкүн эмес — спецификация өндүрүш буйрутмаларында колдонулат.',
      errorBomNotFound: 'Спецификация табылган жок',
      errorDeleteBom: 'Спецификацияны өчүрүү мүмкүн болбоду',
      errorActivateBom: 'Спецификацияны активдөштүрүү мүмкүн болбоду',
      errorArchiveBom: 'Спецификацияны архивдөө мүмкүн болбоду',
      errorCloneBom: 'Спецификацияны клондоо мүмкүн болбоду',
      errorSelectProduct: 'Продуктту тандаңыз',
      errorEnterBomName: 'Спецификация аталышын жазыңыз',
      errorSaveBom: 'Спецификацияны сактоо мүмкүн болбоду',
      errorLoadOrders: 'Буйрутмаларды жүктөөдө ката',
      errorStartProduction: 'Өндүрүштү баштоодо ката',
      errorCompleteProduction: 'Өндүрүштү аяктоодо ката',
      errorCancelProduction: 'Өндүрүштү жокко чыгарууда ката',
      errorLoadDictionaries: 'Справочниктерди жүктөө мүмкүн болбоду',
      errorSelectWarehouse: 'Кампаны тандаңыз',
      errorAddItem: 'Продукт жана саны бар бир позицияны кошуңуз',
      errorCreateOrder: 'Буйрутма түзүү мүмкүн болбоду',
      errorLoadExplosion: 'Разузлованиени жүктөө мүмкүн болбоду',
      errorLoadCosting: 'Калькуляцияны жүктөө мүмкүн болбоду',

      // BOM List
      bomListTitle: 'Спецификациялар (BOM)',
      newBom: 'Жаңы BOM',
      searchPlaceholder: 'Аталыш же продукт боюнча издөө...',
      refreshList: 'Тизмени жаңылоо',
      bomName: 'BOM аталышы',
      product: 'Продукт',
      version: 'Версия',
      components: 'Компоненттер',
      costPrice: 'Өздүк наркы',
      bomsNotFound: 'Спецификациялар табылган жок',
      viewBom: 'Спецификацияны көрүү',
      costCalculation: 'Калькуляция',
      moreActions: 'Дагы аракеттер',
      clone: 'Клондоо',
      explosion: 'Ажыратуу',
      activate: 'Активдештирүү',
      archive: 'Архивдөө',
      archiveFirst: 'Адегенде архивдеңиз',
      deleteBomTitle: 'Спецификацияны өчүрүү',
      deleteBomConfirm: 'Ишенесизби? Бул аракет кайтарылбайт.',
      deleteBomWarning: 'Спецификация жана бардык байланыштуу маалыматтар өчүрүлөт.',

      // BOM Create / Edit
      backToBomList: 'BOM тизмесине',
      editBom: 'BOM өзгөртүү',
      newBomTitle: 'Жаңы спецификация (BOM)',
      importFromExcel: 'Excelден импорт',
      basicInfo: 'Негизги маалымат',
      producedProduct: 'Өндүрүлгөн продукт',
      outputQuantity: 'Чыгаруу саны',
      unitOfMeasure: 'Өлчөө бирдиги',
      description: 'Сүрөттөмө',
      materialsAndComponents: 'Материалдар жана компоненттер',
      addComponent: 'Компонент кошуу',
      type: 'Түрү',
      component: 'Компонент',
      quantity: 'Саны',
      unitPrice: 'Бирдик баасы',
      sum: 'Суммасы',
      noComponentsHint: 'Өздүк наркты эсептөө үчүн компоненттерди кошуңуз',
      material: 'Материал',
      productSemifinished: 'Продукт/Жарым-жартылай',
      editMaterial: 'Материалды өзгөртүү',
      deleteMaterial: 'Материалды өчүрүү',
      productionOperations: 'Өндүрүш операциялары',
      addOperation: 'Операция кошуу',
      operation: 'Операция',
      workCenter: 'Иш борбору',
      timeMin: 'Убакыт, мин',
      ratePerHour: 'Ставка/саат',
      cost: 'Наркы',
      noOperationsHint: 'Толук калькуляция үчүн операцияларды кошуңуз',
      editOperation: 'Операцияны өзгөртүү',
      deleteOperation: 'Операцияны өчүрүү',
      costSummary: 'Жалпы өздүк наркы',
      materialsLabel: 'Материалдар',
      laborCosts: 'Эмгек чыгымдар',
      perUnit: 'Бирдикке',
      information: 'Маалымат',
      output: 'Чыгарылыш',
      editComponent: 'Компонентти өзгөртүү',
      addComponentTitle: 'Компонент кошуу',
      componentType: 'Компонент түрү',
      unitShort: 'Бирд.',
      wastePercent: 'Калдык пайызы',
      note: 'Эскертме',
      editOperationTitle: 'Операцияны өзгөртүү',
      addOperationTitle: 'Операция кошуу',
      operationName: 'Операция аталышы',
      laborTimeMin: 'Эмгек убактысы, мин',
      machineTimeMin: 'Машина убактысы, мин',
      setupTimeMin: 'Тууралоо убактысы, мин',
      laborRate: 'Эмгек ставкасы',
      overheadRate: 'Үстөмө чыгым/саат',

      // BOM Detail
      bomNotFound: 'Спецификация табылган жок',
      backToList: 'Тизмеге',
      editBomAria: 'BOM өзгөртүү',
      cloneBomAria: 'BOM клондоо',
      activateBomAria: 'BOM активдештирүү',
      archiveBomAria: 'BOM архивдөө',
      createOrder: 'Буйрутма түзүү',
      componentsAndMaterials: 'Компоненттер жана материалдар',
      nameLabel: 'Аталышы',
      price: 'Баасы',
      noComponents: 'Компоненттер жок',
      operations: 'Операциялар',
      level: 'Деңгээл',
      path: 'Жол',
      multilevelExplosion: 'Көп деңгээлдүү ажыратуу',
      levels: 'деңгээл',
      clickRefreshExplosion: 'Жүктөө үчүн «Жаңылоо» басыңыз',
      aggregatedComponents: 'Топтолгон компоненттер',
      totalQuantity: 'Жалпы саны',
      costingTitle: 'Нарк калькуляциясы',
      overheadCosts: 'Үстөмө чыгымдар',
      totalCost: 'Жалпы наркы',
      suggestedPrices: 'Сунушталган баалар',
      margin: 'Маржа',
      breakdownByComponents: 'Компоненттер боюнча бөлүштүрүү',
      share: 'Үлүш',
      loadCosting: 'Калькуляцияны жүктөө',
      created: 'Түзүлгөн',
      updated: 'Жаңыланган',
      createManufacturingOrder: 'Өндүрүш буйрутмасын түзүү',
      createOrderFromBom: 'Бул спецификациянын негизинде буйрутма түзүү',
      warehouse: 'Кампа',
      creating: 'Түзүлүүдө...',
      costing: 'Калькуляция',

      // Excel Import
      excelStepUpload: 'Файл жүктөө',
      excelStepMapping: 'Салыштыруу',
      excelStepConfirm: 'Ырастоо',
      excelErrorNoNameCol: 'Файлда материал аталышы тилкеси жок',
      excelErrorNoQtyCol: 'Файлда саны тилкеси жок',
      excelErrorNoMaterials: 'Файлда материалдар табылган жок',
      excelErrorRead: 'Файлды окуу мүмкүн болбоду',
      excelErrorSelectProduct: 'BOM үчүн продукт тандаңыз',
      excelErrorImport: 'Импорт катасы',
      excelImportTitle: 'Excelден BOM импорту',
      excelDragDrop: 'Excel файлды бул жерге сүйрөңүз же тандоо үчүн басыңыз',
      excelSupportedFormats: 'Колдоого алынган форматтар: .xlsx, .xls',
      excelRequiredColumns: 'Милдеттүү тилкелер: материал аталышы, саны',
      excelFound: 'Табылды',
      excelNotFound: 'Табылган жок',
      excelCreateMissing: 'Жетишпеген материалдарды түзүү',
      excelFromFile: 'Файлдан',
      excelMaterialInDb: 'БДдагы материал',
      excelSelectMaterial: 'Материал тандаңыз',
      excelMaterialFound: 'Базадан табылды',
      excelWillCreate: 'Түзүлөт',
      excelMaterialNotFound: 'Табылган жок',
      excelCheckBeforeImport: 'Импорттон мурун маалыматтарды текшериңиз',
      excelSelectProductForBom: 'BOM үчүн продукт тандаңыз',
      excelSummary: 'Жыйынтык',
      excelFile: 'Файл',
      excelTotalItems: 'Жалпы позициялар',
      excelFoundInDb: 'Базадан табылды',
      excelWillBeCreated: 'Түзүлөт',
      excelEstimatedCost: 'Болжолдуу наркы',
      excelImportBtn: 'Импорттоо',

      // Manufacturing Orders
      ordersTitle: 'Өндүрүш буйрутмалары',
      ordersSubtitle: 'Өндүрүш буйрутмаларын башкаруу',
      orderNumber: 'Буйрутма №',
      plan: 'План',
      progress: 'Прогресс',
      startDate: 'Башталышы',
      endDate: 'Аяктоосу',
      refreshOrderList: 'Буйрутма тизмесин жаңылоо',
      newOrder: 'Жаңы буйрутма',
      searchOrderPlaceholder: 'Буйрутма номери боюнча издөө...',
      allStatuses: 'Бардык статустар',
      resetFilters: 'Чыпкаларды тазалоо',
      manageColumns: 'Тилкелерди башкаруу',
      nothingFound: 'Эч нерсе табылган жок',
      noOrders: 'Өндүрүш буйрутмалары жок',
      viewOrder: 'Буйрутманы көрүү',
      cancelOrderTitle: 'Буйрутманы жокко чыгаруу',
      cancelOrderConfirm: 'Бул буйрутманы жокко чыгаргыңыз келеби?',
      cancelReason: 'Жокко чыгаруу себеби',
      cancelOrderBtn: 'Буйрутманы жокко чыгаруу',
      columnManagementTitle: 'Тилкелерди башкаруу',
      productionStarted: 'Өндүрүш башталды',
      productionCompleted: 'Өндүрүш аяктады',
      productionCancelled: 'Өндүрүш жокко чыгарылды',
      start: 'Баштоо',
      complete: 'Аяктоо',

      // Manufacturing Order Create
      newManufacturingOrder: 'Жаңы өндүрүш буйрутмасы',
      newOrderSubtitle: 'Өндүрүштү баштоо үчүн негизги маалыматтарды жана позицияларды толтуруңуз',
      basicData: 'Негизги маалыматтар',
      selectWarehouse: 'Кампа тандаңыз',
      statusOnCreate: 'Түзүүдөгү статус',
      orderItems: 'Буйрутма позициялары',
      addItem: 'Позиция кошуу',
      productId: 'Продукт ID',
      productIdHelper: 'Продукт тизмесинен ID табыңыз же кол менен жазыңыз',
      deleteItem: 'Позицияны өчүрүү',
      totals: 'Жыйынтыктар',
      positions: 'Позициялар',
      totalQuantity: 'Жалпы саны',
      estimatedCost: 'Болжолдуу наркы',
      costHint: 'Нарк милдеттүү эмес, бирок аналитикага жардам берет.',
      orderCreated: 'Өндүрүш буйрутмасы түзүлдү',
      productHints: 'Продукт кеңештери',
      loadingProducts: 'Продукт тизмеси жүктөлүүдө...',
      noProducts: 'Жеткиликтүү продукттар жок. Аларды «Каталог» бөлүмүндө түзүңүз.',
      goToCatalog: 'Продукт каталогуна өтүү',
      openCatalog: 'Каталогду ачуу',
      consumptionCoefficient: 'Чыгым коэффициенти: {{value}}',
    },

    // Batches
    batches: {
      backToList: 'Тизмеге',
      createNewBatch: 'Жаңы партия түзүү',
      createdSuccessfully: 'Партия ийгиликтүү түзүлдү! Багыттоо...',
      batchInfo: 'Партия маалыматы',
      product: 'Продукт *',
      selectProductHelper: 'Бул партия үчүн продуктту тандаңыз',
      variantOptional: 'Вариант (милдеттүү эмес)',
      selectVariantHelper: 'Партия конкреттүү вариант үчүн болсо, тандаңыз',
      warehouse: 'Койго *',
      selectWarehouseHelper: 'Бул партия сакталуучу койгону тандаңыз',
      batchNumber: 'Партия номери *',
      batchNumberHelper: 'Партиянын уникалдуу идентификатору',
      generate: 'Түзүү',
      manufactureDate: 'Өндүрүү күнү',
      manufactureDateHelper: 'Бул партия качан өндүрүлгөн?',
      expiryDate: 'Жарактуулук мөөнөтү',
      expiryDateHelper: 'Бул партиянын жарактуулук мөөнөтү качан бүтөт?',
      supplier: 'Жеткирүүчү',
      supplierHelper: 'Жеткирүүчү же өндүрүүчүнүн аты',
      costPrice: 'Өзүнөн баа (KGS)',
      costPriceHelper: 'Бирдиктин өзүнөн баасы KGSда',
      quantity: 'Саны *',
      quantityHelper: 'Бул партия үчүн баштапкы сан',
      creating: 'Түзүлүүдө...',
      createBatch: 'Партия түзүү',
      help: 'Жардам',
      batchNumberLabel: 'Партия номери',
      expiryDateLabel: 'Жарактуулук мөөнөтү',
      costPriceLabel: 'Өзүнөн баа',
      quantityLabel: 'Саны',
      helpBatchNumber: 'Партиянын уникалдуу идентификатору. Автоматтык номер үчүн «Түзүү» басмасын колдонуңуз.',
      helpExpiryDate: 'FIFO/FEFO көзөмөлдөө үчүн маанилүү. Система эртереөк мөөнөтү бүткөн партияларды артыкчылыктуу жөнөтөт.',
      helpCostPrice: 'COGS (Товардын өзүнөн баасы) жана пайда маржасын эсептөө үчүн колдонулат.',
      helpQuantity: 'Партиянын баштапкы саны. Койго калдыгына кошулат.',
      fillRequiredFields: 'Бардык милдеттүү талааларды толтуруңуз',
      errorCreateBatch: 'Партия түзүү мүмкүн болбоду',
      errorLoadProducts: 'Продукттарды жүктөө мүмкүн болбоду',
      errorLoadWarehouses: 'Койголорду жүктөө мүмкүн болбоду',
      errorLoadVariants: 'Варианттарды жүктөө мүмкүн болбоду',
      // BatchList
      title: 'Товар партиялары',
      refresh: 'Жаңыртуу',
      filters: 'Чыпкалар',
      productId: 'Продукт ID',
      warehouseId: 'Койго ID',
      expiringSoon: 'Жакында бүтөт',
      all: 'Баары',
      within7days: '7 күн ичинде',
      within30days: '30 күн ичинде',
      within60days: '60 күн ичинде',
      within90days: '90 күн ичинде',
      clearFilters: 'Чыпкаларды тазалоо',
      expiresInDays: '{{days}} күндөн кийин бүтөт',
      columnProduct: 'Продукт',
      columnWarehouse: 'Койго',
      reserved: 'бронь',
      daysLeft: 'күн калды',
      columnCreated: 'Түзүлгөн',
      columnActions: 'Аракеттер',
      viewBatch: 'Көрүү',
      viewBatchAria: 'Партияны көрүү',
      editBatch: 'Түзөтүү',
      editBatchAria: 'Партияны түзөтүү',
      deleteBatch: 'Жок кылуу',
      deleteBatchAria: 'Партияны жок кылуу',
      confirmDelete: 'Бул партияны жок кылууну каалайсызбы?',
      errorDeleteBatch: 'Партияны жок кылуу мүмкүн болбоду',
      errorFetchBatches: 'Партияларды жүктөө мүмкүн болбоду',
      detail: {
        title: 'Партия',
        backToList: 'Тизмеге кайтуу',
        fetchError: 'Партияны жүктөө мүмкүн болбоду',
        updateError: 'Партияны жаңыртуу мүмкүн болбоду',
        deleteConfirm: 'Бул партияны жок кылууну каалайсызбы? Бул аракетти артка кайтарууга болбойт.',
        deleteError: 'Партияны жок кылуу мүмкүн болбоду',
        notFound: 'Партия табылган жок',
        expiringSoon: 'Партиянын мөөнөтү бүтөт! {{days}} күн калды.',
        batchInfo: 'Партия жөнүндө маалымат',
        batchNumber: 'Партия номери',
        supplier: 'Жеткирүүчү',
        manufactureDate: 'Чыгарылган күнү',
        expiryDate: 'Мөөнөтү',
        costPrice: 'Түшүмү',
        costPriceKGS: 'Түшүмү (KGS)',
        quantity: 'Саны',
        reserved: 'Брондолгон',
        available: 'Жеткиликтүү',
        created: 'Түзүлгөн',
        daysLeft: 'күн калды',
        productStock: 'Товар жана калдыктар',
        product: 'Товар',
        variant: 'Вариант',
        warehouse: 'Кампа',
        movementHistory: 'Кыймыл тарыхы',
        noMovements: 'Кыймыл жазуулары жок',
        date: 'Күнү',
        type: 'Түрү',
        from: 'Кайдан',
        to: 'Каякка',
        reference: 'Шилтеме',
        notes: 'Эскертүүлөр',
      },
    },

    // Materials Database
    materials: {
      title: 'Материалдар базасы',
      subtitle: 'Чийки заттарды, комплектүүчүлөрдү жана чыгымдуу материалдарды башкаруу',
      currency: 'сом',
      categories: {
        ldsp: 'ЛДСП/Плиталар',
        edge: 'Кромка',
        handles: 'Туткалар',
        hinges: 'Петлялар',
        slides: 'Направляющилер',
        fasteners: 'Бекиткичтер',
        adhesives: 'Жабыштыргычтар',
        glass: 'Айнек',
        countertops: 'Устөл үстүндөрү',
        profiles: 'Профилдер',
        lighting: 'Жарыктандыруу',
        packaging: 'Таңгактоо',
        other: 'Башкалар',
      },
      units: {
        pcs: 'Дана (дана)',
        m: 'Метр (м)',
        m2: 'Чарчы метр (м²)',
        m3: 'Куб метр (м³)',
        kg: 'Килограмм (кг)',
        l: 'Литр (л)',
        pack: 'Таңгак (тң)',
      },
      materialName: 'Аталышы',
      skuLabel: 'Артикул (SKU)',
      categoryLabel: 'Категория',
      allCategories: 'Бардык категориялар',
      unitOfMeasure: 'Өлчөө бирдиги',
      unit: 'Бирдик',
      description: 'Сүрөттөмө',
      basicInfo: 'Негизги маалымат',
      priceAndStock: 'Баа жана запастар',
      costPrice: 'Өздүк наркы',
      minStock: 'Мин. запас',
      maxStock: 'Макс. запас',
      reorderPoint: 'Буйрутма чекити',
      supplier: 'Жеткизүүчү',
      supplierName: 'Жеткизүүчүнүн аталышы',
      leadTimeDays: 'Жеткирүү мөөнөтү (күн)',
      notes: 'Эскертмелер',
      requiredField: 'Милдеттүү талаа',
      selectCategory: 'Категория тандаңыз',
      priceCannotBeNegative: 'Баа терс болушу мүмкүн эмес',
      newMaterial: 'Жаңы материал',
      editMaterial: 'Материалды өзгөртүү',
      deleteMaterial: 'Материалды өчүрүү',
      price: 'Баасы',
      updatePrice: 'Бааны жаңылоо',
      updatePrices: 'Бааларды жаңылоо',
      currentPrice: 'Учурдагы баа',
      newPrice: 'Жаңы баа',
      oldPrice: 'Эски баа',
      minPrice: 'Мин. баа',
      maxPrice: 'Макс. баа',
      change: 'Өзгөрүү',
      changesCount: 'Өзгөрүүлөр',
      changeReason: 'Өзгөрүү себеби',
      changeReasonPlaceholder: 'Баа өзгөрүүсүнүн себебин көрсөтүңүз...',
      was: 'Болгон',
      reason: 'Себеби',
      user: 'Колдонуучу',
      system: 'Система',
      date: 'Күнү',
      priceHistory: 'Баа тарыхы',
      closePriceHistory: 'Баа тарыхын жабуу',
      noPriceHistory: 'Баа өзгөрүү тарыхы жок',
      chart: 'График',
      table: 'Таблица',
      stockMovement: 'Калдыктардын кыймылы',
      noStockHistory: 'Кыймыл тарыхы жок',
      received: 'Кирим',
      writtenOffProduction: 'Өндүрүшкө чыгымдалган',
      currentStock: 'Учурдагы калдык',
      receipt: 'Кирим',
      consumption: 'Чыгым',
      balance: 'Калдык',
      receiptConsumptionByDay: 'Кирим / Чыгым күндөр боюнча',
      stockDynamics: 'Калдыктардын динамикасы',
      totalMaterials: 'Жалпы материалдар',
      categoriesCount: 'Категориялар',
      totalValue: 'Жалпы наркы',
      inStock: 'Кампада',
      inStockShort: 'Бар',
      lowStock: 'Аз запас',
      needsOrdering: 'Буйрутма керек',
      avgPrice: 'Орточо баа',
      perUnit: 'Бирдикке',
      materialsNeedRestock: 'материалдар толуктоону талап кылат',
      needed: 'Керек',
      min: 'Мин',
      show: 'Көрсөтүү',
      hide: 'Жашыруу',
      noMaterials: 'Материалдар табылган жок',
      searchPlaceholder: 'Аталыш же артикул боюнча издөө...',
      select: 'Тандоо',
      selectAll: 'Баарын тандоо',
      materialCreated: 'Материал түзүлдү',
      materialUpdated: 'Материал жаңыланды',
      materialDeleted: 'Материал өчүрүлдү',
      priceUpdated: 'Баа жаңыланды',
      deleteConfirmTitle: 'Өчүрүүнү ырастоо',
      deleteConfirmText: 'Бул материалды өчүргүңүз келеби',
      irreversibleAction: 'Бул аракет кайтарылбайт.',
      bulkDelete: 'Жалпы өчүрүү',
      bulkDeleteConfirm: 'Өчүргүңүз келеби',
      bulkDeleteWarning: 'Бул аракет кайтарылбайт. Тандалган бардык материалдар өчүрүлөт.',
      materialsWord: 'материалдар',
      bulkPriceUpdate: 'Бааларды жалпы жаңылоо',
      willApplyTo: 'Колдонулат',
      selectedMaterials: 'тандалган материалдарга',
      selectCategoryToFilter: 'Материалдарды чыпкалоо үчүн категория тандаңыз',
      selectMaterialsOrCategory: 'Материалдарды тандаңыз же категория көрсөтүңүз',
      specifyChangeValue: 'Өзгөрүү маанисин көрсөтүңүз',
      updateType: 'Жаңылоо түрү',
      percentage: 'Пайыз (%)',
      fixedAmount: 'Туруктуу сумма (сом)',
      percentChange: 'Пайыз өзгөрүүсү',
      amountChange: 'Сумма өзгөрүүсү',
      priceChangeHelper: 'Оң сан бааны көтөрөт, терс сан төмөндөтөт',
      categoryOptional: 'Категория (кошумча)',
      priceExample: 'Мисал: 100 сом материал болот',
      importJson: 'JSON импорт',
      importExcel: 'Excel импорт',
      importMaterials: 'Материалдарды импорттоо',
      importBtn: 'Импорттоо',
      importCount: 'Импорттоо',
      jsonData: 'JSON маалыматтар',
      jsonImportHint: 'Материалдар массиви менен JSON чаптаңыз. Талаалар: name, sku, category, unit, cost_price',
      jsonMustContainArray: 'JSON материалдар массивин камтышы керек',
      invalidJson: 'Туура эмес JSON форматы',
      jsonParseError: 'JSON талдоо катасы',
      foundMaterials: 'Материалдар табылды',
      examples: 'Мисалдар',
      exported: 'Экспорттолду',
      imported: 'Импорттолду',
      created: 'түзүлдү',
      updated: 'жаңыланды',
      skipped: 'өткөрүлдү',
      excelImport: 'Excelден импорт',
      excelImportComplete: 'Excel импорту аякталды',
      excelStepUpload: 'Файл жүктөө',
      excelStepPreview: 'Маалыматтарды көрүү',
      excelStepDuplicates: 'Дубликаттарды иштетүү',
      excelDragDrop: 'Excel файлды бул жерге сүйрөңүз',
      excelClickToSelect: 'же тандоо үчүн басыңыз',
      excelSupportedFormats: 'Колдоого алынган форматтар: .xlsx, .xls',
      excelReadError: 'Файлды окууда ката. Excel файлы туура экенин текшериңиз.',
      excelOnlyXlsx: '.xlsx жана .xls файлдары гана колдолот',
      selected: 'Тандалды',
      showing50of: '50 көрсөтүлүүдө,',
      duplicate: 'Дубликат',
      new: 'Жаңы',
      foundDuplicates: 'Базада бар материалдар табылды',
      chooseDuplicateAction: 'Дубликаттар үчүн аракет тандаңыз',
      updateExisting: 'Бар болгондорду жаңылоо',
      updateExistingDesc: 'Калдык жана өздүк наркы файлдан жаңыланат',
      skipDuplicates: 'Дубликаттарды өткөрүү',
      skipDuplicatesDesc: 'Жаңы материалдар гана импорттолот',
      duplicatesLabel: 'Дубликаттар',
      andMore: 'жана дагы',
      startOver: 'Кайрадан баштоо',
      currencyShort: 'с',
      bulkDeleted: 'Өчүрүлдү: {{count}}',
      bulkPriceUpdated: 'Жаңыланды: {{count}} материалдар',
    },

    // Finance
    finance: {
      payments: 'Төлөмдөр',
      newPayment: 'Жаңы төлөм',
      editPaymentTitle: 'Төлөмдү өзгөртүү',
      editPayment: 'Төлөмдү өзгөртүү',
      cancelPayment: 'Төлөмдү жокко чыгаруу',
      confirmCancelPayment: 'Бул төлөмдү жокко чыгаргыңыз келеби?',
      fetchPaymentsError: 'Төлөмдөрдү жүктөө албады',
      savePaymentError: 'Төлөмдү сактоо албады',
      cancelPaymentError: 'Төлөмдү жокко чыгаруу албады',
      fetchAccountsError: 'Эсептерди жүктөө албады',
      saveAccountError: 'Эсепти сактоо албады',
      deleteAccountError: 'Эсепти өчүрүү албады',
      fetchDashboardError: 'Финанс маалыматтарын жүктөө албады',
      specifyAmount: 'Сумманы көрсөтүңүз',
      number: 'Номер',
      date: 'Күнү',
      type: 'Түрү',
      incoming: 'Кирим',
      outgoing: 'Чыгым',
      amount: 'Сумма',
      counterparty: 'Контрагент',
      category: 'Категория',
      method: 'Төлөм ыкмасы',
      status: 'Статус',
      statusCompleted: 'Аякталган',
      statusPending: 'Күтүүдө',
      statusCancelled: 'Жокко чыгарылган',
      statusRefunded: 'Кайтарылган',
      paymentType: 'Төлөм түрү',
      incomingReceipt: 'Кирим (түшүү)',
      outgoingExpense: 'Чыгым (төлөм)',
      paymentDate: 'Төлөм күнү',
      paymentMethod: 'Төлөм ыкмасы',
      accountCash: 'Эсеп / Касса',
      notSelected: 'Тандалган эмес',
      description: 'Сүрөттөмө',
      documentNumber: 'Документ номери',
      methodCash: 'Накталай',
      methodBankTransfer: 'Банк которуу',
      methodCard: 'Карта',
      methodMobileWallet: 'Мобилдук капчык',
      methodOther: 'Башка',
      // Accounts
      accounts: 'Эсептер',
      totalBalance: 'Жалпы баланс',
      addAccount: 'Эсеп кошуу',
      newAccount: 'Жаңы эсеп',
      editAccountTitle: 'Эсепти өзгөртүү',
      editAccount: 'Эсепти өзгөртүү',
      deleteAccount: 'Эсепти өчүрүү',
      confirmDeleteAccount: 'Бул эсепти өчүргүңүз келеби?',
      specifyAccountName: 'Эсептин аталышын көрсөтүңүз',
      noAccounts: 'Эсептер табылган жок. Биринчи эсепти түзүңүз.',
      default: 'Негизги',
      accountName: 'Эсептин аталышы',
      accountType: 'Эсеп түрү',
      currency: 'Валюта',
      currencyKGS: 'KGS (сом)',
      currencyUSD: 'USD (доллар)',
      currencyRUB: 'RUB (рубль)',
      currencyEUR: 'EUR (евро)',
      bankName: 'Банк аталышы',
      accountNumber: 'Эсеп номери',
      walletNumber: 'Капчык номери',
      defaultAccount: 'Негизги эсеп',
      typeCash: 'Касса',
      typeBank: 'Банк эсеби',
      typeMobileWallet: 'Мобилдук капчык',
      typeCard: 'Карта',
      // Dashboard
      title: 'Финанс',
      monthlyIncome: 'Айлык киреше',
      sinceMonthStart: 'Айдын башынан бери',
      monthlyExpenses: 'Айлык чыгашалар',
      profit: 'Пайда',
      monthlyProfit: 'Айлык пайда',
      allAccounts: 'Бардык эсептер',
      quickActions: 'Тез аракеттер',
      managePayments: 'Төлөмдөрдү башкаруу',
      cashOrders: 'Кассалык ордерлер',
      cashOrdersDesc: 'Кириш жана чыгыш',
      transfers: 'Которуулар',
      betweenAccounts: 'Эсептер ортосунда',
      accountsDesc: 'Кассалар жана банк эсептери',
      financialAccounts: 'Финансылык эсептер',
      noActiveAccounts: 'Активдүү эсептер жок. Биринчи эсепти "Эсептер" бөлүмүндө түзүңүз.',
      createAccount: 'Эсеп түзүү',
      thisWeek: 'Бул жумада',
      weeklyIncome: 'Жумалык киреше',
      weeklyExpenses: 'Жумалык чыгаша',
      weeklyProfit: 'Жумалык пайда',
      pendingPaymentsAlert: 'Сизде {{count}} ырастоону күтүп жаткан төлөм бар.',
    },

    // Suppliers
    suppliers: {
      newSupplier: 'Жаңы жеткизүүчү',
      createSupplier: 'Жеткизүүчү түзүү',
      basicInfo: 'Негизги маалымат',
      contactInfo: 'Байланыш маалыматы',
      addresses: 'Даректер',
      businessTerms: 'Кызматташтык шарттары',
      supplierCode: 'Жеткизүүчү коду',
      legalName: 'Юридикалык аталышы',
      inn: 'ИНН',
      kpp: 'КПП',
      contactPerson: 'Байланыш адамы',
      phone: 'Телефон',
      website: 'Веб-сайт',
      legalAddress: 'Юридикалык дареги',
      actualAddress: 'Чыныгы дареги',
      paymentTermsDays: 'Төлөм мөөнөтү (күн)',
      minOrderAmount: 'Мин. буйрутма суммасы',
      discountPercent: 'Арзандатуу (%)',
      currency: 'Валюта',
      currencyKGS: 'KGS (Сом)',
      currencyUSD: 'USD (Доллар)',
      currencyEUR: 'EUR (Евро)',
      currencyRUB: 'RUB (Рубль)',
      supplierRating: 'Жеткизүүчү рейтинги',
      comment: 'Комментарий',
      nameRequired: 'Аталышы милдеттүү',
      codeRequired: 'Код милдеттүү',
      invalidEmail: 'Email форматы туура эмес',
      cannotBeNegative: 'Терс болушу мүмкүн эмес',
      mustBe0to100: '0 дөн 100 гө чейин болушу керек',
      createError: 'Жеткизүүчүнү түзүүдө ката',
      // SupplierList
      listTitle: 'Жеткизүүчүлөр',
      addSupplier: 'Жеткизүүчү кошуу',
      refresh: 'Жаңылоо',
      searchPlaceholder: 'Аталыш, код, ИНН боюнча издөө...',
      statusLabel: 'Статус',
      filterAll: 'Баары',
      filterActive: 'Активдүү',
      filterInactive: 'Активдүү эмес',
      colCode: 'Код',
      colName: 'Аталыш',
      colContacts: 'Байланыштар',
      colRating: 'Рейтинг',
      colOrders: 'Буйрутмалар',
      colOrderAmount: 'Буйрутмалар суммасы',
      colStatus: 'Статус',
      colActions: 'Аракеттер',
      notFound: 'Жеткизүүчүлөр табылган жок',
      active: 'Активдүү',
      inactive: 'Активдүү эмес',
      viewTooltip: 'Көрүү',
      editTooltip: 'Өзгөртүү',
      deleteTooltip: 'Жок кылуу',
      deleteConfirm: 'Жеткизүүчүнү жок кылуу',
      deleteError: 'Жок кылуу катасы',
      loadErrorList: 'Жеткизүүчүлөрдү жүктөө мүмкүн болгон жок',
      unknownError: 'Белгисиз ката',
      retry: 'Кайталоо',
      rowsPerPage: 'Бетте жазуулар:',
      paginationOf: 'ичинен',
      // SupplierDetail keys
      supplierNotFound: 'Жеткирүүчү табылган жок',
      backToList: 'Тизмеге кайтуу',
      loadError: 'Жеткирүүчүнү жүктөөдө ката',
      orderHistory: 'Буйрутмалар тарыхы',
      orderNumber: 'Номер',
      date: 'Күнү',
      warehouse: 'Койма',
      amount: 'Сумма',
      paymentDelay: 'Төлөм кечигүү',
      days: 'күн',
      discountLabel: 'Арзандатуу',
      ratingLabel: 'Рейтинг',
      statistics: 'Статистика',
      totalOrders: 'Бардык буйрутмалар',
      completedOrders: 'Аякталган',
      totalAmount: 'Жалпы сумма',
      avgDeliveryDelay: 'Орточо жеткирүү кечигүү',
    },

    // Purchases
    purchases: {
      title: 'Сатып алуулар',
      newPurchase: 'Жаңы сатып алуу',
      noPurchases: 'Сатып алуулар жок',
      loadError: 'Сатып алууларды жүктөө мүмкүн болбоду',
      openPurchase: 'Сатып алууну ачуу',
      filters: 'Чыпкалар',
      search: 'Издөө',
      searchPlaceholder: 'Номер, жеткизүүчү…',
      searchEnterApply: 'Enter — колдонуу',
      searchEscClear: 'Esc — тазалоо',
      reset: 'Тазалоо',
      document: 'Документ',
      supplier: 'Жеткизүүчү',
      status: 'Статус',
      amount: 'Сумма',
      statusDraft: 'Долбоор',
      statusConfirmed: 'Буйруталган',
      statusPartiallyReceived: 'Жарымы кабыл алынды',
      statusReceived: 'Толук кабыл алынды',
      statusCancelled: 'Жокко чыгарылды',
      // PurchaseCreate keys
      formPrepareError: 'Форманы даярдоо мүмкүн болгон жок',
      documentNumber: 'Документ номери',
      documentNumberHint: 'Бош калтырыңыз — номер автоматтык түрдө берилет (API колдосо)',
      warehouseLabel: 'Койма',
      responsibleLabel: 'Жоопкер',
      expectedDate: 'Күтүлгөн күнү',
      commentLabel: 'Комментарий',
      items: 'Позициялар',
      searchProductsLabel: 'Товарларды издөө',
      searchProductsPlaceholder: 'Аталышы / SKU…',
      scanModeHint: 'Scan mode: ON (Esc — тазалоо)',
      toggleScanMode: 'Scan mode кошуу',
      productLabel: 'Товар',
      productLoading: 'Жүктөлүүдө…',
      quantity: 'Саны',
      priceKgs: 'Баасы (KGS)',
      addItem: 'Кошуу',
      noItems: 'Позициялар жок',
      enterNumber: 'Сан жазыңыз',
      mustBePositive: '0дөн чоң болушу керек',
      cannotBeNegative: '0дөн аз болбосун',
      removeItemAria: 'Позицияны өчүрүү: {{name}}',
      itemsTotal: 'Позициялар боюнча жыйынтык',
      creating: 'Түзүлүүдө…',
      createBtn: 'Түзүү',
      createError: 'Сатып алууну түзүү мүмкүн болгон жок',
      itemRemoved: 'Позиция өчүрүлдү',
      undo: 'Кайтаруу',
      qtyBump: 'саны',
      detail: {
        title: 'Сатып алуу',
        supplierLabel: 'Жеткизүүчү',
        statusLabel: 'Статус',
        createdLabel: 'Түзүлгөн',
        sumLabel: 'Сумма',
        itemsTitle: 'Позициялар',
        noItems: 'Позициялар жок',
        notFound: 'Сатып алуу табылган жок',
        loadError: 'Сатып алууну жүктөө мүмкүн болгон жок',
        receiveBtn: 'Коймага кабыл алуу',
        receiveMoreBtn: 'Дагы кабыл алуу',
        receivedCount: 'Кабыл алынган позициялар: {{count}}',
        receiveError: 'Кабыл алууда ката',
        pdfError: 'PDF жүктөөдө ката',
      },
      receive: {
        title: 'Коймага кабыл алуу',
        ordered: 'Буйруталган',
        received: 'Кабыл алынган',
        remaining: 'Калган',
        accept: 'Кабыл алуу',
        max: 'Макс',
        allReceived: 'Бардык позициялар толук кабыл алынды.',
        specifyQty: 'Жок дегенде бир позиция үчүн санын көрсөтүңүз',
        error: 'Кабыл алууда ката',
      },
    },

    // Production Tracker
    production: {
      // Board UI
      title: 'Өндүрүш трекери',
      board: 'Өндүрүш тактасы',
      create: 'Түзүү',
      createDialogTitle: 'Өндүрүш трегин түзүү',
      orderId: 'Буйрутма номери',
      orderIdHelper: 'E-commerce буйрутма ID киргизиңиз',
      notes: 'Эскертүүлөр',
      deadline: 'Мөөнөт',
      creating: 'Түзүлүүдө...',
      createSuccess: 'Өндүрүш треги түзүлдү',
      createError: 'Трек түзүүдө ката кетти',
      total: 'Жалпы',
      kanban: 'Канбан',
      list: 'Тизме',
      myTasks: 'Менин тапшырмаларым',
      search: 'Издөө...',
      noItems: 'Трек жок',
      noTasks: 'Тапшырмалар жок',
      open: 'Ачуу',
      stepsCompleted: 'этап',

      // Status filters
      status: 'Статус',
      status_active: 'Активдүү',
      status_completed: 'Аяктаган',
      status_on_hold: 'Тыныгууда',
      status_cancelled: 'Жокко чыгарылган',

      // Priority filters
      priority: 'Артыкчылык',
      priority_urgent: 'Шашылыш',
      priority_high: 'Жогору',
      priority_normal: 'Кадимки',
      priority_low: 'Төмөн',

      // Step names (snake_case — used dynamically via t(`production.step_${code}`))
      step: 'Этап',
      step_manager: 'Менеджер',
      step_constructor: 'Конструктор',
      step_purchaser: 'Сатып алуучу',
      step_cutting: 'Кесүү',
      step_edging: 'Кырдоо',
      step_drilling: 'Тешүү',
      step_assembly: 'Чогултуу',
      step_packaging: 'Таңгактоо',
      step_delivery: 'Жеткирүү',
      step_accounting: 'Бухгалтерия',

      // Step names (camelCase — legacy)
      stepManager: 'Менеджер',
      stepConstructor: 'Конструктор',
      stepPurchaser: 'Сатып алуучу',
      stepCutting: 'Кесүү',
      stepEdgeBanding: 'Кырдоо',
      stepDrilling: 'Тешүү',
      stepAssembly: 'Чогултуу',
      stepPackaging: 'Таңгактоо',
      stepDelivery: 'Жеткирүү',
      stepAccounting: 'Бухгалтерия',

      // Statuses (camelCase — legacy)
      statusPending: 'Күтүүдө',
      statusActive: 'Иштөөдө',
      statusCompleted: 'Аяктаган',
      statusSkipped: 'Өткөрүлгөн',
      statusOnHold: 'Тыныгууда',

      // Priorities (camelCase — legacy)
      priorityLow: 'Төмөн',
      priorityNormal: 'Кадимки',
      priorityHigh: 'Жогору',
      priorityUrgent: 'Шашылыш',

      // Detail / Pipeline
      detail: 'Конвейер чоо-жайы',
      pipeline: 'Конвейер',
      pipelineNumber: 'Конвейер номери',
      createPipeline: 'Өндүрүш трегин түзүү',
      specification: 'Спецификация',
      noSpecification: 'Спецификация толтурулган эмес',
      accounting: 'Өздүк наркы',

      // Step actions
      start: 'Баштоо',
      complete: 'Аяктоо',
      skip: 'Өткөрүү',
      confirm: 'Ырастоо',
      completeStep: 'Этапты аяктоо',
      completeStepTitle: 'Этапты аяктоо',
      startStep: 'Этапты баштоо',
      skipStep: 'Этапты өткөрүү',
      skipped: 'Өткөрүлгөн',
      pending: 'Күтүүдө',
      inProgress: 'Иштөөдө',
      stepStarted: 'Этап башталды',
      stepCompleted: 'Этап аякталды',
      stepSkipped: 'Этап өткөрүлдү',
      role: 'Ролу',
      duration: 'Узактык',
      minutes: 'мин',
      mm: 'мм',

      // Specification editor
      materials: 'Материалдар',
      addMaterial: 'Кошуу',
      materialName: 'Аталышы',
      quantity: 'Саны',
      unit: 'Бирдик',
      dimensions: 'Өлчөмдөр',
      width: 'Туурасы (мм)',
      height: 'Бийиктиги (мм)',
      depth: 'Тереңдиги (мм)',
      additionalNotes: 'Кошумча эскертүүлөр',
      saveSpec: 'Спецификацияны сактоо',
      specSaved: 'Спецификация сакталды',

      // Costs / Accounting
      costs: 'Өздүк наркы',
      costBreakdown: 'Чыгым бөлүштүрүү',
      materialCost: 'Материалдар',
      laborCost: 'Эмгек чыгымдары',
      overheadCost: 'Үстөмө чыгымдар',
      costPrice: 'Өздүк наркы',
      finalPrice: 'Акыркы баа',
      margin: 'Маржа',
      saveCosts: 'Сактоо',
      costsSaved: 'Чыгымдар сакталды',
      summary: 'Жыйынтык',
      specMaterials: 'Спецификация материалдары',

      // Purchase orders
      purchaseOrders: 'Сатып алуу буйрутмалары',
      noPurchaseOrders: 'Байланышкан сатып алуулар жок',
      goToPurchasing: 'Материалдарды сатып алуу',
      purchaserTitle: 'Материалдарды сатып алуу',
      purchasedItems: 'Сатып алынды',
      purchased: 'сатып алынды',
      purchasePrice: 'Сатып алуу баасы',
      purchaseTime: 'Убакыт',
      receipts: 'Чектер',
      markPurchased: 'Сатып алынды деп белгилөө',
      selectAll: 'Баарын тандоо',
      totalPurchaseCost: 'Жалпы',
      savePurchaseData: 'Сактоо',
      purchaseTrackingSaved: 'Сатып алуу маалыматтары сакталды',
      pipelineNotFound: 'Конвейер табылган жок',
      receiptUploaded: 'Чек жүктөлдү',
      receiptUploadError: 'Чекти жүктөөдө ката',
      attachReceipt: 'Чек тиркөө',
      noSpecForPurchase: 'Спецификация конструктор тарабынан толтурула элек. Спецификациянын жүктөлүшүн күтүңүз.',
      constructorPhotos: 'Конструктордон сүрөттөр',
      materialType: 'Түрү',
      andMore: 'жана дагы',

      // Constructor — specification upload
      uploadXmlSpec: 'XML спецификацияны жүктөө',
      xmlHelp: 'Bazis / К3-Мебелден XML файлды жүктөңүз. Материалдар автоматтык түрдө чыгарылат.',
      selectXmlFile: 'XML файлды тандоо',
      invalidXmlFile: 'XML спецификация файлын тандаңыз',
      xmlParsed: 'XML спецификация жүктөлдү',
      positions: 'позициялар',
      project: 'Долбоор',
      specPhotos: 'Сүрөттөр / Чиймелер',
      uploadPhotos: 'Жүктөө',
      photosUploaded: 'Сүрөттөр жүктөлдү',
      noPhotos: 'Жүктөлгөн сүрөттөр жок',
      xmlParseError: 'XML талдоо катасы',
      photoUploadError: 'Сүрөт жүктөө катасы',

      // Notes
      notes: 'Эскертүүлөр',
      completeConfirm: 'Этапты аяктоо?',
      completeNotes: 'Аяктоо эскертүүсү',

      // Board views
      kanbanView: 'Канбан',
      listView: 'Тизме',
      allSteps: 'Бардык этаптар',
      activeSteps: 'Активдүү',
      deadline: 'Мөөнөт',
      assignedTo: 'Дайындалган',
      viewDetail: 'Толугураак',
      noPipelines: 'Конвейерлер табылган жок',

      // Stats
      stats: 'Статистика',
      totalPipelines: 'Жалпы конвейерлер',
      completedToday: 'Бүгүн аяктаган',
      overdue: 'Мөөнөтү өткөн',
    },

    // Quality Control (QC)
    qc: {
      // Dashboard
      title: 'Сапат контролу',
      subtitle: 'Сапат текшерүүлөрүн, кемчиликтерди жана кармоолорду башкаруу',
      refreshData: 'Маалыматтарды жаңылоо',
      templates: 'Шаблондор',
      newInspection: 'Жаңы текшерүү',
      totalInspections: 'Жалпы текшерүүлөр',
      allTime: 'Бардык убакыт',
      successful: 'ийгиликтүү',
      defectsThisWeek: 'бул жумадагы кемчиликтер',
      needsAttention: 'Көңүл буруу керек',
      qualityScore: 'Сапат баллы',
      targetScore: 'Максаттуу балл',
      outOf: 'ичинен',
      inspections: 'текшерүүлөр',
      recentInspections: 'Акыркы текшерүүлөр',
      noInspections: 'Текшерүүлөр жок',
      createInspection: 'Текшерүү түзүү',
      inspectionNum: 'Текшерүү #{{id}}',
      inspector: 'Текшерүүчү',
      quickActions: 'Тез аракеттер',
      qcTemplates: 'Сапат шаблондору',
      defects: 'Кемчиликтер',
      holds: 'Кармоолор',
      reports: 'Отчёттор',
      activeHolds: 'Активдүү кармоолор',
      noActiveHolds: 'Активдүү кармоолор жок',
      holdNum: 'Кармоо #{{id}}',
      pcs: 'даана',
      loadError: 'Сапат контролу маалыматтарын жүктөө мүмкүн болгон жок',
      status_pending: 'Күтүүдө',
      status_in_progress: 'Иштөөдө',
      status_passed: 'Өткөн',
      status_failed: 'Өтпөгөн',
      status_on_hold: 'Кармоодо',

      // Holds
      holdsTitle: 'Кармоолор',
      holdsSubtitle: 'Товарларды кармоо башкаруу',
      createHold: 'Кармоо түзүү',
      releaseHold: 'Кармоону алуу',
      holdActive: 'Активдүү',
      holdReleased: 'Алынды',
      holdExpired: 'Мөөнөтү өттү',
      severityLow: 'Төмөн',
      severityMedium: 'Орточо',
      severityHigh: 'Жогору',
      severityCritical: 'Критикалык',
      reasonQuality: 'Сапат маселеси',
      reasonDocumentation: 'Документация',
      reasonInspectionPending: 'Текшерүүнү күтүүдө',
      reasonCustomerRequest: 'Кардардын суроосу',
      reasonRegulatory: 'Жөнгө салуу талаптары',
      reasonOther: 'Башка',
      productName: 'Товардын аты',
      quantity: 'Саны',
      severity: 'Олуттуулугу',
      reason: 'Себеп',
      description: 'Сүрөттөмө',
      expectedResolutionDate: 'Күтүлгөн чечилүү датасы',
      comment: 'Комментарий',
      confirmReleaseHold: 'Бул кармоону алууну каалайсызбы?',
      releaseReasonPlaceholder: 'Алуу себебин көрсөтүңүз...',
      loadHoldsError: 'Кармоолорду жүктөө мүмкүн болбоду',
      searchHolds: 'Кармоолорду издөө...',
      searchHoldsAria: 'Кармоолорду издөө',
      filterByStatus: 'Статус боюнча',
      number: '№',
      product: 'Товар',
      date: 'Дата',
      holdsNotFound: 'Кармоолор табылган жок',
      openHold: 'Кармоону ачуу',
      refreshHoldsList: 'Кармоолор тизмесин жаңылоо',

      // Templates
      categoryIncoming: 'Кирүүчү',
      categoryInProcess: 'Процесстеги',
      categoryFinal: 'Акыркы',
      categoryPackaging: 'Таңгактоо',
      categoryShipping: 'Жөнөтүү',
      editTemplate: 'Калыпты өзгөртүү',
      newTemplateQC: 'Жаңы СК калыбы',
      category: 'Категория',
      checklist: 'Чеклист',
      addChecklistItemPlaceholder: 'Жаңы чеклист пункту...',
      addChecklistHint: 'Кошуу үчүн Enter же + басыңыз',
      deleteChecklistItem: 'Чеклист пунктун өчүрүү',
      loadTemplatesError: 'Калыптарды жүктөө мүмкүн болбоду',
      copy: 'Көчүрмө',
      templatesTitle: 'СК Калыптары',
      templatesSubtitle: 'Сапат контролунун калыптарын башкаруу',
      refreshTemplatesList: 'Калыптар тизмесин жаңылоо',
      newTemplate: 'Жаңы калып',
      searchTemplates: 'Калыптарды издөө...',
      searchTemplatesAria: 'Калыптарды издөө',
      filterByCategory: 'Категория боюнча',
      checklistItems: 'Чеклист',
      templatesNotFound: 'Калыптар табылган жок',
      duplicate: 'Дубликат',
      duplicateTemplate: 'Калыпты кайталоо',
      editTemplateAria: 'Калыпты өзгөртүү',
      deleteTemplateAria: 'Калыпты өчүрүү',
      deleteTemplateTitle: 'Калыпты өчүрүү?',
      deleteTemplateConfirm: 'Бул калыпты өчүрүүнү каалайсызбы?',

      // Inspections
      statusPending: 'Күтүүдө',
      statusInProgress: 'Процесстеги',
      statusPassed: 'Өттү',
      statusFailed: 'Өтпөдү',
      refPurchase: 'Сатып алуу',
      refProduction: 'Өндүрүш',
      refInventory: 'Инвентаризация',
      refReturn: 'Кайтаруу',
      refOther: 'Башка',
      selectTemplateError: 'Калыпты тандаңыз',
      stepSelectTemplate: 'Калып тандоо',
      stepInspectionData: 'Текшерүү маалыматтары',
      stepChecklist: 'Чеклист',
      editInspection: 'Текшерүүнү өзгөртүү',
      newInspectionQC: 'Жаңы СК текшерүүсү',
      inspectionTemplate: 'Текшерүү калыбы',
      noDescription: 'Сүрөттөмөсүз',
      documentType: 'Документ түрү',
      documentId: 'Документ ID',
      notes: 'Эскертүүлөр',
      fillChecklistResults: 'Контролдук тизме боюнча натыйжаларды толтуруңуз',
      required: 'милдеттүү',
      optional: 'кошумча',
      commentOptional: 'Комментарий (милдеттүү эмес)',
      createInspection: 'Текшерүү түзүү',
      inspectionsTitle: 'СК Текшерүүлөрү',
      inspectionsSubtitle: 'Продукция сапат контролу',
      refreshInspectionsList: 'Текшерүүлөр тизмесин жаңылоо',
      newInspection: 'Жаңы текшерүү',
      searchInspections: 'Текшерүүлөрдү издөө...',
      searchInspectionsAria: 'Текшерүүлөрдү издөө',
      manageColumns: 'Мамычаларды настройкалоо',
      inspectionsNotFound: 'Текшерүүлөр табылган жок',
      loadInspectionsError: 'Текшерүүлөрдү жүктөө мүмкүн болбоду',
      openInspection: 'Текшерүүнү ачуу',
      columnManagementTitle: 'Мамычаларды настройкалоо',
      type: 'Түрү',
    },

    // CRM
    crm: {
      // Dashboard
      loadDashboardError: 'Дашборд маалыматтарын жүктөө мүмкүн болбоду',
      interactionCall: 'Чалуу',
      interactionEmail: 'Email',
      interactionMeeting: 'Жолугушуу',
      interactionNote: 'Эскертүү',
      interactionComplaint: 'Даттануу',
      interactionFeedback: 'Пикир',
      interactionSms: 'СМС',
      interactionChat: 'Чат',
      loadingCrmData: 'CRM маалыматтарын жүктөө...',
      dashboardTitle: 'CRM Дашборд',
      dashboardSubtitle: 'Кардарлар менен мамилелерди башкаруу',
      segments: 'Сегменттер',
      customers: 'Кардарлар',
      activeTasks: 'Активдүү тапшырмалар',
      overdue: 'Мөөнөтү өткөн',
      allOnTime: 'Баары мөөнөтүндө',
      interactionsWeek: 'Жумадагы байланыштар',
      today: 'Бүгүн',
      loyaltyMembers: 'Лоялдуулук программасынын катышуучулары',
      points: 'балл',
      tasks: 'Тапшырмалар',
      allTasks: 'Бардык тапшырмалар',
      awaitingExecution: 'Аткарууну күтүүдө',
      tasksCount: 'тапшырма',
      overdueTasks: 'Мөөнөтү өткөн тапшырмалар',
      urgentTasks: 'Шашылыш тапшырмалар',
      createTask: 'Тапшырма түзүү',
      interactionsWeekTitle: 'Жумадагы байланыштар',
      history: 'Тарых',
      noInteractionsWeek: 'Бул жуманын байланыштары жок',
      addInteraction: 'Байланыш кошуу',
      quickActions: 'Тез аракеттер',
      interactions: 'Байланыштар',
      loyalty: 'Лоялдуулук',

      // Loyalty Programs
      loyaltyTitle: 'Лоялдуулук программалары',
      loyaltyRefresh: 'Жаңыртуу',
      loyaltyNewProgram: 'Жаңы программа',
      loyaltyLoading: 'Жүктөлүүдө...',
      loyaltyNoPrograms: 'Лоялдуулук программалары жок',
      loyaltyNoProgramsHint: 'Кардарларга бонустарды тапшыруу үчүн биринчи программаңызды түзүңүз',
      loyaltyCreateProgram: 'Программа түзүү',
      loyaltyLoadError: 'Лоялдуулук программаларын жүктөө мүмкүн болбоду',
      loyaltyNameRequired: 'Программанын атын жазыңыз',
      loyaltyUpdated: 'Программа жаңыланды',
      loyaltyCreated: 'Программа түзүлдү',
      loyaltySaveError: 'Программаны сактоо мүмкүн болбоду',
      loyaltyDeleted: 'Программа өчүрүлдү',
      loyaltyDeleteError: 'Программаны өчүрүү мүмкүн болбоду',
      loyaltyTypePoints: 'Баллдар',
      loyaltyTypeCashback: 'Кэшбэк',
      loyaltyTypeDiscountTiers: 'Арзандатуу деңгээлдери',
      loyaltyTypeHybrid: 'Гибриддик',
      loyaltyDefault: 'Демейки',
      loyaltyInactive: 'Активдүү эмес',
      loyaltyEarning: 'Эсептөө',
      loyaltyPointPerSom: 'балл / 1 сом (KGS)',
      loyaltyRedeeming: 'Жоюу',
      loyaltyPointEqualsSom: '1 балл = ',
      loyaltySomKGS: ' сом (KGS)',
      loyaltyMinRedeem: 'Жоюу үчүн мин.',
      loyaltyPointsUnit: 'балл',
      loyaltyMaxPayment: 'Макс. төлөм',
      loyaltyOfOrder: '% буюртмадан',
      loyaltyPointsExpiry: 'Баллдардын мөөнөтү',
      loyaltyDays: 'күн',
      loyaltyParticipants: 'катышуучу',
      loyaltyEditAria: 'Программаны өзгөртүү',
      loyaltyDeleteAria: 'Программаны өчүрүү',
      loyaltyEditProgram: 'Программаны өзгөртүү',
      loyaltyName: 'Аталышы',
      loyaltyProgramType: 'Программанын түрү',
      loyaltyDescription: 'Сүрөттөмө',
      loyaltyEarnRules: 'Эсептөө эрежелери',
      loyaltyPointsPerSom: '1 сом үчүн баллдар (KGS)',
      loyaltyMinPurchase: 'Мин. сатып алуу суммасы',
      loyaltyRedeemRules: 'Жоюу эрежелери',
      loyaltyPointValueSom: '1 балл = X сом (KGS)',
      loyaltyMinPointsRedeem: 'Жоюу үчүн мин. баллдар',
      loyaltyMaxOrderPercent: 'Буюртманын макс. %',
      loyaltyExpireDays: 'Мөөнөтү (күн)',
      loyaltyExpireHint: 'Туруктуу баллдар үчүн бош калтырыңыз',
      loyaltyActive: 'Активдүү',
      loyaltyCancel: 'Жокко чыгаруу',
      loyaltySaving: 'Сакталууда...',
      loyaltySave: 'Сактоо',
      loyaltyDeleteTitle: 'Программаны өчүрүүбү?',
      loyaltyDeleteConfirm: '\"{{name}}\" программасын өчүрүүнү каалайсызбы? Бардык катышуучулардын маалыматтары жана транзакциялар өчүрүлөт.',
      loyaltyDelete: 'Өчүрүү',

      // Tasks
      priorityLow: 'Төмөн',
      priorityMedium: 'Орточо',
      priorityHigh: 'Жогору',
      priorityUrgent: 'Шашылыш',
      statusPending: 'Күтүүдө',
      statusInProgress: 'Иштөө учурунда',
      statusCompleted: 'Аткарылды',
      statusCancelled: 'Жокко чыгарылды',
      statusDeferred: 'Кийин калтырылды',
      loadTasksError: 'Тапшырмаларды жүктөө мүмкүн болбоду',
      enterTaskName: 'Тапшырманын атын жазыңыз',
      taskUpdated: 'Тапшырма жаңыланды',
      taskCreated: 'Тапшырма түзүлдү',
      saveTaskError: 'Тапшырманы сактоо мүмкүн болбоду',
      taskDeleted: 'Тапшырма өчүрүлдү',
      deleteTaskError: 'Тапшырманы өчүрүү мүмкүн болбоду',
      taskCompleted: 'Тапшырма аткарылды',
      completeTaskError: 'Тапшырманы аяктоо мүмкүн болбоду',
      taskTitle: 'Тапшырма',
      priority: 'Артыкчылык',
      assignee: 'Аткаруучу',
      customer: 'Кардар',
      dueDate: 'Мөөнөтү',
      complete: 'Аяктоо',
      completeTaskAria: 'Тапшырманы аяктоо',
      editTaskAria: 'Тапшырманы өзгөртүү',
      deleteTaskAria: 'Тапшырманы өчүрүү',
      tasksTitle: 'CRM Тапшырмалары',
      newTask: 'Жаңы тапшырма',
      editTask: 'Тапшырманы өзгөртүү',
      assigneeName: 'Аткаруучунун аты',
      customerName: 'Кардардын аты',
      reminder: 'Эскертүү',
      deleteTaskTitle: 'Тапшырманы өчүрүү?',
      deleteTaskConfirm: 'Бул тапшырманы өчүрүүнү каалайсызбы?',

      // Segments
      segmentsTitle: 'Кардар сегменттери',
      newSegment: 'Жаңы сегмент',
      editSegment: 'Сегментти өзгөртүү',
      discount: 'Арзандатуу',
      discountPercent: 'Арзандатуу (%)',
      paymentDelay: 'Төлөмдү кечиктирүү',
      paymentDelayDays: 'Төлөмдү кечиктирүү (күн)',
      days: 'күн',
      customersCount: 'Кардарлар',
      color: 'Түс',
      loadSegmentsError: 'Сегменттерди жүктөө мүмкүн болбоду',
      enterSegmentName: 'Сегменттин атын жазыңыз',
      segmentUpdated: 'Сегмент жаңыланды',
      segmentCreated: 'Сегмент түзүлдү',
      saveSegmentError: 'Сегментти сактоо мүмкүн болбоду',
      segmentDeleted: 'Сегмент өчүрүлдү',
      deleteSegmentError: 'Сегментти өчүрүү мүмкүн болбоду',
      editSegmentAria: 'Сегментти өзгөртүү',
      deleteSegmentAria: 'Сегментти өчүрүү',
      deleteSegmentTitle: 'Сегментти өчүрүү?',
      deleteSegmentConfirm: 'Сегментти "{name}" өчүрүүнү каалайсызбы? Бардык кардарлар бул сегменттен ажыратылат.',
    },

    // ============================================================
    // CHAT
    // ============================================================
    chat: {
      edited: '(түз.)',
      reply: 'Жооп берүү',
      copy: 'Көчүрүү',
      editMessage: 'Түзөтүү',
      pin: 'Кадоо',
      deleteMessage: 'Өчүрүү',
      today: 'Бүгүн',
      yesterday: 'Кечээ',
      selectChat: 'Чатты тандаңыз',
      orStartNewConversation: 'же жаңы сүйлөшүүнү баштаңыз',
      listenRadio: 'Күтүп жатканда радио угуңуз 🎵',
      online: 'онлайн',
      wasRecentlyOnline: 'жакында онлайн болгон',
      members: 'катышуучу',
      typingSingular: 'жазып жатат...',
      typingPlural: 'жазып жатышат...',
      confirmDeleteMessage: 'Билдирүүнү өчүрүү?',
      messagePlaceholder: 'Билдирүү...',
      editing: 'Түзөтүү',
      startConversation: 'Сүйлөшүүнү баштаңыз!',
      attachFileAria: 'Файл тиркөө',
      stickersAria: 'Стикерлер',
      formattingAria: 'Форматтоо',
      emojiAria: 'Эмодзи',
      sendAria: 'Жөнөтүү',
      cancelAria: 'Жокко чыгаруу',
      openChatListAria: 'Чат тизмесин ачуу',
      chatInfoAria: 'Чат маалыматы',
      searchCtrlFAria: 'Издөө (Ctrl+F)',
      cancelEditAria: 'Түзөтүүнү жокко чыгаруу',
      replyToMessageAria: 'Билдирүүгө жооп берүү',
      scrollToMessageAria: 'Билдирүүгө жылдыруу',
      closeReplyAria: 'Жоопту жабуу',
      messageActionsAria: 'Билдирүү аракеттери',
      info: 'Маалымат',
      editNameAria: 'Аталышын түзөтүү',
      channel: 'Канал',
      group: 'Группа',
      notifications: 'Билдирмелер',
      notificationsOff: 'Өчүрүлгөн',
      notificationsOn: 'Күйгүзүлгөн',
      pinChat: 'Чатты бекитүү',
      pinned: 'Бекитилген',
      notPinned: 'Бекитилбеген',
      membersList: 'Катышуучулар',
      owner: 'Түзүүчү',
      admin: 'Админ',
      mediaFilesLinks: 'Медиа, файлдар, шилтемелер',
      comingSoon: 'Жакында жеткиликтүү болот',
      confirmLeaveChat: 'Чатты таштап кеткиңиз келеби?',
      leaveChat: 'Чаттан чыгуу',
      // Sidebar
      youPrefix: 'Сиз: ',
      noMessages: 'Билдирүүлөр жок',
      chatAvatar: 'Чат аватары',
      chats: 'Чаттар',
      newChat: 'Жаңы чат',
      search: 'Издөө...',
      tabAll: 'Баары',
      tabPersonal: 'Жеке',
      tabGroups: 'Топтор',
      nothingFound: 'Эч нерсе табылган жок',
      noChats: 'Чаттар жок',
      // Video player
      pauseAria: 'Тыным',
      playAria: 'Ойнотуу',
      unmuteAria: 'Үндү күйгүзүү',
      muteAria: 'Үндү өчүрүү',
      pipAria: 'Сүрөт ичинде сүрөт',
      fullscreenAria: 'Толук экран',
      // File drop zone
      exceedsMaxSize: '10MB ашып кетти',
      uploadErrors: 'Жүктөө каталары:',
      dropFilesHere: 'Файлдарды бул жерге таштаңыз',
      maxFilesHint: '{{count}} файлга чейин, ар бири 10MB максимум',
      removeImageAria: 'Сүрөттү жок кылуу',
      removeFileAria: 'Файлды жок кылуу',
      attachFileAria: 'Файл тиркөө',
      // Voice recorder
      micAccessError: 'Микрофонго кирүү мүмкүн болбоду',
      cancelRecordingAria: 'Жазууну жокко чыгаруу',
      stopRecordingAria: 'Жазууну токтотуу',
      deleteRecordingAria: 'Жазууну жок кылуу',
      sendRecordingAria: 'Жазууну жөнөтүү',
      recordVoiceAria: 'Үн билдирүүсүн жаздыруу',
      // ChatAnimations
      userTyping: '{{name}} жазып жатат...',
      twoUsersTyping: '{{name1}} жана {{name2}} жазып жатышат...',
      manyUsersTyping: '{{count}} адам жазып жатышат...',
      sending: 'Жөнөтүлүүдө...',
      newMessageSingular: 'жаңы билдирүү',
      newMessagesPlural: 'жаңы билдирүүлөр',
      unreadMessages: 'Окулбаган билдирүүлөр',
      messageDeleted: 'Билдирүү өчүрүлдү',
      // ChatSearch
      searchFilterAll: 'Баары',
      searchFilterMedia: 'Медиа',
      searchFilterFiles: 'Файлдар',
      searchFilterLinks: 'Шилтемелер',
      searchPlaceholder: '"{{name}}" ичинде издөө...',
      searchDefaultChat: 'чатта',
      clearSearchAria: 'Издөөнү тазалоо',
      previousResultAria: 'Мурунку натыйжа',
      nextResultAria: 'Кийинки натыйжа',
      closeSearchAria: 'Издөөнү жабуу',
      enterTextToSearch: 'Издөө үчүн текст киргизиңиз',
      attachmentPhoto: '📷 Сүрөт',
      attachmentFile: '📎 Файл',
      kbdGoTo: 'өтүү',
      kbdNavigation: 'навигация',
      kbdClose: 'жабуу',
      searchInChatAria: 'Чатта издөө',
      // ChatNotifications
      newMessageTitle: 'Жаңы билдирүү',
      mediaMessage: 'Медиа билдирүү',
      // EmojiPicker
      emojiRecent: 'Акыркылар',
      emojiSmileys: 'Смайлдар',
      emojiGestures: 'Жаңсоолор',
      emojiAnimals: 'Жаныбарлар',
      emojiFood: 'Тамак',
      emojiTravel: 'Саякат',
      emojiActivities: 'Активдүүлүк',
      emojiObjects: 'Буюмдар',
      emojiSymbols: 'Символдор',
      emojiFlags: 'Желектер',
      emojiSearchPlaceholder: 'Эмодзи издөө...',
      noRecentEmojis: 'Акыркы эмодзилер жок',
      selectEmojiAria: 'Эмодзи тандоо {{emoji}}',
      reactionEmojiAria: 'Реакция {{emoji}}',
      errorLoadChats: 'Чаттарды жүктөө мүмкүн эмес',
      errorLoadMessages: 'Кабарларды жүктөө мүмкүн эмес',
      errorSendMessage: 'Кабар жөнөтүү мүмкүн эмес',
      errorCreateChat: 'Чат түзүү мүмкүн эмес',
      // ChatSidebar
      pressNewChatHint: 'Жаңы чат баштоо үчүн + басыңыз',
      // NewChatDialog
      directMessage: 'Жеке билдирүү',
      groupNameLabel: 'Группанын аталышы',
      channelNameLabel: 'Каналдын аталышы',
      descriptionOptional: 'Сүрөттөмө (милдеттүү эмес)',
      searchUsersPlaceholder: 'Колдонуучуларды издөө...',
      noUsersFound: 'Эч ким табылган жок',
      noAvailableUsers: 'Жеткиликтүү колдонуучулар жок',
      createGroup: 'Группа түзүү',
      createChannel: 'Канал түзүү',
      userAvatarAlt: 'Колдонуучунун аватары',
      // UserStatus
      userStatus: {
        presetAtWork: 'Жумушта',
        presetHome: 'Үйдө',
        presetSleeping: 'Уктап жатам',
        presetGaming: 'Ойноп жатам',
        presetStudying: 'Окуп жатам',
        presetWatchingMovie: 'Кино көрүп жатам',
        presetListeningMusic: 'Музыка угуп жатам',
        presetLunch: 'Түшкү овкаттанып жатам',
        presetTraining: 'Машыгуу жасап жатам',
        presetTraveling: 'Саяхатта',
        presetSick: 'Ооруп калдым',
        presetDoNotDisturb: 'Тынчтыкты бузбаңыз',
        presetCelebrating: 'Майрамдап жатам',
        presetCoffee: 'Кофе ичип жатам',
        presetOnTheRoad: 'Жолдо',
        presetOnline: 'Байланышта',
        dur30min: '30 мүнөт',
        dur1hour: '1 саат',
        dur2hours: '2 саат',
        dur4hours: '4 саат',
        dur8hours: '8 саат',
        dur1day: '1 күн',
        dur1week: '1 жума',
        durUnlimited: 'Чексиз',
        durMinutes: '{{m}} мүн',
        durHours: '{{h}} с',
        durDays: '{{d}} күн',
        setStatus: 'Статус коюу',
        changeStatus: 'Статусту өзгөртүү',
        whatAreYouDoing: 'Эмне жасап жатасыз?',
        duration: 'Узактыгы',
        quickSelect: 'Тез тандоо',
        clearStatus: 'Статусту тазалоо',
        justNow: 'жаңы эле',
        minutesAgo: '{{m}} мүн мурун',
        hoursAgo: '{{h}} с мурун',
        recently: 'жакында',
      },
      // Radio Player
      radio: {
        countries: {
          russia: 'Россия',
          somafm: 'SomaFM',
          usa: 'АКШ',
          uk: 'Улуу Британия',
          germany: 'Германия',
          france: 'Франция',
          japan: 'Жапония',
          korea: 'Түштүк Корея',
          turkey: 'Түркия',
          kazakhstan: 'Казакстан',
          uzbekistan: 'Өзбекстан',
          world: 'Дүйнөлүк',
        },
        title: 'Радио',
        searchStations: 'Станцияларды издөө...',
        closeRadio: 'Радиону жабуу',
        stop: 'Токтотуу',
        play: 'Ойнотуу',
        mute: 'Үндү өчүрүү',
        unmute: 'Үндү күйгүзүү',
        onAir: 'Эфирде',
        share: 'Бөлүшүү',
        favorites: 'Тандалмалар',
        removeFromFavorites: 'Тандалмалардан алып салуу',
        addToFavorites: 'Тандалмаларга кошуу',
        playing: 'Ойнотулууда',
        openRadioPlaying: 'Радиону ачуу (ойноп жатат)',
        openRadio: 'Радиону ачуу',
        listening: 'Угуп жатат',
        stopRadio: 'Радиону токтотуу',
        playRadio: 'Радиону ойнотуу',
        streamError: 'Станцияны ойнотуу мүмкүн болбоду',
        playbackError: 'Ойнотуу катасы: {{error}}',
      },
      // Sticker Picker
      stickers: {
        categories: {
          recent: 'Акыркылар',
          popular: 'Популярдуу',
          emotions: 'Эмоциялар',
          animals: 'Жаныбарлар',
          gestures: 'Жаңсоолор',
          celebration: 'Майрамдар',
          love: 'Сүйүү',
        },
        title: 'Стикерлер',
        searchPlaceholder: 'Стикерлерди издөө...',
        closeStickers: 'Стикерлерди жабуу',
        noRecentStickers: 'Акыркы стикерлер жок',
        stickersNotFound: 'Стикерлер табылган жок',
        recentCount: '{{count}} акыркы',
        stickersCount: '{{count}} стикер',
      },
      // Text Formatter
      formatter: {
        bold: 'Калың',
        italic: 'Курсив',
        underline: 'Астын сызылган',
        strikethrough: 'Сызылган',
        code: 'Код',
        codeBlock: 'Код блогу',
        title: 'Форматтоо',
      },
      // Music Player
      music: {
        title: 'Музыка',
        audio: 'Аудио',
        pause: 'Тыным',
        play: 'Ойнотуу',
        share: 'Бөлүшүү',
        close: 'Жабуу',
        listening: 'Угуп жатат',
      },
      // Link Preview
      linkPreview: {
        removePreview: 'Шилтеме алдын ала көрүүнү жок кылуу',
      },
      errorSaveSetting: 'Түзөтүүнү сактоо мүмкүн болбоду',
      errorSaveName: 'Чат аталышын сактоо мүмкүн болбоду',
      errorLeaveChat: 'Чаттан чыгуу мүмкүн болбоду',
      errorUploadFiles: 'Файлдарды жүктөө мүмкүн болбоду',
      errorDeleteMessage: 'Билдирүүнү өчүрүү мүмкүн болбоду',
      errorReaction: 'Реакция кошуу мүмкүн болбоду',
      errorPinMessage: 'Билдирүүнү кадоо мүмкүн болбоду',
      errorLoadMembers: 'Катышуучуларды жүктөө мүмкүн болбоду',
      errorLoadUsers: 'Колдонуучуларды жүктөө мүмкүн болбоду',
      videoThumbnail: 'Видео миниатүрасы',
      youtubeVideo: 'YouTube видеосу',
      vimeoVideo: 'Vimeo видеосу',
      tiktokVideo: 'TikTok видеосу',
      youtubeMusic: 'YouTube Музыка',
    },

    // ============================================================
    // CUSTOMER SUPPORT
    // ============================================================
    support: {
      heading: 'Кардарларды колдоо',
      total: 'Бардыгы',
      active: 'Активдүү',
      waiting: 'Күтүүдө',
      statusNew: 'Жаңы',
      statusOpen: 'Ачык',
      statusPending: 'Күтүүдө',
      statusResolved: 'Чечилди',
      statusClosed: 'Жабылды',
      priorityLow: 'Төмөн',
      priorityMedium: 'Орточо',
      priorityHigh: 'Жогорку',
      priorityCritical: 'Критикалык',
      searchPlaceholder: 'Кайрылууларды издөө...',
      tabAll: 'Баары',
      tabNew: 'Жаңылар',
      tabActive: 'Активдүү',
      tabResolved: 'Чечилгендер',
      noTickets: 'Кайрылуулар жок',
      noNewTickets: 'Жаңы кайрылуулар жок',
      noActiveTickets: 'Активдүү кайрылуулар жок',
      noResolvedTickets: 'Чечилген кайрылуулар жок',
      anonymous: 'Аноним',
      noMessages: 'Билдирүүлөр жок',
      selectChatFromList: 'Тизмеден чатты тандаңыз',
      order: 'Заказ:',
      take: 'Алуу',
      assigned: 'Дайындалган',
      customerInfo: 'Кардар маалыматы',
      name: 'Аты',
      email: 'Email',
      phone: 'Телефон',
      ordersCount: 'Заказдар',
      totalSpent: 'Жалпы сумма',
      changeStatus: 'Статусту өзгөртүү',
      changePriority: 'Приоритетти өзгөртүү',
      closeTicket: 'Кайрылууну жабуу',
      closeTicketTitle: 'Кайрылууну жабуу?',
      closeTicketConfirm: 'Бул кайрылууну жабууну каалайсызбы?',
      inputPlaceholder: 'Билдирүү жазыңыз...',
      sendAria: 'Жөнөтүү',
      defaultCustomerName: 'Кардар',
      defaultManagerName: 'Менеджер',
      errorSendMessage: 'Кабар жөнөтүү мүмкүн эмес',
      errorStatusChange: 'Статусту өзгөртүү мүмкүн эмес',
      errorAssign: 'Менеджерди дайындоо мүмкүн эмес',
      errorLoadChats: 'Чаттарды жүктөө мүмкүн эмес',
      errorLoadMessages: 'Кабарларды жүктөө мүмкүн эмес',
    },

    // ============================================================
    // INTEGRATIONS
    // ============================================================
    integrations: {
      // System names
      system1C: '1С:Соода башкаруу',
      systemMoySklad: 'МойСклад',
      systemInternal: 'Ички эсеп',
      ownAccounting: 'Өздүк эсеп',

      // General
      heading: 'Интеграциялар',
      subtitle: 'Тышкы системаларга туташууларды башкаруу',
      namespace: 'Ат мейкиндиги',
      externalId: 'Тышкы ID',
      addIntegration: 'Интеграция кошуу',
      active: 'Активдүү',
      disabled: 'Өчүрүлгөн',
      system: 'Система:',
      lastSync: 'Акыркы синхр.:',
      never: 'эч качан',
      productsCount: 'товар',
      viewProducts: 'Товарлар',
      settings: 'Орнотуулар',
      logs: 'Журнал',
      webhooks: 'Вебхуктар',
      confirmDeleteIntegration: '"{name}" интеграциясын өчүрүү? Бул аракетти кайтаруу мүмкүн эмес.',
      integrationDeleted: 'Интеграция өчүрүлдү',
      deleteError: 'Өчүрүү катасы',
      error: 'Ката',

      // IntegrationsPage dialog
      createIntegration: 'Интеграция түзүү',
      editIntegration: 'Интеграцияны түзөтүү',
      integrationName: 'Интеграция аталышы',
      integrationNameHelper: 'Интеграция үчүн түшүнүктүү аталыш',
      systemType: 'Система түрү',
      namespace: 'Namespace',
      namespaceHelper: 'Уникалдуу идентификатор (латын, сандар, дефис)',
      apiUrl: 'API URL',
      apiUrlHelper: 'API туташуу үчүн базалык URL',
      activeSwitch: 'Активдүү',
      integrationSaved: 'Интеграция сакталды',
      integrationCreated: 'Интеграция түзүлдү',
      saveError: 'Сактоо катасы',
      editTooltip: 'Түзөтүү',
      editAria: 'Интеграцияны түзөтүү',
      deleteTooltip: 'Өчүрүү',
      deleteAria: 'Интеграцияны өчүрүү',
      settingsTooltip: 'Орнотуулар',
      settingsAria: 'Интеграция орнотуулары',
      logsTooltip: 'Журнал',
      logsAria: 'Интеграция журналы',
      webhooksTooltip: 'Вебхуктар',
      webhooksAria: 'Интеграция вебхуктары',
      productsTooltip: 'Товарлар',
      productsAria: 'Интеграция товарлары',
      noIntegrations: 'Интеграциялар жок',
      noIntegrationsHint: 'Баштоо үчүн "Интеграция кошуу" баскычын басыңыз',

      // 1C Integration
      oneCConnectionSettings: '1С туташуу орнотуулары',
      oneCPlatformInfo: '1С:Соода башкаруу менен OData/REST API аркылуу интеграция',
      urlApi: 'API URL',
      enterOneCUrl: '1С URL киргизиңиз',
      connectionMethod: 'Туташуу ыкмасы',
      odata: 'OData',
      rest: 'REST API',
      authentication: 'Аутентификация',
      basic: 'Basic',
      token: 'Token',
      username: 'Колдонуучу аты',
      password: 'Сырсөз',
      bearerToken: 'Bearer Token',
      syncSettings: 'Синхрондоштуруу орнотуулары',
      synchronize: 'Синхрондоштуруу',
      syncSchedule: 'Синхрондоштуруу графиги',
      manual: 'Кол менен',
      everyHour: 'Ар саат',
      everyDay: 'Ар күн',
      everyWeek: 'Ар жума',
      priceType: 'Баа түрү',
      priceTypePlaceholder: 'Чекене',
      priceTypeHelper: '1С-тагы баа түрүнүн аталышы',
      defaultWarehouse: 'Демейки кампа',
      warehousePlaceholder: 'Негизги кампа',
      warehouseHelper: '1С-тагы кампа аталышы же ID',
      testing: 'Текшерүү...',
      testConnectionBtn: 'Туташууну текшерүү',
      saving: 'Сактоо...',
      saveSettings: 'Орнотууларды сактоо',
      settings1CSaved: '1С орнотуулары сакталды',
      cannotConnect1C: '1С-ке туташуу мүмкүн болбоду',
      tokenGenerateError: 'Токен генерациялоо катасы',

      // 1C Platform (SuperAdmin & Tenant)
      onecDatabasesTitle: '1C Базалар',
      onecStatusActive: 'Активдүү',
      onecStatusProvisioning: 'Түзүлүүдө',
      onecStatusSuspended: 'Токтотулган',
      onecStatusError: 'Ката',
      onecStatusNot_configured: 'Орнотулган эмес',
      onecOrganization: 'Уюштуруу',
      onecServerUrl: 'Сервер URL',
      onecDbName: 'База аты',
      onecLastSync: 'Акыркы синхр.',
      onecErrorCount: 'Каталар',
      onecSuccessRate: 'Ийгилик',
      onecNoDatabases: '1C базалар табылган жок',
      onecActivate: 'Активдештирүү',
      onecSuspend: 'Токтотуу',
      onecRecreate: 'Кайра түзүү',
      onecConfirmDelete: 'Базаны жок кылуу?',
      onecConfirmDeleteText: 'Бул аракет кайтарылгыс. Бардык интеграция маалыматтары жок кылынат.',
      onecConfirmSuspend: 'Базаны токтотуу?',
      onecConfirmActivate: 'Базаны активдештирүү?',
      onecConfirmRecreate: 'Базаны кайра түзүү?',
      onecConfirmRecreateText: 'Учурдагы база жок кылынып, кайра түзүлөт.',
      onecMetricsTitle: '1C Метрикалар',
      onecActiveDbs: 'Активдүү БД',
      onecSuccessfulSyncs: 'Ийгиликтүү синхр.',
      onecFailedSyncs: 'Ийгиликсиз синхр.',
      onecLast24h: 'Акыркы 24 саат',
      onecAvgDuration: 'Орточо убакыт',
      onecRecords: 'жазуулар',
      onecSyncChart: 'Синхрондоштуруу графиги (24с)',
      onecNoChartData: 'График үчүн маалымат жок',
      onecPerOrgStatus: 'Уюштуруу боюнча статус',
      onecHealthTitle: '1C Система ден соолугу',
      onecHealthy: 'Соо',
      onecDegraded: 'Начарлоо',
      onecStale: 'Эскирген',
      onecUnhealthy: 'Оорулуу',
      onecHealthDb: 'База',
      onecHealthDatabases: '1C базалар',
      onecHealthQueue: 'Синхр. кезеги',
      onecHealthErrors: 'Каталар',
      onecPendingItems: 'Күтүүдө',
      onecLastHour: 'Акыркы саат',
      onecHealthDetails: 'Кеңири',
      onecDbBreakdown: 'БД бөлүштүрүү',
      onecSystemInfo: 'Система маалыматы',
      onecLastCheck: 'Акыркы текшерүү',
      onecAutoRefresh: 'Авто-жаңылоо',
      onecPlatformStatus: 'Платформа статусу',
      onecDatabaseStatus: '1C база статусу',
      onecNotConfigured: '1C интеграция уюштурууңуз үчүн орнотула элек',
      onecSyncSuccess: 'Ийгиликтүү',
      onecSyncFailed: 'Каталар',
      onecProvisioning: 'База түзүлүүдө...',
      onecSetupTools: 'Орнотуу куралдары',
      onecSetupTokenDesc: '1C модулду автоматтык орнотуу токени',
      onecGenerateToken: 'Токен түзүү',
      onecInstallerDesc: '1C алмашуу модулунун орнотуучусун жүктөө',
      onecDownloadInstaller: 'Орнотуучуну жүктөө',
      onecSyncLogsTitle: '1C Синхрондоштуруу журналы',
      onecForceSyncAll: 'Бардыгын синхрондоштуруу',
      onecQueued: 'Кезекте',
      onecRecordsProcessed: 'Жазуулар',
      onecDuration: 'Убакыт',
      onecStartedAt: 'Башталышы',
      onecNoLogs: 'Жазуулар жок',
      entityType: 'Түрү',
      direction: 'Багыты',
      directionImport: 'Импорт',
      directionExport: 'Экспорт',

      // 1C Installer page
      installerTitle: '1C модулун орнотуу',
      installerSubtitle: '1Сти уюмуңузга туташтыруунун кадамдык нускамасы',
      installerStep1: 'Системалык талаптар',
      installerStep1Desc: 'Системаңыз минималдуу талаптарга ылайык экенин текшериңиз',
      installerStep2: 'Орнотуу токенин алуу',
      installerStep2Desc: 'Автоматтык орнотуу үчүн токен түзүңүз',
      installerStep3: 'Орнотуучуну жүктөө',
      installerStep3Desc: 'WASSER-1C алмашуу модулунун орнотуучусун жүктөп, иштетиңиз',
      installerStep4: 'Орнотуу жана туташуу',
      installerStep4Desc: 'Орнотууну аяктоо үчүн нускаманы аткарыңыз',
      sysReq_platform: '1С Платформасы',
      sysReq_config: 'Конфигурация',
      sysReq_protocol: 'Протокол',
      sysReq_network: 'Тармак',
      sysReqMin_platform: '1С:Ишкана 8.3.10+',
      sysReqMin_config: '1С:СБ 11.5.10+ / 1С:КА 2.5+',
      sysReqMin_protocol: 'REST API же OData',
      sysReqMin_network: 'HTTPS, порт 443',
      installerInstructions: '1. WASSER-1C-Connector.exe орнотуучуну иштетиңиз\n2. 1С базасына жолду көрсөтүңүз\n3. Setup Token киргизиңиз (2-кадамдан)\n4. Байланыш түрүн тандаңыз: REST API / OData\n5. "Туташтыруу" баскычын басыңыз\n6. "Байланыш орнотулду" билдирүүсүн күтүңүз',
      generateSetupToken: 'Орнотуу токенин түзүү',
      copyToken: 'Токенди көчүрүү',
      copied: 'Көчүрүлдү!',
      tokenExpiresInfo: 'Токен 24 саат жарактуу. Мөөнөтү бүткөндө жаңысын түзүңүз.',
      tokenGenerationFailed: 'Токен түзүү ишке ашкан жок',
      downloadInstaller: 'Орнотуучуну жүктөө',
      downloadFullSetup: '1С Платформа + Коннектор (~530 МБ)',
      downloadConnectorOnly: 'Коннектор гана (~0.03 МБ)',
      downloadPackagesInfo: 'Толук пакет 1С:Ишкана 8.3.19 + WASSER коннектор + авто-орнотуучу. Коннектор гана - 1С мурунтан орнотулган болсо жаңыртуу үчүн.',
      installerMockWarning: 'Демо режимде жүктөө жеткиликтүү эмес. Продда бул жерде орнотуучу шилтемеси болот.',
      downloadSuperAdminOnly: 'Жүктөө SuperAdmin үчүн гана жеткиликтүү. Платформа администраторуна кайрылыңыз.',
      downloadFailed: 'Орнотуучуну жүктөө ишке ашкан жок',
      autoConfigured: 'Туташуу автоматтык орнотулат',
      nextStep: 'Кийинки',
      prevStep: 'Артка',

      // Connector OTA Settings
      connectorOtaTitle: '1С коннектор башкаруу',
      connectorOtaSubtitle: 'Борбордук орнотуулар, мониторинг жана коннекторлорду жаңылоо',
      connectorOtaTabSettings: 'Орнотуулар',
      connectorOtaTabInstances: 'Экземплярлар',
      connectorOtaTabVersions: 'Версиялар',
      connectorOtaOrgIdFilter: 'Уюм ID',
      connectorOtaOrgIdPlaceholder: 'Бош = платформа демейки',
      connectorOtaSyncSettings: 'Синхрондоо орнотуулары',
      connectorOtaSyncInterval: 'Синхрондоо аралыгы (мин)',
      connectorOtaSyncIntervalHelp: 'Коннектор канча тез-тез маалыматтарды синхрондойт',
      connectorOtaBatchSize: 'Пакет өлчөмү',
      connectorOtaProductsEnabled: 'Товарларды синхрондоо',
      connectorOtaStockEnabled: 'Калдыктарды синхрондоо',
      connectorOtaPricesEnabled: 'Бааларды синхрондоо',
      connectorOtaOrdersEnabled: 'Буйрутмаларды синхрондоо',
      connectorOtaCustomersEnabled: 'Кардарларды синхрондоо',
      connectorOtaStatusesEnabled: 'Статустарды синхрондоо',
      connectorOtaLoggingSettings: 'Логирование орнотуулары',
      connectorOtaLogLevel: 'Лог деңгээли',
      connectorOtaLogMaxSize: 'Макс. лог өлчөмү (МБ)',
      connectorOtaConnectorSettings: 'Коннектор орнотуулары',
      connectorOtaAutoUpdate: 'Авто-жаңылоо',
      connectorOtaAutoUpdateHelp: 'Коннектор жаңы версияларды автоматтык жүктөп, 03:00дө кайра жүктөөдө орнотот',
      connectorOtaSettingsSaved: 'Орнотуулар сакталды',
      connectorOtaNoInstances: 'Туташкан коннектор экземплярлары жок',
      connectorOtaColOrg: 'Уюм',
      connectorOtaColVersion: 'Версия',
      connectorOtaColHost: 'Хост',
      connectorOtaColStatus: 'Статус',
      connectorOtaColSyncs: 'Синхр.',
      connectorOtaColErrors: 'Каталар',
      connectorOtaColLastHeartbeat: 'Акыркы heartbeat',
      connectorOtaStatusOnline: 'Онлайн',
      connectorOtaStatusOffline: 'Оффлайн',
      connectorOtaStatusUpdating: 'Жаңыланууда',
      connectorOtaStatusError: 'Ката',
      connectorOtaColVersionName: 'Версия',
      connectorOtaColReleaseNotes: 'Жаңылыктар',
      connectorOtaColSize: 'Өлчөмү',
      connectorOtaColCritical: 'Маанилүү',
      connectorOtaColInstallCount: 'Орнотуулар',
      connectorOtaColCreated: 'Датасы',
      connectorOtaCritical: 'Маанилүү',
      connectorOtaPublishVersion: 'Версия жарыялоо',
      connectorOtaPublishNewVersion: 'Жаңы версия жарыялоо',
      connectorOtaVersionNumber: 'Версия номери',
      connectorOtaReleaseNotes: 'Өзгөрүүлөр',
      connectorOtaR2Key: 'R2 файл ачкычы',
      connectorOtaR2KeyHelp: 'R2 сактагычтагы ZIP жолу',
      connectorOtaMarkCritical: 'Маанилүү жаңылоо (мажбурлоо менен орнотуу)',
      connectorOtaPublish: 'Жарыялоо',
      connectorOtaVersionPublished: 'Версия жарыяланды',
      connectorOtaNav: 'Коннектор орнотуулары',

      // MoySklad Integration
      moySkladConnectionSettings: 'МойСклад туташуу орнотуулары',
      moySkladInfo: 'МойСклад менен JSON API 1.2 аркылуу интеграция',
      apiToken: 'API Токен',
      enterMoySkladToken: 'МойСклад токенин киргизиңиз',
      moySkladTokenHelperText: 'МойСкладдан алыңыз: Орнотуулар → Колдонуучулар жана укуктар → Кирүү токендери',
      optional: 'милд. эмес',
      orgIdHelper: 'Автоматтык аныктоо үчүн бош калтырыңыз',
      storeIdHelper: 'Демейки кампа үчүн бош калтырыңыз',
      useVariants: 'Модификацияларды колдонуу',
      settingsMoySkladSaved: 'МойСклад орнотуулары сакталды',
      cannotConnectMoySklad: 'МойСкладга туташуу мүмкүн болбоду',

      // Sync entities
      syncProducts: 'Товарлар',
      syncPrices: 'Баалар',
      syncStock: 'Калдыктар',
      syncOrders: 'Заказдар',
      syncCategories: 'Категориялар',
      syncImages: 'Сүрөттөр',

      // Integration Logs
      logsHeading: 'Синхрондоштуруу журналы',
      manualSync: 'Кол менен синхрондоштуруу',
      importProducts: 'Товар импорту',
      importPrices: 'Баа импорту',
      importStock: 'Калдык импорту',
      importCategories: 'Категория импорту',
      exportOrders: 'Заказ экспорту',
      exportCustomers: 'Кардар экспорту',
      importImages: 'Сүрөт импорту',
      exportProducts: 'Товар экспорту',
      logStatusSuccess: 'Ийгилик',
      logStatusError: 'Ката',
      logStatusPending: 'Күтүүдө',
      logEntityProducts: 'Товарлар',
      logEntityOrders: 'Заказдар',
      logEntityPrices: 'Баалар',
      logEntityStock: 'Калдыктар',
      logEntityCategories: 'Категориялар',
      logEntityCustomers: 'Кардарлар',
      logEntityImages: 'Сүрөттөр',
      logEntityAll: 'Баары',
      logDate: 'Күнү',
      logEntity: 'Объект',
      logDirection: 'Багыт',
      logRecords: 'Жазуулар',
      logErrors: 'Каталар',
      logDuration: 'Убакыт',
      logStatus: 'Статус',
      noLogs: 'Журналда жазуулар жок',
      import: 'Импорт',
      export: 'Экспорт',
      rowsPerPage: 'Бетте саптар:',
      logDetailsTitle: 'Синхрондоштуруу чоо-жайы',
      logCloseAria: 'Жабуу',
      logDetailStatus: 'Статус:',
      logDetailEntity: 'Объект:',
      logDetailDirection: 'Багыт:',
      logDetailStatistics: 'Статистика',
      logDetailProcessed: 'Иштелди:',
      logDetailErrors: 'Каталар:',
      logDetailTime: 'Убакыт',
      logDetailStarted: 'Башталды:',
      logDetailCompleted: 'Аяктады:',
      logDetailErrorMessage: 'Ката билдирүүсү:',
      logDetailErrorDetails: 'Ката чоо-жайы:',
      retrySync: 'Кайра синхрондоштуруу',
      importFromExternal: 'Импорт —',
      exportToExternal: 'Экспорт —',

      // Webhooks
      webhooksTitle: 'Вебхуктар',
      webhooksSubtitle: 'Окуя билдирүүлөрү үчүн вебхуктарды башкаруу',
      payload: 'Суроо маалыматы',
      response: 'Жооб',
      noResponse: 'Жооб жок',
      secretKey: 'Жашыруун ачкыч',
      addWebhook: 'Вебхук кошуу',
      totalWebhooks: 'Бардыгы',
      activeWebhooks: 'Активдүү',
      successRate: 'Ийгиликтүүлүк',
      totalDeliveries: 'Жеткирүүлөр',
      tabWebhooks: 'Вебхуктар',
      tabLogs: 'Жеткирүү журналы',
      webhookName: 'Аталышы',
      webhookUrl: 'URL',
      webhookEvents: 'Окуялар',
      webhookStatus: 'Статус',
      webhookActions: 'Аракеттер',
      noWebhooks: 'Вебхуктар жок',
      testWebhookTooltip: 'Тестирлөө',
      testWebhookAria: 'Вебхукту тестирлөө',
      webhookLogsTooltip: 'Журнал',
      webhookLogsAria: 'Вебхук журналы',
      editWebhookTooltip: 'Түзөтүү',
      editWebhookAria: 'Вебхукту түзөтүү',
      deleteWebhookTooltip: 'Өчүрүү',
      deleteWebhookAria: 'Вебхукту өчүрүү',
      webhookStatusSuccess: 'Ийгилик',
      webhookStatusError: 'Ката',
      webhookStatusPending: 'Күтүүдө',
      webhookSaved: 'Вебхук сакталды',
      webhookCreated: 'Вебхук түзүлдү',
      webhookSaveError: 'Вебхук сактоо катасы',
      webhookDeleted: 'Вебхук өчүрүлдү',
      webhookDeleteError: 'Вебхук өчүрүү катасы',
      webhookTestSent: 'Тест сурамы жөнөтүлдү',
      webhookTestError: 'Тест сурамын жөнөтүү катасы',
      secretCopied: 'Сырсөз көчүрүлдү',
      secretCopyError: 'Көчүрүү катасы',
      webhookEnabled: 'Вебхук активдештирилди',
      webhookDisabled: 'Вебхук өчүрүлдү',
      webhookToggleError: 'Статус өзгөртүү катасы',
      confirmDeleteWebhook: '"{name}" вебхукту өчүрүү?',

      // Webhook logs tab
      logsRefresh: 'Жаңыртуу',
      logDeliveryDate: 'Күнү',
      logDeliveryWebhook: 'Вебхук',
      logDeliveryEvent: 'Окуя',
      logDeliveryStatus: 'Статус',
      logDeliveryCode: 'Код',
      logDeliveryTime: 'Жооп убактысы',
      logDeliveryAttempt: 'Аракет',
      logDeliveryActions: 'Аракеттер',
      noDeliveryLogs: 'Жеткирүү жазуулары жок',
      expandDetailsAria: 'Чоо-жайын ачуу',
      retryDeliveryTooltip: 'Кайталоо',
      retryDeliveryAria: 'Жеткирүүнү кайталоо',
      deliveryRowsPerPage: 'Бетте саптар:',

      // Webhook create/edit dialog
      createWebhook: 'Вебхук түзүү',
      editWebhookTitle: 'Вебхукту түзөтүү',
      webhookNameLabel: 'Вебхук аталышы',
      webhookUrlLabel: 'Жөнөтүү URL',
      webhookEventsLabel: 'Окуялар',
      selectEventsHelper: 'Билдирүүлөрдү жөнөтүү үчүн окуяларды тандаңыз',
      webhookSecret: 'Купуя ачкыч',
      copySecretAria: 'Купуя сөздү көчүрүү',
      generateSecret: 'Генерациялоо',
      retryCount: 'Аракеттер саны',
      timeout: 'Таймаут (сек)',
      webhookActiveSwitch: 'Активдүү',

      // Webhook event categories & events
      eventCategoryOrders: 'Заказдар',
      eventOrderCreated: 'Түзүлдү',
      eventOrderUpdated: 'Жаңыртылды',
      eventOrderStatusChanged: 'Статус өзгөрдү',
      eventOrderCancelled: 'Жокко чыгарылды',
      eventCategoryProducts: 'Товарлар',
      eventProductCreated: 'Түзүлдү',
      eventProductUpdated: 'Жаңыртылды',
      eventProductDeleted: 'Өчүрүлдү',
      eventProductStockChanged: 'Калдык өзгөрдү',
      eventCategoryCustomers: 'Кардарлар',
      eventCustomerCreated: 'Түзүлдү',
      eventCustomerUpdated: 'Жаңыртылды',
      eventCategoryPayments: 'Төлөмдөр',
      eventPaymentReceived: 'Алынды',
      eventPaymentRefunded: 'Кайтарылды',
      eventCategoryIntegrations: 'Интеграциялар',
      eventSyncCompleted: 'Синхрондоштуруу аяктады',
      eventSyncFailed: 'Синхрондоштуруу катасы',
      eventCategoryInventory: 'Кампа',
      eventStockLow: 'Аз калдык',
      eventStockOut: 'Жок',
      eventStockUpdated: 'Калдык жаңыртылды',
      eventCategorySystem: 'Система',
      eventWebhookTest: 'Тест окуясы',
      eventSystemError: 'Система катасы',
      eventMaintenanceScheduled: 'Пландалган тейлөө',
      eventRateLimitExceeded: 'Сурам лимити ашты',

      // Webhook delete dialog
      deleteWebhookTitle: 'Вебхукту өчүрүү',
      deleteWebhookContent: '"{name}" вебхукту өчүрүүнү каалайсызбы? Бул аракетти кайтаруу мүмкүн эмес.',
      webhookLogsDialogClose: 'Жабуу',
      webhookNameHelper: 'Мисалы: CRM Notification, Accounting Sync',
      webhookSecretHelper: 'Суроолорду кол коюу үчүн (HMAC-SHA256)',
      urlPostHelper: 'POST суроолорду жөнөтүү URL',
      logsFor: 'Журнал: {{name}}',
      requestFormatLabel: 'Суроо форматы:',
      requestFormatValue: 'JSON денеси менен POST',
      headersLabel: 'Баштыктар:',
      ifSecretSet: 'secret коюлган болсо',
      loadProductsError: 'Товарларды жүктөө мүмкүн болбоду',

      // Integration Products Page
      backToIntegrations: 'Интеграцияларга кайтуу',
      products: 'Товарлар',
      deleteAll: 'Баарын өчүрүү',
      productsInMoySklad: 'МойСкладдагы товарлар',
      synced: 'Синхрондолгон',
      searchBySkuNameExternalId: 'SKU, аталышы же external ID боюнча издөө...',
      productName: 'Аталышы',
      price: 'Баасы',
      stock: 'Калдык',
      source: 'Булак',
      updated: 'Жаңыртылган',
      productsNotFound: 'Товарлар табылган жок',
      noSyncedProducts: 'Синхрондолгон товарлар жок',
      clickSyncToLoad: 'Товарларды жүктөө үчүн "Синхрондоштуруу" басыңыз',
      externalSystem: 'тышкы системадан',
      syncProductsFrom: 'Товарларды синхрондоштуруу —',
      syncTokenInfo: 'Синхрондоштуруу үчүн API токен керек. Токен серверде САКТАЛБАЙТ жана учурдагы сурам үчүн гана колдонулат.',
      enterTokenForApi: 'API кирүү үчүн токен киргизиңиз',
      enterApiToken: 'API токен киргизиңиз',
      syncCompleted: 'Синхрондоштуруу аяктады!',
      syncResults: 'Синхрондоштуруу натыйжалары',
      totalProcessed: 'Бардыгы иштелди',
      importedNew: 'Жаңылар импорттолду',
      updatedExisting: 'Бар болгондор жаңыртылды',
      skipped: 'Өткөрүлдү',
      errorsCount: 'Каталар',
      performance: 'Өндүрүмдүүлүк',
      totalTime: 'Жалпы убакыт',
      speed: 'Ылдамдык',
      productsPerSec: 'товар/сек',
      avgTimePerProduct: 'Товарга орточо убакыт',
      executionPhases: 'Аткаруу этаптары',
      phaseDataLoading: 'Маалымат жүктөлүүдө',
      phaseProductProcessing: 'Товар иштетүү',
      phaseFinalization: 'Аяктоо',
      network: 'Тармак',
      apiRequests: 'API сурамдары',
      dataReceived: 'Алынган маалыматтар',
      apiResponseTime: 'API жооп убактысы',
      syncing: 'Синхрондоштуруу...',
      startSync: 'Синхрондоштурууну баштоо',
      deleteAllProducts: 'Бардык товарларды өчүрүү?',
      deleteAllWarning: 'Бул аракет бул интеграциядагы бардык {count} товарды өчүрөт жана кайтарылбайт!',
      confirmDeleteAllProducts: '"{namespace}" интеграциясынан бардык товарларды өчүрүүнү каалайсызбы?',
      deleting: 'Өчүрүлүүдө...',
      deleted: 'Өчүрүлдү',

      // External Products Preview
      productsFrom: 'Товарлар —',
      fetched: 'Жүктөлдү',
      syncedStat: 'Синхрондолду',
      notSynced: 'Синхрондолгон эмес',
      withPhotos: 'Сүрөттүү',
      searchByNameOrSku: 'Аталышы же SKU боюнча издөө...',
      selectAllOnPage: 'Беттеги баарын тандоо',
      selectAll: 'Баарын тандоо',
      deselectAll: 'Баарын алып салуу',
      selectOnlyNotSynced: 'Синхрондолбогондорду гана тандоо',
      notSyncedShort: 'Синхр. жок',
      notSyncedFull: 'Синхрондолбогондор',
      clearSelection: 'Тандоону алып салуу',
      deselect: 'Алып салуу',
      syncShort: 'Синхр.',
      syncSelected: 'Тандалгандарды синхрондоштуруу',
      syncAllShort: 'Баарын синхр.',
      syncAll: 'Баарын синхрондоштуруу',
      doNotClosePage: 'Сураныч, бетти жаппаңыз',
      processed: 'Иштелди',
      imported: 'Импорттолду',
      updatedStat: 'Жаңыртылды',
      currentProduct: 'Учурдагы товар',
      elapsedTime: 'Өткөн убакыт',
      remaining: 'Калды',
      selectAllProducts: 'Бардык товарларды тандоо',
      selectProduct: 'Тандоо',
      photo: 'Сүрөт',
      photosCount: 'сүрөт',
      noPhoto: 'Сүрөт жок',
      syncedStatus: 'Синхрондолгон',
      notSyncedStatus: 'Синхрондолгон эмес',
      noProductsToDisplay: 'Көрсөтүлүүчү товарлар жок',
      selectProductsForSync: 'Синхрондоштуруу үчүн товарларды тандаңыз',
      syncingProducts: '{count} товар синхрондолууда...',
      sec: 'сек',
      min: 'мин',
      calculating: 'эсептөө...',
      loadingDataFromMoySklad: 'МойСкладдан маалымат жүктөлүүдө...',
      completed: 'Аяктады',
      successCount: 'Ийгиликтүү',
      syncError: 'Синхрондоштуруу катасы',
      startingFullSync: 'Толук синхрондоштуруу башталууда...',
      connectingToMoySklad: 'МойСкладга туташуу...',
      loadingProductList: 'Товар тизмеси жүктөлүүдө...',
      fetchingDataFromApi: 'API-ден маалымат алынууда',
      finishingSync: 'Синхрондоштуруу аякталууда...',
      fullSyncCompleted: 'Толук синхрондоштуруу аяктады!',
      requested: 'Суралды',
      successful: 'Ийгиликтүү',
      errors: 'Каталар',
      andMore: 'жана дагы',
      executionTime: 'Аткаруу убактысы',
      secDot: 'сек.',
    },

    // Super Admin
    superAdmin: {
      revenueLoadError: 'Кирешелер боюнча маалыматтарды жүктөөдө ката',
      platformStatus: 'Платформа статусу',
      platformStable: 'Туруктуу иштейт',
      platformAttention: 'Көңүл буруу керек',
      apiRequests24h: 'API суроолор 24с',
      activeOrganizations: 'Активдүү уюмдар',
      activity: {
        justNow: 'жаңы эле',
        minutesAgo: '{{count}} мүн мурун',
        hoursAgo: '{{count}} с мурун',
        daysAgo: '{{count}} күн мурун',
        system: 'Система',
      },
      revenueByOrgs: 'Уюмдар боюнча кирешелер',
      period: 'Мезгил',
      days7: '7 күн',
      days30: '30 күн',
      days90: '90 күн',
      year1: '1 жыл',
      totalGMV: 'Мезгил үчүн жалпы GMV',
      orgsWithSales: 'Сатуу менен уюмдар',
      revenue: 'Киреше',
      ofTotal: 'жалпыдан',
      ordersCount: 'Заказдар',
      usersCount: 'Колдонуучулар',
      productsCount: 'Товарлар',
      noRevenueData: 'Тандалган мезгил үчүн маалымат жок',
      orgsLoadError: 'Уюмдарды жүктөөдө ката',
      organization: 'Уюм',
      plan: 'План',
      status: 'Статус',
      users: 'Колдонуучулар',
      products: 'Товарлар',
      orders: 'Заказдар',
      revenue30d: 'Киреше (30к)',
      owner: 'Ээси',
      actions: 'Аракеттер',
      ordersWord: 'заказ',
      view: 'Көрүү',
      features: 'Функциялар',
      rowsPerPage: 'Бир беттеги саптар:',
      of: 'ичинен',
      moreThan: 'көбүрөөк',
      featureManagement: 'Функцияларды башкаруу',
      featureFlagsSubtitle: 'Платформанын уюмдары үчүн Feature Flags',
      newFeature: 'Жаңы функция',
      allFeatures: 'Бардык функциялар',
      byOrgs: 'Уюмдар боюнча',
      searchFeatures: 'Функцияларды издөө...',
      category: 'Категория',
      allCategories: 'Бардык категориялар',
      found: 'Табылды',
      functionsWord: 'функция',
      noDescription: 'Сүрөттөмө жок',
      flagType_boolean: 'Күйгүзүү/Өчүрүү',
      flagType_plan_based: 'План боюнча',
      flagType_percentage: 'Пайыз',
      flagType_whitelist: 'Ак тизме',
      defaultOn: 'Демейки күйгүзүлгөн',
      defaultOff: 'Демейки өчүрүлгөн',
      selectOrg: 'Уюмду тандаңыз',
      startTyping: 'Атын жаза баштаңыз...',
      selectOrgForFeatures: 'Функцияларды настройкалоо үчүн уюмду тандаңыз',
      unsavedChanges: 'Сакталбаган өзгөрүүлөр бар',
      saving: 'Сакталууда...',
      changed: 'Өзгөртүлдү',
      createNewFeature: 'Жаңы функция түзүү',
      keyField: 'Ачкыч (key)',
      keyFieldHelper: 'Латын тамгалары, сандар, астын сызыктар гана',
      nameField: 'Аталышы',
      descriptionField: 'Сүрөттөмө',
      type: 'Түрү',
      minPlan: 'Мин. план',
      notSpecified: 'Көрсөтүлгөн эмес',
      defaultEnabled: 'Демейки боюнча күйгүзүлгөн',
      betaFeature: 'Beta функция',
      creating: 'Түзүлүүдө...',
      create: 'Түзүү',
      editFeature: 'Түзөтүү',
      defaultOnShort: 'Демейки күйгүзүлгөн',
      beta: 'Beta',
      deprecated: 'Эскирген',
      deleteFeatureConfirm: 'Функцияны жок кылуу',
      // SuperAdmin Dashboard
      platformLoadError: 'Платформа маалыматтарын жүктөөдө ката: {{message}}',
      dashboardTitle: 'Платформаны башкаруу панели',
      dashboardSubtitle: 'Уюмдарды, кирешелерди жана платформа функцияларын контролдоо',
      thisMonth: 'бул айда',
      organizationsActive: 'Уюмдар ({{count}} активдүү)',
      usersLabel: 'Колдонуучулар',
      activeLastWeek: 'Жума боюнча активдүү',
      adminsCount: 'Админдер',
      mrrLabel: 'MRR (айлык киреше)',
      growthLabel: 'Өсүш',
      arrLabel: 'ARR',
      gmv30d: '30 күнгө GMV',
      ordersLabel: 'Заказдар',
      avgOrder: 'Орточо чек',
      tabOrganizations: 'Уюмдар',
      tabRevenue: 'Кирешелер',
      tabActivity: 'Активдүүлүк',
      syncLogsLoadError: 'Синхрондоштуруу логдорун жүктөөдө ката',
      onecRecreateFailed: '1С маалымат базасын кайра түзүүдө ката',
      onecSuspendFailed: '1С маалымат базасын токтотууда ката',
      onecDeleteFailed: '1С маалымат базасын өчүрүүдө ката',
      onecForceSyncFailed: 'Мажбурлап синхрондоштурууда ката',
      featureCreateFailed: 'Флаг түзүүдө ката',
      featureUpdateFailed: 'Флаг жаңыртууда ката',
      featureDeleteFailed: 'Флаг өчүрүүдө ката',
      orgFeaturesUpdateFailed: 'Уюштуруу функцияларын жаңыртууда ката',
      activity: {
        loadError: 'Активдүүлүктү жүктөө катасы',
        title: 'Платформадагы акыркы активдүүлүк',
        noActivity: 'Көрсөтүүгө активдүүлүк жок',
      },
    },

    customization: {
      title: 'Ыңгайлаштыруу',
      subtitle: 'Уюмуңуздун модулдарын, талааларын жана интерфейсин настройкалоо',
      tabModules: 'Модулдар',
      tabCustomFields: 'Кастом талаалар',
      tabPermissions: 'Укуктар',
      tabInterface: 'Интерфейс',
      tabIntegrations: 'Интеграциялар',
      availableModules: 'Жеткиликтүү модулдар',
      modulesDescription: 'Уюмуңуз үчүн модулдарды күйгүзүңүз же өчүрүңүз. Модулдардын жеткиликтүүлүгү жазылуу планыңызга жараша.',
      moduleInventory: 'Кампа',
      moduleInventoryDesc: 'Кампа, калдыктар жана партияларды башкаруу',
      moduleCRM: 'CRM',
      moduleCRMDesc: 'Кардарларды, бүтүмдөрдү жана сатуу воронкасын башкаруу',
      moduleAnalytics: 'Аналитика',
      moduleAnalyticsDesc: 'Кеңейтилген отчеттор жана дашборддор',
      moduleAccounting: 'Бухгалтерия',
      moduleAccountingDesc: 'Эсеп-фактуралар, актылар, салык отчеттуулугу',
      moduleEnabled: 'Модул күйгүзүлдү',
      moduleDisabled: 'Модул өчүрүлдү',
      moduleToggleError: 'Модулду өзгөртүүдө ката',
      customFields: 'Кастом талаалар',
      customFieldsDesc: 'Товарлар, заказдар, колдонуучулар жана кардарлар үчүн кошумча талааларды кошуңуз.',
      addField: 'Талаа кошуу',
      entityType: 'Объект түрү',
      entityProducts: 'Товарлар',
      entityOrders: 'Заказдар',
      entityUsers: 'Колдонуучулар',
      entityCustomers: 'Кардарлар',
      noCustomFields: 'Кастом талаалар жок',
      addFirstField: 'Биринчи талааны кошуңуз',
      fieldKey: 'Ачкыч',
      fieldName: 'Аталышы',
      fieldType: 'Түрү',
      fieldGroup: 'Группа',
      fieldRequired: 'Милдеттүү',
      fieldInForm: 'Формада',
      fieldInTable: 'Таблицада',
      editField: 'Талааны түзөтүү',
      newFieldFor: 'Жаңы талаа',
      fieldKeyLabel: 'Талаа ачкычы (латын)',
      fieldKeyHelper: 'Мисалы: fabric_type, designer_name',
      fieldNameRu: 'Аталышы (RU)',
      fieldNameEn: 'Аталышы (EN)',
      fieldDescription: 'Сүрөттөмө',
      fieldTypeLabel: 'Талаа түрү',
      fieldTypeText: 'Текст',
      fieldTypeTextarea: 'Көп саптуу текст',
      fieldTypeNumber: 'Сан (бүтүн)',
      fieldTypeDecimal: 'Сан (ондук)',
      fieldTypeSelect: 'Тизме',
      fieldTypeMultiselect: 'Көп тандоо',
      fieldTypeCheckbox: 'Чекбокс',
      fieldTypeDate: 'Дата',
      fieldTypeDatetime: 'Дата жана убакыт',
      fieldTypeEmail: 'Email',
      fieldTypePhone: 'Телефон',
      fieldTypeUrl: 'URL',
      fieldTypeColor: 'Түс',
      optionsLabel: 'Варианттар (үтүр менен бөлүнгөн)',
      optionsHelper: 'Пахта, Зыгыр, Жибек, Синтетика',
      minValue: 'Мин. маани',
      maxValue: 'Макс. маани',
      minLength: 'Мин. узундук',
      maxLength: 'Макс. узундук',
      defaultValue: 'Демейки маани',
      fieldGroupLabel: 'Группа (талааларды топтоо үчүн)',
      fieldGroupHelper: 'Мисалы: dimensions, materials, specifications',
      display: 'Көрсөтүү',
      required: 'Милдеттүү',
      inForm: 'Формада',
      inTable: 'Таблицада',
      inCatalog: 'Каталогдо',
      entityForProducts: 'товарлар',
      entityForOrders: 'заказдар',
      entityForUsers: 'колдонуучулар',
      entityForCustomers: 'кардарлар',
      fieldUpdated: 'Талаа жаңыртылды',
      fieldAdded: 'Талаа кошулду',
      fieldSaveError: 'Талааны сактоодо ката',
      deleteFieldConfirm: 'Бул талааны жок кылабызбы? Бардык маанилер жоголот.',
      fieldDeleted: 'Талаа жок кылынды',
      fieldDeleteError: 'Талааны жок кылууда ката',
      adminPermissions: 'Админ укуктары',
      exportData: 'Маалыматтарды экспорттоо',
      apiAccess: 'API жетүү',
      manageIntegrations: 'Интεграцияларды башкаруу',
      userPermissions: 'Колдонуучу укуктары',
      seeB2BPrices: 'B2B бааларды көрүү',
      bulkOrders: 'Көтөрө заказдар',
      permissionsTitle: 'Укуктар жана уруксаттар',
      permissionsDesc: 'Уюмуңуз үчүн кошумча укуктарды настройкалаңыз.',
      uiTitle: 'Интерфейс тууралоолору',
      uiDesc: 'Дүкөнүңүздүн сырткы көрүнүшүн настройкалаңыз.',
      uiBusinessPlan: 'Кеңейтилген интерфейс тууралоолору Business планда жана андан жогору жеткиликтүү.',
      uiBasicSettings: 'Негизги тууралоолор',
      uiInDevelopment: 'Функционал иштелип жатат. Башкы бет, навигация жана каталог тууралоолору жакында пайда болот.',
      integrationsTitle: 'Интеграциялар',
      integrationsDesc: 'Платформанын мүмкүнчүлүктөрүн кеңейтүү үчүн тышкы сервистерди туташтырыңыз.',
      syncProductsOrders: 'Товарлар жана заказдарды синхрондоштуруу',
      onlinePayments: 'Онлайн төлөмдөрдү кабыл алуу',
      emailNotifications: 'Email жөнөтүүлөр жана билдирмелер',
      smsNotifications: 'SMS билдирмелер',
      available: 'Жеткиликтүү',
      comingSoon: 'Жакында',
      configure: 'Настройкалоо',
    },

    orgSettings: {
      title: 'Уюм тууралоолору',
      managementOf: 'Башкаруу',
      tabBasic: 'Негизги',
      tabBranding: 'Брендинг',
      tabDomain: 'Домен',
      tabSubscription: 'Жазылуу',
      basicInfo: 'Негизги маалымат',
      orgName: 'Уюмдун аталышы',
      description: 'Сүрөттөмө',
      subdomain: 'Поддомен',
      subdomainHelp: 'Поддомен түзүлгөндөн кийин өзгөртүүгө болбойт',
      orgId: 'Уюм идентификатору',
      copy: 'Көчүрүү',
      created: 'Түзүлгөн',
      unknown: 'Белгисиз',
      saveChanges: 'Өзгөрүүлөрдү сактоо',
      brandingTitle: 'Брендинг жана дизайн',
      logoUrl: 'Логотип URL',
      logoPreview: 'Логотипти алдын ала көрүү',
      primaryColor: 'Негизги түс',
      secondaryColor: 'Кошумча түс',
      font: 'Шрифт',
      fontHelper: 'Мисалы: Inter, Roboto, Open Sans',
      preview: 'Алдын ала көрүү',
      orgNameOrPlaceholder: 'Уюмдун аталышы',
      primaryButton: 'Негизги баскыч',
      secondaryButton: 'Кошумча баскыч',
      saveBranding: 'Брендингди сактоо',
      domainSettings: 'Домен тууралоолору',
      domainDefaultInfo: 'Демейки боюнча уюмуңуз бул даректе жеткиликтүү:',
      customDomain: 'Өздүк домен',
      domainHelp: 'Домениңизди https:// жана www жок көрсөтүңүз',
      domainVerified: 'Домен ырасталды',
      domainPending: 'Ырастоо күтүлүүдө',
      saveDomain: 'Доменди сактоо',
      setupGuide: 'Настройка нускамасы',
      currentPlan: 'Учурдагы план',
      planFree: 'Акысыз',
      planStarter: 'Стартер',
      planBusiness: 'Бизнес',
      planEnterprise: 'Корпоративдик',
      betaLabel: 'БЕТА',
      active: 'Активдүү',
      inactive: 'Активдүү эмес',
      usageLimits: 'Лимиттерди колдонуу',
      usersLabel: 'Колдонуучулар',
      productsLabel: 'Товарлар',
      ordersLabel: 'Заказдар',
      upgradePlan: 'Планды жакшыртуу',
      upgradeDesc: 'Жогорку планга өтүп дүкөнүңүздүн мүмкүнчүлүктөрүн кеңейтиңиз.',
      contactSales: 'Сатуу бөлүмүнө байланышуу',
      individualOffer: 'Жеке сунуш алуу үчүн бизге байланышыңыз.',
      domainSetupTitle: 'Өздүк доменди настройкалоо',
      domainCnameInfo: 'Өздүк доменди колдонуу үчүн, домениңиздин DNS\'ине төмөнкү CNAME жазууну кошуңуз:',
      dnsPropagation: 'DNS өзгөрүүлөрү толук жайылуу үчүн 24 саатка чейин убакыт талап кылышы мүмкүн.',
      dnsType: 'Түрү',
      dnsName: 'Аты',
      dnsValue: 'Мааниси',
      close: 'Жабуу',
      loadError: 'Уюмду жүктөөдө ката',
      notFound: 'Уюм табылган жок',
      settingsSaved: 'Тууралоолор ийгиликтүү сакталды',
      saveError: 'Сактоо катасы',
      domainSaved: 'Домен сакталды. Активдештирүү үчүн ырастоо керек.',
      domainSaveError: 'Доменди сактоодо ката',
    },

    advAnalytics: {
      title: 'Кеңейтилген аналитика',
      subtitle: 'Бизнес көрсөткүчтөрүн комплекстүү талдоо',
      period: 'Мезгил',
      days7: '7 күн',
      days30: '30 күн',
      days90: '90 күн',
      year1: '1 жыл',
      tabOverview: 'Обзор',
      tabSales: 'Сатуулар',
      tabInventory: 'Запастар',
      tabOperations: 'Операциялар',
      tabCustomers: 'Кардарлар',
      loadError: 'Маалыматтарды жүктөөдө ката',
      vsPrevPeriod: 'мурунку мезгилге салыштырмалуу',
      totalRevenue: 'Жалпы киреше',
      ordersCount: 'Заказдар',
      customersCount: 'Кардарлар',
      avgCheck: 'Орточо чек',
      stockStatus: 'Запас статусу',
      stockHealthy: 'Нормалдуу',
      stockLow: 'Төмөн',
      stockCritical: 'Критикалык',
      orderFulfillment: 'Заказдарды аткаруу',
      fulfilled: 'Аткарылды',
      inProgress: 'Иштелүүдө',
      pending: 'Күтүүдө',
      quality: 'Сапат',
      inspected: 'Текшерилди',
      onInspection: 'Текшерүүдө',
      rejected: 'Четке кагылды',
      topProducts: 'Мыкты товарлар',
      product: 'Товар',
      sold: 'Сатылды',
      revenueCol: 'Киреше',
      recentOrders: 'Акыркы заказдар',
      revenueTitle: 'Киреше',
      ordersTitle: 'Заказдардын саны',
      avgCheckTitle: 'Орточо чек',
      conversion: 'Конверсия',
      salesByCategory: 'Категориялар боюнча сатуулар',
      topProductsTitle: 'Мыкты товарлар',
      qty: 'Саны',
      totalProducts: 'Жалпы товарлар',
      totalValue: 'Жалпы наркы',
      lowStock: 'Аз запас',
      ofAllProducts: 'бардык товарлардан',
      outOfStock: 'Жок',
      stockHealth: 'Запастын абалы',
      normal: 'Нормалдуу',
      lowLevel: 'Төмөн',
      critical: 'Критикалык',
      attentionProducts: 'Көңүл буруу керек товарлар',
      sku: 'Артикул',
      name: 'Аталышы',
      balance: 'Калдык',
      threshold: 'Мин. босого',
      statusCol: 'Статус',
      statusNone: 'Жок',
      statusLow: 'Аз',
      categoryDistribution: 'Категориялар боюнча бөлүштүрүү',
      productsWord: 'товар',
      turnover: 'Товарлардын айлануусу',
      turnoverPerMonth: 'Айланма/ай',
      daysToZero: 'Күн 0гө чейин',
      ordersFulfillment: 'Заказдарды аткаруу',
      avgFulfillmentTime: 'Орт. аткаруу убактысы',
      onTimeDelivery: 'Убагында жеткирилген',
      returns: 'Кайтаруулар',
      cancelled: 'Жокко чыгарылган',
      production: 'Өндүрүш',
      activeOrders: 'Активдүү заказдар',
      completed: 'Аяктаган',
      efficiency: 'Натыйжалуулук',
      defects: 'Кемчиликтер',
      qualityControl: 'Сапат контролу',
      inspections: 'Текшерүүлөр',
      passed: 'Өткөн',
      onHold: 'Кармалган',
      criticalDefects: 'Критикалык кемчиликтер',
      daysShort: 'күн',
      totalCustomers: 'Жалпы кардарлар',
      newForPeriod: 'Мезгил үчүн жаңы',
      avgLTV: 'Орт. LTV',
      repeat: 'Кайталанган',
      customerSegments: 'Кардар сегменттери',
      customersWord: 'кардар',
      topCustomers: 'Мыкты кардарлар',
      client: 'Кардар',
      ordersCol: 'Заказдар',
      amount: 'Сумма',
    },

    components: {
      matSelectTitle: 'Базадан материалдарды тандоо',
      matDbEmpty: 'Материалдар базасы бош. "Чийки зат базасы" бөлүмүнө материалдарды кошуңуз.',
      searchByNameOrCode: 'Аталышы же коду боюнча издөө...',
      categoryLabel: 'Категория',
      allCategories: 'Бардык категориялар',
      catSheets: 'Барактык материалдар',
      catEdge: 'Четтик материалдар',
      catFasteners: 'Бекиткичтер',
      catFittings: 'Фурнитура',
      catPaint: 'Лак-боёк',
      catFabric: 'Кездемелер',
      catGlass: 'Айнек жана күзгүлөр',
      catElectric: 'Электрика',
      catOther: 'Башка',
      selectedCount: 'Тандалган материалдар',
      colCode: 'Код',
      colName: 'Аталышы',
      colCategory: 'Категория',
      colUnit: 'Бирдик',
      colPrice: 'Баа',
      colSupplier: 'Жеткирүүчү',
      colStock: 'Калдык',
      colInfo: 'Инфо',
      stockLow: 'Аз',
      stockAvailable: 'Бар',
      nothingFound: 'Эч нерсе табылган жок',
      noAvailableMaterials: 'Жеткиликтүү материалдар жок',
      tip: 'Кеңеш:',
      tipText: 'Тандоо үчүн материалга басыңыз. Санын техкартага кошкондон кийин көрсөтө аласыз.',
      addSelected: 'Тандалгандарды кошуу',
      updatedAt: 'Жаңыртылган',
      materialInfo: 'Материал жөнүндө маалымат',
      purchasePrice: 'Сатып алуу',
      costCalcTitle: 'Өздүк нарк эсептөө',
      productLabel: 'Товар',
      historyEntries: 'тарыхтагы жазуулар',
      calcHistory: 'Эсептөө тарыхы',
      editMode: 'Түзөтүү режими',
      saveProductFirst: 'Өздүк наркты сактоо үчүн алгач товарды сактаңыз.',
      apiConnected: 'API менен туташкан',
      lastCalc: 'Акыркы эсептөө',
      costPrice: 'Өздүк нарк',
      loadTechCard: 'Техникалык картаны жүктөө',
      uploadExcel: 'Excel жүктөө',
      uploading: 'Жүктөлүүдө...',
      downloadTemplate: 'Шаблонду жүктөп алуу',
      useExcelPrices: 'Excel\'деги бааларды колдонуу',
      autoCreateInDb: 'Базада авто-түзүү',
      autoCreateEnabled: 'Авто-түзүү күйгүзүлгөн',
      autoCreateDesc: 'Excel\'ден жаңы материалдар автоматтык түрдө базага кошулат',
      excelFormat: 'Excel форматы: "Материалдар" барагы (Аталышы, Бирдик, Саны, Баа, Жеткирүүчү) жана "Иштер" барагы (Аталышы, Сааттар, Ставка)',
      materials: 'Материалдар',
      fromDatabase: 'Базадан',
      checkPrices: 'Бааларды текшерүү',
      addManually: 'Кол менен кошуу',
      outdatedPricesWarning: 'Эскирген бааларга ээ материалдар табылды',
      updatePrices: 'Бааларды жаңыртуу',
      colSku: 'Артикул',
      colNameMat: 'Аталышы',
      colUnitMat: 'Бирдик',
      colQty: 'Саны',
      colCoef: 'Коэф.',
      colPricePerUnit: 'Бирдик баа',
      colTotal: 'Сумма',
      colSupplierMat: 'Жеткирүүчү',
      colActions: 'Аракеттер',
      noMaterials: 'Материалдар жок. Excel\'ден жүктөңүз же кол менен кошуңуз.',
      totalMaterials: 'Бардык материалдар:',
      works: 'Иштер',
      addWork: 'Иш кошуу',
      colWorkName: 'Иштин аталышы',
      colHours: 'Сааттар',
      colRatePerHour: 'Ставка/саат',
      colCost: 'Наркы',
      colWorker: 'Аткаруучу',
      colNote: 'Эскертүү',
      noWorks: 'Иштер жок. Кол менен кошуңуз же Excel\'ден жүктөңүз.',
      totalWorks: 'Бардык иштер:',
      calcParams: 'Эсептөө параметрлери',
      overheadExpenses: 'Кошумча чыгымдар',
      profitMargin: 'Пайда маржасы',
      vat: 'КНС',
      vatHelp: 'КР\'да мебель КНСсиз',
      transport: 'Транспорт',
      packaging: 'Таңгактоо',
      otherCosts: 'Башка чыгымдар',
      totalCostCalc: 'Жыйынтыктуу өздүк нарк эсептөө',
      directCosts: 'Түз чыгымдар',
      materialsLabel: 'Материалдар:',
      worksLabel: 'Иштер:',
      totalDirect: 'Жалпы түз:',
      indirectCosts: 'Кыйыр чыгымдар',
      overheadLabel: 'Кошумча',
      transportLabel: 'Транспорт:',
      packagingLabel: 'Таңгактоо:',
      otherLabel: 'Башка:',
      fullCostPrice: 'Толук өздүк нарк:',
      marginLabel: 'Маржа',
      vatLabel: 'КНС',
      recommendedPrice: 'Сунушталган баа:',
      history: 'Тарых',
      exportExcel: 'Excel\'ге экспорттоо',
      createEstimate: 'Смета түзүү',
      saveTechCard: 'Техкартаны сактоо',
      savingDots: 'Сакталууда...',
      important: 'Маанилүү:',
      disclaimerText: 'Бул эсептөөлөр болжолдуу. Акыркы бааны менеджер рынок кырдаалын эске алып белгилейт.',
      historyTitle: 'Өздүк нарк эсептөө тарыхы',
      historyEmpty: 'Тарых бош',
      load: 'Жүктөө',
      author: 'Автор',
      techCardSaved: 'Техникалык карта ийгиликтүү сакталды!',
      noProductId: 'Товар ID көрсөтүлгөн эмес. Өздүк наркты эсептөө алдында товарды сактаңыз.',
      apiErrorLocal: 'API катасы, маалыматтар локалдык сакталды',
      historyLoaded: 'Тарыхтан маалыматтар жүктөлдү',
      historyLoadError: 'Тарыхтан маалыматтарды жүктөөдө ката',
      localCacheLoaded: 'Локалдык кэштен маалыматтар жүктөлдү',
      historyLoadApiError: 'Тарыхты жүктөөдө ката',
      pdfGenerated: 'PDF смета ийгиликтүү түзүлдү',
      pdfError: 'PDF сметаны түзүүдө ката',
      excelLoadedCount: 'Жүктөлдү',
      materialsWord: 'материал',
      worksWord: 'иш',
      deleteMaterial: 'Материалды жок кылуу',
      deleteWork: 'Ишти жок кылуу',
      bomTitle: 'Спецификация (BOM)',
      bomVersion: 'Версия',
      bomComponents: 'Компоненттер',
      bomCostPrice: 'Өздүк нарк',
      bomNotCreated: 'Спецификация түзүлгөн эмес',
      importExcel: 'Excel импорт',
      edit: 'Түзөтүү',
      createBom: 'Түзүү',
      cancel: 'Жокко чыгаруу',
      save: 'Сактоо',
      bomMaterial: 'Материал',
      bomQty: 'Саны',
      bomUnit: 'Бирдик',
      bomPricePerUnit: 'Бирдик баа',
      bomTotal: 'Сумма',
      bomActions: 'Аракеттер',
      selectMaterial: 'Материал тандаңыз',
      notSpecified: 'Көрсөтүлгөн эмес',
      newItem: 'Жаңы',
      bomTotalCost: 'Жалпы өздүк нарк:',
      addMaterial: 'Материал кошуу',
      bomEmptyTitle: 'Спецификация түзүлгөн эмес',
      bomEmptyDesc: 'Спецификацияны кол менен түзүңүз же Excel\'ден импорттоңуз',
      importFromExcel: 'Excel\'ден импорт',
      createManually: 'Кол менен түзүү',
      deleteMaterialTitle: 'Материалды жок кылуубу?',
      deleteMaterialConfirm: 'Бул материалды спецификациядан жок кылууну каалайсызбы?',
      delete: 'Жок кылуу',
      bomLoadError: 'Спецификацияны жүктөө мүмкүн болгон жок',
      bomUpdated: 'Спецификация жаңыртылды',
      bomCreated: 'Спецификация түзүлдү',
      bomSaveError: 'Спецификацияны сактоо мүмкүн болгон жок',
      bomImported: 'Спецификация Excel\'ден импорттолду',
      bomImportError: 'Excel\'ден импорттоодо ката',
      bomAvailableForSaved: 'Спецификация сакталган товарлар үчүн гана жеткиликтүү. Алгач товарды түзүңүз.',
      unitPcs: 'дана',
      currencySom: 'сом',
      bomSpecName: 'Спецификация: {{name}}',
    },

    // Price List Export
    priceList: {
      dialogTitle: 'Прайс-лист экспорт жөндөөлөрү',
      companyInfo: 'Компания жөнүндө маалымат',
      companyName: 'Компаниянын аталышы',
      phone: 'Телефон',
      email: 'Email',
      address: 'Дарек',
      website: 'Веб-сайт',
      heading: 'Аталыш',
      subtitle: 'Кошумча аталыш',
      fieldsToInclude: 'Кошулуучу талаалар',
      sku: 'Артикул (SKU)',
      photo: 'Товар сүрөтү',
      productName: 'Аталышы',
      description: 'Сүрөттөмө',
      category: 'Категория',
      retailPrice: 'Чекене баасы',
      b2bPrice: 'B2B баасы',
      priceQty10: '10 данага баасы',
      priceQty50: '50 данага баасы',
      stock: 'Камда бар',
      priceFormat: 'Баа форматы',
      currency: 'Валюта',
      showVAT: 'КНС көрсөтүү',
      vatRate: 'КНС ставкасы (%)',
      footerSection: 'Төмөнкү колонтитул',
      footerNote: 'Прайс-листтин аягындагы эскертүү',
      cancel: 'Жокко чыгаруу',
      exportBtn: 'Прайс-листти экспорттоо',
      defaultCompanyName: 'WASSER - Сантехника интернет-дүкөнү',
      defaultAddress: 'Бишкек ш., Кыргызстан',
      defaultTitle: 'ПРАЙС-ЛИСТ',
      defaultSubtitle: '{{date}} күнүнө актуалдуу',
      defaultFooter: 'Баалар сом менен көрсөтүлгөн. Товардын бардыгын менеджерлерден тактаңыз.',
    },

    // Widgets
    widgets: {
      dateAndTime: 'Күнү жана убакты',
      bishkekTimezone: 'Бишкек (UTC+6)',
      weekNumber: 'Апта {{n}}',
      dayNumber: 'Күн {{n}}',
      quarter: 'чейрек',
      noData: 'Маалымат жок',
      exchange: {
        title: 'НБКР валюта курсу',
        usd: 'АКШ доллары',
        eur: 'Евро',
        rub: 'Орус рублу',
        kzt: 'Теңге',
        loadError: 'Валюта курсун жүктөө мүмкүн болгон жок',
        dataSource: 'Маалыматтар НБКР тарабынан берилген',
      },
      weather: {
        title: 'Аба ырайы',
        feelsLike: 'Сезилет',
        loadError: 'Аба ырайын жүктөө мүмкүн болгон жок',
        defaultCity: 'Бишкек',
        partlyCloudy: 'Жарым булуттуу',
        windSpeed: 'м/с',
      },
    },

    // Sync Progress
    sync: {
      secSuffix: 'с',
      minSuffix: 'м',
      statusDone: 'Аяктады',
      statusError: 'Ката',
      statusRunning: 'Иштөөдө',
      statusPending: 'Күтүүдө',
      statusUnknown: 'Белгисиз',
      syncTitle: 'Синхрондоштуруу',
      entityProducts: 'товарлар',
      entityStock: 'калдыктар',
      entityOrders: 'буйрутмалар',
      disableAutoRefresh: 'Авто-жаңылоону өчүрүү',
      enableAutoRefresh: 'Авто-жаңылоону күйгүзүү',
      loadError: 'Жүктөө катасы:',
      completed: 'аяктаган',
      processed: 'Иштетилди',
      errors: 'Каталар',
      time: 'Убакыт',
      itemsPerSec: 'элемент/сек',
      syncError: 'Синхрондоштуруу катасы:',
      recentItems: 'Акыркы иштетилген элементтер:',
      successSuffix: 'ийгиликтүү',
      started: 'Башталды:',
      finished: 'Аяктады:',
    },

    // Cost Calculation Utils (costCalculationUtils.js)
    costCalc: {
      // Sheet names
      sheetMaterials: 'Материалдар',
      sheetLabor: 'Иштер',
      sheetCalculation: 'Эсептөө',
      sheetInstructions: 'Нускама',

      // Column headers - Materials
      colName: 'Аталышы',
      colUnit: 'Өлч.бир.',
      colQuantity: 'Саны',
      colPricePerUnit: 'Бирдик баасы',
      colTotal: 'Сумма',
      colSupplier: 'Жеткирүүчү',
      colNotes: 'Эскертүү',

      // Column headers - Labor
      colLaborName: 'Иштин аталышы',
      colHours: 'Саат',
      colRatePerHour: 'Саат/ставка',
      colCost: 'Наркы',
      colWorker: 'Аткаруучу',

      // Cost calculation labels
      costTitle: 'Өздүк нарк эсептөө',
      directCosts: 'ТҮЗДӨН-ТҮЗ ЧЫГЫМДАР',
      materials: 'Материалдар',
      laborLabel: 'Иштер',
      directCostsTotal: 'Жалпы түз чыгымдар',
      indirectCosts: 'КЫЙЫР ЧЫГЫМДАР',
      overheadCosts: 'Кошумча чыгымдар ({{percent}}%)',
      transportCosts: 'Транспорттук чыгымдар',
      packaging: 'Таңгактоо',
      otherCosts: 'Башка чыгымдар',
      totalCost: 'ТОЛУК ӨЗДҮК НАРК',
      priceCalculation: 'БААГА ЭСЕПТӨӨ',
      markup: 'Үстөк баа ({{percent}}%)',
      vatLabel: 'КНС ({{percent}}%)',
      recommendedPrice: 'СУНУШТАЛГАН БААСЫ',

      // Default units
      unitPcs: 'даана',
      unitHour: 'саат',
      unitSqm: 'м²',
      unitLm: 'м.у.',
      unitPack: 'таңгак',

      // Error messages
      errorParsingExcel: 'Excel талдоо катасы: {{message}}',
      errorReadingFile: 'Файлды окуу катасы',
      errorLoadingExceljs: 'exceljs китепканасын жүктөө катасы: {{message}}',
      errorExportExcel: 'Excel экспорттоо катасы: {{message}}',
      errorCreatingTemplate: 'Шаблон түзүү катасы: {{message}}',

      // Validation messages
      noMaterialsAdded: 'Материалдар кошулган эмес',
      materialNoName: 'Материал {{index}}: аталышы көрсөтүлгөн эмес',
      materialInvalidQty: 'Материал "{{name}}": саны туура эмес',
      materialInvalidPrice: 'Материал "{{name}}": баасы туура эмес',
      noLaborAdded: 'Иштер кошулган эмес',
      laborNoName: 'Иш {{index}}: аталышы көрсөтүлгөн эмес',
      laborInvalidHours: 'Иш "{{name}}": сааттар саны туура эмес',
      laborInvalidRate: 'Иш "{{name}}": ставка туура эмес',

      // Compare categories
      catMaterials: 'Материалдар',
      catLabor: 'Иштер',
      catTotalCost: 'Жыйынтыктуу өздүк нарк',

      // Template sample data
      samplePlywood: 'Кайың фанерасы 18мм',
      sampleEdgePVC: 'ПВХ кромка 2мм ак',
      sampleScrews: 'Бурамалар 4x16',
      sampleSupplier1: '"ЛесТорг" ЖЧК',
      sampleSupplier2: '"Эмерек Комплект" ЖЧК',
      sampleSupplier3: '"Крепеж" дүкөнү',
      sampleHighGrade: 'Жогорку сорт',
      samplePcsPerPack: 'Таңгакта 100 даана',
      sampleCutting: 'Материалды кесүү',
      sampleEdgeBanding: 'Кромкалоо',
      sampleAssembly: 'Буюмду чогултуу',
      sampleMaster: 'Устат',
      sampleCarpenter: '1-разряддагы жыгач устасы',

      // Template instructions
      instrTitle: 'ТЕХНИКАЛЫК КАРТАНЫ ТОЛТУРУУ НУСКАМАСЫ',
      instrMaterialsSheet: '"Материалдар" барагы:',
      instrMatName: '- Аталышы: материалдын же тетиктин аталышы',
      instrMatUnit: '- Өлч.бир.: өлчөө бирдиги (м², м.у., даана, кг ж.б.)',
      instrMatQuantity: '- Саны: бир буюмга материалдын чыгымы',
      instrMatPrice: '- Бирдик баасы: материалдын бирдик наркы сомдо',
      instrMatSupplier: '- Жеткирүүчү: жеткирүүчүнүн аты (милдеттүү эмес)',
      instrMatNotes: '- Эскертүү: кошумча маалымат (милдеттүү эмес)',
      instrLaborSheet: '"Иштер" барагы:',
      instrLabName: '- Иштин аталышы: аткарылуучу операциянын сүрөттөлүшү',
      instrLabHours: '- Саат: эмгек чыгымдары саатта',
      instrLabRate: '- Саат/ставка: сааттык төлөм сомдо',
      instrLabWorker: '- Аткаруучу: кызматы/аты (милдеттүү эмес)',
      instrLabNotes: '- Эскертүү: кошумча маалымат (милдеттүү эмес)',
      instrImportant: 'МААНИЛҮҮ:',
      instrKeepHeaders: '- Баш жолдорду өчүрбөңүз (ар бир бараттагы биринчи жол)',
      instrStartRow2: '- Маалыматтарды экинчи жолдон толтурууңуз',
      instrEmptyRows: '- Бош жолдор этибарга алынбайт',
      instrDecimalPoint: '- Ондук бөлүктөр үчүн чекит колдонуңуз (2.5, 2,5 эмес)',
      instrUpload: 'Толтургандан кийин файлды системадагы "Еxcel жүктөө" баскычы аркылуу жүктөңүз',
    },

    // ProductCostCalculation component
    productCost: {
      currencyShort: 'с',
      currencyPerHour: 'с/саат',
      currencyFull: 'сом',
      saveFailed: 'Техкартаны сактоо мүмкүн болгон жок',
      historyFailed: 'Техкарта тарыхын жүктөө мүмкүн болгон жок',
      apiErrorLocalSaved: 'API катасы, маалыматтар жергиликтүү сакталды',
      noDataInFile: 'Файлда маалымат табылган жок. Файлдын структурасын текшериңиз.',
      uploadError: 'Файлды жүктөөдө ката',
      downloadError: 'Ката',
      templateDownloadError: 'Шаблонду жүктөөдө ката',
      generalError: 'Жалпы ката',
      uploadedMaterials: 'Жүктөлдү: {{count}} материал',
      uploadedLabor: ', {{count}} иш',
      orderLabel: 'Заказ',
      productLabel: 'Буюм',
      createdInDb: '✅ Базада түзүлдү: {{count}} материал',
      alreadyInDb: '📦 Базада бар: {{count}}',
      errorsCount: '⚠️ Каталар: {{count}}',
      fromDbChip: 'Базадан ({{code}})',
      supplierNote: 'Жеткирүүчү',
      dbEmpty: 'Материалдар базасы бош',
      outdatedPricesConfirm: '{{count}} материалдын бааларынын мөөнөтү өткөн. Жаңыртасызбы?',
      allPricesActual: 'Бардык баалар актуалдуу!',
      pricesUpdated: '{{count}} материал жаңыртылды. Жалпы айырма: {{diff}}',
      noMaterialsToUpdate: 'Жаңыртыла турган материалдар жок',
      recommendedPriceNote: 'Сунушталган баа: {{price}} сом',
      materialsCountNote: 'Материалдар: {{count}}',
      worksCountNote: 'иштер: {{count}}',
      markupNote: 'Үстөк баа: {{percent}}%',
      pdfSubtitle: 'Ванна бөлмөсүнүн эмеректери',
      pdfDocTitle: 'СМЕТА / КОММЕРЦИЯЛЫК СУНУШ',
      pdfDate: 'Күнү',
      pdfProduct: 'Товар',
      pdfMaterialsHeader: 'Материалдар:',
      pdfWorksHeader: 'Иштер:',
      pdfSummaryHeader: 'Жыйынтыктоо эсептөө:',
      pdfColNum: '№',
      pdfColName: 'Аталышы',
      pdfColUnit: 'Өлч.',
      pdfColQty: 'Саны',
      pdfColPrice: 'Баасы',
      pdfColTotal: 'Сумма',
      pdfColHours: 'Саат',
      pdfColRate: 'Ставка',
      pdfRowMaterials: 'Материалдар',
      pdfRowWorks: 'Иштер',
      pdfRowDirectCosts: 'Түз чыгымдар',
      pdfRowOverhead: 'Кошумча чыгымдар',
      pdfRowTransport: 'Транспорт',
      pdfRowPackaging: 'Таңгактоо',
      pdfRowOtherCosts: 'Башка чыгымдар',
      pdfRowCostPrice: 'ӨЗДҮК НАРК',
      pdfRowMarkup: 'Үстөк баа',
      pdfRowTotalPayable: 'ЖАЛПЫ ТӨЛӨМ',
      pdfDisclaimer1: '* Смета түзүлгөн күндөн 14 күндүн ичинде жарактуу',
      pdfDisclaimer2: '* Баалар кыргыз сомдорунда көрсөтүлгөн (KGS)',
      pdfFilename: 'Смета',
      pdfDefaultProduct: 'товар',
      autoCreateTooltip: 'Excel жүктөөдө базада жок материалдарды автоматтык түрдө түзүү',
    },

    // Materials Integration Utils
    materialsInt: {
      notFoundInDb: 'Базадан табылган жок',
      priceFormat: '{{price}} сом/{{unit}}',
      sheetMaterials: 'Материалдар',
      defaultCategoryOther: 'Башкалар',
      defaultUnitPcs: 'даана',
      errorParsingExcel: 'Excel файлын окууда ката: {{message}}',
      errorReadingFile: 'Файлды окуу катасы',
      errorLoadingLibrary: 'Китепкананы жүктөө катасы: {{message}}',
      sheetServices: 'Кызматтар',
      headerCode: 'Код',
      headerName: 'Аталышы',
      headerCategory: 'Категория',
      headerUnit: 'Өлч. бир.',
      headerPrice: 'Баасы',
      headerSupplierPrice: 'Жеткир. баасы',
      headerSupplier: 'Жеткирүүчү',
      headerMinStock: 'Мин. калдык',
      headerStock: 'Калдык',
      headerNotes: 'Эскертүү',
      headerRate: 'Ставка',
      headerQualification: 'Квалификация',
      errorExport: 'Экспорт катасы: {{message}}',
      examplePlywood: 'Кайың фанерасы 18мм',
      exampleCategorySheet: 'Барактуу материалдар',
      exampleUnitM2: 'м²',
      exampleSupplier1: '"ЛесТорг" ЖЧК',
      exampleNoteHighGrade: 'Жогорку сорт',
      examplePvcEdge: 'ПВХ кромка 2мм ак',
      exampleCategoryEdge: 'Кромка материалдары',
      exampleUnitLm: 'ч.м.',
      exampleSupplier2: 'Эмерек Комплект',
      exampleScrews: 'Бурамалар 4x16',
      exampleCategoryFasteners: 'Бекиткичтер',
      exampleUnitPack: 'таңгак',
      exampleSupplier3: 'Бекиткич Плюс',
      exampleNotePack100: 'Таңгакта 100 даана',
      exampleCutting: 'Материалды кесүү',
      exampleCategoryWoodwork: 'Жыгач иштери',
      exampleUnitHour: 'саат',
      exampleQualMaster: 'Уста',
      exampleNoteIncludesMarking: 'Белгилөөнү камтыйт',
      exampleEdgeBanding: 'Кромка жабуу',
      exampleAssembly: 'Буюмду чогултуу',
      exampleCategoryAssembly: 'Чогултуу',
      exampleQualCarpenter: '1-разряддагы жыгач усташы',
      sheetInstructions: 'Нускама',
      instrTitle: 'МАТЕРИАЛДАР БАЗАСЫН ТОЛТУРУУ БОЮНЧА НУСКАМА',
      instrMaterialsSheet: '"Материалдар" барагы:',
      instrCode: '- Код: уникалдуу материал коду (MAT-001, MAT-002 ж.б.)',
      instrName: '- Аталышы: материалдын толук аталышы',
      instrCategory: '- Категория: Барактуу материалдар, Бекиткичтер, Фурнитура ж.б.',
      instrUnit: '- Өлч. бир.: өлчөө бирдиги (м², ч.м., даана, кг)',
      instrPrice: '- Баасы: учурдагы сатуу баасы',
      instrSupplierPrice: '- Жеткир. баасы: жеткирүүчүдөн сатып алуу баасы',
      instrSupplier: '- Жеткирүүчү: жеткирүүчү компаниянын аталышы',
      instrMinStock: '- Мин. калдык: эскертүү үчүн минималдуу калдык',
      instrStock: '- Калдык: кампадагы учурдагы калдык',
      instrNotes: '- Эскертүү: кошумча маалымат',
      instrServicesSheet: '"Кызматтар" барагы:',
      instrServiceCode: '- Код: уникалдуу кызмат коду (SRV-001, SRV-002 ж.б.)',
      instrServiceName: '- Аталышы: жумуш/операция аталышы',
      instrServiceCategory: '- Категория: Жыгач иштери, Чогултуу, Бүтүрүү ж.б.',
      instrServiceUnit: '- Өлч. бир.: өлчөө бирдиги (саат, даана)',
      instrServiceRate: '- Ставка: бирдик наркы',
      instrServiceQualification: '- Квалификация: аткаруучунун талап кылынган квалификациясы',
      instrServiceNotes: '- Эскертүү: кошумча маалымат',
      instrImportant: 'МААНИЛҮҮ:',
      instrNoDeleteHeaders: '- Аталыштарды (биринчи сапты) өчүрбөңүз',
      instrUniqueCodes: '- Коддор уникалдуу болушу керек',
      instrDecimalPoint: '- Ондук бөлгүч катары чекит колдонуңуз (850.50)',
      instrEmptyRows: '- Бош саптар этибарга алынбайт',
      errorCreatingTemplate: 'Шаблон түзүү катасы: {{message}}',
      priceChangeReason: 'Баа өзгөрүшү',
    },

    // Inventory Counting
    inventoryCounting: {
      status: {
        draft: 'Долбоор',
        inProgress: 'Жүрүп жатат',
        completed: 'Аякталды',
        cancelled: 'Жокко чыгарылды',
      },
      detail: {
        notFound: 'Инвентаризация табылган жок',
        backToList: 'Тизмеге кайтуу',
        backToListAria: 'Инвентаризация тизмесине кайтуу',
        back: 'Артка',
        title: 'Инвентаризация',
        warehouse: 'Кампа',
        responsible: 'Жооптуу',
        startDate: 'Баштоо күнү',
        endDate: 'Аяктоо күнү',
        countProgress: 'Эсептөө жүрүшү',
        report: 'Отчет',
        autoFill: 'Авто толтуруу',
        startInventory: 'Инвентаризацияны баштоо',
        completeCount: 'Аяктоо',
        cancel: 'Жокко чыгаруу',
        product: 'Товар',
        variant: 'Вариант',
        batch: 'Партия',
        expected: 'Күтүлүүдө',
        actual: 'Иш жүзүндө',
        discrepancy: 'Айырма',
        reason: 'Себеп',
        actions: 'Аракеттер',
        noItems: 'Позициялар жок. Авто толтурууну колдонуңуз же кол менен кошуңуз.',
        recount: 'Кайра эсептөө',
        delete: 'Өчүрүү',
        recountTitle: 'Кайра эсептөө:',
        actualRequired: 'Иш жүзүндө *',
        discrepancyReason: 'Айырма себеби',
        note: 'Эскертүү',
        reportDialogTitle: 'Инвентаризация отчету',
        document: 'Документ:',
        totalItems: 'Жалпы позициялар',
        counted: 'Эсептелди',
        expectedTotal: 'Күтүлүүдө:',
        actualTotal: 'Иш жүзүндө:',
        totalDiscrepancy: 'Жалпы айырма:',
        surplus: 'Ашыкча:',
        deficit: 'Жетишсиздик:',
        generatedAt: 'Түзүлгөн:',
        print: 'Басып чыгаруу',
        pdfDownloadError: 'PDF жүктөө катасы: ',
        excelExportError: 'Excel экспорт катасы: ',
        csvProduct: 'Товар',
        csvSku: 'Артикул',
        csvVariant: 'Вариант',
        csvBatch: 'Партия',
        csvExpected: 'Күтүлгөн',
        csvActual: 'Иш жүзүндө',
        csvDiscrepancy: 'Айырма',
        completedAlert: 'Инвентаризация аяктады. Калдыктар жаңыланды.',
        completeError: 'Инвентаризацияны аяктоо катасы',
        reportGenerationError: 'Отчет түзүү катасы',
        confirmStart: 'Инвентаризацияны баштайсызбы? Баштагандан кийин документти оңдоо мүмкүн болбойт.',
        confirmComplete: 'Инвентаризацияны аяктайсызбы? Калдыктар иш жүзүндөгү маалыматтар боюнча жаңыланат. Бул аракет кайтарылгыс.',
        confirmCancel: 'Инвентаризацияны жокко чыгарасызбы?',
        confirmAutoFill: 'Позицияларды калдыктардан авто толтуруу? Учурдагы позициялар өчүрүлөт.',
        confirmDeleteItem: 'Позицияны өчүрөсүзбү?',
        printReportTitle: 'Инвентаризация отчету',
        printWarehouse: 'Кампа:',
        printResponsible: 'Жооптуу:',
        printStatus: 'Статус:',
        printTotalItems: 'Жалпы позициялар:',
        printCounted: 'Эсептелди:',
        printExpectedSum: 'Күтүлгөн сумма:',
        printActualSum: 'Иш жүзүндөгү сумма:',
        printTotalDiscrepancy: 'Жалпы айырма:',
        excelIndicator: 'Көрсөткүч',
        excelValue: 'Маани',
        excelTotalItems: 'Жалпы позициялар',
        excelCounted: 'Эсептелди',
        excelExpectedSum: 'Күтүлгөн сумма',
        excelActualSum: 'Иш жүзүндөгү сумма',
        excelTotalDiscrepancy: 'Жалпы айырма',
        excelSurplus: 'Ашыкча',
        excelDeficit: 'Жетишсиздик',
        excelUncounted: 'Эсептелбеген',
        excelProduct: 'Товар',
        excelVariant: 'Вариант',
        excelBatch: 'Партия',
        excelExpected: 'Күтүлүүдө',
        excelActual: 'Иш жүзүндө',
        excelDiscrepancy: 'Айырма',
        excelReason: 'Себеп',
        excelNote: 'Эскертүү',
        excelSummarySheet: 'Жыйынтыктар',
        excelItemsSheet: 'Позициялар',
        errorUpdateItem: 'Позицияны жаңыртуу мүмкүн болбоду',
        errorDeleteItem: 'Позицияны өчүрүү мүмкүн болбоду',
        errorAutoFill: 'Позицияларды авто толтуруу мүмкүн болбоду',
      },
      list: {
        title: 'Инвентаризация',
        create: 'Түзүү',
        exportExcel: 'Excel экспорт',
        exporting: 'Экспорт...',
        exportAll: 'Баарын экспорттоо (Excel)',
        status: 'Статус',
        all: 'Баары',
        searchByNumber: 'Номер боюнча издөө',
        reset: 'Тазалоо',
        documentNumber: 'Документ номери',
        warehouse: 'Кампа',
        responsible: 'Жооптуу',
        startDate: 'Баштоо күнү',
        endDate: 'Аяктоо күнү',
        positions: 'Позициялар',
        counted: 'Эсептелди',
        actions: 'Аракеттер',
        loading: 'Жүктөлүүдө...',
        notFound: 'Инвентаризациялар табылган жок',
        view: 'Көрүү',
        edit: 'Өзгөртүү',
        start: 'Баштоо',
        delete: 'Өчүрүү',
        complete: 'Аяктоо',
        cancel: 'Жокко чыгаруу',
        rowsPerPage: 'Бир бетте:',
        displayedRows: '{{from}}-{{to}} ичинен {{count}}',
        confirmDelete: 'Инвентаризацияны өчүрөсүзбү?',
        confirmStart: 'Инвентаризацияны баштайсызбы? Баштагандан кийин документти оңдоо мүмкүн болбойт.',
        confirmComplete: 'Инвентаризацияны аяктайсызбы? Калдыктар иш жүзүндөгү маалыматтар боюнча жаңыланат.',
        confirmCancel: 'Инвентаризацияны жокко чыгарасызбы?',
        excelExportError: 'Excel экспорт катасы: ',
        fullExportError: 'Толук экспорт катасы: ',
        excelNumber: 'Номер',
        excelWarehouse: 'Кампа',
        excelResponsible: 'Жооптуу',
        excelStatus: 'Статус',
        excelStart: 'Башталышы',
        excelEnd: 'Аякташы',
        excelPositions: 'Позициялар',
        excelCounted: 'Эсептелди',
        excelSheetName: 'Инвентаризациялар',
      },
      errorDelete: 'Инвентаризацияны өчүрүү мүмкүн болбоду',
      errorStart: 'Инвентаризацияны баштоо мүмкүн болбоду',
      errorComplete: 'Инвентаризацияны аяктоо мүмкүн болбоду',
      errorCancel: 'Инвентаризацияны жокко чыгаруу мүмкүн болбоду',
      create: {
        title: 'Инвентаризация түзүү',
        back: 'Артка',
        nextDocNumber: 'Кийинки документ номери:',
        createError: 'Инвентаризация түзүү катасы',
        selectWarehouse: 'Кампаны тандаңыз',
        selectResponsible: 'Жооптууну көрсөтүңүз',
        warehouseLabel: 'Кампа *',
        startDate: 'Баштоо күнү',
        comment: 'Комментарий',
        fillOptions: 'Позицияларды толтуруу',
        autoFill: 'Калдыктардан автоматтык толтуруу',
        includeZeroStock: 'Нөл калдыктагы товарларды кошуу',
        creating: 'Түзүлүүдө...',
        createBtn: 'Түзүү',
      },
    },

    // Media
    media: {
      productMedia: 'Товар медиасы',
      viewGallery: 'Галереяны көрүү',
      images: 'Сүрөттөр',
      videos: 'Видеолор',
      initError: 'Видео ойноткучту баштоо мүмкүн болгон жок',
      hlsNotSupported: 'HLS бул браузерде колдоого алынбайт',
      videoNotFound: 'Видео табылган жок (404). Cloudflare Streamдон өчүрүлгөн болушу мүмкүн.',
      networkError: 'Түйүн катасы: {{details}}',
      playbackError: 'Ойнотуу катасы: {{details}}',
    },

    images: {
      uploadFailed: 'Сүрөттөрдү жүктөө мүмкүн болгон жок',
      deleteFailed: 'Сүрөттү жок кылуу мүмкүн болгон жок',
    },

    // Image Uploader
    imageUploader: {
      maxImagesReached: 'Максимум {{max}} сүрөт',
      partialUpload: '{{total}} файлдан {{uploading}} гана жүктөлөт ({{slots}} слот бош)',
      failedUploads: '{{count}} файл(дар) жүктөлгөн жок',
      dragDropTitle: 'Сүрөттөрдү сүйрөңүз же тандоо үчүн басыңыз',
      dragDropHint: 'Көп файл • JPEG, PNG, WebP, GIF (макс 10МБ)',
      uploadingProgress: '{{count}} файл жүктөлүүдө... {{percent}}%',
      uploadedCount: 'Жүктөлгөн ({{current}}/{{max}}) • Көрүү үчүн басыңыз, тартип коеңоз',
      firstIsMain: 'Биринчиси = Негизги',
      reorderTip: '💡 Кеңеш: сүрөттөрдү сүйрөп тартиптеңиз. Биринчи сүрөт — негизги.',
      maxReachedHint: 'Сүрөттөрдүн максималдуу саны ({{max}}). Жаңысын жүктөө үчүн бирөөнү өчүрүңүз.',
      noImages: 'Сүрөттөр жүктөлгөн жок',
    },

    // Error Boundary
    errors: {
      pageErrorTitle: 'Барактын катасы',
      pageErrorMessage: 'Бул баракта ката кетти. Жаңыртып көрүңүз же башкы бетке кайтыңыз.',
      retry: 'Кайталоо',
      goHome: 'Башкы бетке',
    },

    // Video Uploader
    video: {
      uploadFile: 'Файл жүктөө',
      uploadFromUrl: 'URL аркылуу жүктөө',
      uploadFromUrlTitle: 'URL аркылуу видео жүктөө',
      hdLabel: 'HD',
      streamLabel: 'Stream',
      r2Label: 'R2',
      videoNamePlaceholder: 'Товардын демо-видеосу',
      dragDropPrompt: 'Видеону сүйрөңүз же тандоо үчүн басыңыз',
      cloudflareHint: 'Cloudflare Stream\'ге жүктөлөт (автоматтык HD транскодировкалоо)',
      supportedFormats: 'Колдоого алынган форматтар: MP4, WebM, MOV, AVI (макс. 1ГБ)',
      supportedHint: 'Колдоого алынат: MP4, WebM, MOV, AVI',
      videoUrl: 'Видео URL',
      videoNameOptional: 'Видео аты (милдеттүү эмес)',
      videoFromUrl: 'URL аркылуу видео',
      uploading: 'Жүктөлүүдө... {{progress}}%',
      uploadedCount: 'Жүктөлгөн видеолор ({{count}}/{{max}})',
      statusProcessing: 'Иштетилүүдө',
      statusReady: 'Даяр',
      maxReached: 'Видеолордун максималдуу саны жетти ({{max}}). Жаңысын жүктөө үчүн видеону жок кылыңыз.',
      uploadFailed: 'Видеону жүктөө мүмкүн эмес',
      deleteFailed: 'Видеону жок кылуу мүмкүн эмес',
      enterUrlError: 'Видео URL киргизиңиз',
    },
  },
};

// Flatten nested objects to dot notation (e.g., 'products.title')
function flattenDictionary(obj, prefix = '') {
  return Object.keys(obj).reduce((acc, key) => {
    const path = prefix ? `${prefix}.${key}` : key;
    if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
      Object.assign(acc, flattenDictionary(obj[key], path));
    } else {
      acc[path] = obj[key];
    }
    return acc;
  }, {});
}

export const flatDictionaries = {
  ru: flattenDictionary(dictionaries.ru),
  en: flattenDictionary(dictionaries.en),
  ky: flattenDictionary(dictionaries.ky),
};
